/* eslint-disable */
import React__default, {
  createElement
} from "react";
import {
  inject,
  observer,
  Provider
} from "mobx-react";
import {
  configure,
  toJS,
  observable,
  action,
  makeObservable
} from "mobx";
import smoothscroll from "smoothscroll-polyfill";
import PropTypes from "prop-types";
import {
  matchPath
} from "react-router";
import axios from "axios";
import socketIOClient from "socket.io-client";
import themeConfig from "../config/theme.config";
import {
  StyleSheet as StyleSheet$1,
  css
} from "aphrodite/no-important";
import {
  useTheme,
  create
} from "@amcharts/amcharts4/core";
import {
  XYChart,
  XYCursor,
  DateAxis,
  ValueAxis,
  LineSeries
} from "@amcharts/amcharts4/charts";
import {
  BrowserRouter,
  Route as Route$1
} from "react-router-dom";
import ResizeObserver from "resize-observer-polyfill";
import ReactDOM from "react-dom";
import PerfectScrollbar from "react-perfect-scrollbar";

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x.default : x
}

function createCommonjsModule(fn, module) {
  return fn(module = {
      exports: {}
  }, module.exports), module.exports
}
var _asyncToGenerator = unwrapExports(createCommonjsModule((function(module) {
      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
          try {
              var info = gen[key](arg),
                  value = info.value
          } catch (error) {
              return void reject(error)
          }
          info.done ? resolve(value) : Promise.resolve(value).then(_next, _throw)
      }
      module.exports = function(fn) {
          return function() {
              var self = this,
                  args = arguments;
              return new Promise((function(resolve, reject) {
                  var gen = fn.apply(self, args);

                  function _next(value) {
                      asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value)
                  }

                  function _throw(err) {
                      asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err)
                  }
                  _next(void 0)
              }))
          }
      }, module.exports.default = module.exports, module.exports.__esModule = !0
  }))),
  _defineProperty = unwrapExports(createCommonjsModule((function(module) {
      module.exports = function(obj, key, value) {
          return key in obj ? Object.defineProperty(obj, key, {
              value: value,
              enumerable: !0,
              configurable: !0,
              writable: !0
          }) : obj[key] = value, obj
      }, module.exports.default = module.exports, module.exports.__esModule = !0
  })));
smoothscroll.polyfill();
class R14Utils {
  constructor() {
      this.dom = new R14DomUtils(this), this.core = new R14CoreUtils(this), this.date = new R14DateUtils(this), this.array = new R14ArrayUtils(this), this.string = this.str = new R14StringUtils(this), this.graphQl = this.gql = new R14GraphQlUtils(this), this.nav = new R14NavUtils(this), this.form = this.fm = new R14FormUtils(this)
  }
}
class R14UtilsChild {
  constructor(utils) {
      this._utils = utils
  }
}
class R14DateUtils extends R14UtilsChild {
  constructor() {
      super(...arguments), _defineProperty(this, "LABEL_TYPE_SHORT", "short"), _defineProperty(this, "LABEL_TYPE_ABBREVIATED", "abbrv"), _defineProperty(this, "LABEL_TYPE_SINGLE_LETTER", "letter"), _defineProperty(this, "_monthLabels", ["january", "febuary", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"]), _defineProperty(this, "_monthLabelsShort", ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"]), _defineProperty(this, "_dayLabels", ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"]), _defineProperty(this, "_dayLabelsShort", ["sun", "mon", "tue", "wed", "thu", "fri", "sat"]), _defineProperty(this, "_dayLabelsAbbrv", ["su", "mo", "tu", "we", "th", "fr", "sa"]), _defineProperty(this, "_dayLabelsSingleLetter", ["s", "m", "t", "w", "t", "f", "s"])
  }
  toShortDate(date) {
      return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear()
  }
  isShortDate(value) {
      var t = value.split("/"),
          d = new Date(t[2] + "/" + t[0] + "/" + t[1]);
      return !(!d || d.getMonth() + 1 != t[0] || d.getDate() != Number(t[1]) || d.getFullYear() != Number(t[2]))
  }
  toTime(val) {
      var hours = null,
          minutes = null,
          isPM = !1;
      if (val instanceof Date) {
          var date = val;
          isPM = date.getHours() >= 12, minutes = date.getMinutes() < 10 ? "0".concat(date.getMinutes()) : date.getMinutes(), 0 === (hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours()) && (hours = 12)
      } else {
          if (!("object" == typeof val && val.hour && val.minute && val.period)) throw new Error("Date Utils Error: Time must be Date or an object returned from parseTime.");
          hours = val.hour, minutes = val.minute, isPM = "PM" === val.period
      }
      return "".concat(hours, ":").concat(minutes, " ").concat(isPM ? "PM" : "AM")
  }
  parseTime(time) {
      var ret = {
              hour: "12",
              minute: "00",
              second: "00",
              period: "PM"
          },
          timeParts = time.trim().replace(" ", ":").split(":");
      return timeParts.length < 3 || (ret.hour = timeParts[0], ret.minute = timeParts[1], 3 === timeParts.length ? ret.period = timeParts[2] : 4 === timeParts.length && (ret.minute = timeParts[2], ret.period = timeParts[3])), ret
  }
  roundUpToMinuteInterval(date) {
      var coeff = 6e4 * (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5);
      return new Date(Math.ceil(date.getTime() / coeff) * coeff)
  }
  fromUnixTimestamp(timestamp) {
      return new Date(1e3 * timestamp)
  }
  getDayLabel(day, type) {
      var ret = "";
      if (day instanceof Date) day = day.getDay();
      else if (day < 0 || day > 6) return null;
      switch (type) {
          case this.LABEL_TYPE_SHORT:
              ret = this._dayLabelsShort[day];
              break;
          case this.LABEL_TYPE_ABBREVIATED:
              ret = this._dayLabelsAbbrv[day];
              break;
          case this.LABEL_TYPE_SINGLE_LETTER:
              ret = this._dayLabelsSingleLetter[day];
              break;
          default:
              ret = this._dayLabels[day]
      }
      return this._utils.str.capitalize(ret)
  }
  getMonthLabel(month, type) {
      var ret = "";
      if (month instanceof Date) month = month.getMonth();
      else if (month < 0 || month > 11) return null;
      switch (type) {
          case this.LABEL_TYPE_SHORT:
              ret = this._monthLabelsShort[month];
              break;
          default:
              ret = this._monthLabels[month]
      }
      return this._utils.str.capitalize(ret)
  }
  getDayOrdinal(date) {
      switch (date.getDate()) {
          case 1:
          case 21:
              return "st";
          case 2:
          case 22:
              return "nd";
          case 3:
          case 23:
              return "rd";
          default:
              return "th"
      }
  }
  getDayRange(date) {
      var startDate = new Date(date);
      startDate.setHours(0, 0, 0, 0);
      var endDate = new Date(startDate);
      return endDate.setHours(23, 59, 59, 0), {
          start: startDate,
          end: endDate
      }
  }
  getWeekRange(date) {
      var startDate = null,
          endDate = null;
      if (arguments.length > 1 && void 0 !== arguments[1] && arguments[1])(endDate = new Date(date)).setHours(23, 59, 59, 0), (startDate = new Date(endDate)).setDate(startDate.getDate() - 7), startDate.setHours(0, 0, 0, 0);
      else {
          (startDate = new Date(date)).setHours(0, 0, 0, 0);
          var _endDate = new Date(startDate);
          _endDate.setDate(_endDate.getDate() + 7), _endDate.setHours(23, 59, 59, 0)
      }
      return {
          start: startDate,
          end: endDate
      }
  }
  toLocalTime(date) {
      var localOffset = 6e4 * (date = new Date(date)).getTimezoneOffset(),
          localTime = date.getTime();
      return date = localTime - localOffset, new Date(date)
  }
  areDatesSameDay(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()
  }
  areDatesSameMonth(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth()
  }
  isDayLessThan(d1, d2) {
      var d1Year = d1.getFullYear(),
          d1Month = d1.getMonth(),
          d1Day = d1.getDate(),
          d2Year = d2.getFullYear(),
          d2Month = d2.getMonth(),
          d2Day = d2.getDate();
      return d1Year < d2Year || !(d1Year > d2Year) && (d1Month < d2Month || d1Day < d2Day)
  }
  isMonthLessThan(d1, d2) {
      var d1Year = d1.getFullYear(),
          d1Month = d1.getMonth(),
          d2Year = d2.getFullYear(),
          d2Month = d2.getMonth();
      return d1Year < d2Year || !(d1Year > d2Year) && d1Month < d2Month
  }
}
class R14CoreUtils {
  arePropsEqual(prop1, prop2, maxDepth) {
      var _depth = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
      if (prop1 === prop2) return !0;
      if ("object" != typeof prop1 || null === prop1 || "object" != typeof prop2 || null === prop2) return !1;
      var keys1 = Object.keys(prop1),
          keys2 = Object.keys(prop2);
      if (keys1.length !== keys2.length) return !1;
      hasOwnProperty.bind(prop2);
      for (var i = 0; i < keys1.length; i++)
          //! bHasOwnProperty(keys1[i]) ||
          if ((!maxDepth || _depth < maxDepth) && "object" == typeof prop1[keys1[i]] && "object" == typeof prop2[keys1[i]]) {
              if (!this.arePropsEqual(prop1[keys1[i]], prop2[keys1[i]], maxDepth, _depth + 1)) return !1
          } else if (prop1[keys1[i]] !== prop2[keys1[i]]) return !1;
      return !0
  }
  getFunctionArgumentNames(func) {
      var fnStr = func.toString().replace(/(\/\/.*)|(\/\*[\s\S]*?\*\/)|(\s*=[^,\)]*(('(?:\\'|[^'\r\n])*')|("(?:\\"|[^"\r\n])*"))|(\s*=[^,\)]*))/gm, "");
      return fnStr.slice(fnStr.indexOf("(") + 1, fnStr.indexOf(")")).match(/([^\s,]+)/g) || []
  }
  getMethodArgumentNames(classObj, methodName) {
      return this.getFunctionArgumentNames(classObj[methodName])
  }
  sleep(time) {
      return new Promise(resolve => setTimeout(resolve, time))
  }
}
class R14NavUtils {
  getRouteByState(state) {
      for (; void 0 !== state.index;) state = state.routes[state.index];
      return state
  }
}
class R14ArrayUtils {
  unique(arr) {
      return [...new Set(arr)]
  }
  shuffle(array) {
      var i = 0,
          j = 0,
          temp = null;
      for (i = array.length - 1; i > 0; i -= 1) j = Math.floor(Math.random() * (i + 1)), temp = array[i], array[i] = array[j], array[j] = temp;
      return array
  }
}
class R14DomUtils extends class {
  getPropertyUnitValues(target, property, unit) {
      var item, map = this.getPropertyUnitMap(),
          factors = {},
          units = {},
          value = target[property] || this.getComputedStyle(target, property),
          numeric = this.stripPropertyValueUnit(value);
      if (null === numeric) throw "getPropertyUnitValues: Invalid property value returned";
      var currUnit, computedUnit = this.getPropertyUnitByValue(value);
      for (item in map)
          if (map[item] == computedUnit) {
              currUnit = item;
              break
          } if (!currUnit) throw "getPropertyUnitValues: Computed unit not found";
      if (unit) {
          unit = this.getPropertyUnitMapIdx(unit, map);
          var tMap = {};
          tMap[currUnit] = map[currUnit], tMap[unit] = map[unit], map = tMap
      }
      var temp = document.createElement("div");
      for (item in temp.style.overflow = "hidden", temp.style.visibility = "hidden", target.parentElement.appendChild(temp), map) temp.style.width = 100 + map[item], factors[item] = 100 / temp.offsetWidth;
      for (item in map) units[item] = numeric * (factors[item] * factors[currUnit]);
      return target.parentElement.removeChild(temp), units
  }
  offset(elmt) {
      var rect = elmt.getBoundingClientRect(),
          scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
          scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return {
          top: rect.top + scrollTop,
          left: rect.left + scrollLeft
      }
  }
  dimensions(elmt) {
      var rect = elmt.getBoundingClientRect();
      return {
          height: rect.height,
          width: rect.width
      }
  }
  scrollPosition() {
      return {
          top: window.pageYOffset || document.documentElement.scrollTop,
          left: window.pageXOffset || document.documentElement.scrollLeft
      }
  }
  scrollTop() {
      var top = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      this.scrollTo(0, top)
  }
  scrollTo(options) {
      if (options) {
          var isAnimated = options.animated || !1,
              x = (options.duration, options.x || null),
              y = options.y || null;
          window.scrollTo({
              top: y,
              left: x,
              behavior: isAnimated && "smooth"
          })
      }
  }
  scrollToElement(elmt) {
      var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if (!elmt) return !1;
      var offset = {
          top: options.top || null,
          left: options.left || null
      };
      if (null === offset.top || null === offset.left) {
          var calcOffset = this.offset(elmt);
          null === offset.top && (offset.top = calcOffset.top), null === offset.left && (offset.left = calcOffset.left)
      }
      options.offsetTop && (offset.top -= options.offsetTop), this.scrollTo(offset.left, offset.top)
  }
  getBodyWidth() {
      var body = document.body,
          html = document.documentElement;
      return Math.max(body.scrollWidth, body.offsetWidth, body.getBoundingClientRect().width, html.clientWidth, html.scrollWidth, html.offsetWidth)
  }
  getBodyHeight() {
      var body = document.body,
          html = document.documentElement;
      return Math.max(body.scrollHeight, body.offsetHeight, body.getBoundingClientRect().height, html.clientHeight, html.scrollHeight, html.offsetHeight)
  }
  getBodySize() {
      return {
          x: this.getBodyWidth(),
          y: this.getBodyHeight()
      }
  }
  getViewportDimensions() {
      return {
          height: this.getViewportHeight(),
          width: this.getViewportWidth()
      }
  }
  getViewportWidth() {
      return window.innerWidth ? window.innerWidth : document.body && document.body.offsetWidth ? document.body.offsetWidth : 0
  }
  getViewportHeight() {
      return window.innerHeight ? window.innerHeight : document.body && document.body.offsetHeight ? document.body.offsetHeight : 0
  }
} {
  hyphenateCssProp(property) {
      return property.replace(/([a-z])([A-Z])/, (function(a, b, c) {
          return b + "-" + c.toLowerCase()
      }))
  }
  getComputedStyle(node, property) {
      return window.getComputedStyle ? (property = this.hyphenateCssProp(property), window.getComputedStyle(node, null).getPropertyValue(property)) : node.currentStyle ? node.currentStyle[property] : node.style[property]
  }
  getTransformInfo(node) {
      var rotateX, rotateZ, matrix = this.parseMatrix(getComputedStyle(node, null).transform),
          rotateY = Math.asin(-matrix.m13);
      return 0 !== Math.cos(rotateY) ? (rotateX = Math.atan2(matrix.m23, matrix.m33), rotateZ = Math.atan2(matrix.m12, matrix.m11)) : (rotateX = Math.atan2(-matrix.m31, matrix.m22), rotateZ = 0), {
          rotate: {
              x: rotateX,
              y: rotateY,
              z: rotateZ
          },
          translate: {
              x: matrix.m41,
              y: matrix.m42,
              z: matrix.m43
          }
      }
  }
  parseMatrix(matrixString) {
      var c = matrixString.split(/\s*[(),]\s*/).slice(1, -1);
      return 6 === c.length ? {
          m11: +c[0],
          m21: +c[2],
          m31: 0,
          m41: +c[4],
          m12: +c[1],
          m22: +c[3],
          m32: 0,
          m42: +c[5],
          m13: 0,
          m23: 0,
          m33: 1,
          m43: 0,
          m14: 0,
          m24: 0,
          m34: 0,
          m44: 1
      } : 16 === c.length ? {
          m11: +c[0],
          m21: +c[4],
          m31: +c[8],
          m41: +c[12],
          m12: +c[1],
          m22: +c[5],
          m32: +c[9],
          m42: +c[13],
          m13: +c[2],
          m23: +c[6],
          m33: +c[10],
          m43: +c[14],
          m14: +c[3],
          m24: +c[7],
          m34: +c[11],
          m44: +c[15]
      } : {
          m11: 1,
          m21: 0,
          m31: 0,
          m41: 0,
          m12: 0,
          m22: 1,
          m32: 0,
          m42: 0,
          m13: 0,
          m23: 0,
          m33: 1,
          m43: 0,
          m14: 0,
          m24: 0,
          m34: 0,
          m44: 1
      }
  }
  getPropertyUnitMap() {
      return {
          pixel: "px",
          percent: "%",
          inch: "in",
          cm: "cm",
          mm: "mm",
          point: "pt",
          pica: "pc",
          em: "em",
          ex: "ex"
      }
  }
  getPropertyUnitMapIdx(unit, map) {
      var unitIdx = null;
      if ((map = map || this.getPropertyUnitMap())[unit]) unitIdx = unit;
      else
          for (var item in map)
              if (map[item] == unit) {
                  unitIdx = item;
                  break
              } if (!unitIdx) throw "getPropertyUnitMapIdx: Unit idx not found";
      return unitIdx
  }
  stripPropertyValueUnit(value) {
      return isNaN(value) && null === (value = value.match(/[-]{0,1}[\d]*[\.]{0,1}[\d]+/g)) ? null : parseFloat(value[0])
  }
  getPropertyUnitByValue(value) {
      return isNaN(value) ? null === (value = value.match(/\D+$/)) ? this.getPropertyUnitMap().pixel : ((value = value[0]).endsWith && value.endsWith(")") && (value = value.substring(0, value.length - 1)), null === value ? this.getPropertyUnitMap().pixel : value) : null
  }
  getPropertyValueByUnit(unit, target, property) {
      return unit = this.getPropertyUnitMapIdx(unit), this.getPropertyUnitValues(target, property, unit)[unit]
  }
  parseElementStyle(styles) {
      if (styles.transform) {
          if ("string" == typeof styles.transform) throw "TODO: Allow transform strings in element reactStyle";
          styles.transform.origin && (styles.transformOrigin = styles.transform.origin, delete styles.transform.origin), styles.transform = this.renderElementTransformStyle(styles.transform)
      }
      return styles
  }
  renderElementTransformStyle(transforms) {
      var transformArr = [];
      for (var p in transforms) switch (p) {
          case "scale":
          case "translate":
              if (Array.isArray(transforms)) {
                  if (transforms.length < 2 || null === transforms[0] || null === transforms[1]) throw "Element Error: Transform array must be [x,y,z,...]";
                  if (null === transforms[0] || null === transforms[1]) throw "Element Error: Transforms array cannot have null values.";
                  transformArr.push("".concat(p, "(").concat(transforms[p].join(","), ")"))
              } else if ("object" == typeof transforms[p]) {
                  if (void 0 === transforms[p].x || null === transforms[p].x) throw "Element Error: Transform must have an x and y";
                  if (void 0 === transforms[p].y || null === transforms[p].y) throw "Element Error: Transform must have an x and y";
                  var pArr = [transforms[p].x, transforms[p].y];
                  transforms[p].y && pArr.push(transforms[p].y), transformArr.push("".concat(p, "(").concat(pArr[p].join(","), ")"))
              } else transformArr.push("".concat(p, "(").concat(transforms[p], ")"));
              break;
          default:
              transformArr.push("".concat(p, "(").concat(transforms[p], ")"))
      }
      return transformArr.length ? transformArr.join(" ") : null
  }
}
class R14StringUtils {
  slugify() {
      var txt = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
      if (!txt) return "";
      var slug = txt.toString().trim().toLowerCase().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, ""),
          slugArr = [],
          len = 0;
      return slug.split("-").forEach(val => {
          len + val.length < 60 && (slugArr.push(val), len += val.length)
      }), slugArr.join("-")
  }
  toUpperCaseWords(str) {
      return (str + "").replace(/^(.)|\s+(.)/g, (function(w) {
          return w.toUpperCase()
      }))
  }
  fromCamelCase(value) {
      return value.replace(/([A-Z]+)/g, " $1").trim()
  }
  capitalize(w) {
      return w.replace(/^\w/, w => w.toUpperCase())
  }
  renderSocialText(text, tagRenderer) {
      if (!text) return text;
      if (-1 === text.indexOf("@[")) return text;
      var tags = text.match(/@\[([a-z\d_]+):([a-z\d_ ]+):([a-z\d_-]+)\]/gi);
      return tags && tags.length ? (tags && tags.length && tags.forEach(val => {
          var idx = 0,
              tagInfo = val.match(/@\[([a-z\d_]+):([a-z\d_ ]+):([a-z\d_-]+)\]/i);
          if (!(tagInfo.length < 4)) {
              var tag = {
                  match: tagInfo[0],
                  type: tagInfo[1],
                  label: tagInfo[2],
                  value: tagInfo[3]
              };
              text = text.replace(tag.match, () => tagRenderer(tag.type, tag.value, tag.label, ++idx))
          }
      }), text) : text
  }
  toHex(str) {
      for (var arr = [], n = 0, l = str.length; n < l; n++) arr.push(Number(str.charCodeAt(n)).toString(16));
      return arr.join("")
  }
  fromHex(hex) {
      hex = hex.toString();
      for (var str = "", n = 0; n < hex.length; n += 2) str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
      return str
  }
}
class R14GraphQlUtils extends R14UtilsChild {
  fieldsToString(fields) {
      var fieldsStr = "";
      if (Array.isArray(fields)) fields.forEach(field => {
          if ("object" == typeof field)
              for (var name in field) fieldsStr += "".concat(name, " {\n").concat(this.fieldsToString(field[name]), "}");
          else fieldsStr += "".concat(field, "\n")
      });
      else if ("object" == typeof fields)
          for (var alias in fields) "object" == typeof fields[alias] ? fieldsStr += "".concat(alias, "{\n").concat(this.fieldsToString(fields[alias]), "}\n") : !0 === fields[alias] || fields[alias] === alias ? fieldsStr += "".concat(alias, "\n") : fieldsStr += "".concat(alias, ": ").concat(fields[alias], "\n");
      return fieldsStr
  }
  createEntityFindQuery(entityName, fields) {
      var entityNameCap = this._utils.str.capitalize(entityName),
          fieldsStr = this.fieldsToString(fields);
      if (!fieldsStr) throw new Error("createEntityFieldQuery Error: No fields found for ".concat(entityName, " find query."));
      return "\n      query Find".concat(entityNameCap, "($page: Int, $resultsPerPage: Int, $totalCount: Boolean!, $sort: [SortOption!]!, $filter: ").concat(entityNameCap, "Filter) {\n        ").concat(entityName, "s(page: $page, resultsPerPage: $resultsPerPage, sort: $sort, filter: $filter){\n          totalCount @include(if: $totalCount)\n          nodes {\n            ").concat(fieldsStr, "\n          }\n        }\n      }")
  }
}
class R14FormUtils extends R14UtilsChild {
  isFile(file) {
      return file instanceof File
  }
}
"development" === process.env.NODE_ENV && configure({
  enforceActions: "observed"
});
class R14 extends class {
  static connect(Component, r14) {
      return inject("app", "r14")(observer(class extends Component {
          constructor(props) {
              super(props)
              if (this.componentDidFocus || this.componentWillFocus) {
                  this.handleMount = super.componentDidMount ? super.componentDidMount.bind(this) : null
                  this.handleUpdate = super.componentDidUpdate ? super.componentDidUpdate.bind(this) : null
              }
          }
          componentDidMount() {
              if (this.componentDidFocus || this.componentWillFocus) {
                  this.handleMount && this.handleMount()
                  this.componentWillFocus && this.componentWillFocus()
                  this.componentDidFocus && this.componentDidFocus()
              } else {
                  super.componentDidMount && super.componentDidMount()
              }
          }
          componentDidUpdate(prevProps, prevState) {
              if (this.componentDidFocus || this.componentWillFocus) {
                  this.handleUpdate && this.handleUpdate(prevProps, prevState)
                  this.componentWillFocus && this.componentWillFocus()
                  this.componentDidFocus && this.componentDidFocus()
              } else {
                  super.componentDidUpdate && super.componentDidUpdate(prevProps, prevState)
              }
          }
          render() {
              r14.rendering = !0;
              var ret = super.render();
              return r14.rendering = !1, ret
          }
      }))
  }
} {
  constructor() {
      super(), this._metadata = {
          config: {},
          themeConfig: {},
          app: null,
          isRendering: !1
      }, this.utils = new R14Utils
  }
  static get utils() {
      return new R14Utils
  }
  static connect(component) {
      return super.connect(component, R14.getInstance())
  }
  static connectForm(component) {
      return inject("app", "r14", "form")(observer(component))
  }
  static connectDraggableContainer(component) {
      return inject("app", "r14", "draggableContainer")(observer(component))
  }
  static getInstance() {
      return global ? (global._r14 || (global._r14 = new R14), global._r14) : (window._r14 || (window._r14 = new R14), window._r14)
  }
  static get instance() {
      return R14.getInstance()
  }
  static get Actions() {
      return R14Actions
  }
  static get Domain() {
      return R14Domain
  }
  static get EntityDomain() {
      return R14EntityDomain
  }
  static get Navigation() {
      return React__default.Component
  }
  static get Theme() {
      return R14ThemeProvider
  }
  static get DomainInstances() {
      return R14DomainInstances
  }
  static listen(domain) {
      var props = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      domain.prototype.__r14MemberStateProps = props;
      // Note: makeObservable should be called in the domain's constructor instead of here
  }
  onExit() {}
  get app() {
      return this._metadata.app
  }
  set app(app) {
      return this._metadata.app = app, this
  }
  get isRendering() {
      return this._metadata.rendering
  }
  set rendering(rendering) {
      return this._metadata.rendering = rendering, this
  }
  get config() {
      return this.app.config
  }
}
class R14Actions {
  constructor(routerPortal, domain) {
      this.result = this.rslt = new R14ActionsResultFactory, this.shouldActionLoad && (this.shouldActionLoad = this.shouldActionLoad.bind(this)), this.actionWillLoad && (this.actionWillLoad = this.actionWillLoad.bind(this)), this._routerPortal = routerPortal
  }
  get model() {
      return R14.getInstance().app.mdl
  }
  get mdl() {
      return this.model
  }
  get domain() {
      return this.mdl.domain
  }
  get dm() {
      return this.domain
  }
  get ui() {
      return this.mdl.ui
  }
  get navigation() {
      return R14.getInstance().app.navigation
  }
  get nav() {
      return this.navigation
  }
  get api() {
      return R14.getInstance().app.api
  }
  get utilities() {
      return R14.getInstance().app.utils
  }
  get utils() {
      return this.utilities
  }
}
class R14ActionsResultFactory {
  component(component) {
      return new R14ActionsComponentResult(component)
  }
}
class R14ActionsComponentResult {
  constructor(component) {
      this._metadata = {
          component: component
      }, this.props = {}
  }
  render() {
      var Component = this._metadata.component;
      return React__default.cloneElement(React__default.createElement(Component, null), this.props)
  }
}
class R14Domain {
  constructor() {
      _defineProperty(this, "__r14DomainState", null), this.isUpdatingState = !1;
      makeObservable(this, {
          setState: action
      })
  }
  get model() {
      return R14.getInstance().app.mdl
  }
  get mdl() {
      return this.model
  }
  get domain() {
      return this.mdl.domain
  }
  get dm() {
      return this.domain
  }
  get entity() {
      return this.mdl.entity
  }
  get ent() {
      return this.entity
  }
  get database() {
      return this.mdl.database
  }
  get db() {
      return this.database
  }
  get query() {
      return this.db.qry
  }
  get qry() {
      return this.query
  }
  get ui() {
      return this.mdl.ui
  }
  get navigation() {
      return R14.getInstance().app.navigation
  }
  get nav() {
      return this.navigation
  }
  get api() {
      return R14.getInstance().app.api
  }
  get utilities() {
      return R14.getInstance().app.utils
  }
  get utils() {
      return this.utilities
  }
  get api() {
      return R14.getInstance().app.api
  }
  get r14() {
      return R14.getInstance()
  }
  setState(values) {
      this.isUpdatingState = !0;
      var memberStateProps = this.__r14MemberStateProps ? this.__r14MemberStateProps : {};
      for (var name in values) name in memberStateProps ? this[name] = values[name] : this.__r14DomainState && (this.__r14DomainState[name] = values[name]);
      this.isUpdatingState = !1
  }
  get state() {
      return this.getState()
  }
  getState() {
      return new Proxy(this, {
          get: function(obj, prop) {
              var r14 = R14.getInstance();
              return prop in obj.__r14DomainState ? r14.isRendering ? obj.__r14DomainState[prop] : toJS(obj.__r14DomainState[prop]) : null
          }
      })
  }
  set state(state) {
      if (this.__r14DomainState) throw "State has already been set.";
      this.__r14DomainState = observable(state)
  }
}
class R14DomainInstances extends R14Domain {
  constructor() {
      return super(), this._instances = {}, new Proxy(() => {}, {
          get: (obj, prop) => this[prop] ? this[prop] : this.exists(prop) ? this.getInstance(prop) : null,
          set: (obj, prop, value) => (this[prop] = value, !0),
          apply: (obj, context, args) => this.getInstance(args[0])
      })
  }
  addInstance(key, instance) {
      this._instances[key] = instance
  }
  removeInstance(key) {
      if (!this.exists(key)) return null;
      delete this._instances[key]
  }
  getInstance(key) {
      return this.exists(key) ? this._instances[key] : null
  }
  exists(key) {
      return !!this._instances[key]
  }
  forEach(fn) {
      for (var i in this._instances) fn(this._instances[i], i)
  }
  map(fn) {
      var res = [];
      for (var i in this._instances) res.push(fn(this._instances[i], i));
      return res
  }
  getInstances() {
      return this._instances
  }
}
class R14EntityDomain extends R14Domain {
  constructor(config) {
      if (super(), !config) throw new Error("No entity config found.");
      if (!config.name) throw new Error("Entity name required in config");
      this._entityConfig = config
  }
  formatEntityName() {
      var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
              capitalize: !1,
              plural: !1
          },
          name = options.plural ? this.entityPluralName : this.entityName;
      return options.capitalize && (name = this.utils.str.capitalize(name)), name
  }
  get entityName() {
      return this._entityConfig.name
  }
  get entityPluralName() {
      return this._entityConfig.pluralName || "".concat(this.entityName, "s")
  }
  get capitalizedEntityName() {
      return this.utils.str.capitalize(this.entityName)
  }
  fieldsToString(fields) {
      return fields ? "string" == typeof fields ? fields : this.utils.gql.fieldsToString(fields) : null
  }
  find(fields) {
      var _this = this,
          options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
      return _asyncToGenerator((function*() {
          var fieldsStr = _this.fieldsToString(fields);
          if (!fieldsStr) throw new Error("Entity Domain Find Error: No fields found");
          return options.filter || (options.filter = {}), options.totalCount || (options.totalCount = !1), options.filter.clientUid = {
              eq: _this.dm.userSession.clientUid
          }, (yield _this.api.qry("\n      query Find".concat(_this.formatEntityName({
              capitalize: !0,
              plural: !0
          }), "($page: Int, $resultsPerPage: Int, $totalCount: Boolean!, $sort: [SortOption!]!, $filter: ").concat(_this.formatEntityName({
              capitalize: !0
          }), "Filter) {\n        ").concat(_this.formatEntityName({
              plural: !0
          }), "(page: $page, resultsPerPage: $resultsPerPage, sort: $sort, filter: $filter){\n          totalCount @include(if: $totalCount)\n          nodes {\n            ").concat(fieldsStr, "\n          }\n        }\n      }"), options)).data[_this.formatEntityName({
              plural: !0
          })]
      }))()
  }
  get(uid, fields) {
      var _this2 = this;
      return _asyncToGenerator((function*() {
          var fieldsStr = _this2.fieldsToString(fields);
          if (!fieldsStr) throw new Error("Entity Domain Get Error: No fields found");
          return (yield _this2.api.qry("\n      query Get".concat(_this2.formatEntityName({
              capitalize: !0
          }), "($uid: ID!) {\n        ").concat(_this2.formatEntityName(), "(uid: $uid){\n          ").concat(fieldsStr, "\n        }\n      }"), {
              uid: uid
          })).data[_this2.formatEntityName()]
      }))()
  }
  create(values) {
      var _this3 = this,
          fields = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
      return _asyncToGenerator((function*() {
          var fieldsStr = _this3.fieldsToString(fields);
          fieldsStr || (fieldsStr = "uid");
          yield _this3.api.mutate("\n      mutation Create".concat(_this3.formatEntityName({
              capitalize: !0
          }), "($input: Create").concat(_this3.formatEntityName({
              capitalize: !0
          }), "Input!) {\n        create").concat(_this3.formatEntityName({
              capitalize: !0
          }), "(input: $input){\n          ").concat(_this3.formatEntityName(), " {\n            ").concat(fieldsStr, "\n          }\n        }\n      }"), {
              input: _this3.parseSubmitValues(values)
          });
          return !0
      }))()
  }
  update(values) {
      var _this4 = this,
          fields = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
      return _asyncToGenerator((function*() {
          var fieldsStr = _this4.fieldsToString(fields);
          fieldsStr || (fieldsStr = "uid");
          yield _this4.api.mutate("\n      mutation Update".concat(_this4.formatEntityName({
              capitalize: !0
          }), "($input: Update").concat(_this4.formatEntityName({
              capitalize: !0
          }), "Input!) {\n        update").concat(_this4.formatEntityName({
              capitalize: !0
          }), "(input: $input){\n          ").concat(_this4.formatEntityName(), " {\n            ").concat(fieldsStr, "\n          }\n        }\n      }"), {
              input: _this4.parseSubmitValues(values)
          });
          return !0
      }))()
  }
  delete(uid) {
      var _this5 = this,
          fields = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
      return _asyncToGenerator((function*() {
          var fieldsStr = _this5.fieldsToString(fields);
          fieldsStr || (fieldsStr = "uid");
          yield _this5.api.mutate("\n      mutation Delete".concat(_this5.formatEntityName({
              capitalize: !0
          }), "($uid: ID!) {\n        delete").concat(_this5.formatEntityName({
              capitalize: !0
          }), "(uid: $uid){\n          ").concat(_this5.formatEntityName(), " {\n            ").concat(fieldsStr, "\n          }\n        }\n      }"), {
              uid: uid
          });
          return !0
      }))()
  }
  fetchEditFormData() {
      var _this6 = this;
      return _asyncToGenerator((function*() {
          return yield _this6.get()
      }))()
  }
  parseSubmitValues(values) {
      return values
  }
}
class R14ThemeProvider {
  constructor(config) {
      R14.getInstance()._metadata.themeConfig = config
  }
}
var _extends = unwrapExports(createCommonjsModule((function(module) {
      function _extends() {
          return module.exports = _extends = Object.assign || function(target) {
              for (var i = 1; i < arguments.length; i++) {
                  var source = arguments[i];
                  for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
              }
              return target
          }, module.exports.default = module.exports, module.exports.__esModule = !0, _extends.apply(this, arguments)
      }
      module.exports = _extends, module.exports.default = module.exports, module.exports.__esModule = !0
  }))),
  Platform = {
      OS: "web",
      Version: 0,
      select: obj => obj.web || {}
  };
class R14Route extends R14.Domain {
  constructor(name, config, portalName) {
      var location = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
          match = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
          navigation = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
          route = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null;
      switch (super(), this._name = name, this._data = {
              params: match ? match.params : {},
              query: {},
              state: {},
              forms: {}
          }, this._app = R14.getInstance().app, this._portal = portalName, this._location = location || null, this._navigation = navigation || {}, this._routeKey = Math.random(), this._path = location && location.pathname, Platform.OS) {
          case "web":
              if (location) {
                  if (location.state)
                      for (var prop in location.state) "_r14" !== prop && (this._data.state[prop] = location.state[prop]);
                  if (location.search) {
                      var searchParams = new URLSearchParams(location.search.substring(1));
                      for (var key of searchParams.keys()) this._data.query[key] = searchParams.get(key)
                  }
              }
              var params = config.initialParams || {};
              match && match.params ? params = _extends({}, params, match.params) : navigation && navigation.state.params && (params = _extends({}, params, navigation.state.params), this._data.params = navigation.state.params), this._data.params = params;
              break;
          default:
              route && (this._data.params = route.params ? route.params : {})
      }
      if (this.ui.form.activeRouteName === this._name) {
          var submittedForm = this.ui.form.submittedForm;
          this._data.forms[submittedForm.name] = submittedForm
      }
      this._config = this._parseConfig(config || {})
  }
  createPath(pathTemplate, data) {
      var ret = pathTemplate;
      for (var param in data) {
          var key = ":".concat(param); - 1 !== ret.indexOf(key) && (ret = ret.replace(key, data[param]))
      }
      return ret
  }
  _parseConfig(initialConfig) {
      var config = _extends({}, initialConfig);
      return initialConfig.metadata && "function" == typeof initialConfig.metadata && (config.metadata = initialConfig.metadata({
          route: this,
          app: this._app
      })), initialConfig.options && (config.options = "function" == typeof initialConfig.options ? initialConfig.options({
          route: this,
          app: this._app
      }) : config.options, delete(config = _extends({}, config, config.options)).options), config
  }
  get component() {
      return this._component
  }
  setComponent(component) {
      return this._component = component, this
  }
  get location() {
      return this._location
  }
  get portal() {
      return this._portal
  }
  get params() {
      return this._data.params
  }
  get forms() {
      return this._data.forms
  }
  get query() {
      return this._data.query
  }
  get state() {
      return this._data.state
  }
  get qry() {
      return this.query
  }
  get data() {
      return _extends({}, this.metadata, this.state, this.query, this.params, this.forms)
  }
  get dt() {
      return this.data
  }
  get path() {
      return this._path
  }
  get name() {
      return this._name || null
  }
  get metadata() {
      return this._config.metadata || {}
  }
}
class R14NavigationBase extends R14.Domain {
  initializeRouterProps(props) {
      if (!props.location) throw "Navigation error, router location not found.";
      if (!props.history) throw "Navigation error, router history not found.";
      this._location = props.location, this._history = props.history, this._activePortals = {}, this.update()
  }
  getPathByRouteName(routeName) {
      if (!this._paths[routeName] && this._navigators[routeName]) {
          if (this._navigators[routeName].initialRoute) {
              var initialRoute = null;
              return initialRoute = "function" == typeof this._navigators[routeName].initialRoute ? this._navigators[routeName].initialRoute({
                  navigator: this._navigators[routeName],
                  app: R14.getInstance().app
              }) : this._navigators[routeName].initialRoute, this.getPathByRouteName(initialRoute)
          }
          return this._navigators[routeName].routes ? this.getPathByRouteName(Object.keys(this._navigators[routeName].routes)[0]) : null
      }
      return this._paths[routeName] || null
  }
  update() {
      var activeRoute = null,
          matchCount = 0,
          match = null,
          activeMatch = null;
      for (var routeName in this._paths) {
          if (match = matchPath(this._location.pathname, this._paths[routeName]), this._location.pathname === this._paths[routeName]) {
              activeRoute = routeName, this._match = match, activeMatch = match;
              break
          }
          if (match && match.isExact) {
              if (match.params) {
                  if (matchCount && Object.keys(match.params).length > matchCount) continue;
                  matchCount = Object.keys(match.params).length
              }
              activeRoute = routeName, this._match = match, activeMatch = match
          }
      }
      if (activeRoute) {
          var historyState = this._location.state,
              activePortals = {};
          if (activePortals[this.getPortalNameByRouteName(activeRoute)] = {
                  name: activeRoute,
                  path: this._location.pathname,
                  match: activeMatch
              }, historyState && historyState.portals)
              for (var _portalName in historyState.portals)
                  if (!activePortals[_portalName]) {
                      var portal = historyState.portals[_portalName];
                      if (this._paths[portal.name]) {
                          var portalMatch = matchPath(portal.path, this._paths[portal.name]);
                          activePortals[_portalName] = _extends({}, portal, {
                              match: portalMatch
                          })
                      }
                  } for (var _portalName2 in activePortals) this.initActiveRoute(activePortals[_portalName2].name, activePortals[_portalName2]);
          for (var k in this._activePortals = activePortals, this._portals) "root" === !this._portals[k].name || activePortals[this._portals[k].name] || this._portals[k].setActiveRoute(null)
      } else if ("/" === this._location.pathname) {
          var initialRoute = this.findInitialRoute(this._routesConfig);
          initialRoute && R14.getInstance().app.nav.to(initialRoute)
      }
  }
  createHistoryState(routeName, routePath) {
      var activePortal = this.getPortalByRouteName(routeName),
          ret = {
              portals: {
                  [activePortal.name]: {
                      name: routeName,
                      path: routePath
                  }
              }
          };
      for (var portalName in this._portals)
          if (!this._portals[portalName].parentPortalName && portalName !== activePortal.name && activePortal.type !== this.PORTAL_TYPE_ROOT) {
              var portal = this._portals[portalName];
              portal.activeRouteName && portal.activeRoutePath && (ret.portals[portalName] = {
                  name: portal.activeRouteName,
                  path: portal.activeRoutePath
              })
          } for (var _portalName3 in this._portals) {
          var childPortal = this._portals[_portalName3];
          childPortal.parentPortalName && (ret.portals[childPortal.parentPortalName] && (ret.portals[_portalName3] || (ret.portals[_portalName3] = {
              name: childPortal.activeRouteName,
              path: childPortal.activeRoutePath
          })))
      }
      return ret
  }
  initPortal(portalName) {
      var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if (!this._portals[portalName]) return !1;
      if (options.parentPortalName && this._portals[portalName].setParentPortalName(options.parentPortalName), this._activePortals[portalName]) this.initActiveRoute(this._activePortals[portalName].name, this._activePortals[portalName]);
      else {
          var routeConfig = this.routesConfig.routes[portalName],
              routeName = this.findInitialRoute(routeConfig);
          this.initActiveRoute(routeName)
      }
  }
  initActiveRoute(routeName) {
      var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          portal = this.getPortalByRouteName(routeName);
      if (!portal) return !1;
      var routeConfig = this.screens(routeName);
      if (routeName === portal.activeRouteName && options.path && options.path === portal.activeRoutePath) return !1;
      var location = options.location || this._location,
          match = options.match || this._match;
      if (portal.parentPortalName) {
          var _routeConfig = this.routesConfig.routes[portal.name],
              _routeName = this.findInitialRoute(_routeConfig);
          if (portal.parentPortalName && this._activePortals[portal.parentPortalName]) {
              var childRoute = this.getRouteByRouteName(_routeName),
                  childRoutePath = this.createPath(childRoute.path, this._portals[portal.parentPortalName].route.data);
              match = matchPath(childRoutePath, childRoute.path), location = {
                  pathname: childRoutePath,
                  search: "",
                  state: this._location.state
              }
          }
      }
      var route = new R14Route(routeName, routeConfig, portal.name, location, match, options.navigation);
      if (portal.setActiveRoute(route), this.setActiveRoute(route), routeConfig && routeConfig.initialParentRoute) {
          var parentRouteConfig = this.screens(routeConfig.initialParentRoute);
          if (parentRouteConfig && parentRouteConfig.portal !== routeConfig.portal) {
              var parentPortal = this.portals(parentRouteConfig.portal);
              if (parentPortal && !parentPortal.activeRouteName) {
                  var parentUrl = parentRouteConfig.path,
                      parentParams = {};
                  for (var param in portal.route.data) {
                      var key = ":".concat(param); - 1 !== parentUrl.indexOf(key) && (parentUrl = parentUrl.replace(key, portal.route.data[param]), parentParams[param] = portal.route.data[param])
                  }
                  var parentMatch = {
                          params: parentParams,
                          path: parentRouteConfig.path,
                          url: parentUrl,
                          isExact: !0
                      },
                      parentLocation = {
                          pathname: parentUrl,
                          search: "",
                          state: this._location.state
                      },
                      parentRoute = new R14Route(routeConfig.initialParentRoute, this.screens(routeConfig.initialParentRoute), parentPortal.name, parentLocation, parentMatch);
                  parentPortal.setActiveRoute(parentRoute)
              }
          }
      }
  }
}
class R14Portal extends R14.Domain {
  constructor(name, type) {
      var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      super(), this._name = name, this._data = options.data || {}, this._type = type, this._parentPortalName = null, this.state = {
          activeRouteName: options.route || null,
          activeRoutePath: options.path || null
      }
  }
  createAppInstance() {
      return new Proxy(this, {
          get: function(obj, prop) {
              switch (prop) {
                  case "route":
                  case "rt":
                      return obj.route;
                  default:
                      return R14.instance.app[prop]
              }
          }
      })
  }
  get activeRouteName() {
      return this.state.activeRouteName
  }
  get activeRoutePath() {
      return this.state.activeRoutePath
  }
  setActiveRoute(route) {
      return this.setState({
          activeRouteName: route ? route.name : null,
          activeRoutePath: route ? route.path : null
      }), this._route = route, this
  }
  setParentPortalName(parentPortalName) {
      this._parentPortalName = parentPortalName
  }
  get data() {
      return this._route ? this._route.data : {}
  }
  get route() {
      return this._route
  }
  get name() {
      return this._name
  }
  get type() {
      return this._type
  }
  get parentPortalName() {
      return this._parentPortalName
  }
}
class R14Navigation extends R14NavigationBase {
  constructor() {
      super(), this.PORTAL_TYPE_ROOT = "ROOT", this.PORTAL_TYPE_MODAL = "MODAL", this.PORTAL_TYPE_CONTAINER = "CONTAINER", this._routesConfig = null, this._routes = {}, this._screens = {}, this._paths = {}, this._navigators = {}, this._portals = {}, this._initialScreen = null, this._history = null, this._location = null, this._match = null, this._activeRouteParams = {}, this.state = {
          activeRoute: null
      }, this._currRoute = null, this._prevRoute = null
  }
  get routesConfig() {
      return this._routesConfig
  }
  routeForwarder(route) {
      var params = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return this._routesConfig.routeForwarder ? this._routesConfig.routeForwarder(route, params) : route
  }
  createPath(pathTemplate, data) {
      var ret = pathTemplate;
      for (var param in data) {
          var key = ":".concat(param); - 1 !== ret.indexOf(key) && (ret = ret.replace(key, data[param]))
      }
      return ret
  }
  setActiveRoute(route) {
      if (null !== route && route instanceof R14Route == !1) throw new Error("Active Route Error. Bad route type.");
      route && this.currRoute && route.path === this._currRoute.path || (this._prevRoute = this._currRoute, this._currRoute = route, this.setState({
          activeRouteName: route.name || null,
          activeRoutePath: route.path || null
      }))
  }
  get currRoute() {
      return this._currRoute
  }
  get prevRoute() {
      return this._prevRoute
  }
  handleBeforeLoad(appContext) {
      var _this = this;
      return _asyncToGenerator((function*() {
          var ret = !0,
              shouldActionLoadMethod = appContext._metadata.actions.shouldActionLoad || _this._navigators.r14NavRoot.shouldActionLoad,
              actionWillLoadMethod = appContext._metadata.actions.actionWillLoad || _this._navigators.r14NavRoot.actionWillLoad;
          return shouldActionLoadMethod && (ret = yield shouldActionLoadMethod({
              to: _this.currRoute,
              from: _this.prevRoute,
              app: appContext
          })), !0 === ret && actionWillLoadMethod && (yield actionWillLoadMethod({
              to: _this.currRoute,
              from: _this.prevRoute,
              app: appContext
          })), ret
      }))()
  }
  get activeRouteName() {
      return this.state.activeRouteName
  }
  get activeRoutePath() {
      return this.state.activeRoutePath
  }
  screens(key) {
      return this._screens[key] || null
  }
  portals(name) {
      return this._portals[name] || null
  }
  addPortal(name, type) {
      var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      return this._portals[name] = new R14Portal(name, type, options), this._portals[name]
  }
  removePortal(name) {
      this._portals[name] && delete this._portals[name]
  }
  navigators(key) {
      return this._navigators[key] || null
  }
  initializeRoutes(routes) {
      this._routesConfig = "function" == typeof routes ? routes() : routes, this._initNavigation(this._routesConfig)
  }
  findInitialRoute(routesConfig) {
      var initialRoute = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
      return routesConfig.initialRoute && routesConfig.routes && routesConfig.routes[routesConfig.initialRoute] ? this.findInitialRoute(routesConfig.routes[routesConfig.initialRoute], routesConfig.initialRoute) : initialRoute
  }
  _printProps(props) {
      var out = "";
      for (var prop in props) {
          if ("props" === prop) throw console.log(prop, props[prop]), new Error("Error: Navigation prop error");
          if ("type" !== prop && "routes" !== prop)
              if (prop.endsWith("Navigator")) out += this._printProps(props[prop]);
              else switch (out += "".concat(prop, "="), typeof props[prop]) {
                  case "string":
                      out += "'".concat(props[prop], "'\n");
                      break;
                  case "object":
                      out += "{".concat(JSON.stringify(props[prop]), "}\n");
                      break;
                  case "boolean":
                      out += "{".concat(props[prop] ? "true" : "false", "}\n");
                      break;
                  case "function":
                      console.log("FUNCTION", props[prop].toString()), out += "{".concat(props[prop].toString(), "}\n");
                      break;
                  default:
                      throw console.log("add type prop", prop, typeof props[prop]), new Error("sldkjf lsdkjf lksdjf")
              }
      }
      return out
  }
  _printRoute(name, route) {
      var out = "<Route\nname='".concat(name, "'\n");
      return out += this._printProps(route), out += "/>\n"
  }
  _printRoutes(name) {
      var navigator = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          out = "",
          nav = {
              name: name,
              type: null,
              props: {}
          };
      for (var prop in navigator || (navigator = this._routesConfig, nav.type = "root"), navigator) "routes" !== prop && (nav.props[prop] = navigator[prop]);
      var navTag = null;
      switch (navigator.type || "stack") {
          case "stack":
          case "container":
              navTag = "StackNavigator";
              break;
          case "tab":
              navTag = "TabNavigator";
              break;
          case "drawer":
              navTag = "DrawerNavigator";
              break;
          case "modal":
              navTag = "ModalNavigator";
              break;
          default:
              throw new Error("UNKNOWN TYPE")
      }
      if (out += "<".concat(navTag, "\n"), out += this._printProps(navigator), out += ">\n", navigator.routes)
          for (var routeName in navigator.routes) {
              var route = navigator.routes[routeName];
              route.type && route.routes && Object.keys(route.routes).length ? (console.log("route.type, route.routes", route.type, route.routes, Object.keys(route.routes).length), out += this._printRoutes(routeName, route)) : (out += this._printRoute(routeName, route), console.log("ROUTE", routeName))
          }
      return console.log("NAVIGATOR END", nav.name), out += "</".concat(navTag, ">\n")
  }
  addNavigator(navigator, name, portal, parent, routePath) {
      switch (this._navigators[name] = {
              type: navigator.type,
              portal: portal,
              routePath: [...routePath],
              parent: parent,
              routes: navigator.routes,
              initialRoute: navigator.initialRoute || null
          }, navigator.shouldActionLoad && (this._navigators[name].shouldActionLoad = navigator.shouldActionLoad), navigator.actionWillLoad && (this._navigators[name].actionWillLoad = navigator.actionWillLoad), navigator.type) {
          case "tab":
              navigator.tabNavigator && (this._navigators[name].tabNavigator = navigator.tabNavigator || {});
              break;
          case "drawer":
              navigator.drawerNavigator && (this._navigators[name].drawerNavigator = navigator.drawerNavigator || {});
              break;
          case "modal":
              navigator.header && (this._navigators[name].header = navigator.header);
              break;
          case "container":
          case "stack":
          default:
              navigator.header && (this._navigators[name].header = navigator.header)
      }
  }
  _initNavigation(routesConfig) {
      var portal = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          parent = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          routePath = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
      if (!routesConfig.routes) return null;
      for (var name in null === parent && (parent = "r14NavRoot", this.addNavigator(routesConfig, "r14NavRoot", null, null, [...routePath]), routePath.push(parent)), routesConfig.path && (this._paths[parent] = routesConfig.path), routesConfig.routes)
          if (routesConfig.routes[name].routes) {
              var childRoutePath = [...routePath];
              if (childRoutePath.push(name), "r14NavRoot" === parent) switch (routesConfig.routes[name].type) {
                  case "modal":
                      portal = "modal";
                      break;
                  case "container":
                      portal = name;
                      break;
                  default:
                      portal = "root"
              }
              this.addNavigator(routesConfig.routes[name], name, portal, parent, childRoutePath), this._initNavigation(routesConfig.routes[name], portal, name, childRoutePath)
          } else routesConfig.routes[name].path && (this._paths[name] = routesConfig.routes[name].path), this._screens[name] = _extends({
              routePath: [...routePath],
              portal: portal,
              parent: parent
          }, routesConfig.routes[name])
  }
  getPortalByRouteName(routeName) {
      var portalName = this.getPortalNameByRouteName(routeName);
      return this.portals(portalName)
  }
  getPortalNameByRouteName(routeName) {
      return this._screens[routeName] ? this._navigators[this._screens[routeName].parent].portal : this._navigators[routeName] ? this._navigators[routeName].portal : null
  }
  getRouteByRouteName(routeName) {
      return this._screens[routeName] ? this._screens[routeName] : this._navigators[routeName] ? this._navigators[routeName] : void 0
  }
  isScreenInNavigator(screen, navigator) {
      if (!this._navigators[navigator]) throw "No navigator found";
      if (!this._screens[screen]) throw "No screen found";
      return !!this._navigators[navigator].routes[screen]
  }
  getNextNavigatorName(screen, navigator) {
      if (!this._navigators[navigator]) throw "No navigator found Err 2";
      if (!this._screens[screen]) throw "No screen found Err 2";
      var foundCurr = !1;
      for (var name of this._screens[screen].routePath)
          if (name === navigator) foundCurr = !0;
          else if (foundCurr) return name;
      return null
  }
  parseNavigationProps(props) {
      var routeProps = {
          route: props.route || null,
          delay: props.delay || 0
      };
      if (!props.to) throw "Navigation props Error: No to.";
      if ("object" == typeof props.to ? (props.to.pathname ? routeProps.route = props.to.pathname : props.to.route && (routeProps.route = props.to.route), props.to.portal && (routeProps.portal = props.to.portal), props.to.state && (routeProps.state = props.to.state)) : routeProps.route = props.to, !routeProps.route) throw "Route Link Error: No pathname.";
      return routeProps
  }
  isActiveRoute(route) {
      "string" == typeof route && (route = {
          route: route,
          params: {}
      });
      var routeName = route.route;
      this.getRouteByRouteName(route.route);
      if (this.activeRouteName === routeName) return !0;
      var portal = this.getPortalByRouteName(routeName);
      if (!portal.route) return !1;
      var portalRouteName = portal.route.name;
      if (portalRouteName === routeName) return !0;
      portal.route.path;
      var portalRoute = this.getRouteByRouteName(portalRouteName);
      if (portalRoute && portalRoute.routePath && -1 !== portalRoute.routePath.indexOf(routeName)) {
          var portalRouteParams = portal.route.params;
          if (!route.params || 0 === Object.keys(route.params).length) return !0;
          for (var i in route.params)
              if (!portalRouteParams[i] || portalRouteParams[i] !== route.params[i]) return !1;
          return !0
      }
      return !1
  }
}
class R14AppNavigationBase {
  constructor(r14, app) {
      this._app = app, this._r14 = r14
  }
  back() {
      var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      this._historyAction("back", null, null, options)
  }
  openExternalUrl(url) {
      window.open(url)
  }
  open(route) {
      var params = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      this._historyAction("open", route, params)
  }
  to(route) {
      var params = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      this._historyAction("push", route, params)
  }
  navigate(route) {
      var params = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      this._historyAction("push", route, params)
  }
  replace(route, params) {
      this._historyAction("push", route, params)
  }
  push(route) {
      var params = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      this._historyAction("push", route, params)
  }
  _historyAction(action, route) {
      var params = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          options = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
          shouldLeave = !0,
          ignoreForms = options.ignoreForms || [];
      if (this._r14.app.ui.form.forEach(form => {
              if (form.onBeforeNavigation && !ignoreForms.includes(form.name) && !form.isSubmitting) {
                  if (!shouldLeave) throw new Error("[FORM ERROR] Multiple form onBeforeNavigation not supported");
                  if ("function" == typeof form.onBeforeNavigation) {
                      var formRes = form.onBeforeNavigation(form);
                      formRes ? formRes instanceof Promise ? (formRes.then(promiseFormRes => {
                          if ("string" == typeof promiseFormRes) shouldLeave = window.confirm(promiseFormRes);
                          else if (!0 === promiseFormRes) {
                              var nOpts = _extends({}, options);
                              nOpts.ignoreForms || (nOpts.ignoreForms = []), nOpts.ignoreForms.includes(form.name) || nOpts.ignoreForms.push(form.name), this._historyAction(action, route, params, nOpts)
                          }
                      }), shouldLeave = !1) : !0 === formRes || "string" == typeof formRes && (shouldLeave = window.confirm(formRes)) : shouldLeave = !1
                  } else "string" == typeof form.onBeforeNavigation && (shouldLeave = window.confirm(form.onBeforeNavigation))
              }
          }), !shouldLeave) return !1;
      if ("back" !== action) {
          var routeName = "object" == typeof route ? route.route : route,
              portal = this.getPortal(route),
              path = this.getPath(route, params),
              historyState = this._r14.navigation.createHistoryState(routeName, path);
          switch (portal.type) {
              case this._r14.navigation.PORTAL_TYPE_CONTAINER:
                  path = this._r14.navigation._location.pathname + this._r14.navigation._location.search
          }
          "open" !== action ? this._r14.navigation._history[action](path, historyState) : this.openExternalUrl(path)
      } else this._r14.navigation._history.goBack()
  }
  getPath(route) {
      var params = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      "object" == typeof route && (params = route.params || {}, route = route.route || null);
      var path = this._r14.navigation.getPathByRouteName(route);
      if (!path) throw "Could not find path for route '".concat(route, "'");
      var urlParams = [];
      if (params) {
          var paramKeys = Object.keys(params).sort((a, b) => b.length - a.length);
          for (var name of paramKeys) - 1 != path.indexOf(":".concat(name)) ? path = path.replace(":".concat(name), params[name]) : urlParams.push("".concat(name, "=").concat(params[name]));
          urlParams.length && (path = "".concat(path, "?").concat(urlParams.join("&")))
      }
      return path
  }
  getPortal(route) {
      return "object" == typeof route && (route = route.route || null), route ? this._r14.navigation.getPortalByRouteName(route) : null
  }
  updateState(state) {
      if (!this._r14.navigation._location) return !1;
      var path = this._r14.navigation._location.pathname + this._r14.navigation._location.search,
          newState = _extends({}, this.state, state);
      this._r14.navigation._history.replace(path, newState)
  }
  get state() {
      return this._r14.navigation._location.state || {}
  }
  get route() {
      var activeRoute = this._r14.navigation.activeRouteName;
      if (!activeRoute) return null;
      var route = this._r14.navigation.screens(activeRoute) || null;
      if (route && (route.name = activeRoute, "modal" === route.portal && route.initialParentRoute)) {
          var rootPortal = this._r14.navigation.portals("root");
          rootPortal.route.name && (route.initialParentRoute = rootPortal.route.name)
      }
      return route.data = this._r14.navigation.activeRouteData, route
  }
  get rt() {
      return this.route
  }
}
class AsyncStorageBase {
  static setItem(key, val) {
      return _asyncToGenerator((function*() {
          return localStorage.setItem(key, val)
      }))()
  }
  static getItem(key) {
      return _asyncToGenerator((function*() {
          return localStorage.getItem(key)
      }))()
  }
  static removeItem(key) {
      return _asyncToGenerator((function*() {
          return localStorage.removeItem(key)
      }))()
  }
  static clear() {
      return _asyncToGenerator((function*() {
          return localStorage.clear()
      }))()
  }
}
class AsyncStorage extends AsyncStorageBase {}
class R14ApiResult {
  constructor(res) {
      return this._metadata = {
          data: res.data || {},
          errors: res.errors || []
      }, new Proxy(this, {
          get: (obj, prop) => obj[prop] ? obj[prop] : "then" === prop ? void 0 : (console.warn("R14Api Warning: Accessing data '".concat(prop, "' directly from the result is being depreciated. Please use the data / error properties.")), obj.data[prop]),
          set: (obj, prop, val) => {
              console.warn("R14Api Warning: Cannot set api result values.")
          }
      })
  }
  toString() {
      return this._metadata.toString()
  }
  get data() {
      return this._metadata.data
  }
  get errors() {
      return this._metadata.errors
  }
}
class R14ApiSubscription {
  constructor(r14, requestData, callback) {
      this._r14 = r14, this._requestData = requestData, this._callback = callback, this._keys = null
  }
  subscribe() {
      var _this = this;
      return _asyncToGenerator((function*() {
          var subscriber = new Promise((resolve, reject) => {
              _this._r14.app.io.emit("subscribe", _this._requestData, data => {
                  if (data && data.keys)
                      for (var i in data.keys) _this._r14.app.io.on(data.keys[i], res => {
                          _this._callback(new R14ApiResult(res))
                      });
                  resolve(data || null)
              })
          });
          return _this._keys = yield subscriber, _this
      }))()
  }
  unsubscribe() {
      return this.off()
  }
  off() {
      if (this._keys) {
          for (var i in this._keys) this._r14.app.io.off(this._keys[i]);
          this._r14.app.io.emit("unsubscribe", {
              keys: this._keys
          })
      }
  }
}
class R14Api {
  constructor(R14, app, options) {
      if (!options.config || !options.config.api) throw "Api Error: No default config options found.";
      if (!options.config.api.url) throw "Api Error: No default config url found.";
      this._config = options.config.api, this.qry = this.query, this.mut = this.mutate, this._r14 = R14, this._qryBatch = {}, this._qryBatchTimeout = null, this._qryBatchTimeouts = {}, this._qryBatchIdx = 0, this._qryBatchTimeoutIdx = 0, this._qryBatchTimeoutKey = null, this._qryBatchResponses = {}
  }
  batch(queries) {
      var _this = this;
      return _asyncToGenerator((function*() {
          if (Array.isArray()) throw new Error("TODO ADD BATCH QURY BY ARR");
          if ("object" != typeof queries) throw new Error("Api Error: Batch must be given object or array");
          return yield _this.fetch("/graphql", {
              queries: queries
          })
      }))()
  }
  autoBatch(query, variables) {
      var _this2 = this;
      return _asyncToGenerator((function*() {
          var batchKey = "qb".concat(++_this2._qryBatchIdx);
          _this2._qryBatch[batchKey] = {
              query: query,
              variables: variables
          };
          var promise = new Promise((resolve, reject) => {
              _this2._qryBatchResponses[batchKey] = {
                  resolve: resolve,
                  reject: reject
              }
          });
          return _this2.runBatch(), promise
      }))()
  }
  runBatch() {
      var _this3 = this;
      this._qryBatchTimeoutKey || (this._qryBatchTimeoutKey = "qbt".concat(++this._qryBatchTimeoutIdx));
      var qryBatchTimeoutKey = this._qryBatchTimeoutKey;
      this._qryBatchTimeouts[qryBatchTimeoutKey] || (this._qryBatchTimeouts[qryBatchTimeoutKey] = setTimeout(_asyncToGenerator((function*() {
          _this3._qryBatchTimeoutKey = null;
          var res = yield _this3.batch(_this3._qryBatch), resData = res && res.data ? res.data : {};
          for (var k in resData) _this3._qryBatch[k] && delete _this3._qryBatch[k], _this3._qryBatchResponses[k] && (_this3._qryBatchResponses[k].resolve(new R14ApiResult(resData[k])), delete _this3._qryBatchResponses[k]);
          delete _this3._qryBatchTimeouts[qryBatchTimeoutKey]
      })), 250))
  }
  query(query) {
      var _this4 = this,
          variables = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return _asyncToGenerator((function*() {
          return yield _this4.autoBatch(query, variables)
      }))()
  }
  subscribe(query) {
      var _this5 = this,
          variables = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          callback = arguments.length > 2 ? arguments[2] : void 0;
      return _asyncToGenerator((function*() {
          var token = yield _this5._getAccessToken(), subscription = new R14ApiSubscription(_this5._r14, {
              query: query,
              variables: variables,
              accessToken: token || null
          }, callback);
          return yield subscription.subscribe()
      }))()
  }
  mutate(mutation) {
      var _this6 = this,
          variables = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return _asyncToGenerator((function*() {
          var formData = _this6.createFormData(mutation, variables),
              res = yield _this6.fetch("/graphql", formData);
          return new R14ApiResult(res)
      }))()
  }
  fetch(namespace) {
      var _this7 = this,
          data = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return _asyncToGenerator((function*() {
          var config = {
              headers: {}
          };
          (yield _this7.hasAccessToken()) && (config.headers.Authorization = "Bearer " + (yield _this7._getAccessToken()));
          return (yield axios.post(_this7.baseUrl + namespace, data, config)).data
      }))()
  }
  post(namespace, data) {
      var _this8 = this;
      return _asyncToGenerator((function*() {
          return yield _this8.fetch(namespace, data)
      }))()
  }
  createFileMap(variables) {
      var map = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          namespace = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "r14.file";
      if (variables instanceof File) return map[namespace] = variables, null;
      if (Array.isArray(variables)) return variables.forEach((variable, i) => {
          var nNamespace = namespace ? "".concat(namespace, ".").concat(i) : i;
          variables[i] = this.createFileMap(variable, map, nNamespace)
      }), variables;
      if ("object" != typeof variables) return variables;
      for (var k in variables) {
          var nNamespace = namespace ? "".concat(namespace, ".").concat(k) : k;
          variables[k] = this.createFileMap(variables[k], map, nNamespace)
      }
      return variables
  }
  createFormData(query, variables) {
      var fileMap = {};
      this.createFileMap(variables, fileMap);
      var formData = new FormData,
          ret = null;
      if (Object.keys(fileMap).length) {
          for (var k in formData.append("r14GraphQlQuery", JSON.stringify({
                  query: query,
                  variables: variables
              })), fileMap) formData.append(k, fileMap[k]);
          ret = formData
      } else ret = {
          query: query,
          variables: variables
      };
      return ret
  }
  submit(namespace, form) {
      var _this9 = this;
      return _asyncToGenerator((function*() {
          var formData = form instanceof FormData ? form : form.toFormData(),
              config = {
                  headers: {
                      "Content-Type": "multipart/form-data"
                  }
              };
          return (yield _this9.hasAccessToken()) && (config.headers.Authorization = "Bearer " + (yield _this9._getAccessToken())), (yield axios.post(_this9.baseUrl + namespace, formData, config)).data.data
      }))()
  }
  get config() {
      return this._config
  }
  get baseUrl() {
      return this.config.url
  }
  createAccessTokenRequestUri(uri) {
      var _this10 = this;
      return _asyncToGenerator((function*() {
          if (!(yield _this10.accessTokenExists())) return null;
          var accessToken = yield _this10._getAccessToken();
          return new Promise((resolve, reject) => {
              var xhr = new XMLHttpRequest;
              xhr.open("GET", uri), xhr.responseType = "blob", xhr.setRequestHeader("Authorization", "Bearer " + accessToken), xhr.onreadystatechange = () => {
                  if (xhr.readyState === xhr.DONE)
                      if (200 === xhr.status) {
                          var dataUri = URL.createObjectURL(xhr.response);
                          resolve(dataUri)
                      } else resolve(null)
              }, xhr.send()
          })
      }))()
  }
  _getAccessToken() {
      return _asyncToGenerator((function*() {
          return (yield AsyncStorage.getItem("accessToken")) || null
      }))()
  }
  setAccessToken(accessToken) {
      return _asyncToGenerator((function*() {
          return yield AsyncStorage.setItem("accessToken", accessToken), !0
      }))()
  }
  deleteAccessToken() {
      return _asyncToGenerator((function*() {
          return yield AsyncStorage.removeItem("accessToken"), !0
      }))()
  }
  accessTokenExists() {
      return _asyncToGenerator((function*() {
          return !!(yield AsyncStorage.getItem("accessToken"))
      }))()
  }
  hasAccessToken() {
      var _this11 = this;
      return _asyncToGenerator((function*() {
          return yield _this11.accessTokenExists()
      }))()
  }
}
class R14Io {
  constructor(R14, app, options) {
      if (this._socket = null, this._config = options.config && options.config.io ? options.config.io : null, this._config) {
          if (!this._config.url) throw new Error("IO Error: No default config url found.");
          this._socket = socketIOClient(this._config.url, {
              reconnection: !0,
              reconnectionDelay: 500,
              reconnectionAttempts: 10
          })
      }
  }
  on(event, callback) {
      if (!this._socket) throw new Error("IO Error: No socket connection found with on.");
      return this._socket.on(event, callback)
  }
  off(event) {
      if (!this._socket) throw new Error("IO Error: No socket connection found with off.");
      this._socket.off(event)
  }
  emit(event, data) {
      var callback = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
      if (!this._socket) throw new Error("IO Error: No socket connection found with emit.");
      this._socket.emit(event, data, callback)
  }
}
var FormValidators = {
  email: value => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(value) ? {
      success: !0,
      value: value
  } : {
      error: "Please enter a valid email."
  },
  key: value => /^\w+([\.-]?\w+)+$/.test(value) ? {
      success: !0,
      value: value
  } : {
      error: "Please enter a valid key."
  },
  username: value => {
      var isValid = value.match(/^\w+$/);
      return value = value.trim(), isValid && (value.length < 3 || value.length > 15) && (isValid = !1), isValid ? {
          success: !0,
          value: value
      } : {
          error: "Please enter a valid username.",
          value: value
      }
  },
  password: value => !(!value || value.length < 6) || {
      error: "Password must be at least 6 characters."
  },
  passwordConfirm: (value, options, form) => form.elmts.password ? form.elmts.password.value === value || {
      error: "Password Mismatch"
  } : {
      error: "Password element not found."
  },
  positiveInt: value => (value = "".concat(value), !!/^\d+$/.test(value) || {
      error: "Must be a positive whole number."
  }),
  int: value => !!(value = "".concat(value)).match(/^-{0,1}\d+$/) || {
      error: "Must be a whole number."
  },
  number: _number => !isNaN(_number) || {
      error: "Must be a whole number."
  },
  shortDate: value => {
      var t = value.split("/"),
          d = new Date(t[2] + "/" + t[0] + "/" + t[1]);
      return !(!d || d.getMonth() + 1 != t[0] || d.getDate() != Number(t[1]) || d.getFullYear() != Number(t[2])) || {
          error: "Date format MM/DD/YYYY."
      }
  },
  hexColor: hex => !!/^#([A-Fa-f0-9]{3}$)|([A-Fa-f0-9]{6}$)/.test(hex) || {
      error: "Invalid hex color."
  },
  time: value => !!(value = "".concat(value)).match(/^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/) || {
      error: "Must be a valid time."
  }
};
class FormUiDomain extends R14.DomainInstances {
  constructor() {
      super(), this._submittedForm = null, this.state = {
          activeRouteName: null
      }
  }
  create(props) {
      var form = new FormUiDomainInstance(props, this);
      return this.addInstance(props.name, form), form
  }
  remove(name) {
      this.removeInstance(name)
  }
  setSubmittedForm(form) {
      this._submittedForm = form, this.setState({
          activeRouteName: form.to.route
      })
  }
  clearSubmittedForm() {
      this._submittedForm = null, this.setState({
          activeRouteName: null
      })
  }
  get submittedForm() {
      return this._submittedForm
  }
  get activeRouteName() {
      return this.state.activeRouteName
  }
}
class FormUiDomainInstance extends R14.Domain {
  constructor(props, forms) {
      if (super(), !props.name) throw "Form Error: Form must have a name.";
      this.state = {
          redirect: !1,
          errors: []
      }, this._name = props.name, this._to = props.to || null, this._values = !1, this._initialValues = {}, this._activeColor = props.activeColor || null, this._onSubmit = props.onSubmit || null, this._onBeforeNavigation = props.onBeforeNavigation || null, this._validateBeforeSubmit = props.validateBeforeSubmit || !1, this._onValueChange = props.onValueChange || null, this._backgroundColor = props.backgroundColor || null, this._isValid = !1, this._hasMounted = !1, this._defaultValidators = FormValidators, this._validators = [], this._forms = forms, this._valid = !0, this._submitting = !1, this._app = props.app, this.elements = this.elmts = new FormElementUiDomain(this), props.validators && this.addValidators(props.validators)
  }
  remove() {
      this._forms.remove(this._name)
  }
  addElement(props) {
      var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return this.elements.add(props, options)
  }
  addValidators(validators) {
      for (var name in validators) this._validators[name] = validators[name]
  }
  removeElement(name) {
      return this.elements.remove(name)
  }
  triggerValueChange(value, element) {
      this._onValueChange && this._onValueChange(value, element, this)
  }
  submit() {
      var _this = this;
      return _asyncToGenerator((function*() {
          if (_this.submitting) return !1;
          _this.setSubmitting(!0), _this.clearErrors();
          var to = _this.to,
              ret = !0;
          if (_this._validateBeforeSubmit && !(yield _this.validate())) ret = !1;
          else if (_this._onSubmit) {
              var onSubmitRes = yield _this._onSubmit(_this);
              if (onSubmitRes) {
                  if (!React__default.isValidElement(onSubmitRes)) throw new Error("Unknown type returned from ");
                  _this.setState({
                      redirect: onSubmitRes
                  }), ret = !1
              } else !1 === onSubmitRes && (ret = !1)
          }
          if (!ret) return _this.setSubmitting(!1), !1;
          _this._forms.setSubmittedForm(_this), to.route !== _this._app.route.name ? _this._app.nav.to(to) : _this._app.nav.replace(to), console.log("SET SUBMITTING FALSE"), _this.setSubmitting(!1)
      }))()
  }
  toFormData() {
      var formData = new FormData,
          formMetadata = {
              name: this.name,
              elmts: {}
          };
      return this.elmts.forEach(elmt => {
          formMetadata.elmts[elmt.name] = {}, formData.append(elmt.name, elmt.value)
      }), formData.append("_r14FormMetadata", JSON.stringify(formMetadata)), formData
  }
  get name() {
      return this._name
  }
  get activeColor() {
      return this._activeColor
  }
  get theme() {
      return this._theme
  }
  get onBeforeNavigation() {
      return this._onBeforeNavigation
  }
  get backgroundColor() {
      return this._backgroundColor
  }
  get to() {
      var to = null;
      if (this._to) to = "object" == typeof this._to ? this._to : {
          route: this._to
      };
      else {
          var route = this._app.route;
          to = {
              route: this._app.route.name,
              params: route ? _extends({}, route.query, route.params) : {}
          }, this._to = to
      }
      return to
  }
  get routeName() {
      return this.to.route
  }
  get values() {
      var ret = {};
      return this.elements.forEach(elmt => {
          ret[elmt.name] = elmt.parseValue()
      }), ret
  }
  get initialValues() {
      return this._initialValues
  }
  get hasMounted() {
      return this._hasMounted
  }
  get isSubmitting() {
      return this._submitting
  }
  get submitting() {
      return this._submitting
  }
  setSubmitting(submitting) {
      return this._submitting = submitting, this
  }
  handleMount(values) {
      return this._hasMounted = !0, this.setInitialValues(values)
  }
  setInitialValues(values) {
      return this._initialValues = values, this.setValues(values), this
  }
  setValues(values) {
      for (var name in values) this.elmts[name] && this.elmts[name].setValue(values[name]);
      return this.clearErrors(), this
  }
  reset() {
      return this.elements.forEach(elmt => {
          elmt.setValue(null)
      }), this.clearErrors(), this
  }
  get errors() {
      return this.state.errors
  }
  get validators() {
      return this._validators
  }
  setErrors(errors) {
      this.setState({
          errors: errors
      })
  }
  clearErrors() {
      this.setErrors([])
  }
  addError(error) {
      var errors = this.state.errors;
      errors.push(error), this.setErrors(errors)
  }
  addErrors(errors) {
      this.setErrors(_extends({}, this.state.errors, errors))
  }
  isValid() {
      var _this2 = this;
      return _asyncToGenerator((function*() {
          return _this2._isValid
      }))()
  }
  validate() {
      var _this3 = this;
      return _asyncToGenerator((function*() {
          _this3._valid = !0;
          var elmts = _this3.elmts.getInstances();
          for (var n in elmts) {
              var elmt = elmts[n];
              yield elmt.validate(), elmt.isValid || (_this3._valid = !1)
          }
          return _this3._valid
      }))()
  }
}
class FormElementUiDomain extends R14.DomainInstances {
  constructor(form) {
      super(), this._form = form
  }
  add(props) {
      var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          element = new FormElementUiDomainInstance(this._form, props, options);
      return this.addInstance(props.name, element), element
  }
  remove(name) {
      return this.removeInstance(name), this
  }
}
class FormElementUiDomainInstance extends R14.Domain {
  constructor(form, props) {
      var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if (super(), !props.name) throw "Form Error: Form element must have a name.";
      this._form = form, this._name = props.name, this._label = props.label || null, this._helper = props.helper || null, this._required = props.required || !1, this._ref = React__default.createRef(), this._eventListeners = {}, this._valueLabels = {}, this._valueParser = props.valueParser || null, this._useTextValue = options.useTextValue || !1;
      var validators = props.validators || props.validator || !1;
      validators && !Array.isArray(validators) && "object" != typeof validators && (validators = [validators]);
      var initialValue = null;
      this._form.hasMounted && this._form.initialValues[this._name] && (initialValue = this._form.initialValues[this._name]), this._validators = validators, this.state = {
          valid: !1,
          value: props.value || initialValue || null,
          textValue: props.textValue || null,
          focus: props.focus || !1,
          blur: props.blur || !1,
          disabled: props.disabled || !1,
          autoFill: !1,
          error: !1,
          success: !1,
          items: props.items || props.children || [],
          loading: !1
      }
  }
  get form() {
      return this._form
  }
  get value() {
      return this.state.value
  }
  set value(value) {
      return this.setValue(value)
  }
  get textValue() {
      return this.state.textValue
  }
  set textValue(value) {
      return this.setTextValue(value)
  }
  validate() {
      var _this4 = this,
          options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return _asyncToGenerator((function*() {
          var val = options.useTextValue ? _this4.textValue : _this4.value;
          if (_this4.valid = !1, _this4.error = !1, _this4.success = !1, _this4.isRequired || _this4.validator)
              if (_this4.isRequired && (!val || "string" == typeof val && "" === val.trim() || "object" == typeof val && 0 === val.length)) _this4.valid = !1, _this4.error = "string" == typeof _this4.isRequired ? _this4.isRequired : "Required";
              else if (_this4.isRequired || null !== val && ("string" != typeof val || "" !== val.trim()))
              if (_this4.validator) {
                  var validator = {};
                  for (var i in "string" == typeof _this4.validator ? validator[_this4.validator] = !0 : Array.isArray(_this4.validator) ? _this4.validator.map(value => {
                          "string" == typeof value ? validator[_this4.validator] = !0 : "object" == typeof value ? validator = _extends({}, validator, value) : validator[value] = !0
                      }) : validator = _this4.validator, validator) {
                      var opts = "object" == typeof validator[i] ? validator[i] : {},
                          validatorFn = null;
                      if (_this4.form._validators[i]) validatorFn = _this4.form._validators[i];
                      else {
                          if (!_this4.form._defaultValidators[i]) throw "Unable to find validator: '" + i + "'";
                          validatorFn = _this4.form._defaultValidators[i]
                      }
                      var rslt = !1;
                      if (!options.useTextValue && _this4._useTextValue && Array.isArray(val)) {
                          var nVals = [];
                          for (var _i in val) {
                              if (!0 !== (rslt = yield validatorFn(val[_i], opts, _this4, _this4.form)) && !rslt.success) break;
                              nVals.push(rslt.value || val[_i])
                          }(!0 === rslt || rslt.success) && (_this4.value = nVals)
                      } else rslt = yield validatorFn(val, opts, _this4, _this4.form);
                      if (!rslt) {
                          _this4.valid = !1, _this4.error = "Unknown Validation Error";
                          break
                      }
                      if (!0 === rslt) _this4.valid = !0, _this4.error = "";
                      else {
                          if (rslt.error) {
                              _this4.valid = !1, _this4.error = "string" == typeof rslt.error ? rslt.error : "Not Valid";
                              break
                          }
                          rslt.success && (_this4.valid = !0, _this4.success = "string" == typeof rslt.success ? rslt.success : "")
                      }
                      rslt.value && (options.useTextValue ? _this4.textValue = rslt.value : _this4._useTextValue || (_this4.value = rslt.value))
                  }
              } else _this4.valid = !0;
          else _this4.valid = !0;
          else _this4.valid = !0;
          return _this4.isValid ? _this4.error = !1 : _this4.success = !1, !!_this4.isValid || {
              error: _this4.error
          }
      }))()
  }
  parseValue() {
      return this._valueParser ? this._valueParser(this.value) : this.value
  }
  setValue(value) {
      var hasChanged = value !== this.state.value;
      return this.setState({
          value: value
      }), hasChanged && this._triggerEventListener("change"), this
  }
  setTextValue(textValue) {
      var hasChanged = textValue !== this.state.textValue;
      return this.setState({
          textValue: textValue
      }), hasChanged && this._triggerEventListener("change"), this
  }
  get items() {
      return this.state.items
  }
  set items(items) {
      return this.setItems(items)
  }
  setItems(items) {
      return this.setState({
          items: items
      }), this
  }
  setLoading(isLoading) {
      this.setState({
          loading: isLoading
      })
  }
  get isLoading() {
      return this.state.loading
  }
  get loading() {
      return this.state.loading
  }
  select() {
      return this.focus(), this.ref.current && this.ref.current.select && this.ref.current.select(), this
  }
  focus() {
      return this.setFocus(!0)
  }
  setFocus(focus) {
      return this.ref.current && this.ref.current.focus && this.ref.current.focus(), this.setState({
          focus: focus,
          blur: !focus
      }), this._triggerEventListener("focus"), this
  }
  get isFocused() {
      return this.state.focus
  }
  blur() {
      return this.setBlur(!0)
  }
  setBlur(blur) {
      return this.setState({
          blur: blur,
          focus: !blur
      }), this._triggerEventListener("blur"), this
  }
  get isBlurred() {
      return this.blur
  }
  setAutoFill(autoFill) {
      this.setState({
          autoFill: autoFill
      })
  }
  get hasAutoFill() {
      return this.state.autoFill
  }
  get name() {
      return this._name
  }
  get label() {
      return this._label
  }
  get disabled() {
      return this.state.disabled
  }
  set disabled(disabled) {
      return this.setDisabled(disabled)
  }
  setDisabled(disabled) {
      return this.setState({
          disabled: disabled
      }), disabled ? this._triggerEventListener("disabled") : this._triggerEventListener("enabled"), this
  }
  get isDisabled() {
      return this.state.disabled
  }
  get isRequired() {
      return this._required
  }
  get validator() {
      return this.validators
  }
  get validators() {
      return this._validators
  }
  set validators(validators) {
      this._validators = validators
  }
  get isActive() {
      var val = this._useTextValue ? this.textValue : this.value;
      return !!(this.hasAutoFill || this.isFocused || val)
  }
  addValidators(validators) {
      for (var name in validators) this._validators[name] = validators[name]
  }
  setError(error) {
      return this.setState({
          error: error
      }), error && this._triggerEventListener("error"), this
  }
  set error(error) {
      return this.setError(error)
  }
  get error() {
      return this.state.error
  }
  get helper() {
      return this._helper
  }
  setSuccess(success) {
      return this.setState({
          success: success
      }), success && this._triggerEventListener("success"), this
  }
  set success(success) {
      return this.setSuccess(success)
  }
  get success() {
      return this.state.success
  }
  get valid() {
      return this.state.valid
  }
  set valid(valid) {
      return this.setValid(valid)
  }
  setValid(valid) {
      return this.setState({
          valid: valid
      }), valid && this._triggerEventListener("valid"), this
  }
  get isValid() {
      return this.valid
  }
  get ref() {
      return this._ref
  }
  set ref(ref) {
      return this._ref = ref, this
  }
  addEventListener(type, callback) {
      this._eventListeners[type] || (this._eventListeners[type] = []), this._eventListeners[type].push(callback)
  }
  _triggerEventListener(type) {
      this._eventListeners[type] && this._eventListeners[type].forEach(callback => {
          callback(type, this, this._form)
      })
  }
  remove() {
      this._form.removeElement(this._name)
  }
}
class KeyMapperUiDomain extends R14.DomainInstances {
  constructor() {
      super(), this.handleKeyUp = this.handleKeyUp.bind(this), this._keyDownKeys = {}, this._initialized = !1
  }
  handleKeyUp(e) {
      var key = this.getKeyByEvent(e);
      key && this._keyDownKeys[key] && delete this._keyDownKeys[key]
  }
  addKeyDownKey(key) {
      this._keyDownKeys[key] = !0
  }
  isKeyDown(key) {
      return this._keyDownKeys[key] || !1
  }
  initialize() {
      document.addEventListener("keyup", this.handleKeyUp), this._initialized = !0
  }
  create(name) {
      var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      this._initialized || this.initialize();
      var keyMapper = new KeyMapperUiDomainInstance(name, options, this);
      return this.addInstance(name, keyMapper), keyMapper
  }
  instance(name) {
      var _this = this,
          options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return _asyncToGenerator((function*() {
          return _this.exists(name) ? _this.getInstance(name) : _this.create(name, options)
      }))()
  }
  getKeyByEvent(e) {
      if (!e) return null;
      var key = e.key || e.nativeEvent && e.nativeEvent.key || null;
      return key ? ("Control" !== key && e.ctrlKey && (key = "Ctrl".concat(key)), "Alt" !== key && e.altKey && (key = "Alt".concat(key)), "Shift" !== key && e.shiftKey && (key = "Shift".concat(key)), key) : null
  }
  disconnect(name) {
      this.remove(name)
  }
  remove(name) {
      if (this.exists(name)) {
          var keyMapper = this.getInstance(name);
          keyMapper.isConnected ? keyMapper.disconnect() : this.removeInstance(name)
      }
  }
}
class KeyMapperUiDomainInstance extends R14.Domain {
  constructor(name, options, keyMapperUiDomain) {
      super(), this.handleKeyDown = this.handleKeyDown.bind(this), this._KeyMapperUiDomain = keyMapperUiDomain, this._actions = {}, this._options = options, this._keys = {}, this._onkeyDown = [], this._name = name, this._isConnected = !1, this._keyDownKeys = {}, this.init()
  }
  init() {
      document.addEventListener("keydown", this.handleKeyDown), this._isConnected = !0
  }
  get isConnected() {
      return this._isConnected
  }
  get name() {
      return this._name
  }
  onKeyDown(callback) {
      return this._onkeyDown.push(callback), this
  }
  addAction(name, keys, callback) {
      var options = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      for (var key of (this._actions[name] = _extends({
              keys: keys,
              callback: callback
          }, options), Array.isArray(keys) || (keys = [keys]), keys)) this._keys[key] || (this._keys[key] = []), this._keys[key].includes(name) || this._keys[key].push(name);
      return this
  }
  isActionKey(key) {
      return !!this._keys[key]
  }
  handleKeyDown(e) {
      var key = this._KeyMapperUiDomain.getKeyByEvent(e);
      if (key) {
          var triggerKeyDown = !1,
              triggerActions = [];
          if (this._keys[key]) {
              for (var actionName of this._keys[key])
                  if (this._actions[actionName]) {
                      if (!1 === this._options.repeat || !1 === this._actions[actionName].repeat) {
                          if (this._KeyMapperUiDomain.isKeyDown(key)) {
                              e.preventDefault(), e.stopPropagation();
                              continue
                          }
                          this._KeyMapperUiDomain.addKeyDownKey(key)
                      }
                      triggerKeyDown = !0, !triggerActions.includes(actionName) && triggerActions.push(actionName)
                  }
          } else triggerKeyDown = !0;
          if (triggerKeyDown && this._onkeyDown.length)
              for (var callback of this._onkeyDown) callback({
                  key: key,
                  e: e
              });
          triggerActions.forEach(actionName => {
              this._actions[actionName].callback({
                  key: key,
                  e: e,
                  actionName: actionName
              })
          })
      }
  }
  disconnect() {
      document.removeEventListener("keydown", this.handleKeyDown), this._isConnected = !1, this.ui.keyMapper.remove(this.name)
  }
  getInfo() {
      var info = {
          name: this.name,
          actions: {}
      };
      for (var actionName in this._actions) info.actions[actionName] = this.getActionInfo(actionName);
      return info
  }
  getActionInfo(actionName) {
      var action = this._actions[actionName];
      if (!action) return null;
      var info = {
          name: actionName,
          label: action.label || null,
          keys: []
      };
      for (var key of action.keys) info.keys.push({
          key: key,
          label: this.getKeyLabel(key)
      });
      return info
  }
  getActionKeyLabels(actionName) {
      return this._actions[actionName] ? this._actions[actionName].keys.map(key => this.getKeyLabel(key)) : null
  }
  getKeyLabel(key) {
      var label = key,
          prefixArr = [],
          prefixLen = 0;
      return ["Ctrl", "Shift", "Alt"].forEach(val => {
          -1 !== label.indexOf(val) && label !== val && (prefixArr.push("".concat(val, " + ")), prefixLen += val.length)
      }), prefixLen && (label = label.substring(prefixLen)), label = this.utils.str.fromCamelCase(label), prefixArr.length && (label = "".concat(prefixArr.join("")).concat(label)), label
  }
}
class DraggableUiDomain extends R14.DomainInstances {
  create(props) {
      if (!props.name) throw "Draggable Error: Must have a name.";
      var draggableInstance = new DraggableUiInstance(props, this);
      return this.addInstance(props.name, draggableInstance), draggableInstance
  }
  remove(name) {
      this.removeInstance(name)
  }
}
class DraggableUiInstance extends R14.DomainInstances {
  constructor(props, containers) {
      super(), this._containers = containers, this._props = props, this._activeView = null, this._measure = null, this._layout = null, this.state = {
          activeViewName: null,
          x: null,
          y: null,
          height: null,
          width: null,
          layout: null
      }
  }
  remove() {
      this._containers.removeInstance(this._props.name)
  }
  setActiveView() {
      var view = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
      this.setState({
          activeViewName: view ? view.name : null
      }), this._activeView = view || null
  }
  get active() {
      return !!this.state.activeViewName
  }
  get activeView() {
      return this._activeView || null
  }
  handleMeasure(measure) {
      this.setState(_extends({}, measure))
  }
  addView(props) {
      if (!props.name) throw "Draggable View Error: Must have a name.";
      var draggableInstance = new DraggableViewUiInstance(props, this);
      return this.addInstance(props.name, draggableInstance), draggableInstance
  }
  removeView(name) {
      return this.removeInstance(name), this
  }
  handlePressCancel(event) {
      this.active && (this.activeView.handleContainerPressCancel(event), this.setActiveView(null))
  }
  handlePressMove(event) {
      console.log("press move"), this.active && this.activeView.handleContainerPressMove(event)
  }
}
class DraggableViewUiInstance extends R14.Domain {
  constructor(props, container) {
      super(), this.DRAG_TYPE_MOVE = "MOVE", this.DRAG_TYPE_RESIZE_RIGHT = "RESIZE_RIGHT", this.DRAG_TYPE_RESIZE_LEFT = "RESIZE_LEFT", this.DRAG_TYPE_RESIZE_TOP = "RESIZE_TOP", this.DRAG_TYPE_RESIZE_BOTTOM = "RESIZE_BOTTOM", this.DRAG_TYPE_RESIZE_TOP_RIGHT = "RESIZE_TOP_RIGHT", this.DRAG_TYPE_RESIZE_TOP_LEFT = "RESIZE_TOP_LEFT", this.DRAG_TYPE_RESIZE_BOTTOM_RIGHT = "RESIZE_BOTTOM_RIGHT", this.DRAG_TYPE_RESIZE_BOTTOM_LEFT = "RESIZE_BOTTOM_LEFT", this._props = props, this._container = container, this._pressInEvent = null, this._dragType = null, this._resizeTargetSize = 4, this.state = {
          dragX: 0,
          dragY: 0,
          resizeHeight: null,
          resizeWidth: null,
          layout: null
      }, this._styleOnDrag = null
  }
  remove() {
      this._container.removeInstance(this.name)
  }
  get name() {
      return this.props.name
  }
  get props() {
      return this._props
  }
  get active() {
      return this._container.state.activeViewName === this.name
  }
  get styleOnDrag() {
      return this._styleOnDrag
  }
  get container() {
      return this._container
  }
  get pressInEvent() {
      return this._pressInEvent
  }
  get dragType() {
      return this._dragType
  }
  get props() {
      return this._props
  }
  get dragX() {
      return this.state.dragX
  }
  get dragY() {
      return this.state.resizeWidth
  }
  get resizeWidth() {
      return this.state.resizeHeight
  }
  get resizeHeight() {
      return this.state.dragY
  }
  get layout() {
      return this.state.layout
  }
  setPressInEvent(event) {
      this._pressInEvent = event
  }
  setDragType(dragType) {
      this._dragType = dragType
  }
  setLayout(layout) {
      var currLayout = this.state.layout || {};
      this.setState({
          layout: _extends({}, currLayout, layout)
      })
  }
  normalizeEvent(event) {
      var nativeEvent = event.nativeEvent || {};
      return nativeEvent.translationX = this.state.dragX, nativeEvent.translationY = this.state.dragY, nativeEvent.height = this.state.resizeHeight || this.props.height || this.state.layout.height || null, nativeEvent.width = this.state.resizeWidth || this.props.width || this.state.layout.width || null, {
          nativeEvent: nativeEvent
      }
  }
  handlePressIn(event) {
      event = this.normalizeEvent(event);
      var dragType = this.calculateDragType(event);
      this.setDragType(dragType), this.setPressInEvent(event), this.container.setActiveView(this), this.props.onDragStart && this.props.onDragStart(event, this)
  }
  calculateDragType(event) {
      var pos = event.nativeEvent || null,
          locationX = pos.locationX,
          locationY = pos.locationY;
      return locationX <= this._resizeTargetSize && locationY >= this.layout.height - this._resizeTargetSize ? this.DRAG_TYPE_RESIZE_BOTTOM_LEFT : locationX <= this._resizeTargetSize && locationY <= this._resizeTargetSize ? this.DRAG_TYPE_RESIZE_TOP_LEFT : locationX <= this._resizeTargetSize ? this.DRAG_TYPE_RESIZE_LEFT : locationX >= this.layout.width - this._resizeTargetSize && locationY >= this.layout.height - this._resizeTargetSize ? this.DRAG_TYPE_RESIZE_BOTTOM_RIGHT : locationX >= this.layout.width - this._resizeTargetSize && locationY <= this._resizeTargetSize ? this.DRAG_TYPE_RESIZE_TOP_RIGHT : locationX >= this.layout.width - this._resizeTargetSize ? this.DRAG_TYPE_RESIZE_RIGHT : locationY <= this._resizeTargetSize ? this.DRAG_TYPE_RESIZE_TOP : locationY >= this.layout.height - this._resizeTargetSize ? this.DRAG_TYPE_RESIZE_BOTTOM : this.DRAG_TYPE_MOVE
  }
  calculateDragLayout(event) {
      var ret = {
              dragX: 0,
              dragY: 0,
              resizeHeight: null,
              resizeWidth: null
          },
          dragX = event.nativeEvent.pageX - this.pressInEvent.nativeEvent.pageX,
          dragY = event.nativeEvent.pageY - this.pressInEvent.nativeEvent.pageY;
      switch (this.dragType) {
          case this.DRAG_TYPE_RESIZE_LEFT:
              ret.resizeWidth = this.layout.width + -1 * dragX, ret.dragX = dragX;
              break;
          case this.DRAG_TYPE_RESIZE_RIGHT:
              ret.resizeWidth = this.layout.width + dragX;
              break;
          case this.DRAG_TYPE_RESIZE_TOP:
              ret.resizeHeight = this.layout.height + -1 * dragY, ret.dragY = dragY;
              break;
          case this.DRAG_TYPE_RESIZE_BOTTOM:
              ret.resizeHeight = this.layout.height + dragY;
              break;
          case this.DRAG_TYPE_RESIZE_TOP_LEFT:
              ret.resizeWidth = this.layout.width + -1 * dragX, ret.resizeHeight = this.layout.height + -1 * dragY, ret.dragY = dragY, ret.dragX = dragX;
              break;
          case this.DRAG_TYPE_RESIZE_TOP_RIGHT:
              ret.resizeWidth = this.layout.width + dragX, ret.resizeHeight = this.layout.height + -1 * dragY, ret.dragY = dragY;
              break;
          case this.DRAG_TYPE_RESIZE_BOTTOM_RIGHT:
              ret.resizeWidth = this.layout.width + dragX, ret.resizeHeight = this.layout.height + dragY;
              break;
          case this.DRAG_TYPE_RESIZE_BOTTOM_LEFT:
              ret.resizeWidth = this.layout.width + -1 * dragX, ret.resizeHeight = this.layout.height + dragY, ret.dragX = dragX;
              break;
          default:
              ret.dragX = dragX, ret.dragY = dragY
      }
      return ret
  }
  handlePressOut(event) {
      event = this.normalizeEvent(event), this.setPressInEvent(null), this.setDragType(null), this.reset(), this.props.onDragEnd && this.props.onDragEnd(event, this)
  }
  handleContainerPressCancel(event) {
      event = this.normalizeEvent(event), this.reset(), this.props.onDragCancel && this.props.onDragCancel(event, this)
  }
  handleContainerPressMove(event) {
      if (event = this.normalizeEvent(event), console.log("HANDL CONTAINER PRESS MOVE", event), this.active) {
          var dragLayout = this.calculateDragLayout(event);
          this.props.styleOnDrag && (this._styleOnDrag = this.props.styleOnDrag(event, this) || null), this.setState(dragLayout), this.props.onDrag && this.props.onDrag(event, this)
      }
  }
  handleLayout(event) {
      this.state.layout && this.active || this.setState({
          layout: event && event.nativeEvent ? event.nativeEvent.layout : null
      })
  }
  handleMeasure(x, y, width, height, pageX, pageY) {
      this._measure = {
          x: x,
          y: y,
          width: width,
          height: height,
          pageX: pageX,
          pageY: pageY
      }
  }
  reset() {
      this.setState({
          dragX: 0,
          dragY: 0,
          resizeHeight: null,
          resizeWidth: null
      }), this._styleOnDrag = null, this.container.setActiveView(null)
  }
}
class ThemeUiDomain {
  constructor() {
      this._config = {}, this._key = null, this._theme = {}, this.initializeDefault(), this._config = R14.getInstance()._metadata.themeConfig
  }
  initializeDefault() {
      if (!themeConfig) throw new Error("Theme Error: No theme config found.");
      var key = Object.keys(themeConfig)[0] || null;
      this._config = _extends({}, themeConfig);
      var theme = this._config[key] || null;
      this._key = key, this._theme = theme
  }
  initialize(themeConfig) {
      var _this = this;
      return _asyncToGenerator((function*() {
          if (!themeConfig) throw new Error("Theme Error: No theme config found.");
          var key = Object.keys(themeConfig)[0] || null;
          _this._config = _extends({}, themeConfig);
          var theme = _this._config[key] || null,
              themeJson = yield AsyncStorage.getItem("r14AppTheme"), storThemeInfo = null;
          themeJson && (key = (storThemeInfo = JSON.parse(themeJson)).key, _this._config[key] && _this._config[key].colors ? theme.colors = _this._config[key].colors : storThemeInfo.theme && (theme = storThemeInfo.theme)), _this._key = key, _this._theme = theme
      }))()
  }
  get colors() {
      return new Proxy(this, {
          get: function(obj, prop) {
              return new ThemeColorValue(obj, "color", prop)
          }
      })
  }
  get components() {
      return console.log("get components", this._theme.components), this._theme.components
  }
  componentColors(componentKey) {
      var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return new Proxy(this, {
          get: (obj, prop) => new ThemeColorValue(obj, "color", prop, componentKey, options)
      })
  }
  componentOptions(componentKey) {
      return this._theme.components && this._theme.components[componentKey] && this._theme.components[componentKey].options ? this._theme.components[componentKey].options : {}
  }
  setTheme(key) {
      var theme = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
              reload: !0
          };
      if (theme || (theme = this.config[key] || null), !theme) throw new Error("Theme Error: No theme found with key ".concat(key));
      AsyncStorage.setItem("r14AppTheme", JSON.stringify({
          key: key,
          theme: this._config[key] ? null : theme
      })), this._key = key, this._theme = theme, options && options.reload && window && window.location.reload()
  }
  get config() {
      return this._config || null
  }
  get theme() {
      return this._theme
  }
  get key() {
      return this._key
  }
}
class DimensionsBase {
  static get(dim) {
      return {
          width: window.innerWidth,
          height: window.innerHeight
      }
  }
  static addEventListener(type, handler) {
      if ("change" !== type) throw new Error("Dimensions Error: Unknown type ".concat(type, "."));
      window.addEventListener("resize", () => {
          DimensionsBase._handler(type, handler)
      })
  }
  static removeEventListener(type, handler) {
      window.removeEventListener("resize", () => {
          DimensionsBase._handler(type, handler)
      })
  }
  static _handler(type, handler) {
      var dimensions = {
          width: window.innerWidth,
          height: window.innerHeight
      };
      handler({
          window: dimensions,
          screen: dimensions
      })
  }
}
class StyleSheetBase extends R14.Domain {
  constructor(styles) {
      super();
      var {
          height: height,
          width: width
      } = DimensionsBase.get("window");
      return this.state = {
          height: height,
          width: width
      }, this._styles = styles, this._parsedStyles = null, this._hasScreenListener = !1, new Proxy(this, {
          get: (obj, prop) => {
              this._styles[prop] && this._styles[prop].screen && this.state.height && this.state.width;
              var styles = this._parse(this._styles);
              if (styles["::placeholder"]) throw new Error("SLDKJF");
              return this._parsedStyles || (this._parsedStyles = StyleSheet$1.create(styles)), obj._parsedStyles[prop]
          }
      })
  }
  static create(styles) {
      return new StyleSheetBase(styles)
  }
  static className(styles) {
      return css(styles)
  }
  _parse(styles) {
      var nStyles = {};
      for (var name in styles)
          if (styles[name]) {
              var style = this._parseStyle(styles[name]);
              null != style && (nStyles[name] = style)
          } return nStyles
  }
  _parseStyle(style) {
      if (!style) return null;
      var nStyle = {};
      for (var p in style) style[p] instanceof ThemeColorValue ? nStyle[p] = style[p].toString() : nStyle[p] = style[p];
      if ("flex" in (nStyle = this._parseElevation(nStyle)) && (nStyle.display = "flex", nStyle.flexGrow = nStyle.flex, delete nStyle.flex, "flexDirection" in nStyle || (nStyle.flexDirection = "column")), "lineHeight" in nStyle && "number" == typeof nStyle.lineHeight && (nStyle.lineHeight = "".concat(nStyle.lineHeight, "px")), nStyle.screen) {
          var screenStyle = this._parseStyle(this._parseScreen(nStyle.screen));
          delete(nStyle = _extends({}, nStyle, screenStyle)).screen
      }
      return nStyle.placeholder && delete(nStyle = _extends({}, nStyle, {
          ":placeholder": this._parseStyle(nStyle.placeholder)
      })).placeholder, nStyle.animationName && (nStyle.animationName = this._parse(nStyle.animationName)), nStyle.hover && delete(nStyle = _extends({}, nStyle, {
          ":hover": this._parseStyle(nStyle.hover)
      })).hover, nStyle.transform && (nStyle.transform = StyleSheetBase.utils.renderCssTransformStr(nStyle.transform)), nStyle
  }
  _parseScreen(handler) {
      return this._hasScreenListener || (this._hasScreenListener = !0, DimensionsBase.addEventListener("change", _ref => {
          var {
              window: window
          } = _ref;
          this.setState({
              height: window.height,
              width: window.width
          }), this._parsedStyles = StyleSheet$1.create(this._parse(this._styles))
      })), handler({
          height: this.state.height,
          width: this.state.width
      })
  }
  _parseElevation(style) {
      if ("elevation" in style) {
          var elevationMap = ["0px 0px 0px 0px", "0px 1px 2px 1px", "0px 1px 3px 1px", "0px 1px 4px 1px", "0px 1px 6px 1px", "0px 1px 8px 1px", "0px 1px 10px 1px", "0px 2px 11px 1px", "0px 2px 12px 1px", "0px 2px 14px 1px", "0px 2px 15px 1px", "0px 2px 16px 1px", "0px 2px 17px 2px"];
          if (elevationMap[style.elevation]) {
              var alpha = ".24";
              switch (style.elevation) {
                  case 1:
                      alpha = ".15";
                      break;
                  case 2:
                  case 3:
                  case 4:
                      alpha = ".2"
              }
              style.boxShadow = "".concat(elevationMap[style.elevation], " rgba(0, 0, 0, ").concat(alpha, ")")
          }
          delete style.elevation
      }
      return style
  }
}
_defineProperty(StyleSheetBase, "absoluteFill", {
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}), _defineProperty(StyleSheetBase, "utils", {
  renderCssTransformStr: transform => {
      if ("string" == typeof transform) return transform;
      var transformArr = [];
      return transform.forEach(trans => {
          for (var t in trans) {
              var val = trans[t];
              if ("string" != typeof val) switch (t) {
                  case "scale":
                      break;
                  default:
                      val = "".concat(val, "px")
              }
              transformArr.push("".concat(t, "(").concat(val, ")"))
          }
      }), transformArr.length ? transformArr.join(" ") : null
  }
});
class StyleSheet extends StyleSheetBase {
  static color(hex) {
      return new Color(hex)
  }
  static margin(top) {
      var right = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          bottom = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          left = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
      return null === right && (right = bottom = left = top), {
          margin: 0,
          marginTop: top,
          marginRight: right,
          marginBottom: bottom,
          marginLeft: left
      }
  }
  static padding(top) {
      var right = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          bottom = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          left = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
      return null === right && (right = bottom = left = top), {
          padding: 0,
          paddingTop: top,
          paddingRight: right,
          paddingBottom: bottom,
          paddingLeft: left
      }
  }
  static border(width, style, color) {
      return {
          borderWidth: width,
          borderColor: color,
          borderStyle: style
      }
  }
  static parseColor(color) {
      return color instanceof ThemeColorValue ? color.toString() : color
  }
}
class Color {
  constructor(hex) {
      if (this._hex = null, hex instanceof ThemeColorValue) this._themeColorValue = hex;
      else {
          if (!this.validate(hex)) throw "Invalid color ".concat(hex);
          this._hex = hex
      }
      this._alpha = 1
  }
  hex() {
      return this._hex
  }
  rgba() {
      var alpha = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
      return this._themeColorValue ? (this._themeColorValue.setOption("alpha", alpha), this._themeColorValue) : Color.hexToRgba(this._hex, alpha)
  }
  static hexToRgba(hex, alpha) {
      var color = hex;
      "object" == typeof color && (color = color.toString()), color = color.replace("#", "");
      var r = parseInt(color.substring(0, 2), 16),
          g = parseInt(color.substring(2, 4), 16),
          b = parseInt(color.substring(4, 6), 16);
      return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")")
  }
  validate(hex) {
      return /^#([A-Fa-f0-9]{3}$)|([A-Fa-f0-9]{6}$)/.test(hex)
  }
}
var Theme = new Proxy((function() {}), {
  get: (obj, prop) => getThemeInstance()[prop],
  set: (obj, prop, val) => (getThemeInstance()[prop] = val, !0)
});

function getThemeInstance() {
  var instance = global ? global._r14Theme : window._r14Theme;
  return instance || (instance = new ThemeUiDomain, global ? global._r14Theme = instance : window._r14Theme = instance), instance
}
var Colors = new Proxy((function() {}), {
  get: function(obj, prop) {
      return Theme.colors[prop]
  }
});
class ThemeColorValue {
  constructor(themeDomain, type, key, componentKey) {
      var options = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
      this._themeDomain = themeDomain, this._type = type, this._key = key, this._componentKey = componentKey, this._options = options
  }
  default (val) {
      return this._options.default = val, this
  }
  setOption(key, value) {
      this._options[key] = value
  }
  toString() {
      var theme = this._themeDomain.theme,
          colorValue = null;
      switch (this._type) {
          case "color":
              this._componentKey && (theme.components && theme.components[this._componentKey] && theme.components[this._componentKey].colors && theme.components[this._componentKey].colors[this._key] ? colorValue = theme.components[this._componentKey].colors[this._key] : this._options.default && (colorValue = this._options.default, "string" == typeof this._options.default ? colorValue = this._options.default : this._options.default.toString && (colorValue = this._options.default.toString()))), !colorValue && theme.colors && theme.colors[this._key] && (colorValue = theme.colors[this._key]), colorValue && this._options.alpha && this._options.alpha < 1 && (colorValue = Color.hexToRgba(theme.colors[this._key], this._options.alpha))
      }
      return colorValue || this._options.default || null
  }
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d, b) {
  return (extendStatics = Object.setPrototypeOf || {
          __proto__: []
      }
      instanceof Array && function(d, b) {
          d.__proto__ = b
      } || function(d, b) {
          for (var p in b) Object.prototype.hasOwnProperty.call(b, p) && (d[p] = b[p])
      })(d, b)
};

function __extends(d, b) {
  if ("function" != typeof b && null !== b) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

  function __() {
      this.constructor = d
  }
  extendStatics(d, b), d.prototype = null === b ? Object.create(b) : (__.prototype = b.prototype, new __)
}

function __generator(thisArg, body) {
  var f, y, t, g, _ = {
      label: 0,
      sent: function() {
          if (1 & t[0]) throw t[1];
          return t[1]
      },
      trys: [],
      ops: []
  };
  return g = {
      next: verb(0),
      throw: verb(1),
      return: verb(2)
  }, "function" == typeof Symbol && (g[Symbol.iterator] = function() {
      return this
  }), g;

  function verb(n) {
      return function(v) {
          return function(op) {
              if (f) throw new TypeError("Generator is already executing.");
              for (; _;) try {
                  if (f = 1, y && (t = 2 & op[0] ? y.return : op[0] ? y.throw || ((t = y.return) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                  switch (y = 0, t && (op = [2 & op[0], t.value]), op[0]) {
                      case 0:
                      case 1:
                          t = op;
                          break;
                      case 4:
                          return _.label++, {
                              value: op[1],
                              done: !1
                          };
                      case 5:
                          _.label++, y = op[1], op = [0];
                          continue;
                      case 7:
                          op = _.ops.pop(), _.trys.pop();
                          continue;
                      default:
                          if (!(t = _.trys, (t = t.length > 0 && t[t.length - 1]) || 6 !== op[0] && 2 !== op[0])) {
                              _ = 0;
                              continue
                          }
                          if (3 === op[0] && (!t || op[1] > t[0] && op[1] < t[3])) {
                              _.label = op[1];
                              break
                          }
                          if (6 === op[0] && _.label < t[1]) {
                              _.label = t[1], t = op;
                              break
                          }
                          if (t && _.label < t[2]) {
                              _.label = t[2], _.ops.push(op);
                              break
                          }
                          t[2] && _.ops.pop(), _.trys.pop();
                          continue
                  }
                  op = body.call(thisArg, _)
              } catch (e) {
                  op = [6, e], y = 0
              } finally {
                  f = t = 0
              }
              if (5 & op[0]) throw op[1];
              return {
                  value: op[0] ? op[1] : void 0,
                  done: !0
              }
          }([n, v])
      }
  }
}! function() {
  function Percent(percent) {
      this._value = percent
  }
  Object.defineProperty(Percent.prototype, "value", {
      get: function() {
          return this._value / 100
      },
      enumerable: !0,
      configurable: !0
  }), Object.defineProperty(Percent.prototype, "percent", {
      get: function() {
          return this._value
      },
      enumerable: !0,
      configurable: !0
  }), Percent.prototype.toString = function() {
      return this._value + "%"
  }
}();

function hasValue(a) {
  return null != a
}

function isNumber(value) {
  return "number" == typeof value && Number(value) == value
}

function each(array, fn) {
  for (var length = array.length, i = 0; i < length; ++i) fn(array[i], i)
}

function remove(array, element) {
  var found = !1,
      index = array.indexOf(element);
  if (-1 !== index) {
      found = !0, array.splice(index, 1);
      for (var length_1 = array.length; index < length_1;) array[index] === element ? (array.splice(index, 1), --length_1) : ++index
  }
  return found
}

function move(array, element, toIndex) {
  var index = function(array, value) {
      for (var length = array.length, i = 0; i < length; ++i)
          if (array[i] === value) return i;
      return -1
  }(array, element); - 1 !== index && function(array, index) {
      array.splice(index, 1)
  }(array, index), null == toIndex ? array.push(element) : function(array, index, value) {
      array.splice(index, 0, value)
  }(array, toIndex, element)
}

function add(array, element, index) {
  isNumber(index) ? 0 === index ? array.unshift(element) : array.splice(index, 0, element) : array.push(element)
}
var Disposer = function() {
      function Disposer(dispose) {
          this._disposed = !1, this._dispose = dispose
      }
      return Disposer.prototype.isDisposed = function() {
          return this._disposed
      }, Disposer.prototype.dispose = function() {
          this._disposed || (this._disposed = !0, this._dispose())
      }, Disposer
  }(),
  EventDispatcher = (function(_super) {
      function MultiDisposer(disposers) {
          return _super.call(this, (function() {
              each(disposers, (function(x) {
                  x.dispose()
              }))
          })) || this
      }
      __extends(MultiDisposer, _super)
  }(Disposer), function(_super) {
      function MutableValueDisposer() {
          var _this = _super.call(this, (function() {
              hasValue(_this._disposer) && (_this._disposer.dispose(), _this._disposer = void 0)
          })) || this;
          return _this
      }
      __extends(MutableValueDisposer, _super), MutableValueDisposer.prototype.get = function() {
          return this._value
      }, MutableValueDisposer.prototype.set = function(value, disposer) {
          hasValue(this._disposer) && this._disposer.dispose(), this._disposer = disposer, this._value = value
      }, MutableValueDisposer.prototype.reset = function() {
          this.set(void 0, void 0)
      }
  }(Disposer), function(_super) {
      function CounterDisposer() {
          var _this = null !== _super && _super.apply(this, arguments) || this;
          return _this._counter = 0, _this
      }
      __extends(CounterDisposer, _super), CounterDisposer.prototype.increment = function() {
          var _this = this;
          return ++this._counter, new Disposer((function() {
              --_this._counter, 0 === _this._counter && _this.dispose()
          }))
      }
  }(Disposer), function() {
      function EventDispatcher() {
          this._listeners = [], this._killed = [], this._disabled = {}, this._iterating = 0, this._enabled = !0, this._disposed = !1
      }
      return EventDispatcher.prototype.isDisposed = function() {
          return this._disposed
      }, EventDispatcher.prototype.dispose = function() {
          if (!this._disposed) {
              this._disposed = !0;
              var a = this._listeners;
              this._iterating = 1, this._listeners = null, this._disabled = null;
              try {
                  each(a, (function(x) {
                      x.disposer.dispose()
                  }))
              } finally {
                  this._killed = null, this._iterating = null
              }
          }
      }, EventDispatcher.prototype.hasListeners = function() {
          return 0 !== this._listeners.length
      }, EventDispatcher.prototype.hasListenersByType = function(type) {
          return function(array, test) {
              for (var length = array.length, i = 0; i < length; ++i)
                  if (test(array[i])) return !0;
              return !1
          }(this._listeners, (function(x) {
              return (null === x.type || x.type === type) && !x.killed
          }))
      }, EventDispatcher.prototype.enable = function() {
          this._enabled = !0
      }, EventDispatcher.prototype.disable = function() {
          this._enabled = !1
      }, EventDispatcher.prototype.enableType = function(type) {
          delete this._disabled[type]
      }, EventDispatcher.prototype.disableType = function(type, amount) {
          void 0 === amount && (amount = 1 / 0), this._disabled[type] = amount
      }, EventDispatcher.prototype._removeListener = function(listener) {
          if (0 === this._iterating) {
              var index = this._listeners.indexOf(listener);
              if (-1 === index) throw new Error("Invalid state: could not remove listener");
              this._listeners.splice(index, 1)
          } else this._killed.push(listener)
      }, EventDispatcher.prototype._removeExistingListener = function(once, type, callback, context) {
          if (this._disposed) throw new Error("EventDispatcher is disposed");
          this._eachListener((function(info) {
              info.once !== once || info.type !== type || null != callback && info.callback !== callback || info.context !== context || info.disposer.dispose()
          }))
      }, EventDispatcher.prototype.isEnabled = function(type) {
          if (this._disposed) throw new Error("EventDispatcher is disposed");
          return this._enabled && this._listeners.length > 0 && this.hasListenersByType(type) && null == this._disabled[type]
      }, EventDispatcher.prototype.has = function(type, callback, context) {
          return -1 !== function(array, matches) {
              for (var length = array.length, i = 0; i < length; ++i)
                  if (matches(array[i], i)) return i;
              return -1
          }(this._listeners, (function(info) {
              return !0 !== info.once && info.type === type && (null == callback || info.callback === callback) && info.context === context
          }))
      }, EventDispatcher.prototype._shouldDispatch = function(type) {
          if (this._disposed) throw new Error("EventDispatcher is disposed");
          var count = this._disabled[type];
          return isNumber(count) ? (count <= 1 ? delete this._disabled[type] : --this._disabled[type], !1) : this._enabled
      }, EventDispatcher.prototype._eachListener = function(fn) {
          var _this = this;
          ++this._iterating;
          try {
              each(this._listeners, fn)
          } finally {
              --this._iterating, 0 === this._iterating && 0 !== this._killed.length && (each(this._killed, (function(killed) {
                  _this._removeListener(killed)
              })), this._killed.length = 0)
          }
      }, EventDispatcher.prototype.dispatchImmediately = function(type, event) {
          this._shouldDispatch(type) && this._eachListener((function(listener) {
              listener.killed || null !== listener.type && listener.type !== type || listener.dispatch(type, event)
          }))
      }, EventDispatcher.prototype.dispatch = function(type, event) {
          this._shouldDispatch(type) && this._eachListener((function(listener) {
              !listener.killed && (null === listener.type || listener.type)
          }))
      }, EventDispatcher.prototype._on = function(once, type, callback, context, shouldClone, dispatch) {
          var _this = this;
          if (this._disposed) throw new Error("EventDispatcher is disposed");
          this._removeExistingListener(once, type, callback, context);
          var info = {
              type: type,
              callback: callback,
              context: context,
              shouldClone: shouldClone,
              dispatch: dispatch,
              killed: !1,
              once: once,
              disposer: new Disposer((function() {
                  info.killed = !0, _this._removeListener(info)
              }))
          };
          return this._listeners.push(info), info
      }, EventDispatcher.prototype.onAll = function(callback, context, shouldClone) {
          return void 0 === shouldClone && (shouldClone = !0), this._on(!1, null, callback, context, shouldClone, (function(type, event) {
              return callback.call(context, type, event)
          })).disposer
      }, EventDispatcher.prototype.on = function(type, callback, context, shouldClone) {
          return void 0 === shouldClone && (shouldClone = !0), this._on(!1, type, callback, context, shouldClone, (function(type, event) {
              return callback.call(context, event)
          })).disposer
      }, EventDispatcher.prototype.once = function(type, callback, context, shouldClone) {
          void 0 === shouldClone && (shouldClone = !0);
          var x = this._on(!0, type, callback, context, shouldClone, (function(type, event) {
              x.disposer.dispose(), callback.call(context, event)
          }));
          return x.disposer
      }, EventDispatcher.prototype.off = function(type, callback, context) {
          this._removeExistingListener(!1, type, callback, context)
      }, EventDispatcher.prototype.copyFrom = function(source) {
          var _this = this;
          if (this._disposed) throw new Error("EventDispatcher is disposed");
          if (source === this) throw new Error("Cannot copyFrom the same TargetedEventDispatcher");
          each(source._listeners, (function(x) {
              !x.killed && x.shouldClone && (null === x.type ? _this.onAll(x.callback, x.context) : x.once ? _this.once(x.type, x.callback, x.context) : _this.on(x.type, x.callback, x.context))
          }))
      }, EventDispatcher
  }());
! function(_super) {
  function TargetedEventDispatcher(target) {
      var _this = _super.call(this) || this;
      return _this.target = target, _this
  }
  __extends(TargetedEventDispatcher, _super), TargetedEventDispatcher.prototype.copyFrom = function(source) {
      var _this = this;
      if (this._disposed) throw new Error("EventDispatcher is disposed");
      if (source === this) throw new Error("Cannot copyFrom the same TargetedEventDispatcher");
      each(source._listeners, (function(x) {
          x.context !== source.target && !x.killed && x.shouldClone && (null === x.type ? _this.onAll(x.callback, x.context) : x.once ? _this.once(x.type, x.callback, x.context) : _this.on(x.type, x.callback, x.context))
      }))
  }
}(EventDispatcher);

function hasKey(object, key) {
  return {}.hasOwnProperty.call(object, key)
}

function each$1(object, fn) {
  ! function(object, fn) {
      for (var key in object)
          if (hasKey(object, key) && !fn(key, object[key])) break
  }(object, (function(key, value) {
      return fn(key, value), !0
  }))
}

function each$2(iter, fn) {
  iter((function(value) {
      return fn(value), !0
  }))
}! function(_super) {
  function DictionaryDisposer(dict) {
      var disposer = dict.events.on("removed", (function(x) {
          x.oldValue.dispose()
      }), void 0, !1);
      return _super.call(this, (function() {
          disposer.dispose(), each$2(dict.iterator(), (function(a) {
              a[1].dispose()
          }))
      })) || this
  }
  __extends(DictionaryDisposer, _super)
}(Disposer);
var Dictionary = function() {
      function Dictionary() {
          this.events = new EventDispatcher, this._dictionary = {}
      }
      return Dictionary.prototype.hasKey = function(key) {
          return hasKey(this._dictionary, key)
      }, Dictionary.prototype.getKey = function(key) {
          return this._dictionary[key]
      }, Dictionary.prototype.insertKey = function(key, value) {
          if (hasKey(this._dictionary, key)) throw new Error("Key " + key + " already exists in dictionary");
          this._dictionary[key] = value, this.events.isEnabled("insertKey") && this.events.dispatchImmediately("insertKey", {
              type: "insertKey",
              target: this,
              key: key,
              newValue: value
          })
      }, Dictionary.prototype.setKey = function(key, value) {
          if (hasKey(this._dictionary, key)) {
              var oldValue = this._dictionary[key];
              oldValue !== value && (this._dictionary[key] = value, this.events.isEnabled("setKey") && this.events.dispatchImmediately("setKey", {
                  type: "setKey",
                  target: this,
                  key: key,
                  oldValue: oldValue,
                  newValue: value
              }), this.events.isEnabled("removed") && this.events.dispatchImmediately("removed", {
                  type: "removed",
                  target: this,
                  oldValue: oldValue
              }))
          } else this._dictionary[key] = value, this.events.isEnabled("insertKey") && this.events.dispatchImmediately("insertKey", {
              type: "insertKey",
              target: this,
              key: key,
              newValue: value
          })
      }, Dictionary.prototype.updateKey = function(key, fn) {
          if (!hasKey(this._dictionary, key)) throw new Error("Key " + key + " doesn't exist in dictionary");
          var oldValue = this._dictionary[key],
              newValue = fn(oldValue);
          oldValue !== newValue && (this._dictionary[key] = newValue, this.events.isEnabled("setKey") && this.events.dispatchImmediately("setKey", {
              type: "setKey",
              target: this,
              key: key,
              oldValue: oldValue,
              newValue: newValue
          }), this.events.isEnabled("removed") && this.events.dispatchImmediately("removed", {
              type: "removed",
              target: this,
              oldValue: oldValue
          }))
      }, Dictionary.prototype.removeKey = function(key) {
          if (hasKey(this._dictionary, key)) {
              var oldValue = this._dictionary[key];
              delete this._dictionary[key], this.events.isEnabled("removeKey") && this.events.dispatchImmediately("removeKey", {
                  type: "removeKey",
                  target: this,
                  key: key,
                  oldValue: oldValue
              }), this.events.isEnabled("removed") && this.events.dispatchImmediately("removed", {
                  type: "removed",
                  target: this,
                  oldValue: oldValue
              })
          }
      }, Dictionary.prototype.insertKeyIfEmpty = function(key, ifEmpty) {
          return this.hasKey(key) || this.insertKey(key, ifEmpty()), this.getKey(key)
      }, Dictionary.prototype.clear = function() {
          var _this = this;
          this.events.isEnabled("removed") && each$1(this._dictionary, (function(key, value) {
              _this.events.dispatchImmediately("removed", {
                  type: "removed",
                  target: _this,
                  oldValue: value
              })
          })), this._dictionary = {}, this.events.isEnabled("cleared") && this.events.dispatchImmediately("cleared", {
              type: "cleared",
              target: this
          })
      }, Dictionary.prototype.copyFrom = function(source) {
          var _this = this;
          each$2(source.iterator(), (function(a) {
              _this.setKey(a[0], a[1])
          }))
      }, Dictionary.prototype.iterator = function() {
          return object = this._dictionary,
              function(push) {
                  for (var key in object)
                      if (hasKey(object, key) && !push([key, object[key]])) break
              };
          var object
      }, Dictionary.prototype[Symbol.iterator] = function() {
          var _a, _b, _i, key;
          return __generator(this, (function(_c) {
              switch (_c.label) {
                  case 0:
                      for (_b in _a = [], this._dictionary) _a.push(_b);
                      _i = 0, _c.label = 1;
                  case 1:
                      return _i < _a.length ? (key = _a[_i], hasKey(this._dictionary, key) ? [4, [key, this._dictionary[key]]] : [3, 3]) : [3, 4];
                  case 2:
                      _c.sent(), _c.label = 3;
                  case 3:
                      return _i++, [3, 1];
                  case 4:
                      return [2]
              }
          }))
      }, Dictionary.prototype.each = function(f) {
          each$2(this.iterator(), (function(_a) {
              var _b = function(o, n) {
                      var m = "function" == typeof Symbol && o[Symbol.iterator];
                      if (!m) return o;
                      var r, e, i = m.call(o),
                          ar = [];
                      try {
                          for (;
                              (void 0 === n || n-- > 0) && !(r = i.next()).done;) ar.push(r.value)
                      } catch (error) {
                          e = {
                              error: error
                          }
                      } finally {
                          try {
                              r && !r.done && (m = i.return) && m.call(i)
                          } finally {
                              if (e) throw e.error
                          }
                      }
                      return ar
                  }(_a, 2),
                  key = _b[0],
                  value = _b[1];
              return f(key, value)
          }))
      }, Dictionary.prototype.sortedIterator = function() {
          return iter = this.iterator(), fn = function(x, y) {
                  return a = x[0], b = y[0], a === b ? 0 : a < b ? -1 : 1;
                  var a, b
              }, array = function(iter) {
                  var output = [];
                  return iter((function(value) {
                      return output.push(value), !0
                  })), output
              }(iter).sort(fn),
              function(push) {
                  for (var length = array.length, i = 0; i < length && push(array[i]); ++i);
              };
          var iter, fn, array
      }, Dictionary
  }(),
  cache = (function(_super) {
      function DictionaryTemplate(t) {
          var _this = _super.call(this) || this;
          return _this.template = t, _this
      }
      __extends(DictionaryTemplate, _super), Object.defineProperty(DictionaryTemplate.prototype, "template", {
          get: function() {
              return this._template
          },
          set: function(v) {
              v.isTemplate = !0, this._template = v
          },
          enumerable: !0,
          configurable: !0
      }), DictionaryTemplate.prototype.copyFrom = function(source) {
          var _this = this;
          each$2(source.iterator(), (function(a) {
              _this.setKey(a[0], a[1].clone())
          }))
      }, DictionaryTemplate.prototype.create = function(key) {
          var _this = this;
          return this.insertKeyIfEmpty(key, (function() {
              return _this.template.clone()
          }))
      }
  }(Dictionary), new(function() {
      function Cache() {
          this._storage = new Dictionary, this.ttl = 1e3
      }
      return Cache.prototype.set = function(owner, key, value, ttl) {
          var ownerStorage = this._storage.insertKeyIfEmpty(owner, (function() {
                  return new Dictionary
              })),
              item = {
                  touched: (new Date).getTime(),
                  ttl: isNumber(ttl) ? ttl : this.ttl,
                  value: value
              };
          ownerStorage.setKey(key, item)
      }, Cache.prototype.get = function(owner, key, value) {
          if (void 0 === value && (value = void 0), this._storage.hasKey(owner)) {
              var ownerStorage = this._storage.getKey(owner);
              if (ownerStorage.hasKey(key)) {
                  var cacheItem = ownerStorage.getKey(key);
                  return cacheItem.ttl && cacheItem.touched + cacheItem.ttl < (new Date).getTime() && (cacheItem.expired = !0), cacheItem.expired ? (ownerStorage.removeKey(key), value) : cacheItem.value
              }
              return value
          }
          return value
      }, Cache.prototype.clear = function(owner) {
          owner ? this._storage.removeKey(owner) : this._storage.clear()
      }, Cache
  }())),
  registry = new(function() {
      function Registry() {
          var _this = this;
          this.events = new EventDispatcher, this.themes = [], this.loadedThemes = {}, this._uidCount = 0, this.registeredClasses = {}, this._placeholders = {}, this.invalidSprites = {}, this.invalidDatas = {}, this.invalidRawDatas = [], this.invalidDataItems = [], this.invalidDataRange = [], this.invalidPositions = {}, this.invalidLayouts = {}, this.baseSprites = [], this.baseSpritesByUid = {}, this.queue = [], this.deferred = [], this.uid = this.getUniqueId(), this.invalidSprites.noBase = [], this.invalidDatas.noBase = [], this.invalidLayouts.noBase = [], this.invalidPositions.noBase = [], "undefined" != typeof addEventListener && (addEventListener("beforeprint", (function() {
              each(_this.baseSprites, (function(sprite) {
                  var svg = sprite.paper.svg;
                  svg.setAttribute("viewBox", "0 0 " + svg.clientWidth + " " + svg.clientHeight)
              }))
          })), addEventListener("afterprint", (function() {
              each(_this.baseSprites, (function(sprite) {
                  sprite.paper.svg.removeAttribute("viewBox")
              }))
          })))
      }
      return Registry.prototype.getUniqueId = function() {
          var uid = this._uidCount;
          return this._uidCount += 1, "id-" + uid
      }, Object.defineProperty(Registry.prototype, "map", {
          get: function() {
              return this._map || (this._map = new Dictionary), this._map
          },
          enumerable: !0,
          configurable: !0
      }), Registry.prototype.setCache = function(key, value, ttl) {
          cache.set(this.uid, key, value, ttl)
      }, Registry.prototype.getCache = function(key, value) {
          return void 0 === value && (value = void 0), cache.get(this.uid, key, value)
      }, Registry.prototype.dispatch = function(eventType, data) {
          this.events.isEnabled(eventType) && (data ? (data.type = eventType, data.target = data.target || this, this.events.dispatch(eventType, {
              type: eventType,
              target: this
          })) : this.events.dispatch(eventType, {
              type: eventType,
              target: this
          }))
      }, Registry.prototype.dispatchImmediately = function(eventType, data) {
          this.events.isEnabled(eventType) && (data ? (data.type = eventType, data.target = data.target || this, this.events.dispatchImmediately(eventType, data)) : this.events.dispatchImmediately(eventType, {
              type: eventType,
              target: this
          }))
      }, Registry.prototype.getPlaceholder = function(key) {
          return hasValue(this._placeholders[key]) || (this._placeholders[key] = "__amcharts_" + key + "_" + function(chars) {
              for (var res = "", choice = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", i = 0; i < chars; i++) res += choice.charAt(Math.floor(Math.random() * choice.length));
              return res
          }(8) + "__"), this._placeholders[key]
      }, Registry.prototype.addToInvalidComponents = function(component) {
          component.baseId ? move(this.invalidDatas[component.baseId], component) : move(this.invalidDatas.noBase, component)
      }, Registry.prototype.removeFromInvalidComponents = function(component) {
          component.baseId && remove(this.invalidDatas[component.baseId], component), remove(this.invalidDatas.noBase, component)
      }, Registry.prototype.addToInvalidSprites = function(sprite) {
          sprite.baseId ? add(this.invalidSprites[sprite.baseId], sprite) : add(this.invalidSprites.noBase, sprite)
      }, Registry.prototype.removeFromInvalidSprites = function(sprite) {
          sprite.baseId && remove(this.invalidSprites[sprite.baseId], sprite), remove(this.invalidSprites.noBase, sprite)
      }, Registry.prototype.addToInvalidPositions = function(sprite) {
          sprite.baseId ? add(this.invalidPositions[sprite.baseId], sprite) : add(this.invalidPositions.noBase, sprite)
      }, Registry.prototype.removeFromInvalidPositions = function(sprite) {
          sprite.baseId && remove(this.invalidPositions[sprite.baseId], sprite), remove(this.invalidPositions.noBase, sprite)
      }, Registry.prototype.addToInvalidLayouts = function(sprite) {
          sprite.baseId ? add(this.invalidLayouts[sprite.baseId], sprite) : add(this.invalidLayouts.noBase, sprite)
      }, Registry.prototype.removeFromInvalidLayouts = function(sprite) {
          sprite.baseId && remove(this.invalidLayouts[sprite.baseId], sprite), remove(this.invalidLayouts.noBase, sprite)
      }, Registry
  }());

function is(object, name) {
  var x = registry.registeredClasses[name];
  return null != x && object instanceof x
}
useTheme((function(object) {
  is(object, "SpriteState") && (object.transitionDuration = 400), is(object, "Component") && (object.rangeChangeDuration = 500, object.interpolationDuration = 500, object.sequencedInterpolation = !1, is(object, "SankeyDiagram") && (object.sequencedInterpolation = !0), is(object, "FunnelSeries") && (object.sequencedInterpolation = !0)), is(object, "Chart") && (object.defaultState.transitionDuration = 2e3, object.hiddenState.transitionDuration = 1e3), is(object, "Tooltip") && (object.animationDuration = 400, object.defaultState.transitionDuration = 400, object.hiddenState.transitionDuration = 400), is(object, "Scrollbar") && (object.animationDuration = 500), is(object, "Series") && (object.defaultState.transitionDuration = 1e3, object.hiddenState.transitionDuration = 700, object.hiddenState.properties.opacity = 1, object.showOnInit = !0), is(object, "MapSeries") && (object.hiddenState.properties.opacity = 0), is(object, "PercentSeries") && (object.hiddenState.properties.opacity = 0), is(object, "FunnelSlice") && (object.defaultState.transitionDuration = 800, object.hiddenState.transitionDuration = 1e3, object.hiddenState.properties.opacity = 1), is(object, "Slice") && (object.defaultState.transitionDuration = 700, object.hiddenState.transitionDuration = 1e3, object.hiddenState.properties.opacity = 1), is(object, "Preloader") && (object.hiddenState.transitionDuration = 2e3), is(object, "Column") && (object.defaultState.transitionDuration = 700, object.hiddenState.transitionDuration = 1e3, object.hiddenState.properties.opacity = 1), is(object, "Column3D") && (object.hiddenState.properties.opacity = 0)
}));
class ChartUiDomain extends R14.DomainInstances {
  create(props) {
      var chart = new ChartUiInstanceDomain(props);
      return this.addInstance(props.name, chart), chart
  }
}
class ChartUiInstanceDomain extends R14.Domain {
  constructor(props) {
      if (super(), !props.name) throw "Chart Error: Chart must have a name.";
      this._name = props.name, this._props = props, this.state = {}
  }
  get domElementId() {
      return "chart_".concat(this._name)
  }
  remove() {
      this.chart && this.chart.dispose()
  }
  initialize() {
      var data = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          chart = create(this.domElementId, XYChart);
      chart.cursor = new XYCursor;
      var dateAxis = chart.xAxes.push(new DateAxis);
      if (dateAxis.renderer.minGridDistance = 50, dateAxis.renderer.grid.template.location = .5, dateAxis.startLocation = .5, dateAxis.endLocation = .5, dateAxis.renderer.labels.template.fontSize = 13, this._props.dateAxis && (this._props.dateAxis.dateRangeStart && (dateAxis.min = this._props.dateAxis.dateRangeStart.getTime()), this._props.dateAxis.dateRangeEnd && (dateAxis.max = this._props.dateAxis.dateRangeEnd.getTime()), this._props.dateAxis.dateRangeStart && this._props.dateAxis.dateRangeEnd && (dateAxis.strictMinMax = !0), this._props.dateAxis.intervalUnit && this._props.dateAxis.intervalValue && (dateAxis.baseInterval = {
              timeUnit: this._props.dateAxis.intervalUnit,
              count: this._props.dateAxis.intervalValue
          }), this._props.dateAxis.labelFormats))
          for (var key in this._props.dateAxis.labelFormats) dateAxis.dateFormats.setKey(key, this._props.dateAxis.labelFormats[key]);
      dateAxis.renderer.labels.template.fill = Colors.onBackground.toString(), dateAxis.renderer.grid.template.stroke = Colors.onBackground.toString();
      var valueAxis = chart.yAxes.push(new ValueAxis);
      valueAxis.renderer.labels.template.fill = Colors.onBackground.toString(), valueAxis.renderer.grid.template.stroke = Colors.onBackground.toString(), valueAxis.renderer.labels.template.fontSize = 13, data && data.nodes && data.nodes.forEach(node => {
          var series = chart.series.push(new LineSeries);
          series.dataFields.valueY = "value", series.dataFields.dateX = "date", series.connect = !1, series.autoGapCount = 1, series.name = node.name, series.tooltipText = "".concat(node.name, ": [bold]{valueY}[/]"), series.cursorTooltipEnabled = !0, series.snapTooltip = !0, series.tooltipPosition = "fixed", series.strokeWidth = 1.5;
          var seriesData = [];
          node && node.data && node.data.length && node.data.forEach(val => {
              seriesData.push({
                  date: new Date(val.x),
                  value: parseFloat(val.y)
              })
          }), series.data = seriesData
      }), this.chart = chart
  }
}
class ChartUiDomain$1 extends ChartUiDomain {
  constructor() {
      super()
  }
}
class DataTableUiDomain extends R14.DomainInstances {
  create(props) {
      var dataTable = new DataTableInstanceUiDomain(props);
      return this.addInstance(props.name, dataTable), dataTable
  }
}
class DataTableInstanceUiDomain extends R14.Domain {
  constructor(props, component) {
      if (super(), !props.name) throw "DataTable Error: DataTable must have a name.";
      if (!props.columns) throw "DataTable Error: DataTable must have columns prop.";
      this.props = props;
      var historyState = {};
      this.nav.state._r14DataTable && this.nav.state._r14DataTable[this.props.name] && (historyState = this.nav.state._r14DataTable[this.props.name]), this._columns = this.props.columns;
      var hiddenColumns = [];
      for (var colName in this._columns) this._columns[colName].collapsed && hiddenColumns.push(colName);
      this.state = {
          hasLoaded: !1,
          showActivityIndicator: !0,
          page: historyState.page || this.props.initialPage,
          rowsPerPage: historyState.rowsPerPage || this.props.initialRowsPerPage,
          sortColumnName: historyState.sortColumnName || this.initialSortColumnName(),
          sortDirection: historyState.sortDirection || this.props.initialSortDirection,
          totalRows: historyState.totalRows || this.props.initialTotalRows,
          initialized: !1,
          selectedRows: this.props.initialSelectedRows,
          showFilters: !1,
          filters: null,
          searchTextInputValue: "",
          showSearch: !1,
          hiddenColumns: hiddenColumns
      }, this._data = {}, this._component = component, this._autoRefreshInterval = null, props.autoRefresh && this.autoRefresh(props.autoRefresh), this._autoSize = this.props.autoSize || !1, this._searchTextChangeTimeout = null
  }
  autoRefresh() {
      var seconds = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 5;
      seconds ? (this._autoRefreshInterval && this.autoRefresh(!1), this._autoRefreshInterval = setInterval(() => {
          this.refresh({
              init: !1,
              reset: !0,
              indicator: !1
          })
      }, 1e3 * seconds)) : this._autoRefreshInterval && (clearInterval(this._autoRefreshInterval), this._autoRefreshInterval = null)
  }
  remove() {
      this.autoRefresh(!1), this.ui.dataTable.removeInstance(this.props.name)
  }
  init() {}
  refresh() {
      var _this = this,
          options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return _asyncToGenerator((function*() {
          return "init" in options || (options.init = !0), yield _this.load(options)
      }))()
  }
  resetFilters() {
      var _this2 = this;
      return _asyncToGenerator((function*() {
          _this2.hasFilterValues && (_this2.ui.form["dataTable".concat(_this2.props.name, "FilterForm")] && _this2.ui.form["dataTable".concat(_this2.props.name, "FilterForm")].reset(), _this2.load(1, {
              filters: null,
              init: !0,
              indicator: !0
          }))
      }))()
  }
  submitFilters(formName) {
      var _this3 = this,
          options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return _asyncToGenerator((function*() {
          var filters = {},
              formVals = _this3.ui.form[formName].values;
          for (var f in formVals) null !== formVals[f] && (filters[f] = formVals[f]);
          _this3.load(1, _extends({
              filters: filters && Object.keys(filters).length ? filters : null,
              init: !0,
              indicator: !0
          }, options))
      }))()
  }
  load() {
      var _this4 = this,
          page = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
          options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return _asyncToGenerator((function*() {
          page && "object" == typeof page && (page = (options = page).page || null);
          var shouldInit = options.init || !_this4.isInitialized,
              shouldReset = !0 === options.reset || options.sortColumnName && options.sortColumnName !== _this4.sortColumnName || options.sortDirection && options.sortDirection !== _this4.sortDirection || options.rowsPerPage && options.rowsPerPage !== _this4.rowsPerPage || options.search && options.search !== _this4.state.searchTextInputValue || !1,
              showIndicator = !(shouldInit || _this4._data[page] && !shouldReset);
          "indicator" in options && (showIndicator = !0 === options.indicator);
          _this4.state.hasLoaded;
          var sortColumnName = options.sortColumnName || _this4.sortColumnName,
              sortDirection = options.sortDirection || _this4.sortDirection,
              rowsPerPage = options.rowsPerPage || _this4.rowsPerPage,
              totalRows = _this4.totalRows,
              filters = "filters" in options ? options.filters : _this4.state.filters,
              search = options.search || _this4.state.searchTextInputValue,
              currState = {
                  page: page = page || _this4.state.page,
                  rowsPerPage: rowsPerPage,
                  sortColumnName: sortColumnName,
                  sortDirection: sortDirection,
                  totalRows: totalRows,
                  filters: filters,
                  search: search
              };
          if (showIndicator && _this4.ui.progressIndicator.show(), _this4.state.hasLoaded && _this4.setState({
                  hasLoaded: !1,
                  showActivityIndicator: !shouldReset
              }), shouldInit) {
              var newState = yield _this4.props.initializer(currState);
              "page" in newState && (page = newState.page), "rowsPerPage" in newState && (rowsPerPage = newState.rowsPerPage), "totalRows" in newState && (totalRows = newState.totalRows), "sortDirection" in newState && (sortDirection = newState.sortDirection), "filters" in newState && (filters = newState.filters), _this4._data = {
                  [page]: newState.pageData || []
              }
          } else if (shouldReset) {
              var newData = yield _this4.props.pageLoader(currState);
              !Array.isArray(newData) && "object" == typeof newData && newData.pageData && (newData = newData.pageData), _this4._data = {
                  [page]: newData
              }
          } else _this4._data[page] || (_this4._data[page] = yield _this4.props.pageLoader(currState));
          var selectedRows = _this4.state.selectedRows;
          _this4.props.isSelectedRow && _this4._data[page].forEach(row => {
              var key = _this4.keyExtractor(row);
              _this4.props.isSelectedRow(row) ? -1 === selectedRows.indexOf(key) && selectedRows.push(key) : -1 !== selectedRows.indexOf(key) && selectedRows.splice(selectedRows.indexOf(key), 1)
          }), showIndicator && _this4.ui.progressIndicator.hide({
              timeout: 750
          });
          var navState = _this4.nav.state;
          navState._r14DataTable || (navState._r14DataTable = {}), navState._r14DataTable[_this4.props.name] = {
              page: page,
              rowsPerPage: rowsPerPage,
              sortColumnName: sortColumnName,
              sortDirection: sortDirection
          }, _this4.nav.updateState(navState), _this4.setState({
              hasLoaded: !0,
              page: page,
              rowsPerPage: rowsPerPage,
              sortColumnName: sortColumnName,
              sortDirection: sortDirection,
              totalRows: totalRows,
              initialized: !0,
              selectedRows: selectedRows,
              filters: filters && Object.keys(filters).length ? filters : null
          })
      }))()
  }
  isSelectedRow(row) {
      return -1 !== this.state.selectedRows.indexOf(this.keyExtractor(row))
  }
  hasSelectedAllRows() {
      return !!this.pageData.length && (this.pageData.forEach(row => {
          this.isSelectedRow(row)
      }), this.state.selectedRows.length === this.pageData.length)
  }
  getRow(key) {
      for (var row of this.pageData)
          if (this.keyExtractor(row) === key) return row;
      return !1
  }
  showColumn(columnKey) {
      this.addHiddenColumn(columnKey)
  }
  hideColumn(columnKey) {
      this.removeHiddenColumn(columnKey)
  }
  toggleColumn(columnKey) {
      this.isColumnVisible(columnKey) ? this.addHiddenColumn(columnKey) : this.removeHiddenColumn(columnKey)
  }
  addHiddenColumn(columnKey) {
      if (this.isColumnVisible(columnKey)) {
          var hiddenColumns = this.state.hiddenColumns;
          hiddenColumns.push(columnKey), this.setState({
              hiddenColumns: hiddenColumns
          })
      }
  }
  removeHiddenColumn(columnKey) {
      if (!this.isColumnVisible(columnKey)) {
          var hiddenColumns = this.state.hiddenColumns,
              idx = hiddenColumns.indexOf(columnKey); - 1 !== idx && hiddenColumns.splice(idx, 1), this.setState({
              hiddenColumns: hiddenColumns
          })
      }
  }
  isColumnVisible(columnKey) {
      return !this.state.hiddenColumns.includes(columnKey)
  }
  keyExtractor(row, index) {
      return this.props.rowKeyExtractor(row)
  }
  handleRowCheckboxValueChange(key, value) {
      var _this5 = this;
      return _asyncToGenerator((function*() {
          var row = _this5.getRow(key);
          if (_this5.props.onRowSelect) {
              var ret = yield _this5.props.onRowSelect(row, value, _this5);
              if (!1 === ret) return;
              if ("object" == typeof ret) return void _this5.updateRow(row)
          }
      }))()
  }
  handleSelectAllCheckboxValueChange(value) {
      var _this6 = this;
      return _asyncToGenerator((function*() {
          var rows = [];
          if (_this6.pageData.forEach(row => {
                  _this6.isSelectedRow(row) !== value && rows.push(row)
              }), rows.length) {
              var ret = yield _this6.props.onRowsSelect(rows, value, _this6);
              !1 !== ret && Array.isArray(ret) && _this6.updateRows(ret)
          }
      }))()
  }
  showSearch() {
      this.setState({
          showSearch: !0
      })
  }
  hideSearch() {
      this.setState({
          showSearch: !1
      })
  }
  searchTextExists() {
      return !(!this.state.searchTextInputValue || "" === this.state.searchTextInputValue)
  }
  handleSearchChangeText(val) {
      var _this7 = this;
      return _asyncToGenerator((function*() {
          _this7.setState({
              searchTextInputValue: val
          }), _this7._searchTextChangeTimeout && clearTimeout(_this7._searchTextChangeTimeout), _this7._searchTextChangeTimeout = setTimeout(() => {
              _this7.load(1, {
                  search: val,
                  init: !0
              })
          }, 250)
      }))()
  }
  initialSortColumnName() {
      if (this.props.initialSortColumnName) return this.props.initialSortColumnName;
      for (var i in this.props.columns)
          if (this.props.columns[i].sortable) return i;
      return null
  }
  get filtersVisible() {
      return this.state.showFilters
  }
  toggleFilters() {
      this.setState({
          showFilters: !this.state.showFilters
      })
  }
  showFilters() {
      this.setState({
          showFilters: !0
      })
  }
  hideFilters() {
      this.setState({
          showFilters: !1
      })
  }
  get name() {
      return this._name
  }
  get totalPages() {
      return this.totalRows ? Math.ceil(this.totalRows / this.rowsPerPage) : 0
  }
  get totalRows() {
      return this.state.totalRows
  }
  get pageData() {
      return this.state.page && this._data[this.state.page] ? this._data[this.state.page] : []
  }
  get page() {
      return this.state.page
  }
  get sortColumnName() {
      return this.state.sortColumnName
  }
  get sortDirection() {
      return this.sortColumnName ? this.state.sortDirection : null
  }
  get startIndex() {
      return (this.page - 1) * this.rowsPerPage
  }
  get endIndex() {
      return this.startIndex + (this.rowsPerPage - 1)
  }
  get rowsPerPage() {
      return this.state.rowsPerPage
  }
  get isInitialized() {
      return this.state.initialized
  }
  get autoSize() {
      return this._autoSize
  }
  get columns() {
      return this._columns
  }
  get hasFilterValues() {
      return !(!this.state.filters || !Object.keys(this.state.filters).length)
  }
  get rowsPerPageSelectMenuItems() {
      return [{
          label: "5",
          value: 5
      }, {
          label: "10",
          value: 10
      }, {
          label: "25",
          value: 25
      }, {
          label: "50",
          value: 50
      }, {
          label: "100",
          value: 100
      }]
  }
  updateRow(row) {
      this.updateRows([row])
  }
  updateRows(rows) {
      var selectedRows = this.state.selectedRows,
          hasStateUpdate = !1,
          rowVals = {};
      for (var p in rows.forEach(row => {
              rowVals[this.keyExtractor(row)] = row
          }), this._data)
          for (var i in this._data[p]) {
              var key = this.keyExtractor(this._data[p][i]);
              if (rowVals[key]) {
                  var row = rowVals[key];
                  if (this._data[p][i] = row, this.props.isSelectedRow) {
                      var isSelected = this.props.isSelectedRow(row);
                      isSelected && -1 === selectedRows.indexOf(key) ? (hasStateUpdate = !0, selectedRows.push(key)) : isSelected || -1 === selectedRows.indexOf(key) || (hasStateUpdate = !0, selectedRows.splice(selectedRows.indexOf(key), 1))
                  }
              }
          }
      hasStateUpdate && this.setState({
          selectedRows: selectedRows
      })
  }
  loadNextPage() {
      var _this8 = this;
      return _asyncToGenerator((function*() {
          return !(_this8.page >= _this8.totalPages) && (yield _this8.load(_this8.page + 1))
      }))()
  }
  loadPreviousPage() {
      var _this9 = this;
      return _asyncToGenerator((function*() {
          return !(_this9.page <= 1) && (yield _this9.load(_this9.page - 1))
      }))()
  }
  setSort(colName) {
      var sortDirection = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
      sortDirection || (sortDirection = colName === this.sortColumnName && "asc" === this.sortDirection ? "desc" : "asc"), this.load(1, {
          sortColumnName: colName,
          sortDirection: sortDirection,
          reset: !0
      })
  }
}
class InfiniteListUiDomain extends R14.DomainInstances {
  create(props) {
      var infiniteList = new InfiniteListInstanceUiDomain(props);
      return this.addInstance(props.name, infiniteList), infiniteList
  }
}
class InfiniteListInstanceUiDomain extends R14.Domain {
  constructor(props, component) {
      if (super(), !props.name) throw "InfiniteList Error: InfiniteList must have a name.";
      this.props = props;
      var historyState = {};
      this.nav.state._r14InfiniteList && this.nav.state._r14InfiniteList[this.props.name] && (historyState = this.nav.state._r14InfiniteList[this.props.name]), this.state = {
          hasLoaded: !1,
          showActivityIndicator: !0,
          page: historyState.page || this.props.initialPage,
          rowsPerPage: historyState.rowsPerPage || this.props.initialRowsPerPage,
          totalRows: historyState.totalRows || this.props.initialTotalRows,
          initialized: !1,
          selectedRows: this.props.initialSelectedRows,
          showFilters: !1,
          searchTextInputValue: "",
          showSearch: !1
      }, this._columns = this.props.columns, this._data = {}, this._component = component, this._autoRefreshInterval = null, props.autoRefresh && this.autoRefresh(props.autoRefresh), this._autoSize = this.props.autoSize || !1, this._searchTextChangeTimeout = null
  }
  autoRefresh() {
      var seconds = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 5;
      seconds ? (this._autoRefreshInterval && this.autoRefresh(!1), this._autoRefreshInterval = setInterval(() => {
          this.refresh({
              init: !1,
              reset: !0,
              indicator: !1
          })
      }, 1e3 * seconds)) : this._autoRefreshInterval && (clearInterval(this._autoRefreshInterval), this._autoRefreshInterval = null)
  }
  remove() {
      this.autoRefresh(!1), this.ui.infiniteList.removeInstance(this.props.name)
  }
  init() {}
  refresh() {
      var _this = this,
          options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return _asyncToGenerator((function*() {
          return "init" in options || (options.init = !0), yield _this.load(options)
      }))()
  }
  load() {
      var _this2 = this,
          page = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
          options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return _asyncToGenerator((function*() {
          page && "object" == typeof page && (page = (options = page).page || null);
          var shouldInit = options.init || !_this2.isInitialized,
              shouldReset = !0 === options.reset || options.rowsPerPage && options.rowsPerPage !== _this2.rowsPerPage || options.search && options.search !== _this2.state.searchTextInputValue || !1,
              showIndicator = !(shouldInit || _this2._data[page] && !shouldReset);
          "indicator" in options && (showIndicator = !0 === options.indicator);
          _this2.state.hasLoaded, options.sortColumnName || _this2.sortColumnName, options.sortDirection || _this2.sortDirection;
          var rowsPerPage = options.rowsPerPage || _this2.rowsPerPage,
              totalRows = _this2.totalRows,
              filters = options.filters || _this2.filters,
              search = options.search,
              currState = {
                  page: page = page || _this2.state.page,
                  rowsPerPage: rowsPerPage,
                  totalRows: totalRows,
                  filters: filters,
                  search: search
              };
          if (showIndicator && _this2.ui.progressIndicator.show(), _this2.state.hasLoaded && _this2.setState({
                  hasLoaded: !1,
                  showActivityIndicator: !shouldReset
              }), shouldInit) {
              var newState = yield _this2.props.initializer(currState);
              "page" in newState && (page = newState.page), "rowsPerPage" in newState && (rowsPerPage = newState.rowsPerPage), "totalRows" in newState && (totalRows = newState.totalRows), _this2._data = {
                  [page]: newState.pageData || []
              }
          } else if (shouldReset) {
              var newData = yield _this2.props.pageLoader(currState);
              _this2._data = {
                  [page]: newData
              }
          } else _this2._data[page] || (_this2._data[page] = yield _this2.props.pageLoader(currState));
          var selectedRows = _this2.state.selectedRows;
          _this2.props.isSelectedRow && _this2._data[page].forEach(row => {
              var key = _this2.keyExtractor(row);
              _this2.props.isSelectedRow(row) ? -1 === selectedRows.indexOf(key) && selectedRows.push(key) : -1 !== selectedRows.indexOf(key) && selectedRows.splice(selectedRows.indexOf(key), 1)
          }), showIndicator && _this2.ui.progressIndicator.hide({
              timeout: 750
          });
          var navState = _this2.nav.state;
          navState._r14InfiniteList || (navState._r14InfiniteList = {}), navState._r14InfiniteList[_this2.name] = {
              page: page,
              rowsPerPage: rowsPerPage
          }, _this2.nav.updateState(navState), _this2.setState({
              hasLoaded: !0,
              page: page,
              rowsPerPage: rowsPerPage,
              totalRows: totalRows,
              initialized: !0,
              selectedRows: selectedRows
          })
      }))()
  }
  getRow(key) {
      for (var row of this.pageData)
          if (this.keyExtractor(row) === key) return row;
      return !1
  }
  keyExtractor(row, index) {
      return this.props.rowKeyExtractor(row)
  }
  showSearch() {
      this.setState({
          showSearch: !0
      })
  }
  hideSearch() {
      this.setState({
          showSearch: !1
      })
  }
  searchTextExists() {
      return !(!this.state.searchTextInputValue || "" === this.state.searchTextInputValue)
  }
  handleSearchChangeText(val) {
      var _this3 = this;
      return _asyncToGenerator((function*() {
          _this3.setState({
              searchTextInputValue: val
          }), _this3._searchTextChangeTimeout && clearTimeout(_this3._searchTextChangeTimeout), _this3._searchTextChangeTimeout = setTimeout(() => {
              _this3.refresh({
                  search: val
              })
          }, 250)
      }))()
  }
  get name() {
      return this._name
  }
  get totalPages() {
      return this.totalRows ? Math.ceil(this.totalRows / this.rowsPerPage) : 0
  }
  get totalRows() {
      return this.state.totalRows
  }
  get data() {
      var data = [];
      for (var page in this._data) data.push(...this._data[page]);
      return data
  }
  get page() {
      return this.state.page
  }
  get startIndex() {
      return (this.page - 1) * this.rowsPerPage
  }
  get endIndex() {
      return this.startIndex + (this.rowsPerPage - 1)
  }
  get rowsPerPage() {
      return this.state.rowsPerPage
  }
  get isInitialized() {
      return this.state.initialized
  }
  get autoSize() {
      return this._autoSize
  }
  updateRow(row) {
      this.updateRows([row])
  }
  updateRows(rows) {
      var selectedRows = this.state.selectedRows,
          hasStateUpdate = !1,
          rowVals = {};
      for (var p in rows.forEach(row => {
              rowVals[this.keyExtractor(row)] = row
          }), this._data)
          for (var i in this._data[p]) {
              var key = this.keyExtractor(this._data[p][i]);
              if (rowVals[key]) {
                  var row = rowVals[key];
                  if (this._data[p][i] = row, this.props.isSelectedRow) {
                      var isSelected = this.props.isSelectedRow(row);
                      isSelected && -1 === selectedRows.indexOf(key) ? (hasStateUpdate = !0, selectedRows.push(key)) : isSelected || -1 === selectedRows.indexOf(key) || (hasStateUpdate = !0, selectedRows.splice(selectedRows.indexOf(key), 1))
                  }
              }
          }
      hasStateUpdate && this.setState({
          selectedRows: selectedRows
      })
  }
  loadNextPage() {
      var _this4 = this;
      return _asyncToGenerator((function*() {
          return !(_this4.page >= _this4.totalPages) && (yield _this4.load(_this4.page + 1))
      }))()
  }
  loadPreviousPage() {
      var _this5 = this;
      return _asyncToGenerator((function*() {
          return !(_this5.page <= 1) && (yield _this5.load(_this5.page - 1))
      }))()
  }
}
class ViewportUiDomain extends R14.Domain {
  constructor() {
      super(), this.handleResize = this.handleResize.bind(this), DimensionsBase.addEventListener("change", this.handleResize);
      var {
          height: height,
          width: width
      } = DimensionsBase.get("window");
      this.state = {
          height: height,
          width: width
      }
  }
  handleResize(_ref) {
      var {
          window: window
      } = _ref;
      this.setState({
          height: window.height,
          width: window.width
      })
  }
  get height() {
      return this.state.height
  }
  get width() {
      return this.state.width
  }
}
class NavigatorUiDomain extends R14.DomainInstances {
  create(props) {
      var dialog = new NavigatorInstanceUiDomain(this, props);
      return this.addInstance(props.name, dialog), dialog
  }
  remove(name) {
      this.removeInstance(name)
  }
}
class NavigatorInstanceUiDomain extends R14.Domain {
  constructor(navigatorDomain, props) {
      if (super(), !props.name) throw "Navigator Error: Navigator must have a name.";
      this._name = props.name, this._navigatorDomain = navigatorDomain, this._onToggledCallback = null, this._navigation = props.navigation || null;
      var options = {};
      switch (props.navigator.type) {
          case "drawer":
              options = props.navigator.drawerNavigator || {}
      }
      this._navigatorType = props.navigator.type, this._onToggledCallback = props.onToggled || null, this.state = {
          visible: props.visible || !1,
          layoutStyles: null,
          options: options,
          toggle: !1
      }
  }
  setLayoutStyles(layoutStyles) {
      return this.setState({
          layoutStyles: layoutStyles
      }), this
  }
  get isVisible() {
      return this.state.visible
  }
  set visible(visible) {
      return this.setVisible(visible)
  }
  setVisible(visible) {
      var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return this.setState({
          visible: visible,
          toggled: !!options.toggled
      }), this
  }
  show() {
      this.setVisible(!0)
  }
  hide() {
      this.setVisible(!1)
  }
  setOption(name, value) {
      var options = this.state.options;
      options[name] !== value && (options[name] = value, this.setState({
          options: options
      }))
  }
  get options() {
      return this.state.options
  }
  hide() {
      this.setVisible(!1)
  }
  toggle() {
      this._onToggledCallback && this._onToggledCallback(!this.isVisible), this._navigation && this._navigation.toggleDrawer(), this.setVisible(!this.isVisible, {
          toggled: !0
      })
  }
  onToggled(callback) {
      this._onToggledCallback = callback
  }
  get isToggled() {
      return this.state.toggled
  }
  get toggled() {
      return this.isToggled
  }
  remove() {
      this._navigatorDomain.remove(this._name)
  }
}
class ProgressIndicatorUIDomain extends R14.Domain {
  constructor() {
      super(), this.state = {
          instances: {}
      }
  }
  show() {
      var name = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default",
          options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if ("object" == typeof name && (name = (options = name).name || "default"), !this.state.instances[name]) {
          var instances = this.state.instances;
          instances[name] = options, this.setState({
              instances: instances
          })
      }
  }
  hide() {
      var name = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default",
          options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if ("object" == typeof name && (name = (options = name).name || "default"), this.state.instances[name]) {
          var timeout = options.timeout || 0,
              _hide = name => {
                  var instances = this.state.instances;
                  delete instances[name], this.setState({
                      instances: instances
                  })
              };
          timeout ? setTimeout(() => _hide(name), timeout) : _hide(name)
      }
  }
  isVisible() {
      var name = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default";
      return !!this.state.instances[name]
  }
  shouldOverlay() {
      var name = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default";
      return !!this.isVisible(name) && !1 !== this.state.instances[name].overlay
  }
}
class SnackBarUiDomain extends R14.Domain {
  constructor() {
      super(), this.handleRequestDismiss = this.handleRequestDismiss.bind(this), this.state = {
          visible: !1
      }, this._props = {
          name: "navigator",
          message: ""
      }
  }
  show(message) {
      var props = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if ("object" == typeof message && (message = (props = message).message), !message) throw new Error("SnackBack Error: Message Required");
      return props.message = message, this._props = props, props.name || (props.name = "default"), this.state.visible && (console.error("SnackBar Error: SnackBar already visible. TODO: hide then show."), this.setState({
          visible: !1
      })), this.setState({
          visible: !0
      }), this
  }
  get props() {
      return this._props
  }
  handleRequestDismiss() {
      this.props.onRequestDismiss ? this.props.onRequestDismiss() : this.hide()
  }
  dismiss() {
      return this.hide()
  }
  hide() {
      return this.setState({
          visible: !1
      }), this
  }
}
class R14App {
  constructor(options) {
      if (!options.config) throw "R14 Error: No Config.";
      this._r14 = R14.getInstance(), this._isInitialized = !1, this._metadata = {
          model: new R14AppModel(this._r14, this, options),
          navigation: new R14AppNavigationBase(this._r14, this, options),
          api: new R14Api(this._r14, this, options),
          io: new R14Io(this._r14, this, options),
          actions: new options.actions,
          config: options.config,
          routes: options.routes,
          icons: options.icons,
          theme: options.theme,
          defaultLayout: options.defaultLayout || null,
          utilities: this._r14.utils,
          scrollBehavior: options.scrollBehavior || null,
          isInitialized: !1
      }
  }
  initialize() {
      var _this = this;
      return _asyncToGenerator((function*() {
          return _this._isInitialized || (yield Theme.initialize(_this.theme), _this._r14.app = _this, _this._r14.navigation = new R14Navigation, _this._r14.navigation.initializeRoutes(_this._metadata.routes), yield _this.model.initialize(), _this._isInitialized = !0), !0
      }))()
  }
  get navigation() {
      return this._metadata.navigation
  }
  get nav() {
      return this._metadata.navigation
  }
  get action() {
      return this._metadata.actions
  }
  get act() {
      return this._metadata.act
  }
  get api() {
      return this._metadata.api
  }
  get io() {
      return this._metadata.io
  }
  get router() {
      return this._metadata.router
  }
  get rtr() {
      return this._metadata.router
  }
  get model() {
      return this._metadata.model
  }
  get mdl() {
      return this.model
  }
  get domain() {
      return this.mdl.domain
  }
  get dm() {
      return this.domain
  }
  get entity() {
      return this.mdl.entity
  }
  get ent() {
      return this.entity
  }
  get database() {
      return this.mdl.database
  }
  get db() {
      return this.database
  }
  get query() {
      return this.db.qry
  }
  get qry() {
      return this.query
  }
  get ui() {
      return this.mdl.ui
  }
  get routes() {
      return this._metadata.routes
  }
  get theme() {
      return this._metadata.theme
  }
  get icons() {
      return this._metadata.icons
  }
  get utilities() {
      return this._metadata.utilities
  }
  get utils() {
      return this._metadata.utilities
  }
  get api() {
      return this._metadata.api
  }
  get defaultLayout() {
      return this._metadata.defaultLayout
  }
  get config() {
      return this._metadata.config
  }
  get scrollBehavior() {
      return this._metadata.scrollBehavior
  }
  get r14Instance() {
      return this._r14
  }
}
class R14AppModel {
  constructor(r14, app, options) {
      if (!options.domains) throw "R14 Error: No Domains config found.";
      if (!options.domains.domain) throw "R14 Error: No domain found in domains config.";
      if (!options.domains.ui) throw "R14 Error: No Ui found in domains config.";
      this._app = app, this._r14 = r14;
      var domains = {};
      for (var k in options.domains.domain) domains[k] = new options.domains.domain[k];
      options.domains.ui.form && console.warn("Replacing UI Form ignored."), options.domains.ui.form = FormUiDomain, options.domains.ui.keyMapper && console.warn("Replacing UI Key Mapper ignored."), options.domains.ui.keyMapper = KeyMapperUiDomain, options.domains.ui.snackBar && console.warn("Replacing UI SnackBar ignored."), options.domains.ui.snackBar = SnackBarUiDomain, options.domains.ui.draggable && console.warn("Replacing UI Draggable ignored."), options.domains.ui.draggable = DraggableUiDomain, options.domains.ui.navigator && console.warn("Replacing UI Navigator ignored."), options.domains.ui.navigator = NavigatorUiDomain, options.domains.ui.dataTable && console.warn("Replacing UI DataTable ignored."), options.domains.ui.dataTable = DataTableUiDomain, options.domains.ui.infiniteList && console.warn("Replacing UI Infinite List ignored."), options.domains.ui.infiniteList = InfiniteListUiDomain, options.domains.ui.viewport && console.warn("Replacing UI Viewport ignored."), options.domains.ui.viewport = ViewportUiDomain, options.domains.ui.chart && console.warn("Replacing UI Chart ignored."), options.domains.ui.chart = ChartUiDomain$1, options.domains.ui.progressIndicator && console.warn("Replacing UI Progress indicator ignored."), options.domains.ui.progressIndicator = ProgressIndicatorUIDomain;
      var uiDomains = {};
      for (var _k in options.domains.ui) uiDomains[_k] = new options.domains.ui[_k](r14);
      this._domain = domains, this._ui = uiDomains
  }
  initialize() {
      var _this2 = this;
      return _asyncToGenerator((function*() {
          var promises = [];
          for (var i in _this2._domain) _this2._domain[i].setup && promises.push(_this2._domain[i].setup()), _this2._domain[i].domainDidLoad && promises.push(_this2._domain[i].domainDidLoad());
          for (var _i in _this2._ui) _this2._ui[_i].setup && promises.push(_this2._ui[_i].setup()), _this2._ui[_i].domainDidLoad && promises.push(_this2._ui[_i].domainDidLoad());
          return yield Promise.all(promises), !0
      }))()
  }
  get domain() {
      return this._domain
  }
  get dm() {
      return this.domain
  }
  get ui() {
      return this._ui
  }
}
class ViewBase extends React__default.Component {
  constructor(props) {
      super(props), this.htmlRef = this.props.htmlRef || React__default.createRef(), this.layoutTimeout = null, this.prevLayout = null, this.state = {
          styleOnLayout: null
      }, (this.props.onLayout || this.props.styleOnLayout) && (this.resizeObserver = new ResizeObserver(entries => {
          this.triggerOnLayout()
      }))
  }
  componentDidMount() {
      this.props.onLayout && (this.layoutTimeout = setTimeout(() => {
          this.triggerOnLayout()
      }, 5), this.resizeObserver.observe(this.htmlRef.current))
  }
  componentWillUnmount() {
      this.props.onLayout && (this.layoutTimeout && clearTimeout(this.layoutTimeout), this.resizeObserver.disconnect())
  }
  triggerOnLayout() {
      var event;
      if (!this.props.onLayout && !this.props.styleOnLayout || !this.htmlRef.current) return !1;
      var layout = {
          x: this.htmlRef.current.offsetLeft,
          y: this.htmlRef.current.offsetTop,
          width: this.htmlRef.current.offsetWidth,
          height: this.htmlRef.current.offsetHeight
      };
      if (this.prevLayout && layout.x === this.prevLayout.x && layout.y === this.prevLayout.y && layout.height === this.prevLayout.height && layout.width === this.prevLayout.width) return !1;
      if (event = {
              nativeEvent: {
                  layout: layout
              }
          }, this.props.onLayout && this.props.onLayout(event), this.props.styleOnLayout) {
          var styleOnLayout = this.props.styleOnLayout(event) || null;
          styleOnLayout !== this.state.styleOnLayout && this.setState({
              styleOnLayout: styleOnLayout
          })
      }
      this.prevLayout = layout
  }
  measureInWindow(callback) {
      var offset = R14.utils.dom.offset(this.htmlRef.current),
          dimensions = R14.utils.dom.dimensions(this.htmlRef.current);
      callback(offset.left, offset.top, dimensions.width, dimensions.height)
  }
  measure(callback) {
      var offset = R14.utils.dom.offset(this.htmlRef.current),
          dimensions = R14.utils.dom.dimensions(this.htmlRef.current);
      callback(this.htmlRef.current.offsetLeft, this.htmlRef.current.offsetTop, dimensions.width, dimensions.height, offset.left, offset.top)
  }
  render() {
      var htmlTag = this.props.htmlTag || "div";
      htmlTag = htmlTag.toLowerCase();
      var styles = this.styles(),
          props = {
              onFocus: this.props.onFocus,
              onBlur: this.props.onBlur,
              onScroll: this.props.onScroll,
              tabIndex: this.props.tabIndex,
              ref: this.htmlRef,
              className: StyleSheet.className([this.props.style, this.props.pointerEvents && styles.pointerEvents, this.props.styleOnLayout && styles.styleOnLayout])
          };
      switch (this.props.draggable && (props.draggable = this.props.draggable, this.props.onDragStart && (props.onDragStart = this.props.onDragStart), this.props.onDragEnd && (props.onDragEnd = this.props.onDragEnd)), this.props.onDragEnter && (props.onDragEnter = this.props.onDragEnter), this.props.onDragLeave && (props.onDragLeave = this.props.onDragLeave), this.props.onDragOver && (props.onDragOver = this.props.onDragOver), this.props.onDrop && (props.onDrop = this.props.onDrop), this.props.onPointerDown && (props.onPointerDown = this.props.onPointerDown), this.props.onPointerUp && (props.onPointerUp = this.props.onPointerUp), this.props.onPointerMove && (props.onPointerMove = this.props.onPointerMove), this.props.onKeyDown && (props.onKeyDown = this.props.onKeyDown), this.props.onKeyUp && (props.onKeyUp = this.props.onKeyUp), this.props.tooltip && (props.title = this.props.tooltip), this.props.id && (props.id = this.props.id), htmlTag) {
          case "a":
              this.props.onClick && (props.onClick = this.props.onClick), this.props.href && (props.href = this.props.href)
      }
      "string" == typeof this.props.children && console.error("View Component Error: String '".concat(this.props.children, "' passed to View. Please enclose strings in a Text component."));
      var view = null;
      if (this.props.Component) {
          var Component = this.props.Component,
              componentProps = this.props.ComponentProps || {},
              componentRef = this.props.ComponentHtmlRefFunction ? ref => {
                  this.htmlRef = this.props.ComponentHtmlRefFunction(ref)
              } : this.htmlRef;
          this.props.ComponentHtmlRefProp ? (componentProps.ref = componentProps.ref || null, componentProps[this.props.ComponentHtmlRefProp] = componentRef) : componentProps.ref = componentRef, view = React__default.createElement(Component, _extends({}, props, {
              ref: null
          }, componentProps), this.props.children)
      } else view = React__default.createElement(htmlTag, props, this.props.children);
      return view
  }
  styles() {
      if (!this.props.pointerEvents && !this.props.styleOnLayout) return {};
      var styles = {
          pointerEvents: {
              pointerEvents: this.props.pointerEvents
          }
      };
      return this.state.styleOnLayout && (styles.styleOnLayout = this.state.styleOnLayout), StyleSheet.create(styles)
  }
}
class ActivityIndicatorBase extends React__default.PureComponent {
  render() {
      var styles = this.styles(),
          circleSpinnerWrapperStyles = [styles.circleSpinnerWrapper],
          circleSpinnerStyles = [styles.circleSpinner];
      return this.props.size && (circleSpinnerWrapperStyles.push(styles["".concat(this.props.size, "Wrapper")]), circleSpinnerStyles.push(styles[this.props.size])), React__default.createElement(ViewBase, {
          style: styles.loadingSpinner
      }, React__default.createElement(ViewBase, {
          style: circleSpinnerWrapperStyles
      }, React__default.createElement(ViewBase, {
          style: circleSpinnerStyles
      })))
  }
  styles() {
      return StyleSheet.create({
          loadingSpinner: {
              display: "block",
              position: "relative"
          },
          circleSpinnerWrapper: {
              display: "block",
              position: "relative",
              fontSize: 0,
              color: this.props.color || Colors.primary,
              width: 36,
              height: 36,
              boxSizing: "border-box"
          },
          circleSpinner: _extends({
              display: "inline-block",
              width: 36,
              height: 36,
              boxSizing: "border-box",
              float: "none",
              backgroundColor: "transparent"
          }, StyleSheet.border(1, "solid", this.props.color || Colors.primary), {
              background: "transparent",
              borderBottomColor: "transparent",
              borderWidth: 3,
              borderRadius: "100%",
              animationName: {
                  "0%": {
                      transform: "rotate(0deg)"
                  },
                  "50%": {
                      transform: "rotate(180deg)"
                  },
                  "100%": {
                      transform: "rotate(360deg)"
                  }
              },
              animationDuration: "750ms",
              animationIterationCount: "infinite",
              animationTimingFunction: "linear"
          }),
          smallWrapper: {
              width: 20,
              height: 20
          },
          small: {
              width: 20,
              height: 20,
              borderWidth: 2
          }
      })
  }
}
class ActivityIndicator extends React__default.Component {
  render() {
      return React__default.createElement(ViewBase, {
          style: [this.style.container, this.props.containerStyle]
      }, React__default.createElement(ActivityIndicatorBase, {
          color: StyleSheet.parseColor(this.props.color || Colors.primary),
          size: this.props.size || "small"
      }))
  }
  get style() {
      return StyleSheet.create({
          container: {
              flex: 0,
              alignItems: "center",
              justifyContent: "center",
              padding: 64
          }
      })
  }
}
_defineProperty(ActivityIndicator, "propTypes", {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  size: PropTypes.oneOf(["large", "small"])
}), _defineProperty(ActivityIndicator, "defaultProps", {
  color: Colors.primary,
  size: "small"
});
class AnimatedElementBase extends React__default.PureComponent {
  constructor(props) {
      super(props), this.htmlRef = React__default.createRef(), this.handleAnimationEnd = this.handleAnimationEnd.bind(this), this.handleAnimationStart = this.handleAnimationStart.bind(this), this.eventListeners = {}, this.hasMounted = !1, this.hasUnmounted = !1, this.type = this.props.type || "view", this.state = {
          unmount: !this.props.in && this.props.unmountOnExit
      }
  }
  parseAnimation(animation) {
      for (var k in animation) animation[k].transform && "string" != typeof animation[k].transform && (animation[k].transform = StyleSheet.utils.renderCssTransformStr(animation[k].transform));
      return animation
  }
  init() {
      this.updateEventListeners(), !(!this.props.in && this.props.unmountOnExit) && this.state.unmount && this.setState({
          unmount: !1
      })
  }
  updateEventListeners() {
      this.htmlRef.current && (this.props.onStart && (this.eventListeners.onAnimationStart = this.htmlRef.current.addEventListener("animationstart", this.handleAnimationStart)), (this.props.onExit || this.props.unmountOnExit || this.props.onEnd) && !this.eventListeners.onAnimationEnd && (this.eventListeners.onAnimationEnd = this.htmlRef.current.addEventListener("animationend", this.handleAnimationEnd)))
  }
  removeEventListeners() {
      this.eventListeners.onAnimationEnd && (document.removeEventListener("animationend", this.handleAnimationEnd), delete this.eventListeners.onAnimationEnd), this.eventListeners.onAnimationStart && (document.removeEventListener("animationstart", this.handleAnimationStart), delete this.eventListeners.onAnimationStart)
  }
  handleAnimationStart() {
      this.props.onStart && this.props.onStart()
  }
  handleAnimationEnd() {
      this.props.onEnd && this.props.onEnd(), this.props.in || (this.props.onExit && this.props.onExit(), this.props.onEnd && this.props.onEnd(), this.hasUnmounted || this.props.in || !this.props.unmountOnExit || this.setState({
          unmount: !0
      }))
  }
  componentDidUpdate() {
      this.init()
  }
  componentDidMount() {
      this.hasMounted = !0, this.init()
  }
  componentWillUnmount() {
      this.hasMounted = !1, this.hasUnmounted = !0, this.removeEventListeners()
  }
  render() {
      var styles = this.styles();
      if (this.state.unmount) return null;
      var animatedElementStyles = [styles.animatedElement];
      this.props.style && animatedElementStyles.push(this.props.style);
      var Component = "text" === this.type ? TextInput : ViewBase;
      return React__default.createElement(Component, _extends({}, this.props, {
          style: animatedElementStyles,
          htmlRef: this.htmlRef,
          pointerEvents: this.props.pointerEvents || null
      }), this.props.children)
  }
  get animationCss() {
      var animation = null,
          duration = this.props.duration || "250ms",
          delay = this.props.delay || null;
      if (!(this.props.animation || this.props.enter || this.props.to && this.props.from)) return null;
      if (this.props.to && this.props.from) animation = {
          from: this.props.from,
          to: this.props.to
      };
      else if (this.props.animation && this.props.animation.enter || this.props.enter) {
          var animationExit = this.props.exit || this.props.animation && this.props.animation.exit || {},
              animationEnter = this.props.enter || this.props.animation && this.props.animation.enter;
          animation = {
              from: this.props.in ? animationExit : animationEnter,
              to: this.props.in ? animationEnter : animationExit
          }, this.hasMounted || this.props.animateOnMount || (duration = 0)
      } else animation = this.props.animation;
      "string" != typeof duration && (duration = "".concat(duration, "ms")), delay && "string" != typeof delay && (delay = "".concat(delay, "ms"));
      var initialCss = {};
      return (animation = this.parseAnimation(animation)).from && (initialCss = animation.from), _extends({
          animationName: animation,
          animationDuration: duration,
          animationDelay: delay,
          animationTimingFunction: this.props.timingFunction || "ease-in",
          animationIterationCount: this.props.iterationCount || null,
          animationFillMode: this.props.fillMode || "forwards"
      }, initialCss)
  }
  styles() {
      return StyleSheet.create({
          animatedElement: _extends({}, this.animationCss)
      })
  }
}
class AnimatedView extends React__default.PureComponent {
  render() {
      return React__default.createElement(AnimatedElementBase, _extends({
          type: "view"
      }, this.props))
  }
}
_defineProperty(AnimatedView, "propTypes", {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  animation: PropTypes.object,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  timingFunction: PropTypes.oneOf(["linear", "ease", "ease-in", "ease-out", "ease-in-"]),
  iterationCount: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(["infinite"])]),
  fillMode: PropTypes.oneOf(["forwards", "backwards", "both"]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
}), _defineProperty(AnimatedView, "defaultProps", {
  duration: 250,
  timingFunction: "ease-in",
  fillMode: "forwards"
});
class TextBase extends React__default.Component {
  constructor(props) {
      super(props), this.htmlRef = this.props.htmlRef || React__default.createRef()
  }
  render() {
      var htmlTag = this.props.htmlTag || "span",
          styles = this.styles(),
          TextComponent = React__default.createElement(htmlTag, {
              ref: this.htmlRef,
              className: StyleSheet.className([this.props.style, styles.wrap, this.props.pointerEvents && styles.pointerEvents])
          }, this.props.children);
      return this.props.onLayout && (this.resizeObserver = new ResizeObserver(entries => {
          this.triggerOnLayout()
      })), TextComponent
  }
  triggerOnLayout() {
      if (!this.props.onLayout) return !1;
      var ret = {
          nativeEvent: {
              layout: {
                  x: this.htmlRef.current.offsetLeft,
                  y: this.htmlRef.current.offsetTop,
                  width: this.htmlRef.current.offsetWidth,
                  height: this.htmlRef.current.offsetHeight
              }
          }
      };
      this.props.onLayout(ret)
  }
  componentDidMount() {
      this.props.onLayout && (this.triggerOnLayout(), this.resizeObserver.observe(this.htmlRef.current))
  }
  styles() {
      return StyleSheet.create({
          wrap: {
              whiteSpace: this.props.noWrap ? "nowrap" : "pre-wrap"
          },
          pointerEvents: {
              pointerEvents: this.props.pointerEvents
          }
      })
  }
}
class TextInput extends React__default.PureComponent {
  render() {
      return React__default.createElement(TextBase, _extends({}, this.props, {
          style: [styles.text, this.props.style]
      }))
  }
}
var _class, _temp, styles = StyleSheet.create({
      text: {
          color: Colors.onBackground
      }
  }),
  Route = R14.connect((_temp = _class = class extends React__default.Component {
      constructor(props) {
          super(props), this.name = null, this.path = null, this.hasFocused = !1, this.hasRendered = !1, this.isReloading = !1, this._hasSubmittedForm = !1, this._portal = this.props.r14.navigation.getPortalByRouteName(this.props.name), this._r14AppInstance = this._portal.createAppInstance(), this.state = {
              component: null,
              isLoading: !1
          }
      }
      forward() {
          if (this.props.config.to) {
              var route = null,
                  params = {};
              return "string" == typeof this.props.config.to ? route = this.props.config.to : (route = this.props.config.to.route, this.props.config.to.params && (params = _extends({}, params, this.props.config.to.params))), this.props.app.nav.to(route, params), !0
          }
          return !1
      }
      componentDidUpdate(prevProps) {
          this.name === this.props.name && this.hasSubmittedForm;
          if (this.path === this.props.path && this.hasSubmittedForm) {
              if (this.forward()) return !1;
              this.props.r14.navigation.initActiveRoute(this.props.name, this.props), this.isReloading = !0, this.initializeActionResult()
          }
      }
      componentWillFocus() {
          if (!this.props.path || this.path !== this.props.path) {
              if (this.forward()) return !1;
              var isActiveRoute = !1;
              this._portal && this._portal.route && this._portal.route.path && this._portal.route.path === this.props.path && (isActiveRoute = !0), isActiveRoute || this.props.r14.navigation.initActiveRoute(this.props.name, this.props), this.isReloading = !1, this.name = this.props.name, this.path = this.props.path, this.initializeActionResult()
          }
      }
      setLoading(isLoading) {
          this.setState({
              isLoading: isLoading
          })
      }
      get isLoading() {
          return this.state.isLoading
      }
      handleLayout() {}
      load() {
          return _asyncToGenerator((function*() {}))()
      }
      initializeActionResult() {
          var _this = this;
          return _asyncToGenerator((function*() {
              if (!_this.props.name) throw "Route name prop is required.";
              if (!_this.props.config) throw "Route config prop is required for route '".concat(_this.props.name, "'.");
              yield _this.props.app.initialize(), _this.props.app.ui.form.clearSubmittedForm(), _this.isReloading ? _this.props.app.ui.progressIndicator.show() : _this.setState({
                  component: null,
                  isLoading: !0
              });
              var beforeLoadRes = yield _this.props.r14.navigation.handleBeforeLoad(_this.props.app);
              if (React__default.isValidElement(beforeLoadRes)) _this.setState({
                  component: beforeLoadRes,
                  isLoading: !1
              });
              else if (!0 === beforeLoadRes) {
                  var action = _this.props.config.action || "default",
                      actionName = null,
                      Actions = null;
                  if (_this.props.config.actions) {
                      if (!(Actions = new _this.props.config.actions)["".concat(action, "Action")]) throw "Unable to find action '".concat(action, "Action' for route '").concat(_this.props.name, "'");
                      actionName = "".concat(action, "Action")
                  } else Actions = _this.props.app.action, actionName = _this.props.config.action || _this.props.name;
                  if (!Actions || !actionName || !Actions[actionName]) throw new Error("Unable to find action method for route '".concat(_this.props.name, "'."));
                  var Component = yield Actions[actionName](_this._portal.data);
                  _this.isReloading && (_this.props.app.ui.progressIndicator.hide({
                      timeout: 750
                  }), _this.isReloading = !1), _this.setState({
                      component: Component,
                      isLoading: !1
                  })
              }
          }))()
      }
      get hasSubmittedForm() {
          return this.props.app.ui.form.activeRouteName === this.props.name && (this._hasSubmittedForm = !0, !0)
      }
      render() {
          return this.state.isLoading ? React__default.createElement(ActivityIndicator, {
              size: "large",
              containerStyle: styles$1.activityIndicator
          }) : (this.hasSubmittedForm, React__default.createElement(Provider, {
              app: this._r14AppInstance
          }, React__default.createElement(ViewBase, {
              key: Theme.key,
              style: styles$1.routeContainer
          }, React__default.createElement(AnimatedView, {
              animation: {
                  from: {
                      opacity: 0
                  },
                  to: {
                      opacity: 1
                  }
              },
              timingFunction: "ease-out",
              duration: 250,
              style: styles$1.route
          }, this.state.component))))
      }
  }, _defineProperty(_class, "propTypes", {
      name: PropTypes.string.isRequired,
      config: PropTypes.object.isRequired
  }), _temp)),
  styles$1 = StyleSheet.create({
      activityIndicator: {
          flex: 1,
          justifyContent: "space-around",
          alignItems: "center",
          backgroundColor: Colors.background
      },
      routeContainer: {
          flex: 1,
          backgroundColor: Colors.background
      },
      route: {
          flex: 1
      },
      text: {
          color: "#000000"
      }
  });
class Modal extends React__default.Component {
  render() {
      var animationType = this.props.animationType || "none",
          modalView = null;
      if ("none" === animationType) {
          if (!this.props.visible) return null;
          modalView = React__default.createElement(ViewBase, {
              style: [styles$2.modal, this.props.style]
          }, this.props.children)
      } else {
          var animation = "slide" === animationType ? {
              enter: {
                  transform: [{
                      translateY: 0
                  }],
                  opacity: 1
              },
              exit: {
                  transform: [{
                      translateY: 400
                  }],
                  opacity: 0
              }
          } : {
              enter: {
                  opacity: 1
              },
              exit: {
                  opacity: 0
              }
          };
          modalView = React__default.createElement(AnimatedView, {
              style: [styles$2.modal, this.props.style],
              in: this.props.visible,
              animation: animation,
              animateOnMount: !0,
              unmountOnExit: !0,
              duration: 100
          }, this.props.children)
      }
      return modalView ? ReactDOM.createPortal(modalView, document.getElementById("root")) : null
  }
}
var styles$2 = StyleSheet.create({
  modal: _extends({
      zIndex: 7,
      flex: 1,
      flexDirection: "column",
      position: "absolute"
  }, StyleSheet.absoluteFill, {
      overflow: "hidden"
  })
});
class FadeView extends React__default.PureComponent {
  render() {
      return React__default.createElement(AnimatedView, _extends({}, this.props, {
          in: this.props.visible,
          enter: {
              opacity: 1
          },
          exit: {
              opacity: 0
          },
          animateOnMount: this.props.animateOnMount,
          unmountOnExit: !("unmountOnExit" in this.props) || this.props.unmountOnExit,
          timeout: this.props.timeout,
          duration: this.props.duration
      }), this.props.children)
  }
}
class ShowHideText extends React__default.PureComponent {
  constructor(props) {
      super(props), this.handlePressIn = this.handlePressIn.bind(this), this.handlePressOut = this.handlePressOut.bind(this), this.handlePressCancel = this.handlePressCancel.bind(this), this.handleLayout = this.handleLayout.bind(this), this.state = {
          fadeIn: !1,
          scale: 0,
          locationX: 0,
          locationY: 0
      }, this._layout = null, this._animationType = null
  }
  handlePressIn(event) {
      var scale = this.calculateScale(event.nativeEvent.locationX, event.nativeEvent.locationY);
      this._animationType = "scale", this.setState({
          scale: scale,
          locationX: event.nativeEvent.locationX,
          locationY: event.nativeEvent.locationY,
          fadeIn: !0
      })
  }
  handlePressOut(event) {
      "scale" === this._animationType && this.state.fadeIn && this.setState({
          fadeIn: !1
      })
  }
  handlePressCancel(event) {
      this.handlePressOut(event)
  }
  handleLayout(event) {
      this._layout = event.nativeEvent.layout
  }
  calculateScale(x, y) {
      var radius = this.props.size ? this.props.size / 2 : null;
      if (null === radius) {
          var distance = (x1, y1, x2, y2) => Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2)),
              {
                  width: width,
                  height: height
              } = this._layout;
          radius = Math.max(distance(0, 0, x, y), distance(0, height, x, y), distance(width, 0, x, y), distance(width, height, x, y))
      }
      return 2 * radius / 24
  }
  createDynamicStyles() {
      var dynamicStyles = {
          ripple: {
              overflow: !1 === this.props.bounded ? null : "hidden"
          },
          animatedView: {
              top: this.state.locationY - 12,
              left: this.state.locationX - 12,
              backgroundColor: StyleSheet.color(this.props.color || Colors.onSurface).rgba(.12)
          }
      };
      return StyleSheet.create(dynamicStyles)
  }
  render() {
      var dynamicStyles = this.createDynamicStyles();
      return React__default.createElement(TouchableBase, {
          timingFunction: "ease-in",
          style: [styles$3.ripple, dynamicStyles.ripple],
          onPressIn: this.handlePressIn,
          onPressOut: this.handlePressOut,
          onPressCancel: this.handlePressCancel,
          onLayout: this.handleLayout,
          feedback: !1
      }, React__default.createElement(FadeView, {
          visible: this.state.fadeIn,
          duration: 150
      }, React__default.createElement(AnimatedView, {
          style: [styles$3.animatedView, dynamicStyles.animatedView, this.props.styles],
          from: {
              transform: [{
                  scale: 1
              }]
          },
          to: {
              transform: [{
                  scale: this.state.scale
              }]
          },
          duration: 250,
          pointerEvents: "none"
      })))
  }
}
_defineProperty(ShowHideText, "propTypes", {
  in: PropTypes.bool,
  offsetTop: PropTypes.bool,
  offsetLeft: PropTypes.bool
}), _defineProperty(ShowHideText, "defaultProps", {
  in: !1
});
var styles$3 = StyleSheet.create({
  ripple: _extends({
      position: "absolute"
  }, StyleSheet.absoluteFill, {
      cursor: "inherit"
  }),
  animatedView: {
      position: "absolute",
      top: 0,
      left: 0,
      height: 24,
      width: 24,
      borderRadius: 12,
      backgroundColor: StyleSheet.color(Colors.onSurface).rgba(.12),
      position: "absolute"
  }
});
class LinkBase extends React__default.Component {
  constructor(props) {
      super(props), this.handlePress = this.handlePress.bind(this), this.ref = React__default.createRef()
  }
  handlePress(e) {
      e.preventDefault(), this.props.onPress(e)
  }
  measureInWindow(callback) {
      this.ref.current.measureInWindow(callback)
  }
  measure(callback) {
      this.ref.current.measure(callback)
  }
  render() {
      styles$4.link, this.props.style;
      return React__default.createElement(ViewBase, {
          href: this.props.routeProps.route,
          style: [styles$4.link, this.props.style],
          onClick: this.handlePress,
          htmlTag: "a",
          ref: this.ref,
          onLayout: this.props.onLayout
      }, this.props.children, React__default.createElement(ShowHideText, null))
  }
}
var styles$4 = StyleSheet.create({
      link: {
          textDecoration: "none",
          position: "relative"
      }
  }),
  Link = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props), this.handlePress = this.handlePress.bind(this), this.routeProps = null, this.initialize(), this.ref = React__default.createRef(), this.state = {
              isActive: this.isActive
          }
      }
      componentDidUpdate() {
          this.initialize()
          this.updateActive()
      }
      componentDidMount() {
          this.state.isActive && this.isActive && this.props.onActive ? this.props.onActive(this) : this.updateActive()
      }
      updateActive() {
          this.isActive !== this.state.isActive && (this.isActive && this.props.onActive && this.props.onActive(this), this.setState({
              isActive: this.isActive
          }))
      }
      handlePress(e) {
          this.props.onPress && this.props.onPress(e), this.props.app.navigation.to(this.routeProps)
      }
      handleActive() {
          this.props.onActive && this.props.onActive(this)
      }
      parseLinkProps(props) {
          var routeProps = {
              route: props.route || null,
              delay: props.delay || 0
          };
          if (!props.to) throw "Route Link Error: No to.";
          if ("object" == typeof props.to ? (props.to.pathname ? routeProps.route = props.to.pathname : props.to.route && (routeProps.route = props.to.route), props.to.params && (routeProps.params = props.to.params), props.to.portal && (routeProps.portal = props.to.portal), props.to.state && (routeProps.state = props.to.state)) : routeProps.route = props.to, !routeProps.route) throw "Route Link Error: No pathname.";
          return routeProps
      }
      initialize() {
          this.routeProps = this.parseLinkProps(this.props)
      }
      get isActive() {
          return this.props.app.r14Instance.navigation.isActiveRoute(this.routeProps)
      }
      get className() {}
      measureInWindow(callback) {
          this.ref.current.measureInWindow(callback)
      }
      measure(callback) {
          this.ref.current.measure(callback)
      }
      render() {
          var linkStyles = [];
          return this.props.style && linkStyles.push(this.props.style), this.props.activeStyle && this.isActive && linkStyles.push(this.props.activeStyle), React__default.createElement(LinkBase, {
              routeProps: this.routeProps,
              style: linkStyles,
              onPress: this.handlePress,
              ref: this.ref
          }, this.props.children)
      }
  });
class TouchableBase extends React__default.Component {
  constructor(props) {
      super(props), this.POINTER_TYPE_MOUSE = "MOUSE", this.POINTER_TYPE_TOUCH = "TOUCH", this.handlePress = this.handlePress.bind(this), this.handlePressIn = this.handlePressIn.bind(this), this.handlePressOut = this.handlePressOut.bind(this), this.handlePressMove = this.handlePressMove.bind(this), this.handlePressCancel = this.handlePressCancel.bind(this), this.handleMouseDown = this.handleMouseDown.bind(this), this.handleMouseUp = this.handleMouseUp.bind(this), this.handleMouseMove = this.handleMouseMove.bind(this), this.handleMouseLeave = this.handleMouseLeave.bind(this), this.htmlRef = React__default.createRef(), (this.props.onLayout || this.props.styleOnLayout) && (this.resizeObserver = new ResizeObserver(entries => {
          this.triggerOnLayout()
      })), this._pointerType = null, this._press = !1, this.state = {
          press: !1
      }, this._id = Math.random()
  }
  componentDidMount() {
      this.props.onLayout && (setTimeout(() => {
          this.triggerOnLayout()
      }, 5), this.resizeObserver.observe(this.htmlRef.current))
  }
  componentWillUnmount() {
      this.props.onLayout && this.resizeObserver.disconnect()
  }
  triggerOnLayout() {
      var event;
      if (!this.props.onLayout && !this.props.styleOnLayout || !this.htmlRef.current) return !1;
      event = {
          nativeEvent: {
              layout: {
                  x: this.htmlRef.current.offsetLeft,
                  y: this.htmlRef.current.offsetTop,
                  width: this.htmlRef.current.offsetWidth,
                  height: this.htmlRef.current.offsetHeight
              }
          }
      }, this.props.onLayout && this.props.onLayout(event)
  }
  measureInWindow(callback) {
      var offset = R14.utils.dom.offset(this.htmlRef.current),
          dimensions = R14.utils.dom.dimensions(this.htmlRef.current);
      callback(offset.left, offset.top, dimensions.width, dimensions.height)
  }
  measure(callback) {
      var offset = R14.utils.dom.offset(this.htmlRef.current),
          dimensions = R14.utils.dom.dimensions(this.htmlRef.current);
      callback(this.htmlRef.current.offsetLeft, this.htmlRef.current.offsetTop, dimensions.width, dimensions.height, offset.left, offset.top)
  }
  normalizeEvent(e) {
      var event = {
          nativeEvent: {
              locationX: null,
              locationY: null,
              pageX: null,
              pageY: null,
              movementX: null,
              movementY: null
          }
      };
      if (!e.nativeEvent) return event;
      if (window.TouchEvent && e.nativeEvent instanceof window.TouchEvent) {
          var touch = null;
          if (e.nativeEvent.touches && e.nativeEvent.touches.length ? touch = e.nativeEvent.touches[0] : e.nativeEvent.changedTouches && e.nativeEvent.changedTouches.length && (touch = e.nativeEvent.changedTouches[0]), !touch) return event;
          if (event.nativeEvent.pageX = touch.pageX, event.nativeEvent.pageY = touch.pageY, this.htmlRef.current) {
              var pPos = this.htmlRef.current.getBoundingClientRect();
              pPos && (event.nativeEvent.locationX = touch.pageX - pPos.x, event.nativeEvent.locationY = touch.pageY - pPos.y)
          }
          this._lastEvent && (event.nativeEvent.movementX = touch.pageX - this._lastEvent.nativeEvent.pageX, event.nativeEvent.movementY = touch.pageY - this._lastEvent.nativeEvent.pageY)
      } else if (window.MouseEvent && e.nativeEvent instanceof window.MouseEvent) {
          if (this.htmlRef.current) {
              var _pPos = this.htmlRef.current.getBoundingClientRect();
              _pPos && (event.nativeEvent.locationX = e.nativeEvent.pageX - _pPos.x, event.nativeEvent.locationY = e.nativeEvent.pageY - _pPos.y)
          } else event.nativeEvent.locationX = e.nativeEvent.offsetX, event.nativeEvent.locationY = e.nativeEvent.offsetY;
          event.nativeEvent.pageX = e.nativeEvent.pageX, event.nativeEvent.pageY = e.nativeEvent.pageY, "movementX" in e.nativeEvent ? (event.nativeEvent.movementX = e.nativeEvent.movementX, event.nativeEvent.movementY = e.nativeEvent.movementY) : this._lastEvent && (event.nativeEvent.movementX = e.nativeEvent.pageX - this._lastEvent.nativeEvent.pageX, event.nativeEvent.movementY = e.nativeEvent.pageY - this._lastEvent.nativeEvent.pageY)
      }
      return event.preventDefault = () => {
          e.preventDefault()
      }, event.stopPropagation = () => {
          e.stopPropagation()
      }, this._lastEvent = event, event
  }
  handlePress(e) {
      this.props.onPress && this.props.onPress(this.normalizeEvent(e))
  }
  handleMouseDown(e) {
      if (this._pointerType) {
          if (this._pointerType !== this.POINTER_TYPE_MOUSE) return
      } else this._pointerType = this.POINTER_TYPE_MOUSE;
      this.handlePressIn(e, !0)
  }
  handlePressIn(e) {
      var mouseEvent = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      if (this._pointerType) {
          if (this._pointerType === this.POINTER_TYPE_TOUCH && mouseEvent) return
      } else this._pointerType = this.POINTER_TYPE_TOUCH;
      return this.setState({
          press: !0
      }), this._press = !0, this.props.onPressIn && this.props.onPressIn(this.normalizeEvent(e)), !1
  }
  handleMouseUp(e) {
      this._pointerType !== this.POINTER_TYPE_TOUCH && this.handlePressOut(e)
  }
  handlePressOut(e) {
      this.setState({
          press: !1
      }), this._press = !1, this.props.onPressOut && this.props.onPressOut(this.normalizeEvent(e))
  }
  handleMouseMove(e) {
      this._pointerType !== this.POINTER_TYPE_TOUCH && this.handlePressMove(e)
  }
  handlePressMove(e) {
      this.state.press && this.props.onPressMove && this.props.onPressMove(this.normalizeEvent(e))
  }
  handleMouseLeave(e) {
      this._pointerType !== this.POINTER_TYPE_TOUCH && this.handlePressCancel(e)
  }
  handlePressCancel(e) {
      this.state.press && this.props.onPressCancel && this.props.onPressCancel(this.normalizeEvent(e))
  }
  preventDefault(e) {
      e.preventDefault()
  }
  render() {
      if (this.props.to) return React__default.createElement(Link, _extends({}, this.props, {
          ref: this.htmlRef
      }));
      var props = {
          className: StyleSheet.className([styles$5.touchable, this.props.style])
      };
      return this.props.onPress && (props.onClick = this.handlePress), (this.props.onPressIn || this.props.onPressMove || this.props.onPressCancel) && (props.onMouseDown = this.handleMouseDown, props.onTouchStart = this.handlePressIn), (this.props.onPressOut || this.props.onPressMove || this.props.onPressCancel) && (props.onMouseUp = this.handleMouseUp, props.onTouchEnd = this.handlePressOut), this.props.onPressMove && (props.onMouseMove = this.handleMouseMove, props.onTouchMove = this.handlePressMove), this.props.onPressCancel && (props.onMouseLeave = this.handleMouseLeave, props.onTouchCancel = this.handlePressCancel), this.props.tooltip && (props.title = this.props.tooltip), "string" == typeof this.props.children && console.error("Touchable Component Error: String '".concat(this.props.children, "' passed to View. Please enclose strings in a Text component.")), React__default.createElement("div", _extends({}, props, {
          ref: this.htmlRef
      }), this.props.children, this.props.feedback && React__default.createElement(ShowHideText, null))
  }
}
_defineProperty(TouchableBase, "propTypes", {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onPress: PropTypes.func,
  onPressIn: PropTypes.func,
  onPressOut: PropTypes.func,
  onPressMove: PropTypes.func,
  onPressCancel: PropTypes.func,
  feedback: PropTypes.bool
}), _defineProperty(TouchableBase, "defaultProps", {
  feedback: !0
});
var styles$5 = StyleSheet.create({
  touchable: {
      cursor: "pointer",
      position: "relative",
      outline: 0,
      "-webkit-tap-highlight-color": "transparent",
      "-webkit-touch-callout:": "none",
      touchAction: "none",
      userSelect: "none"
  }
});
class ScrollViewBase extends React__default.Component {
  constructor(props) {
      super(props), this.lastScrollTop = 0, this.scrollEnabled = !0, this.doResetScroll = !1, this.htmlRef = React__default.createRef(), this.ref = React__default.createRef(), this.scrollBarRef = React__default.createRef(), this.contentHtmlRef = React__default.createRef(), this.handleLayout = this.handleLayout.bind(this), this.handleContentSizeChange = this.handleContentSizeChange.bind(this), this.handleScroll = this.handleScroll.bind(this), this.lastContentSize = {
          x: null,
          y: null
      }
  }
  componentDidMount() {}
  scrollTo(params) {
      if (!this.htmlRef.current) return !1;
      var scrollParams = {
          left: params.x || 0,
          top: params.y || 0
      };
      !1 !== params.animated && (scrollParams.behavior = "smooth"), this.htmlRef.current.scrollTo(scrollParams)
  }
  scrollToEnd() {
      var params = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      if (!this.htmlRef.current) return !1;
      params.y = this.htmlRef.current.scrollHeight + this.htmlRef.current.clientHeight || 0, setTimeout(() => this.scrollTo(params))
  }
  handleLayout(val) {
      if (this.props.onLayout) return this.props.onLayout(val)
  }
  handleScroll() {
      this.triggerOnScroll()
  }
  triggerOnScroll() {
      this.htmlRef.current && this.props.onScroll && this.props.onScroll({
          nativeEvent: {
              contentOffset: {
                  x: this.htmlRef.current.scrollLeft,
                  y: this.htmlRef.current.scrollTop
              },
              layout: {
                  width: this.htmlRef.current.offsetWidth,
                  height: this.htmlRef.current.offsetHeight
              },
              contentSize: {
                  width: this.contentHtmlRef.current.scrollWidth,
                  height: this.contentHtmlRef.current.scrollHeight
              }
          }
      })
  }
  measureInWindow(callback) {
      this.ref && this.ref.current && this.ref.current.measureInWindow(callback)
  }
  measure(callback) {
      this.ref && this.ref.current && this.ref.current.measure(callback)
  }
  handleContentSizeChange(val) {
      var contentSize = {
          width: val.nativeEvent.layout.width,
          height: val.nativeEvent.layout.height
      };
      contentSize.width === this.lastContentSize.width && contentSize.height === this.lastContentSize.height || (this.lastContentSize = contentSize, this.scrollBarRef && this.scrollBarRef.current && this.scrollBarRef.current._ps.update(), this.props.onContentSizeChange && this.props.onContentSizeChange(contentSize.width, contentSize.height))
  }
  get overflow() {
      var overflowX = this.props.overflowX || this.props.overflow || "hidden",
          overflowY = this.props.overflowY || this.props.overflow || "auto";
      return this.props.horizontal && (overflowX = "auto", overflowY = "hidden"), {
          x: overflowX,
          y: overflowY
      }
  }
  render() {
      var overflowX = this.overflow.x,
          overflowY = this.overflow.y,
          componentProps = {
              ref: this.scrollBarRef,
              options: {}
          };
      "hidden" === overflowX && (componentProps.options.suppressScrollX = !0), "hidden" === overflowY && (componentProps.options.suppressScrollY = !0);
      var styles = this.createDynamicStyles();
      return React__default.createElement(ViewBase, {
          onLayout: this.props.onLayout && this.handleLayout,
          ref: this.ref,
          style: [styles.scrollView, !this.scrollEnabled && styles.disabled, this.props.style],
          Component: PerfectScrollbar,
          ComponentRef: this.scrollbarRef,
          ComponentHtmlRefProp: "containerRef",
          ComponentHtmlRefFunction: ref => (this.htmlRef = {
              current: ref
          }, this.htmlRef),
          ComponentProps: componentProps,
          onScroll: this.props.onScroll && this.handleScroll
      }, React__default.createElement(ViewBase, {
          style: [styles.scrollViewContent, this.props.contentStyle],
          htmlRef: this.contentHtmlRef,
          onLayout: this.handleContentSizeChange
      }, this.props.children))
  }
  createDynamicStyles() {
      var height = this.props.height || null;
      this.props.autoSize && (height = "100%");
      var overflowX = this.overflow.x,
          overflowY = this.overflow.y,
          scrollViewStyle = height ? {
              overflowY: overflowY,
              overflowX: overflowX,
              height: this.props.height
          } : _extends({
              overflowY: overflowY,
              overflowX: overflowX,
              position: "absolute",
              flex: 1
          }, StyleSheet.absoluteFill);
      return !1 === this.props.showsHorizontalScrollIndicator && (scrollViewStyle["::-webkit-scrollbar"] = {
          width: 0,
          backgroundColor: "transparent"
      }, scrollViewStyle["::-webkit-scrollbar *"] = {
          backgroundColor: "transparent"
      }, scrollViewStyle.boxSizing = "content-box"), StyleSheet.create({
          scrollView: scrollViewStyle,
          disabled: {
              marginTop: "-".concat(this.lastScrollTop, "px"),
              position: "relative"
          },
          scrollViewContent: {
              flex: 1
          }
      })
  }
}
class Modal$1 extends React__default.PureComponent {
  constructor(props) {
      super(props), this.handleBackdropPress = this.handleBackdropPress.bind(this), this.handleRequestClose = this.handleRequestClose.bind(this)
  }
  handleBackdropPress() {
      this.props.onBackdropPress && this.props.onBackdropPress()
  }
  handleRequestClose() {
      return !this.props.onRequestClose || this.props.onRequestClose()
  }
  handleContentLayout(event) {
      if (this.props.scrollEnabled) DimensionsBase.get("window")
  }
  render() {
      var ContentWrapper = this.props.scrollEnabled ? ScrollViewBase : ViewBase;
      return React__default.createElement(Modal, _extends({}, this.props, {
          onRequestClose: this.handleRequestClose
      }), React__default.createElement(ContentWrapper, {
          style: styles$6.contentWrapper
      }, React__default.createElement(ViewBase, {
          style: [styles$6.content, this.props.contentStyle]
      }, this.props.children)), (this.props.onBackdropPress || this.props.backdrop) && React__default.createElement(TouchableBase, {
          onPress: this.handleBackdropPress,
          feedback: !1,
          style: styles$6.backdropTouchable
      }, React__default.createElement(ViewBase, {
          style: [styles$6.backdrop, this.props.backdropStyle]
      })))
  }
}
_defineProperty(Modal$1, "propTypes", {
  visible: PropTypes.bool.isRequired,
  animationType: PropTypes.oneOf(["slide", "fade", "none"]),
  transparent: PropTypes.bool
}), _defineProperty(Modal$1, "defaultProps", {
  animationType: "none"
});
var styles$6 = StyleSheet.create({
  backdrop: _extends({}, StyleSheet.absoluteFill),
  backdropTouchable: _extends({}, StyleSheet.absoluteFill),
  contentWrapper: {
      flex: 1
  },
  content: {
      position: "relative",
      flex: 1,
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-around"
  }
});
class Surface extends React__default.PureComponent {
  constructor(props) {
      super(props)
  }
  render() {
      var styles = this.styles();
      return React__default.createElement(ViewBase, _extends({}, this.props, {
          style: [styles.surface, this.props.style]
      }), this.props.children)
  }
  styles() {
      return StyleSheet.create({
          surface: {
              backgroundColor: Colors.surface,
              color: Colors.onSurface,
              padding: 16,
              elevation: this.props.elevation || 2
          }
      })
  }
}
class ExternalLinkBase extends React__default.PureComponent {
  render() {
      var linkContent = this.props.url;
      return React__default.Children.count(this.props.children) ? linkContent = this.props.children : this.props.title && (linkContent = this.props.title), React__default.createElement("a", {
          href: this.props.url,
          className: StyleSheet.className([this.props.style]),
          target: "_BLANK",
          rel: "noopener noreferrer"
      }, linkContent)
  }
}
class ExternalLink extends React__default.PureComponent {
  render() {
      return React__default.createElement(ExternalLinkBase, _extends({}, this.props, {
          style: [styles$7.text, this.props.style]
      }))
  }
}
_defineProperty(ExternalLink, "propTypes", {
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
});
var _path, _path$1, _path$2, _path$3, _path$4, _path$5, _path$6, _path$7, _path$8, _path$9, _path$a, _path$b, _path$c, _path$d, _path$e, _path$f, _path$g, _path$h, _path$i, _path$j, _path$k, _path$l, _path$m, _path$n, _path$o, _path$p, _path$q, _path$r, _path$s, _path$t, _path$u, _path$v, _path$w, _path$x, _path$y, _path$z, _path$A, _path$B, _path$C, _path$D, _path$E, _path$F, _path$G, _path$H, _path$I, _path$J, _path$K, _path$L, _path$M, _path$N, _path$O, _path$P, _path$Q, _path$R, _path$S, _path$T, _path$U, _path$V, _path$W, _path$X, _path$Y, _path$Z, _path$_, _path$$, _path$10, _path$11, _path$12, _path$13, _path$14, _path$15, _path$16, _path$17, _path$18, _path$19, _path$1a, _path$1b, _path$1c, _path$1d, _path$1e, _path$1f, _path$1g, _path$1h, _path$1i, _path$1j, _path$1k, _path$1l, _path$1m, _path$1n, _path$1o, _path$1p, _path$1q, _path$1r, _path$1s, _path$1t, _path2, _path$1u, _path2$1, _path$1v, _path2$2, _path$1w, _path2$3, _path$1x, _path2$4, _path$1y, _path$1z, _path$1A, _path$1B, _path$1C, _path$1D, _path$1E, _path$1F, _path$1G, _path$1H, _path$1I, _path$1J, _path$1K, _path$1L, styles$7 = StyleSheet.create({
  text: {
      color: Colors.secondary
  }
});
class SvgIcon extends React__default.PureComponent {
  render() {
      var styles = this.styles(),
          SvgIcon = this.props.svg;
      return React__default.createElement(SvgIcon, {
          className: StyleSheet.className([styles.svgIcon, this.props.style]),
          height: "".concat(this.props.size, "px"),
          width: "".concat(this.props.size, "px"),
          preserveAspectRatio: "xMinYMin slice",
          viewBox: [0, 0, 24, 24]
      })
  }
  styles() {
      return StyleSheet.create({
          svgIcon: {
              fill: this.props.color || "#FFFFFF",
              height: this.props.size,
              width: this.props.size
          }
      })
  }
}

function _extends$1() {
  return (_extends$1 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgPencil(props) {
  return createElement("svg", _extends$1({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path || (_path = createElement("path", {
      d: "M20.71 7.04c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.37-.39-1.02-.39-1.41 0l-1.84 1.83 3.75 3.75M3 17.25V21h3.75L17.81 9.93l-3.75-3.75L3 17.25z"
  })))
}

function _extends$2() {
  return (_extends$2 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgAccountCircle(props) {
  return createElement("svg", _extends$2({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1 || (_path$1 = createElement("path", {
      d: "M12 19.2c-2.5 0-4.71-1.28-6-3.2.03-2 4-3.1 6-3.1s5.97 1.1 6 3.1a7.232 7.232 0 01-6 3.2M12 5a3 3 0 013 3 3 3 0 01-3 3 3 3 0 01-3-3 3 3 0 013-3m0-3A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10c0-5.53-4.5-10-10-10z"
  })))
}

function _extends$3() {
  return (_extends$3 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgFileDocumentBoxMultipleOutline(props) {
  return createElement("svg", _extends$3({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$2 || (_path$2 = createElement("path", {
      d: "M16 15H9v-2h7v2m3-4H9V9h10v2m0-4H9V5h10v2M3 5v16h16v2H3a2 2 0 01-2-2V5h2m18-4a2 2 0 012 2v14c0 1.11-.89 2-2 2H7a2 2 0 01-2-2V3c0-1.11.89-2 2-2h14M7 3v14h14V3H7z"
  })))
}

function _extends$4() {
  return (_extends$4 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgBrain(props) {
  return createElement("svg", _extends$4({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$3 || (_path$3 = createElement("path", {
      d: "M21.33 12.91c.09 1.55-.62 3.04-1.89 3.95l.77 1.49c.23.45.26.98.06 1.45-.19.47-.58.84-1.06 1l-.79.25a1.687 1.687 0 01-1.86-.55L14.44 18c-.89-.15-1.73-.53-2.44-1.1-.5.15-1 .23-1.5.23-.88 0-1.76-.27-2.5-.79-.53.16-1.07.23-1.62.22-.79.01-1.57-.15-2.3-.45a4.105 4.105 0 01-2.43-3.61c-.08-.72.04-1.45.35-2.11-.29-.75-.32-1.57-.07-2.33C2.3 7.11 3 6.32 3.87 5.82c.58-1.69 2.21-2.82 4-2.7 1.6-1.5 4.05-1.66 5.83-.37.42-.11.86-.17 1.3-.17 1.36-.03 2.65.57 3.5 1.64 2.04.53 3.5 2.35 3.58 4.47.05 1.11-.25 2.2-.86 3.13.07.36.11.72.11 1.09m-5-1.41c.57.07 1.02.5 1.02 1.07a1 1 0 01-1 1h-.63c-.32.9-.88 1.69-1.62 2.29.25.09.51.14.77.21 5.13-.07 4.53-3.2 4.53-3.25a2.592 2.592 0 00-2.69-2.49 1 1 0 01-1-1 1 1 0 011-1c1.23.03 2.41.49 3.33 1.3.05-.29.08-.59.08-.89-.06-1.24-.62-2.32-2.87-2.53-1.25-2.96-4.4-1.32-4.4-.4-.03.23.21.72.25.75a1 1 0 011 1c0 .55-.45 1-1 1-.53-.02-1.03-.22-1.43-.56-.48.31-1.03.5-1.6.56-.57.05-1.04-.35-1.07-.9a.968.968 0 01.88-1.1c.16-.02.94-.14.94-.77 0-.66.25-1.29.68-1.79-.92-.25-1.91.08-2.91 1.29C6.75 5 6 5.25 5.45 7.2 4.5 7.67 4 8 3.78 9c1.08-.22 2.19-.13 3.22.25.5.19.78.75.59 1.29-.19.52-.77.78-1.29.59-.73-.32-1.55-.34-2.3-.06-.32.27-.32.83-.32 1.27 0 .74.37 1.43 1 1.83.53.27 1.12.41 1.71.4-.15-.26-.28-.53-.39-.81a1.038 1.038 0 011.96-.68c.4 1.14 1.42 1.92 2.62 2.05 1.37-.07 2.59-.88 3.19-2.13.23-1.38 1.34-1.5 2.56-1.5m2 7.47l-.62-1.3-.71.16 1 1.25.33-.11m-4.65-8.61a1 1 0 00-.91-1.03c-.71-.04-1.4.2-1.93.67-.57.58-.87 1.38-.84 2.19a1 1 0 001 1c.57 0 1-.45 1-1 0-.27.07-.54.23-.76.12-.1.27-.15.43-.15.55.03 1.02-.38 1.02-.92z"
  })))
}

function _extends$5() {
  return (_extends$5 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgFileOutline(props) {
  return createElement("svg", _extends$5({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$4 || (_path$4 = createElement("path", {
      d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6m4 18H6V4h7v5h5v11z"
  })))
}

function _extends$6() {
  return (_extends$6 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgFileHidden(props) {
  return createElement("svg", _extends$6({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$5 || (_path$5 = createElement("path", {
      d: "M13 9h1v2h-3V7h2v2m5.5 0l-2.12-2.12 1.25-1.25L20 8v2h-2v1h-3V9h3.5M13 3.5V2h-1v2h1v2h-2V4H9V2H8v2H6v1H4V4c0-1.11.89-2 2-2h8l2.36 2.36-1.25 1.25L13 3.5M20 20a2 2 0 01-2 2h-2v-2h2v-1h2v1m-2-5h2v3h-2v-3m-6 7v-2h3v2h-3m-4 0v-2h3v2H8m-2 0a2 2 0 01-2-2v-2h2v2h1v2H6m-2-8h2v3H4v-3m0-4h2v3H4v-3m14 1h2v3h-2v-3M4 6h2v3H4V6z"
  })))
}

function _extends$7() {
  return (_extends$7 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgAccountSettings(props) {
  return createElement("svg", _extends$7({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$6 || (_path$6 = createElement("path", {
      d: "M12 4a4 4 0 014 4 4 4 0 01-4 4 4 4 0 01-4-4 4 4 0 014-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4m-5 8h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2z"
  })))
}

function _extends$8() {
  return (_extends$8 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgPowerPlug(props) {
  return createElement("svg", _extends$8({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$7 || (_path$7 = createElement("path", {
      d: "M16 7V3h-2v4h-4V3H8v4C7 7 6 8 6 9v5.5L9.5 18v3h5v-3l3.5-3.5V9c0-1-1-2-2-2z"
  })))
}

function _extends$9() {
  return (_extends$9 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCodeBraces(props) {
  return createElement("svg", _extends$9({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$8 || (_path$8 = createElement("path", {
      d: "M8 3a2 2 0 00-2 2v4a2 2 0 01-2 2H3v2h1a2 2 0 012 2v4a2 2 0 002 2h2v-2H8v-5a2 2 0 00-2-2 2 2 0 002-2V5h2V3m6 0a2 2 0 012 2v4a2 2 0 002 2h1v2h-1a2 2 0 00-2 2v4a2 2 0 01-2 2h-2v-2h2v-5a2 2 0 012-2 2 2 0 01-2-2V5h-2V3h2z"
  })))
}

function _extends$a() {
  return (_extends$a = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgMenu(props) {
  return createElement("svg", _extends$a({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$9 || (_path$9 = createElement("path", {
      d: "M3 6h18v2H3V6m0 5h18v2H3v-2m0 5h18v2H3v-2z"
  })))
}

function _extends$b() {
  return (_extends$b = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgMenuUp(props) {
  return createElement("svg", _extends$b({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$a || (_path$a = createElement("path", {
      d: "M7 15l5-5 5 5H7z"
  })))
}

function _extends$c() {
  return (_extends$c = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgMenuDown(props) {
  return createElement("svg", _extends$c({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$b || (_path$b = createElement("path", {
      d: "M7 10l5 5 5-5H7z"
  })))
}

function _extends$d() {
  return (_extends$d = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgSettingsOutline(props) {
  return createElement("svg", _extends$d({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$c || (_path$c = createElement("path", {
      d: "M12 8a4 4 0 014 4 4 4 0 01-4 4 4 4 0 01-4-4 4 4 0 014-4m0 2a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2m-2 12c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46a.493.493 0 01.12-.64l2.11-1.66L4.5 12l.07-1-2.11-1.63a.493.493 0 01-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.13.22.07.49-.12.64L19.43 11l.07 1-.07 1 2.11 1.63c.19.15.25.42.12.64l-2 3.46c-.12.22-.39.31-.61.22l-2.49-1c-.52.39-1.06.73-1.69.98l-.37 2.65c-.04.24-.25.42-.5.42h-4m1.25-18l-.37 2.61c-1.2.25-2.26.89-3.03 1.78L5.44 7.35l-.75 1.3L6.8 10.2a5.55 5.55 0 000 3.6l-2.12 1.56.75 1.3 2.43-1.04c.77.88 1.82 1.52 3.01 1.76l.37 2.62h1.52l.37-2.61c1.19-.25 2.24-.89 3.01-1.77l2.43 1.04.75-1.3-2.12-1.55c.4-1.17.4-2.44 0-3.61l2.11-1.55-.75-1.3-2.41 1.04a5.42 5.42 0 00-3.03-1.77L12.75 4h-1.5z"
  })))
}

function _extends$e() {
  return (_extends$e = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgAccountMultiple(props) {
  return createElement("svg", _extends$e({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$d || (_path$d = createElement("path", {
      d: "M16 13c-.29 0-.62 0-.97.05C16.19 13.89 17 15 17 16.5V19h6v-2.5c0-2.33-4.67-3.5-7-3.5m-8 0c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m0-2a3 3 0 003-3 3 3 0 00-3-3 3 3 0 00-3 3 3 3 0 003 3m8 0a3 3 0 003-3 3 3 0 00-3-3 3 3 0 00-3 3 3 3 0 003 3z"
  })))
}

function _extends$f() {
  return (_extends$f = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgAccount(props) {
  return createElement("svg", _extends$f({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$e || (_path$e = createElement("path", {
      d: "M12 4a4 4 0 014 4 4 4 0 01-4 4 4 4 0 01-4-4 4 4 0 014-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4z"
  })))
}

function _extends$g() {
  return (_extends$g = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgFilterVariant(props) {
  return createElement("svg", _extends$g({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$f || (_path$f = createElement("path", {
      d: "M6 13h12v-2H6M3 6v2h18V6M10 18h4v-2h-4v2z"
  })))
}

function _extends$h() {
  return (_extends$h = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgDotsVertical(props) {
  return createElement("svg", _extends$h({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$g || (_path$g = createElement("path", {
      d: "M12 16a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 012-2m0-6a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 012-2m0-6a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 012-2z"
  })))
}

function _extends$i() {
  return (_extends$i = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgDotsHorizontal(props) {
  return createElement("svg", _extends$i({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$h || (_path$h = createElement("path", {
      d: "M16 12a2 2 0 012-2 2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2m-6 0a2 2 0 012-2 2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2m-6 0a2 2 0 012-2 2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2z"
  })))
}

function _extends$j() {
  return (_extends$j = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgMagnify(props) {
  return createElement("svg", _extends$j({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$i || (_path$i = createElement("path", {
      d: "M9.5 3A6.5 6.5 0 0116 9.5c0 1.61-.59 3.09-1.56 4.23l.27.27h.79l5 5-1.5 1.5-5-5v-.79l-.27-.27A6.516 6.516 0 019.5 16 6.5 6.5 0 013 9.5 6.5 6.5 0 019.5 3m0 2C7 5 5 7 5 9.5S7 14 9.5 14 14 12 14 9.5 12 5 9.5 5z"
  })))
}

function _extends$k() {
  return (_extends$k = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCheckboxBlankOutline(props) {
  return createElement("svg", _extends$k({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$j || (_path$j = createElement("path", {
      d: "M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2m0 2v14H5V5h14z"
  })))
}

function _extends$l() {
  return (_extends$l = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCheckboxMarked(props) {
  return createElement("svg", _extends$l({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$k || (_path$k = createElement("path", {
      d: "M10 17l-5-5 1.41-1.42L10 14.17l7.59-7.59L19 8m0-5H5c-1.11 0-2 .89-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z"
  })))
}

function _extends$m() {
  return (_extends$m = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCheckboxMultipleBlankOutline(props) {
  return createElement("svg", _extends$m({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$l || (_path$l = createElement("path", {
      d: "M20 16V4H8v12h12m2 0a2 2 0 01-2 2H8a2 2 0 01-2-2V4c0-1.11.89-2 2-2h12a2 2 0 012 2v12m-6 4v2H4a2 2 0 01-2-2V7h2v13h12z"
  })))
}

function _extends$n() {
  return (_extends$n = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCheckboxMultipleMarked(props) {
  return createElement("svg", _extends$n({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$m || (_path$m = createElement("path", {
      d: "M22 16a2 2 0 01-2 2H8a2 2 0 01-2-2V4c0-1.11.89-2 2-2h12a2 2 0 012 2v12m-6 4v2H4a2 2 0 01-2-2V7h2v13h12m-3-6l7-7-1.41-1.41L13 11.17 9.91 8.09 8.5 9.5 13 14z"
  })))
}

function _extends$o() {
  return (_extends$o = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCheckCircleOutline(props) {
  return createElement("svg", _extends$o({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$n || (_path$n = createElement("path", {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8-1.41-1.42z"
  })))
}

function _extends$p() {
  return (_extends$p = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgFormatListCheckbox(props) {
  return createElement("svg", _extends$p({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$o || (_path$o = createElement("path", {
      d: "M21 19v-2H8v2h13m0-6v-2H8v2h13M8 7h13V5H8v2M4 5v2h2V5H4M3 5a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V5m1 6v2h2v-2H4m-1 0a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2m1 6v2h2v-2H4m-1 0a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2z"
  })))
}

function _extends$q() {
  return (_extends$q = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCalendar(props) {
  return createElement("svg", _extends$q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$p || (_path$p = createElement("path", {
      d: "M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2h-1V1m-1 11h-5v5h5v-5z"
  })))
}

function _extends$r() {
  return (_extends$r = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgEmailOutline(props) {
  return createElement("svg", _extends$r({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$q || (_path$q = createElement("path", {
      d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6m-2 0l-8 5-8-5h16m0 12H4V8l8 5 8-5v10z"
  })))
}

function _extends$s() {
  return (_extends$s = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgStop(props) {
  return createElement("svg", _extends$s({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$r || (_path$r = createElement("path", {
      d: "M18 18H6V6h12v12z"
  })))
}

function _extends$t() {
  return (_extends$t = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgStopCircle(props) {
  return createElement("svg", _extends$t({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$s || (_path$s = createElement("path", {
      d: "M12 2A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2M9 9h6v6H9"
  })))
}

function _extends$u() {
  return (_extends$u = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgStopCircleOutline(props) {
  return createElement("svg", _extends$u({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$t || (_path$t = createElement("path", {
      d: "M12 2A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2m0 2c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8M9 9v6h6V9"
  })))
}

function _extends$v() {
  return (_extends$v = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgMinus(props) {
  return createElement("svg", _extends$v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$u || (_path$u = createElement("path", {
      d: "M19 13H5v-2h14v2z"
  })))
}

function _extends$w() {
  return (_extends$w = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgPlay(props) {
  return createElement("svg", _extends$w({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$v || (_path$v = createElement("path", {
      d: "M8 5.14v14l11-7-11-7z"
  })))
}

function _extends$x() {
  return (_extends$x = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgPlayCircle(props) {
  return createElement("svg", _extends$x({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$w || (_path$w = createElement("path", {
      d: "M10 16.5v-9l6 4.5M12 2A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2z"
  })))
}

function _extends$y() {
  return (_extends$y = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgPlayCircleOutline(props) {
  return createElement("svg", _extends$y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$x || (_path$x = createElement("path", {
      d: "M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-18A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2m-2 14.5l6-4.5-6-4.5v9z"
  })))
}

function _extends$z() {
  return (_extends$z = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgConsole(props) {
  return createElement("svg", _extends$z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$y || (_path$y = createElement("path", {
      d: "M20 19V7H4v12h16m0-16a2 2 0 012 2v14a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h16m-7 14v-2h5v2h-5m-3.42-4L5.57 9H8.4l3.3 3.3c.39.39.39 1.03 0 1.42L8.42 17H5.59l3.99-4z"
  })))
}

function _extends$A() {
  return (_extends$A = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgConsoleNetwork(props) {
  return createElement("svg", _extends$A({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$z || (_path$z = createElement("path", {
      d: "M17 3a2 2 0 012 2v10a2 2 0 01-2 2h-4v2h1a1 1 0 011 1h7v2h-7a1 1 0 01-1 1h-4a1 1 0 01-1-1H2v-2h7a1 1 0 011-1h1v-2H7a2 2 0 01-2-2V5a2 2 0 012-2h10M7 7l4 4-4 4h2.85l3.28-3.28c.37-.39.37-1.02 0-1.42L9.83 7H7m10 6h-3v2h3v-2z"
  })))
}

function _extends$B() {
  return (_extends$B = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgClockOutline(props) {
  return createElement("svg", _extends$B({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$A || (_path$A = createElement("path", {
      d: "M12 20a8 8 0 008-8 8 8 0 00-8-8 8 8 0 00-8 8 8 8 0 008 8m0-18a10 10 0 0110 10 10 10 0 01-10 10C6.47 22 2 17.5 2 12A10 10 0 0112 2m.5 5v5.25l4.5 2.67-.75 1.23L11 13V7h1.5z"
  })))
}

function _extends$C() {
  return (_extends$C = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgViewDashboardOutline(props) {
  return createElement("svg", _extends$C({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$B || (_path$B = createElement("path", {
      d: "M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3M11 3H3v10h8V3m10 8h-8v10h8V11m-10 4H3v6h8v-6z"
  })))
}

function _extends$D() {
  return (_extends$D = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgDeveloperBoard(props) {
  return createElement("svg", _extends$D({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$C || (_path$C = createElement("path", {
      d: "M22 9V7h-2V5a2 2 0 00-2-2H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-2h2v-2h-2v-2h2v-2h-2V9h2m-4 10H4V5h14v14M6 13h5v4H6v-4m6-6h4v3h-4V7M6 7h5v5H6V7m6 4h4v6h-4v-6z"
  })))
}

function _extends$E() {
  return (_extends$E = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCalendarClock(props) {
  return createElement("svg", _extends$E({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$D || (_path$D = createElement("path", {
      d: "M15 13h1.5v2.82l2.44 1.41-.75 1.3L15 16.69V13m4-5H5v11h4.67c-.43-.91-.67-1.93-.67-3a7 7 0 017-7c1.07 0 2.09.24 3 .67V8M5 21a2 2 0 01-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 012 2v6.1c1.24 1.26 2 2.99 2 4.9a7 7 0 01-7 7c-1.91 0-3.64-.76-4.9-2H5m11-9.85A4.85 4.85 0 0011.15 16c0 2.68 2.17 4.85 4.85 4.85A4.85 4.85 0 0020.85 16c0-2.68-2.17-4.85-4.85-4.85z"
  })))
}

function _extends$F() {
  return (_extends$F = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgServer(props) {
  return createElement("svg", _extends$F({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$E || (_path$E = createElement("path", {
      d: "M4 1h16a1 1 0 011 1v4a1 1 0 01-1 1H4a1 1 0 01-1-1V2a1 1 0 011-1m0 8h16a1 1 0 011 1v4a1 1 0 01-1 1H4a1 1 0 01-1-1v-4a1 1 0 011-1m0 8h16a1 1 0 011 1v4a1 1 0 01-1 1H4a1 1 0 01-1-1v-4a1 1 0 011-1M9 5h1V3H9v2m0 8h1v-2H9v2m0 8h1v-2H9v2M5 3v2h2V3H5m0 8v2h2v-2H5m0 8v2h2v-2H5z"
  })))
}

function _extends$G() {
  return (_extends$G = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgMonitorDashboard(props) {
  return createElement("svg", _extends$G({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$F || (_path$F = createElement("path", {
      d: "M21 16V4H3v12h18m0-14a2 2 0 012 2v12a2 2 0 01-2 2h-7v2h2v2H8v-2h2v-2H3a2 2 0 01-2-2V4c0-1.11.89-2 2-2h18M5 6h9v5H5V6m10 0h4v2h-4V6m4 3v5h-4V9h4M5 12h4v2H5v-2m5 0h4v2h-4v-2z"
  })))
}

function _extends$H() {
  return (_extends$H = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgHeartPulse(props) {
  return createElement("svg", _extends$H({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$G || (_path$G = createElement("path", {
      d: "M7.5 4A5.5 5.5 0 002 9.5c0 .5.09 1 .22 1.5H6.3l1.27-3.37c.3-.8 1.48-.88 1.86 0L11.5 13l.59-1.42c.13-.33.48-.58.91-.58h8.78c.13-.5.22-1 .22-1.5A5.5 5.5 0 0016.5 4c-1.86 0-3.5.93-4.5 2.34C11 4.93 9.36 4 7.5 4M3 12.5a1 1 0 00-1 1 1 1 0 001 1h2.44L11 20c1 .9 1 .9 2 0l5.56-5.5H21a1 1 0 001-1 1 1 0 00-1-1h-7.6l-.93 2.3c-.4 1.01-1.55.87-1.92.03L8.5 9.5l-.96 2.33c-.15.38-.49.67-.94.67H3z"
  })))
}

function _extends$I() {
  return (_extends$I = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgDatabaseCheck(props) {
  return createElement("svg", _extends$I({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$H || (_path$H = createElement("path", {
      d: "M17.75 22.16l-2.75-3L16.16 18l1.59 1.59L21.34 16l1.16 1.41-4.75 4.75M12 3c4.42 0 8 1.79 8 4s-3.58 4-8 4-8-1.79-8-4 3.58-4 8-4M4 9c0 2.21 3.58 4 8 4s8-1.79 8-4v3c0 .43-.13.84-.38 1.22-.52-.14-1.06-.22-1.62-.22-2.21 0-4.15 1.2-5.19 3H12c-4.42 0-8-1.79-8-4V9m0 5c0 2.21 3.58 4 8.08 4L12 19c0 .7.12 1.37.34 2H12c-4.42 0-8-1.79-8-4v-3z"
  })))
}

function _extends$J() {
  return (_extends$J = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgDatabase(props) {
  return createElement("svg", _extends$J({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$I || (_path$I = createElement("path", {
      d: "M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4M4 9v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4m0 5v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4s-8-1.79-8-4z"
  })))
}

function _extends$K() {
  return (_extends$K = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgDatabaseImport(props) {
  return createElement("svg", _extends$K({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$J || (_path$J = createElement("path", {
      d: "M12 3C8.59 3 5.69 4.07 4.54 5.57l5.25 5.25c.71.11 1.43.18 2.21.18 4.42 0 8-1.79 8-4s-3.58-4-8-4M3.92 7.08L2.5 8.5 5 11H0v2h5l-2.5 2.5 1.42 1.42L8.84 12M20 9c0 2.21-3.58 4-8 4-.66 0-1.3-.05-1.91-.13l-2.47 2.47c1.26.41 2.76.66 4.38.66 4.42 0 8-1.79 8-4m0 2c0 2.21-3.58 4-8 4-2.28 0-4.33-.5-5.79-1.25l-1.68 1.68C5.68 19.93 8.59 21 12 21c4.42 0 8-1.79 8-4"
  })))
}

function _extends$L() {
  return (_extends$L = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgDatabaseExport(props) {
  return createElement("svg", _extends$L({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$K || (_path$K = createElement("path", {
      d: "M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4c.5 0 1-.03 1.5-.08V9.5h2.89l-1-1L18.9 5c-1.4-1.2-3.96-2-6.9-2m6.92 4.08L17.5 8.5 20 11h-5v2h5l-2.5 2.5 1.42 1.42L23.84 12M4 9v3c0 2.21 3.58 4 8 4 1.17 0 2.26-.15 3.25-.37l1.13-1.13H13.5v-1.58c-.5.05-1 .08-1.5.08-4.42 0-8-1.79-8-4m0 5v3c0 2.21 3.58 4 8 4 2.94 0 5.5-.8 6.9-2L17 17.1c-1.39.56-3.1.9-5 .9-4.42 0-8-1.79-8-4z"
  })))
}

function _extends$M() {
  return (_extends$M = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgChartLine(props) {
  return createElement("svg", _extends$M({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$L || (_path$L = createElement("path", {
      d: "M16 11.78l4.24-7.33 1.73 1-5.23 9.05-6.51-3.75L5.46 19H22v2H2V3h2v14.54L9.5 8l6.5 3.78z"
  })))
}

function _extends$N() {
  return (_extends$N = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCogs(props) {
  return createElement("svg", _extends$N({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$M || (_path$M = createElement("path", {
      d: "M15.9 18.45c1.35 0 2.45-1.1 2.45-2.45s-1.1-2.45-2.45-2.45c-1.36 0-2.45 1.1-2.45 2.45s1.09 2.45 2.45 2.45m5.2-1.77l1.48 1.16c.13.11.17.29.08.45l-1.4 2.42a.35.35 0 01-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.27 1.85c-.02.17-.17.3-.34.3h-2.8c-.18 0-.32-.13-.35-.3l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.75.7c-.15.06-.34 0-.42-.15l-1.4-2.42a.351.351 0 01.08-.45l1.48-1.16-.05-.68.05-.69-1.48-1.15a.353.353 0 01-.08-.45l1.4-2.42c.08-.16.27-.22.42-.16l1.75.71c.36-.28.75-.52 1.18-.69l.26-1.86c.03-.16.17-.29.35-.29h2.8c.17 0 .32.13.34.29l.27 1.86c.42.17.82.41 1.18.69l1.74-.71c.17-.06.34 0 .43.16l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.15.05.69-.05.68M6.69 8.07c.87 0 1.57-.7 1.57-1.57 0-.87-.7-1.58-1.57-1.58A1.58 1.58 0 005.11 6.5c0 .87.71 1.57 1.58 1.57m3.34-1.13l.97.74c.07.07.09.19.03.29l-.9 1.56c-.05.1-.17.14-.27.1l-1.12-.45-.74.44-.19 1.19c-.02.11-.11.19-.22.19h-1.8c-.12 0-.21-.08-.23-.19L5.4 9.62l-.76-.44-1.14.45c-.09.04-.2 0-.26-.1l-.9-1.56c-.06-.1-.03-.22.05-.29l.95-.74-.03-.44.03-.44-.95-.74a.229.229 0 01-.05-.29l.9-1.56c.06-.1.17-.14.26-.1l1.13.45.77-.44.16-1.19c.02-.11.11-.19.23-.19h1.8c.11 0 .2.08.22.19L8 3.38l.74.44 1.12-.45c.1-.04.22 0 .27.1l.9 1.56c.06.1.04.22-.03.29l-.97.74.03.44-.03.44z"
  })))
}

function _extends$O() {
  return (_extends$O = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgSourceBranch(props) {
  return createElement("svg", _extends$O({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$N || (_path$N = createElement("path", {
      d: "M13 14c-3.36 0-4.46 1.35-4.82 2.24C9.25 16.7 10 17.76 10 19a3 3 0 01-3 3 3 3 0 01-3-3c0-1.31.83-2.42 2-2.83V7.83A2.99 2.99 0 014 5a3 3 0 013-3 3 3 0 013 3c0 1.31-.83 2.42-2 2.83v5.29c.88-.65 2.16-1.12 4-1.12 2.67 0 3.56-1.34 3.85-2.23A3.006 3.006 0 0114 7a3 3 0 013-3 3 3 0 013 3c0 1.34-.88 2.5-2.09 2.86C17.65 11.29 16.68 14 13 14m-6 4a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1M7 4a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1m10 2a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1z"
  })))
}

function _extends$P() {
  return (_extends$P = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgEyeCheckOutline(props) {
  return createElement("svg", _extends$P({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$O || (_path$O = createElement("path", {
      d: "M23.5 17l-5 5-3.5-3.5 1.5-1.5 2 2 3.5-3.5 1.5 1.5M12 9a3 3 0 013 3 3 3 0 01-3 3 3 3 0 01-3-3 3 3 0 013-3m0-4.5c5 0 9.27 3.11 11 7.5-.25.65-.56 1.26-.92 1.85a5.77 5.77 0 00-1.9-.73l.64-1.12a9.821 9.821 0 00-17.64 0A9.821 9.821 0 0012 17.5l1.21-.07c-.14.5-.21 1.03-.21 1.57v.46l-1 .04c-5 0-9.27-3.11-11-7.5 1.73-4.39 6-7.5 11-7.5z"
  })))
}

function _extends$Q() {
  return (_extends$Q = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgAccountGroup(props) {
  return createElement("svg", _extends$Q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$P || (_path$P = createElement("path", {
      d: "M12 5.5A3.5 3.5 0 0115.5 9a3.5 3.5 0 01-3.5 3.5A3.5 3.5 0 018.5 9 3.5 3.5 0 0112 5.5M5 8c.56 0 1.08.15 1.53.42-.15 1.43.27 2.85 1.13 3.96C7.16 13.34 6.16 14 5 14a3 3 0 01-3-3 3 3 0 013-3m14 0a3 3 0 013 3 3 3 0 01-3 3c-1.16 0-2.16-.66-2.66-1.62a5.536 5.536 0 001.13-3.96c.45-.27.97-.42 1.53-.42M5.5 18.25c0-2.07 2.91-3.75 6.5-3.75s6.5 1.68 6.5 3.75V20h-13v-1.75M0 20v-1.5c0-1.39 1.89-2.56 4.45-2.9-.59.68-.95 1.62-.95 2.65V20H0m24 0h-3.5v-1.75c0-1.03-.36-1.97-.95-2.65 2.56.34 4.45 1.51 4.45 2.9V20z"
  })))
}

function _extends$R() {
  return (_extends$R = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCloudSync(props) {
  return createElement("svg", _extends$R({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$Q || (_path$Q = createElement("path", {
      d: "M12 4a7.49 7.49 0 017.35 6.04c2.6.18 4.65 2.32 4.65 4.96a5 5 0 01-5 5H6a6 6 0 01-6-6c0-3.09 2.34-5.64 5.35-5.96A7.496 7.496 0 0112 4M7.5 9.69c-1.44 1.81-1.3 4.37.32 5.99C8.66 16.5 9.81 17 11 17v1.86l2.83-2.82L11 13.21V15c-.66 0-1.3-.26-1.77-.73-.84-.84-.97-2.16-.31-3.15L7.5 9.69m1.67-.72l1.45 1.45L12 11.79V10c.66 0 1.3.26 1.77.73.84.84.97 2.16.31 3.15l1.42 1.43c1.44-1.81 1.3-4.37-.32-5.99C14.34 8.5 13.19 8 12 8V6.14L9.17 8.97z"
  })))
}

function _extends$S() {
  return (_extends$S = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCloud(props) {
  return createElement("svg", _extends$S({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$R || (_path$R = createElement("path", {
      d: "M19.35 10.03A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 000 14a6 6 0 006 6h13a5 5 0 005-5c0-2.64-2.05-4.78-4.65-4.97z"
  })))
}

function _extends$T() {
  return (_extends$T = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgRestore(props) {
  return createElement("svg", _extends$T({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$S || (_path$S = createElement("path", {
      d: "M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6a7 7 0 017-7 7 7 0 017 7 7 7 0 01-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.896 8.896 0 0013 21a9 9 0 009-9 9 9 0 00-9-9z"
  })))
}

function _extends$U() {
  return (_extends$U = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgImport(props) {
  return createElement("svg", _extends$U({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$T || (_path$T = createElement("path", {
      d: "M14 12l-4-4v3H2v2h8v3m10 2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v3h2V6h12v12H6v-3H4v3a2 2 0 002 2h12a2 2 0 002-2z"
  })))
}

function _extends$V() {
  return (_extends$V = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgExport(props) {
  return createElement("svg", _extends$V({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$U || (_path$U = createElement("path", {
      d: "M23 12l-4-4v3h-9v2h9v3M1 18V6a2 2 0 012-2h12a2 2 0 012 2v3h-2V6H3v12h12v-3h2v3a2 2 0 01-2 2H3a2 2 0 01-2-2z"
  })))
}

function _extends$W() {
  return (_extends$W = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgApplicationImport(props) {
  return createElement("svg", _extends$W({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$V || (_path$V = createElement("path", {
      d: "M1 12h9.76l-2.5-2.5 1.41-1.42L14.59 13l-4.92 4.92-1.41-1.42 2.5-2.5H1v-2m18-9a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2v-3h2v3h14V7H5v3H3V5a2 2 0 012-2h14z"
  })))
}

function _extends$X() {
  return (_extends$X = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgApplicationExport(props) {
  return createElement("svg", _extends$X({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$W || (_path$W = createElement("path", {
      d: "M8 12h9.76l-2.5-2.5 1.41-1.42L21.59 13l-4.92 4.92-1.41-1.42 2.5-2.5H8v-2m11-9a2 2 0 012 2v4.67l-2-2V7H5v12h14v-.67l2-2V19a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14z"
  })))
}

function _extends$Y() {
  return (_extends$Y = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCubeOutline(props) {
  return createElement("svg", _extends$Y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$X || (_path$X = createElement("path", {
      d: "M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 013 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L6.04 7.5 12 10.85l5.96-3.35L12 4.15M5 15.91l6 3.38v-6.71L5 9.21v6.7m14 0v-6.7l-6 3.37v6.71l6-3.38z"
  })))
}

function _extends$Z() {
  return (_extends$Z = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgShieldAccount(props) {
  return createElement("svg", _extends$Z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$Y || (_path$Y = createElement("path", {
      d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4m0 4a3 3 0 013 3 3 3 0 01-3 3 3 3 0 01-3-3 3 3 0 013-3m5.13 12A9.69 9.69 0 0112 20.92 9.69 9.69 0 016.87 17c-.34-.5-.63-1-.87-1.53 0-1.65 2.71-3 6-3s6 1.32 6 3c-.24.53-.53 1.03-.87 1.53z"
  })))
}

function _extends$_() {
  return (_extends$_ = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgHelpCircleOutline(props) {
  return createElement("svg", _extends$_({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$Z || (_path$Z = createElement("path", {
      d: "M11 18h2v-2h-2v2m1-16A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14a4 4 0 00-4 4h2a2 2 0 012-2 2 2 0 012 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5a4 4 0 00-4-4z"
  })))
}

function _extends$$() {
  return (_extends$$ = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgMessageTextOutline(props) {
  return createElement("svg", _extends$$({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$_ || (_path$_ = createElement("path", {
      d: "M20 2a2 2 0 012 2v12a2 2 0 01-2 2H6l-4 4V4a2 2 0 012-2h16M4 4v13.17L5.17 16H20V4H4m2 3h12v2H6V7m0 4h9v2H6v-2z"
  })))
}

function _extends$10() {
  return (_extends$10 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgGit(props) {
  return createElement("svg", _extends$10({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$$ || (_path$$ = createElement("path", {
      d: "M2.6 10.59L8.38 4.8l1.69 1.7c-.24.85.15 1.78.93 2.23v5.54c-.6.34-1 .99-1 1.73a2 2 0 002 2 2 2 0 002-2c0-.74-.4-1.39-1-1.73V9.41l2.07 2.09c-.07.15-.07.32-.07.5a2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2c-.18 0-.35 0-.5.07L13.93 7.5a1.98 1.98 0 00-1.15-2.34c-.43-.16-.88-.2-1.28-.09L9.8 3.38l.79-.78c.78-.79 2.04-.79 2.82 0l7.99 7.99c.79.78.79 2.04 0 2.82l-7.99 7.99c-.78.79-2.04.79-2.82 0L2.6 13.41c-.79-.78-.79-2.04 0-2.82z"
  })))
}

function _extends$11() {
  return (_extends$11 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgNpm(props) {
  return createElement("svg", _extends$11({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$10 || (_path$10 = createElement("path", {
      d: "M4 10v4h2v-3h1v3h1v-4H4m5 0v5h2v-1h2v-4H9m3 1v2h-1v-2h1m2-1v4h2v-3h1v3h1v-3h1v3h1v-4h-6M3 9h18v6h-9v1H8v-1H3V9z"
  })))
}

function _extends$12() {
  return (_extends$12 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgChevronDoubleUp(props) {
  return createElement("svg", _extends$12({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$11 || (_path$11 = createElement("path", {
      d: "M7.41 18.41L6 17l6-6 6 6-1.41 1.41L12 13.83l-4.59 4.58m0-6L6 11l6-6 6 6-1.41 1.41L12 7.83l-4.59 4.58z"
  })))
}

function _extends$13() {
  return (_extends$13 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgChevronDoubleDown(props) {
  return createElement("svg", _extends$13({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$12 || (_path$12 = createElement("path", {
      d: "M16.59 5.59L18 7l-6 6-6-6 1.41-1.41L12 10.17l4.59-4.58m0 6L18 13l-6 6-6-6 1.41-1.41L12 16.17l4.59-4.58z"
  })))
}

function _extends$14() {
  return (_extends$14 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgEye(props) {
  return createElement("svg", _extends$14({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$13 || (_path$13 = createElement("path", {
      d: "M12 9a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3m0 8a5 5 0 01-5-5 5 5 0 015-5 5 5 0 015 5 5 5 0 01-5 5m0-12.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5z"
  })))
}

function _extends$15() {
  return (_extends$15 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgRobot(props) {
  return createElement("svg", _extends$15({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$14 || (_path$14 = createElement("path", {
      d: "M12 2a2 2 0 012 2c0 .74-.4 1.39-1 1.73V7h1a7 7 0 017 7h1a1 1 0 011 1v3a1 1 0 01-1 1h-1v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1H2a1 1 0 01-1-1v-3a1 1 0 011-1h1a7 7 0 017-7h1V5.73c-.6-.34-1-.99-1-1.73a2 2 0 012-2M7.5 13A2.5 2.5 0 005 15.5 2.5 2.5 0 007.5 18a2.5 2.5 0 002.5-2.5A2.5 2.5 0 007.5 13m9 0a2.5 2.5 0 00-2.5 2.5 2.5 2.5 0 002.5 2.5 2.5 2.5 0 002.5-2.5 2.5 2.5 0 00-2.5-2.5z"
  })))
}

function _extends$16() {
  return (_extends$16 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgLanguagePython(props) {
  return createElement("svg", _extends$16({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$15 || (_path$15 = createElement("path", {
      d: "M19.14 7.5A2.86 2.86 0 0122 10.36v3.78A2.86 2.86 0 0119.14 17H12c0 .39.32.96.71.96H17v1.68a2.86 2.86 0 01-2.86 2.86H9.86A2.86 2.86 0 017 19.64v-3.75a2.85 2.85 0 012.86-2.85h5.25a2.85 2.85 0 002.85-2.86V7.5h1.18m-4.28 11.79c-.4 0-.72.3-.72.89 0 .59.32.71.72.71a.71.71 0 00.71-.71c0-.59-.32-.89-.71-.89m-10-1.79A2.86 2.86 0 012 14.64v-3.78A2.86 2.86 0 014.86 8H12c0-.39-.32-.96-.71-.96H7V5.36A2.86 2.86 0 019.86 2.5h4.28A2.86 2.86 0 0117 5.36v3.75a2.85 2.85 0 01-2.86 2.85H8.89a2.85 2.85 0 00-2.85 2.86v2.68H4.86M9.14 5.71c.4 0 .72-.3.72-.89 0-.59-.32-.71-.72-.71-.39 0-.71.12-.71.71s.32.89.71.89z"
  })))
}

function _extends$17() {
  return (_extends$17 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgFolderOutline(props) {
  return createElement("svg", _extends$17({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$16 || (_path$16 = createElement("path", {
      d: "M20 18H4V8h16m0-2h-8l-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h16a2 2 0 002-2V8a2 2 0 00-2-2z"
  })))
}

function _extends$18() {
  return (_extends$18 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCursorMove(props) {
  return createElement("svg", _extends$18({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$17 || (_path$17 = createElement("path", {
      d: "M13 6v5h5V7.75L22.25 12 18 16.25V13h-5v5h3.25L12 22.25 7.75 18H11v-5H6v3.25L1.75 12 6 7.75V11h5V6H7.75L12 1.75 16.25 6H13z"
  })))
}

function _extends$19() {
  return (_extends$19 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgArrowUpBoldCircleOutline(props) {
  return createElement("svg", _extends$19({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$18 || (_path$18 = createElement("path", {
      d: "M12 7l5 5h-3v4h-4v-4H7l5-5m0 15A10 10 0 012 12 10 10 0 0112 2a10 10 0 0110 10 10 10 0 01-10 10m0-2a8 8 0 008-8 8 8 0 00-8-8 8 8 0 00-8 8 8 8 0 008 8z"
  })))
}

function _extends$1a() {
  return (_extends$1a = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgArrowUpBold(props) {
  return createElement("svg", _extends$1a({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$19 || (_path$19 = createElement("path", {
      d: "M15 20H9v-8H4.16L12 4.16 19.84 12H15v8z"
  })))
}

function _extends$1b() {
  return (_extends$1b = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgChevronUp(props) {
  return createElement("svg", _extends$1b({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1a || (_path$1a = createElement("path", {
      d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
  })))
}

function _extends$1c() {
  return (_extends$1c = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgChartBubble(props) {
  return createElement("svg", _extends$1c({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1b || (_path$1b = createElement("path", {
      d: "M7.2 11.2c1.77 0 3.2 1.43 3.2 3.2 0 1.77-1.43 3.2-3.2 3.2-1.77 0-3.2-1.43-3.2-3.2 0-1.77 1.43-3.2 3.2-3.2m7.6 4.8a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 012-2m.4-12A4.8 4.8 0 0120 8.8c0 2.65-2.15 4.8-4.8 4.8a4.8 4.8 0 01-4.8-4.8c0-2.65 2.15-4.8 4.8-4.8z"
  })))
}

function _extends$1d() {
  return (_extends$1d = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCloseCircle(props) {
  return createElement("svg", _extends$1d({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1c || (_path$1c = createElement("path", {
      d: "M12 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S2 17.53 2 12 6.47 2 12 2m3.59 5L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41 15.59 7z"
  })))
}

function _extends$1e() {
  return (_extends$1e = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgCheckboxMarkedCircle(props) {
  return createElement("svg", _extends$1e({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1d || (_path$1d = createElement("path", {
      d: "M10 17l-5-5 1.41-1.42L10 14.17l7.59-7.59L19 8m-7-6A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2z"
  })))
}

function _extends$1f() {
  return (_extends$1f = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgMagnifyMinusOutline(props) {
  return createElement("svg", _extends$1f({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1e || (_path$1e = createElement("path", {
      d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 009.5 3 6.5 6.5 0 003 9.5 6.5 6.5 0 009.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 5 1.5-1.5-5-5m-6 0C7 14 5 12 5 9.5S7 5 9.5 5 14 7 14 9.5 12 14 9.5 14M7 9h5v1H7V9z"
  })))
}

function _extends$1g() {
  return (_extends$1g = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgMagnifyPlusOutline(props) {
  return createElement("svg", _extends$1g({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1f || (_path$1f = createElement("path", {
      d: "M15.5 14l5 5-1.5 1.5-5-5v-.79l-.27-.28A6.471 6.471 0 019.5 16 6.5 6.5 0 013 9.5 6.5 6.5 0 019.5 3 6.5 6.5 0 0116 9.5c0 1.61-.59 3.09-1.57 4.23l.28.27h.79m-6 0C12 14 14 12 14 9.5S12 5 9.5 5 5 7 5 9.5 7 14 9.5 14m2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1z"
  })))
}

function _extends$1h() {
  return (_extends$1h = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgMagnifyMinus(props) {
  return createElement("svg", _extends$1h({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1g || (_path$1g = createElement("path", {
      d: "M9 2a7 7 0 017 7c0 1.57-.5 3-1.39 4.19l.8.81H16l6 6-2 2-6-6v-.59l-.81-.8A6.916 6.916 0 019 16a7 7 0 01-7-7 7 7 0 017-7M5 8v2h8V8H5z"
  })))
}

function _extends$1i() {
  return (_extends$1i = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgMagnifyPlus(props) {
  return createElement("svg", _extends$1i({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1h || (_path$1h = createElement("path", {
      d: "M9 2a7 7 0 017 7c0 1.57-.5 3-1.39 4.19l.8.81H16l6 6-2 2-6-6v-.59l-.81-.8A6.916 6.916 0 019 16a7 7 0 01-7-7 7 7 0 017-7M8 5v3H5v2h3v3h2v-3h3V8h-3V5H8z"
  })))
}

function _extends$1j() {
  return (_extends$1j = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgFileDocument(props) {
  return createElement("svg", _extends$1j({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1i || (_path$1i = createElement("path", {
      d: "M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.11.89-2 2-2m9 16v-2H6v2h9m3-4v-2H6v2h12z"
  })))
}

function _extends$1k() {
  return (_extends$1k = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgFileDocumentBoxRemove(props) {
  return createElement("svg", _extends$1k({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1j || (_path$1j = createElement("path", {
      d: "M14.46 15.88l1.42-1.42L18 16.59l2.12-2.13 1.42 1.42L19.41 18l2.13 2.12-1.42 1.42L18 19.41l-2.12 2.13-1.42-1.42L16.59 18l-2.13-2.12M12 17v-2H7v2h5m5-6H7v2h7.69A5.983 5.983 0 0012 18c0 1.09.29 2.12.8 3H5a2 2 0 01-2-2V5c0-1.11.89-2 2-2h14a2 2 0 012 2v7.8c-.88-.51-1.91-.8-3-.8l-1 .08V11m0-2V7H7v2h10z"
  })))
}

function _extends$1l() {
  return (_extends$1l = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgFileDocumentBoxCheck(props) {
  return createElement("svg", _extends$1l({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1k || (_path$1k = createElement("path", {
      d: "M17 21l-2.75-3 1.16-1.16L17 18.43l3.59-3.59 1.16 1.41M12.8 21H5a2 2 0 01-2-2V5c0-1.11.89-2 2-2h14a2 2 0 012 2v7.8c-.88-.51-1.91-.8-3-.8l-1 .08V11H7v2h7.69A5.983 5.983 0 0012 18c0 1.09.29 2.12.8 3m-.8-6H7v2h5m5-10H7v2h10"
  })))
}

function _extends$1m() {
  return (_extends$1m = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgWindowRestore(props) {
  return createElement("svg", _extends$1m({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1l || (_path$1l = createElement("path", {
      d: "M4 8h4V4h12v12h-4v4H4V8m12 0v6h2V6h-8v2h6M6 12v6h8v-6H6z"
  })))
}

function _extends$1n() {
  return (_extends$1n = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgWindowClose(props) {
  return createElement("svg", _extends$1n({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1m || (_path$1m = createElement("path", {
      d: "M13.46 12L19 17.54V19h-1.46L12 13.46 6.46 19H5v-1.46L10.54 12 5 6.46V5h1.46L12 10.54 17.54 5H19v1.46L13.46 12z"
  })))
}

function _extends$1o() {
  return (_extends$1o = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgWindowMinimize(props) {
  return createElement("svg", _extends$1o({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1n || (_path$1n = createElement("path", {
      d: "M20 14H4v-4h16"
  })))
}

function _extends$1p() {
  return (_extends$1p = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgWindowMaximize(props) {
  return createElement("svg", _extends$1p({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1o || (_path$1o = createElement("path", {
      d: "M4 4h16v16H4V4m2 4v10h12V8H6z"
  })))
}
class MaterialCommunityIcons extends React__default.PureComponent {
  get svgIcon() {
      var SvgIcon = null;
      switch (this.props.name) {
          case "close-circle":
              SvgIcon = SvgCloseCircle;
              break;
          case "checkbox-marked-circle":
              SvgIcon = SvgCheckboxMarkedCircle;
              break;
          case "magnify-minus-outline":
              SvgIcon = SvgMagnifyMinusOutline;
              break;
          case "magnify-plus-outline":
              SvgIcon = SvgMagnifyPlusOutline;
              break;
          case "magnify-minus":
              SvgIcon = SvgMagnifyMinus;
              break;
          case "magnify-plus":
              SvgIcon = SvgMagnifyPlus;
              break;
          case "file-document":
              SvgIcon = SvgFileDocument;
              break;
          case "file-document-box-remove":
              SvgIcon = SvgFileDocumentBoxRemove;
              break;
          case "file-document-box-check":
              SvgIcon = SvgFileDocumentBoxCheck;
              break;
          case "chevron-up":
              SvgIcon = SvgChevronUp;
              break;
          case "arrow-up-bold-circle-outline":
              SvgIcon = SvgArrowUpBoldCircleOutline;
              break;
          case "arrow-up-bold":
              SvgIcon = SvgArrowUpBold;
              break;
          case "brain":
              SvgIcon = SvgBrain;
              break;
          case "eye":
              SvgIcon = SvgEye;
              break;
          case "chart-bubble":
              SvgIcon = SvgChartBubble;
              break;
          case "language-python":
              SvgIcon = SvgLanguagePython;
              break;
          case "robot":
              SvgIcon = SvgRobot;
              break;
          case "chart-line":
              SvgIcon = SvgChartLine;
              break;
          case "checkbox-blank-outline":
              SvgIcon = SvgCheckboxBlankOutline;
              break;
          case "checkbox-marked":
              SvgIcon = SvgCheckboxMarked;
              break;
          case "checkbox-multiple-blank-outline":
              SvgIcon = SvgCheckboxMultipleBlankOutline;
              break;
          case "checkbox-multiple-marked":
              SvgIcon = SvgCheckboxMultipleMarked;
              break;
          case "chevron-double-up":
              SvgIcon = SvgChevronDoubleUp;
              break;
          case "chevron-double-down":
              SvgIcon = SvgChevronDoubleDown;
              break;
          case "format-list-checkbox":
              SvgIcon = SvgFormatListCheckbox;
              break;
          case "email-outline":
              SvgIcon = SvgEmailOutline;
              break;
          case "folder-outline":
              SvgIcon = SvgFolderOutline;
              break;
          case "pencil":
              SvgIcon = SvgPencil;
              break;
          case "account":
              SvgIcon = SvgAccount;
              break;
          case "account-circle":
              SvgIcon = SvgAccountCircle;
              break;
          case "account-settings":
              SvgIcon = SvgAccountSettings;
              break;
          case "file-document-box-multiple-outline":
              SvgIcon = SvgFileDocumentBoxMultipleOutline;
              break;
          case "file":
              SvgIcon = SvgFileOutline;
              break;
          case "fileHidden":
              SvgIcon = SvgFileHidden;
              break;
          case "power-plug":
              SvgIcon = SvgPowerPlug;
              break;
          case "calendar":
              SvgIcon = SvgCalendar;
              break;
          case "clock-outline":
              SvgIcon = SvgClockOutline;
              break;
          case "code-braces":
              SvgIcon = SvgCodeBraces;
              break;
          case "check-circle-outline":
              SvgIcon = SvgCheckCircleOutline;
              break;
          case "database":
              SvgIcon = SvgDatabase;
              break;
          case "database-export":
              SvgIcon = SvgDatabaseExport;
              break;
          case "database-import":
              SvgIcon = SvgDatabaseImport;
              break;
          case "cogs":
              SvgIcon = SvgCogs;
              break;
          case "source-branch":
              SvgIcon = SvgSourceBranch;
              break;
          case "eye-check-outline":
              SvgIcon = SvgEyeCheckOutline;
              break;
          case "menu":
              SvgIcon = SvgMenu;
              break;
          case "menu-up":
              SvgIcon = SvgMenuUp;
              break;
          case "menu-down":
              SvgIcon = SvgMenuDown;
              break;
          case "settings-outline":
              SvgIcon = SvgSettingsOutline;
              break;
          case "account-multiple":
              SvgIcon = SvgAccountMultiple;
              break;
          case "account-group":
              SvgIcon = SvgAccountGroup;
              break;
          case "filter-variant":
              SvgIcon = SvgFilterVariant;
              break;
          case "magnify":
              SvgIcon = SvgMagnify;
              break;
          case "minus":
              SvgIcon = SvgMinus;
              break;
          case "dots-vertical":
              SvgIcon = SvgDotsVertical;
              break;
          case "dots-horizontal":
              SvgIcon = SvgDotsHorizontal;
              break;
          case "stop":
              SvgIcon = SvgStop;
              break;
          case "stop-circle":
              SvgIcon = SvgStopCircle;
              break;
          case "stop-circle-outline":
              SvgIcon = SvgStopCircleOutline;
              break;
          case "play":
              SvgIcon = SvgPlay;
              break;
          case "play-circle":
              SvgIcon = SvgPlayCircle;
              break;
          case "play-circle-outline":
              SvgIcon = SvgPlayCircleOutline;
              break;
          case "console":
              SvgIcon = SvgConsole;
              break;
          case "console-network":
              SvgIcon = SvgConsoleNetwork;
              break;
          case "view-dashboard":
              SvgIcon = SvgViewDashboardOutline;
              break;
          case "developer-board":
              SvgIcon = SvgDeveloperBoard;
              break;
          case "calendar-clock":
              SvgIcon = SvgCalendarClock;
              break;
          case "server":
              SvgIcon = SvgServer;
              break;
          case "message-text-outline":
              SvgIcon = SvgMessageTextOutline;
              break;
          case "monitor-dashboard":
              SvgIcon = SvgMonitorDashboard;
              break;
          case "heart-pulse":
              SvgIcon = SvgHeartPulse;
              break;
          case "dashboard-check":
              SvgIcon = SvgDatabaseCheck;
              break;
          case "cloud-sync":
              SvgIcon = SvgCloudSync;
              break;
          case "cloud":
              SvgIcon = SvgCloud;
              break;
          case "restore":
              SvgIcon = SvgRestore;
              break;
          case "import":
              SvgIcon = SvgImport;
              break;
          case "export":
              SvgIcon = SvgExport;
              break;
          case "application-import":
              SvgIcon = SvgApplicationImport;
              break;
          case "application-export":
              SvgIcon = SvgApplicationExport;
              break;
          case "cube-outline":
              SvgIcon = SvgCubeOutline;
              break;
          case "security-account":
          case "shield-account":
              SvgIcon = SvgShieldAccount;
              break;
          case "help-circle-outline":
              SvgIcon = SvgHelpCircleOutline;
              break;
          case "git":
              SvgIcon = SvgGit;
              break;
          case "npm":
              SvgIcon = SvgNpm;
              break;
          case "cursor-move":
              SvgIcon = SvgCursorMove;
              break;
          case "window-restore":
              SvgIcon = SvgWindowRestore;
              break;
          case "window-close":
              SvgIcon = SvgWindowClose;
              break;
          case "window-minimize":
              SvgIcon = SvgWindowMinimize;
              break;
          case "window-maximize":
              SvgIcon = SvgWindowMaximize;
              break;
          default:
              throw "Icon ".concat(this.props.name, " not found")
      }
      return SvgIcon
  }
  render() {
      return React__default.createElement(SvgIcon, _extends({
          svg: this.svgIcon
      }, this.props))
  }
}

function _extends$1q() {
  return (_extends$1q = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgArrowUpward(props) {
  return createElement("svg", _extends$1q({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1p || (_path$1p = createElement("path", {
      d: "M13 20h-2V8l-5.5 5.5-1.42-1.42L12 4.16l7.92 7.92-1.42 1.42L13 8v12z"
  })))
}

function _extends$1r() {
  return (_extends$1r = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgArrowDownward(props) {
  return createElement("svg", _extends$1r({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1q || (_path$1q = createElement("path", {
      d: "M11 4h2v12l5.5-5.5 1.42 1.42L12 19.84l-7.92-7.92L5.5 10.5 11 16V4z"
  })))
}

function _extends$1s() {
  return (_extends$1s = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgArrowBack(props) {
  return createElement("svg", _extends$1s({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1r || (_path$1r = createElement("path", {
      d: "M20 11v2H8l5.5 5.5-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5 8 11h12z"
  })))
}

function _extends$1t() {
  return (_extends$1t = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgArrowForward(props) {
  return createElement("svg", _extends$1t({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1s || (_path$1s = createElement("path", {
      d: "M4 11v2h12l-5.5 5.5 1.42 1.42L19.84 12l-7.92-7.92L10.5 5.5 16 11H4z"
  })))
}

function _extends$1u() {
  return (_extends$1u = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgKeyboardArrowUp(props) {
  return createElement("svg", _extends$1u({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1t || (_path$1t = createElement("path", {
      d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
  })), _path2 || (_path2 = createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
  })))
}

function _extends$1v() {
  return (_extends$1v = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgKeyboardArrowDown(props) {
  return createElement("svg", _extends$1v({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1u || (_path$1u = createElement("path", {
      d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
  })), _path2$1 || (_path2$1 = createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0V0z"
  })))
}

function _extends$1w() {
  return (_extends$1w = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgKeyboardArrowLeft(props) {
  return createElement("svg", _extends$1w({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1v || (_path$1v = createElement("path", {
      d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
  })), _path2$2 || (_path2$2 = createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0V0z"
  })))
}

function _extends$1x() {
  return (_extends$1x = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgKeyboardArrowRight(props) {
  return createElement("svg", _extends$1x({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1w || (_path$1w = createElement("path", {
      d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
  })), _path2$3 || (_path2$3 = createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0V0z"
  })))
}

function _extends$1y() {
  return (_extends$1y = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgClose(props) {
  return createElement("svg", _extends$1y({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1x || (_path$1x = createElement("path", {
      d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  })), _path2$4 || (_path2$4 = createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
  })))
}

function _extends$1z() {
  return (_extends$1z = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgLock(props) {
  return createElement("svg", _extends$1z({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1y || (_path$1y = createElement("path", {
      d: "M12 17a2 2 0 002-2 2 2 0 00-2-2 2 2 0 00-2 2 2 2 0 002 2m6-9a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V10a2 2 0 012-2h1V6a5 5 0 015-5 5 5 0 015 5v2h1m-6-5a3 3 0 00-3 3v2h6V6a3 3 0 00-3-3z"
  })))
}

function _extends$1A() {
  return (_extends$1A = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgAdd(props) {
  return createElement("svg", _extends$1A({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1z || (_path$1z = createElement("path", {
      d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
  })))
}

function _extends$1B() {
  return (_extends$1B = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgNotifications(props) {
  return createElement("svg", _extends$1B({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1A || (_path$1A = createElement("path", {
      d: "M21 19v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 012-2 2 2 0 012 2v.29c2.97.88 5 3.61 5 6.71v6l2 2m-7 2a2 2 0 01-2 2 2 2 0 01-2-2"
  })))
}

function _extends$1C() {
  return (_extends$1C = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgNotificationsNone(props) {
  return createElement("svg", _extends$1C({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1B || (_path$1B = createElement("path", {
      d: "M16 17H7v-6.5C7 8 9 6 11.5 6S16 8 16 10.5m2 5.5v-5.5c0-3.07-2.14-5.64-5-6.32V3.5A1.5 1.5 0 0011.5 2 1.5 1.5 0 0010 3.5v.68c-2.87.68-5 3.25-5 6.32V16l-2 2v1h17v-1m-8.5 4a2 2 0 002-2h-4a2 2 0 002 2z"
  })))
}

function _extends$1D() {
  return (_extends$1D = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgNotificationsActive(props) {
  return createElement("svg", _extends$1D({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1C || (_path$1C = createElement("path", {
      d: "M21 19v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 012-2 2 2 0 012 2v.29c2.97.88 5 3.61 5 6.71v6l2 2m-7 2a2 2 0 01-2 2 2 2 0 01-2-2m9.75-17.81l-1.42 1.42A8.982 8.982 0 0121 11h2c0-2.93-1.16-5.75-3.25-7.81M1 11h2c0-2.4.96-4.7 2.67-6.39L4.25 3.19A10.96 10.96 0 001 11z"
  })))
}

function _extends$1E() {
  return (_extends$1E = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgRefresh(props) {
  return createElement("svg", _extends$1E({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1D || (_path$1D = createElement("path", {
      d: "M17.65 6.35A7.958 7.958 0 0012 4a8 8 0 00-8 8 8 8 0 008 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18a6 6 0 01-6-6 6 6 0 016-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
  })))
}

function _extends$1F() {
  return (_extends$1F = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgSort(props) {
  return createElement("svg", _extends$1F({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1E || (_path$1E = createElement("path", {
      d: "M3 13h12v-2H3m0-5v2h18V6M3 18h6v-2H3v2z"
  })))
}

function _extends$1G() {
  return (_extends$1G = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgMessage(props) {
  return createElement("svg", _extends$1G({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1F || (_path$1F = createElement("path", {
      d: "M20 2H4a2 2 0 00-2 2v18l4-4h14a2 2 0 002-2V4a2 2 0 00-2-2M6 9h12v2H6m8 3H6v-2h8m4-4H6V6h12"
  })))
}

function _extends$1H() {
  return (_extends$1H = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgDeleteSweep(props) {
  return createElement("svg", _extends$1H({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1G || (_path$1G = createElement("path", {
      d: "M15 16h4v2h-4v-2m0-8h7v2h-7V8m0 4h6v2h-6v-2M3 18a2 2 0 002 2h6a2 2 0 002-2V8H3v10M14 5h-3l-1-1H6L5 5H2v2h12V5z"
  })))
}

function _extends$1I() {
  return (_extends$1I = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgDelete(props) {
  return createElement("svg", _extends$1I({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1H || (_path$1H = createElement("path", {
      d: "M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19a2 2 0 002 2h8a2 2 0 002-2V7H6v12z"
  })))
}

function _extends$1J() {
  return (_extends$1J = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgErrorOutline(props) {
  return createElement("svg", _extends$1J({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1I || (_path$1I = createElement("path", {
      d: "M11 15h2v2h-2v-2m0-8h2v6h-2V7m1-5C6.47 2 2 6.5 2 12a10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2m0 18a8 8 0 01-8-8 8 8 0 018-8 8 8 0 018 8 8 8 0 01-8 8z"
  })))
}

function _extends$1K() {
  return (_extends$1K = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgOpenInNew(props) {
  return createElement("svg", _extends$1K({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1J || (_path$1J = createElement("path", {
      d: "M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3m-2 16H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7h-2v7z"
  })))
}

function _extends$1L() {
  return (_extends$1L = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgViewColumn(props) {
  return createElement("svg", _extends$1L({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1K || (_path$1K = createElement("path", {
      d: "M16 5v13h5V5M4 18h5V5H4m6 13h5V5h-5v13z"
  })))
}

function _extends$1M() {
  return (_extends$1M = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key])
      }
      return target
  }).apply(this, arguments)
}

function SvgDragHandle(props) {
  return createElement("svg", _extends$1M({
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24
  }, props), _path$1L || (_path$1L = createElement("path", {
      d: "M21 11H3V9h18v2m0 2H3v2h18v-2z"
  })))
}
class MaterialIcons extends React__default.PureComponent {
  get svgIcon() {
      var SvgIcon = null;
      switch (this.props.name) {
          case "close":
              SvgIcon = SvgClose;
              break;
          case "lock":
              SvgIcon = SvgLock;
              break;
          case "add":
              SvgIcon = SvgAdd;
              break;
          case "arrow-upward":
              SvgIcon = SvgArrowUpward;
              break;
          case "arrow-downward":
              SvgIcon = SvgArrowDownward;
              break;
          case "arrow-back":
              SvgIcon = SvgArrowBack;
              break;
          case "arrow-forward":
              SvgIcon = SvgArrowForward;
              break;
          case "keyboard-arrow-right":
              SvgIcon = SvgKeyboardArrowRight;
              break;
          case "keyboard-arrow-left":
              SvgIcon = SvgKeyboardArrowLeft;
              break;
          case "keyboard-arrow-up":
              SvgIcon = SvgKeyboardArrowUp;
              break;
          case "keyboard-arrow-down":
              SvgIcon = SvgKeyboardArrowDown;
              break;
          case "notifications":
              SvgIcon = SvgNotifications;
              break;
          case "notifications-none":
              SvgIcon = SvgNotificationsNone;
              break;
          case "notifications-active":
              SvgIcon = SvgNotificationsActive;
              break;
          case "message":
              SvgIcon = SvgMessage;
              break;
          case "refresh":
              SvgIcon = SvgRefresh;
              break;
          case "sort":
              SvgIcon = SvgSort;
              break;
          case "delete-sweep":
              SvgIcon = SvgDeleteSweep;
              break;
          case "delete":
              SvgIcon = SvgDelete;
              break;
          case "error-outline":
              SvgIcon = SvgErrorOutline;
              break;
          case "open-in-new":
              SvgIcon = SvgOpenInNew;
              break;
          case "view-column":
              SvgIcon = SvgViewColumn;
              break;
          case "drag-handle":
              SvgIcon = SvgDragHandle;
              break;
          default:
              throw "Icon ".concat(this.props.name, " not found")
      }
      return SvgIcon
  }
  render() {
      return React__default.createElement(SvgIcon, _extends({}, this.props, {
          svg: this.svgIcon
      }))
  }
}
class Icon extends React__default.Component {
  constructor(props) {
      super(props), this._iconMap = R14.getInstance().app.icons || null
  }
  getComponent(family) {
      switch (family) {
          case "MaterialCommunityIcons":
              return MaterialCommunityIcons;
          case "MaterialIcons":
              return MaterialIcons;
          default:
              throw "Icon family ".concat(this.props.family || "NULL", " not found")
      }
  }
  getSize(size) {
      if ("number" == typeof size) return size;
      var ret = null;
      switch (size) {
          case "small":
              ret = 20;
              break;
          case "medium":
              ret = 24;
              break;
          case "large":
              ret = 32;
              break;
          case "huge":
              ret = 40;
              break;
          default:
              ret = 24
      }
      return ret
  }
  render() {
      var styles = this.styles();
      if (!this._iconMap) throw new Error("Icon Error: Icon map not found in app config.");
      if (!this.props.name) throw new Error("Icon requires a name");
      if (!this._iconMap[this.props.name]) throw new Error("Icon Not Found: ".concat(this.props.name));
      var Component = this.getComponent(this._iconMap[this.props.name].family),
          size = this.getSize(this.props.size);
      return React__default.createElement(ViewBase, {
          style: [styles.container, this.props.style],
          tooltip: this.props.tooltip || null,
          htmlTag: "i"
      }, React__default.createElement(Component, {
          size: size,
          name: this._iconMap[this.props.name].name,
          color: this.props.color || Colors.onBackground
      }))
  }
  styles() {
      var size = this.getSize(this.props.size);
      return StyleSheet.create({
          container: {
              flex: 0,
              height: size,
              width: size
          }
      })
  }
}
class IconButton extends React__default.PureComponent {
  constructor(props) {
      super(props), this.handlePress = this.handlePress.bind(this)
  }
  handlePress(e) {
      !this.props.disabled && this.props.onPress && this.props.onPress(e)
  }
  render() {
      var iconButtonStyles = [styles$8.iconButton],
          iconColor = this.props.color || StyleSheet.color(Colors.onBackground).rgba(.8);
      switch (iconButtonStyles.push(styles$8[this.props.size]), this.props.variant && iconButtonStyles.push(variantStyles[this.props.variant]), this.props.variant) {
          case "circle":
              iconColor = this.props.color || StyleSheet.color(Colors.onSecondary).rgba(.8)
      }
      if (this.props.color || this.props.backgroundColor) {
          var colorStyle = {};
          this.props.color && (colorStyle.color = this.props.color), this.props.backgroundColor && (colorStyle.backgroundColor = this.props.backgroundColor);
          var colorStyles = StyleSheet.create({
              iconButton: colorStyle
          });
          iconButtonStyles.push(colorStyles.iconButton)
      }
      var title = null;
      if (this.props.title) {
          var titleStyles = [styles$8.title];
          iconButtonStyles.push(styles$8.iconButtonTitle), "bottom" === this.props.titlePosition && (titleStyles.push(styles$8.titleBottom), iconButtonStyles.push(styles$8.iconButtonTitleBottom)), title = React__default.createElement(TextInput, {
              style: titleStyles,
              color: iconColor
          }, this.props.title)
      }
      this.props.disabled && iconButtonStyles.push(styles$8.disabled), this.props.style && iconButtonStyles.push(this.props.style);
      var nProps = {};
      this.props.disabled && (nProps.disabled = !0);
      var icon = React__default.createElement(Icon, {
          name: this.props.icon,
          disabled: this.props.disabled,
          color: iconColor,
          size: this.props.size,
          selected: this.props.selected || null,
          filled: this.props.filled || null,
          tooltip: this.props.tooltip || null,
          style: styles$8.icon
      });
      return this.props.to ? (nProps.style = iconButtonStyles, nProps.exact = this.props.exact || null, nProps.activeStyle = this.props.activeStyle || null, nProps.to = this.props.to, React__default.createElement(Link, nProps, icon, title)) : this.props.externalUrl ? (nProps.style = iconButtonStyles, nProps.activeStyle = this.props.activeStyle || null, nProps.url = this.props.externalUrl, React__default.createElement(ExternalLink, nProps, icon, title)) : (nProps.onPress = this.handlePress, nProps.onPressMove = this.props.onPressMove || null, React__default.createElement(ViewBase, {
          style: iconButtonStyles
      }, icon, title, React__default.createElement(TouchableBase, {
          style: styles$8.touchable,
          onPress: this.handlePress,
          onPressMove: this.props.onPressMove || null,
          disabled: this.props.disabled || null
      }, React__default.createElement(ViewBase, {
          style: styles$8.touchable
      }))))
  }
}
_defineProperty(IconButton, "propTypes", {
  title: PropTypes.string,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  backgroundColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  size: PropTypes.oneOf(["circle"]),
  size: PropTypes.oneOf(["large", "small", "medium"]),
  disabled: PropTypes.bool,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  externalUrl: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onPress: PropTypes.func,
  icon: PropTypes.string
}), _defineProperty(IconButton, "defaultProps", {
  size: "medium"
});
var styles$8 = StyleSheet.create({
      touchable: _extends({
          flex: 1,
          position: "absolute"
      }, StyleSheet.absoluteFill),
      iconButton: {
          position: "relative",
          flex: 0,
          flexDirection: "row",
          flexWrap: "nowrap",
          backgroundColor: "transparent",
          height: 48,
          width: "auto",
          padding: 6,
          marginTop: 0,
          marginRight: 4,
          marginBottom: 0,
          marginLeft: 4,
          fontSize: 15,
          overflow: "visible",
          textAlign: "center",
          color: Colors.onBackground,
          borderRadius: 4,
          overflow: "hidden"
      },
      disabled: {
          opacity: .5
      },
      disabledText: {
          color: StyleSheet.color(Colors.primary).rgba(.5)
      },
      small: {
          height: 36,
          padding: 8,
          lineHeight: 20
      },
      medium: {
          height: 36,
          width: "auto",
          padding: 6
      },
      title: {
          width: "auto",
          lineHeight: 24,
          height: "100%",
          paddingLeft: 4
      },
      titleSmall: {
          lineHeight: 20,
          fontSize: 13
      },
      iconButtonTitleBottom: {
          height: 40,
          flex: 1,
          flexDirection: "column",
          alignItems: "center"
      },
      titleBottom: {
          paddingLeft: 0
      }
  }),
  variantStyles = StyleSheet.create({
      circle: {
          backgroundColor: Colors.secondary,
          borderRadius: 24,
          elevation: 1
      }
  }),
  TabNavigator = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props), this.tabNavRef = React__default.createRef(), this.tabNavCntrRef = React__default.createRef(), this.activeItemRef = React__default.createRef(), this.handleActiveItem = this.handleActiveItem.bind(this), this.updateLayoutStyles()
      }
      updateLayoutStyles() {
          this.props.onLayoutStylesUpdate && this.props.onLayoutStylesUpdate(this.layoutStyles)
      }
      componentDidMount() {
          this.props.scrollEnabled
      }
      handleActiveItem(item) {
          item.measure(offsetLeft => {
              console.log("item.measureOffset", offsetLeft)
          })
      }
      renderItems() {
          if (this.props.routes) throw "Prop routes not available.";
          return this.props.children.map(element => {
              var ref = null;
              return element.props.to && element.props.to.route && this.props.app.r14Instance.navigation.isActiveRoute(element.props.to.route) && (ref = this.activeItemRef), React__default.cloneElement(element, {
                  ref: ref,
                  position: this.props.position,
                  scrollEnabled: this.props.scrollEnabled
              })
          })
      }
      componentWillUnmount() {
          this.props.onWillBlur && this.props.onWillBlur(this.props, this.props.app)
      }
      render() {
          var tabNavCntrStyles = [styles$9.tabNavCntr],
              tabNavStyles = [styles$9.tabNav],
              position = this.props.position || "top";
          switch (position) {
              case "top":
                  tabNavCntrStyles.push(styles$9.tabNavCntrTop), tabNavStyles.push(styles$9.tabNavTop);
                  break;
              case "bottom":
                  tabNavCntrStyles.push(styles$9.tabNavCntrBottom), tabNavStyles.push(styles$9.tabNavBottom);
                  break;
              case "left":
                  tabNavCntrStyles.push(styles$9.tabNavCntrLeft), tabNavStyles.push(styles$9.tabNavLeft);
                  break;
              case "responsive-left-bottom":
                  tabNavCntrStyles.push(styles$9.tabNavCntrResponsiveLeftBottom), tabNavStyles.push(styles$9.tabNavResponsiveLeftBottom)
          }
          var TabNavCntr = ViewBase,
              tabNavCntrProps = {};
          if (this.props.scrollEnabled) switch (position) {
              case "top":
              case "bottom":
                  TabNavCntr = TabNavigatorScrollView, tabNavCntrProps.horizontal = !0, tabNavCntrProps.showsHorizontalScrollIndicator = !1, tabNavCntrStyles.push(styles$9.tabNavCntrScrollX), tabNavStyles.push(styles$9.tabNavScrollX)
          }
          return tabNavCntrProps.style = tabNavCntrStyles, React__default.createElement(TabNavCntr, _extends({}, tabNavCntrProps, {
              tabNavigator: this
          }), React__default.createElement(ViewBase, {
              ref: this.tabNavRef,
              style: tabNavStyles
          }, this.renderItems()))
      }
      get layoutStyles() {
          var layoutStyles = null;
          switch (this.props.position || "top") {
              case "top":
                  layoutStyles = StyleSheet.create({
                      offset: {
                          marginTop: 48
                      }
                  });
                  break;
              case "bottom":
                  layoutStyles = StyleSheet.create({
                      offset: {
                          marginBottom: 48
                      }
                  });
                  break;
              case "left":
                  layoutStyles = StyleSheet.create({
                      offset: {
                          marginLeft: 56
                      }
                  });
                  break;
              case "responsive-left-bottom":
                  layoutStyles = StyleSheet.create({
                      offset: {
                          marginLeft: 56,
                          screen: _ref => {
                              var {
                                  width: width
                              } = _ref;
                              if (width <= 640) return {
                                  marginLeft: 0,
                                  marginBottom: 56
                              }
                          }
                      }
                  })
          }
          return layoutStyles
      }
  }),
  styles$9 = StyleSheet.create({
      tabNavCntr: {
          position: "absolute",
          backgroundColor: Colors.primaryDark,
          elevation: 2
      },
      tabNavCntrTop: {
          height: 48,
          top: 0,
          right: 0,
          left: 0,
          bottom: null,
          backgroundColor: Colors.background,
          screen: _ref2 => {
              var {
                  width: width
              } = _ref2;
              if (width <= 640) return {
                  height: 48,
                  elevation: 4
              }
          }
      },
      tabNavCntrLeft: {
          top: 0,
          right: null,
          left: 0,
          bottom: 0,
          width: 56
      },
      tabNavCntrResponsiveLeftBottom: {
          top: 0,
          right: null,
          left: 0,
          bottom: 0,
          width: 56,
          screen: _ref3 => {
              var {
                  width: width
              } = _ref3;
              if (width <= 640) return {
                  height: 56,
                  width: "auto",
                  elevation: 12,
                  top: null,
                  right: 0,
                  left: 0,
                  bottom: 0
              }
          }
      },
      tabNavCntrBottom: {
          top: null,
          right: 0,
          left: 0,
          bottom: 0
      },
      tabNav: {
          flex: 0,
          flexDirection: "column",
          justifyContent: "flex-start"
      },
      tabNavResponsiveLeftBottom: {
          screen: _ref4 => {
              var {
                  width: width
              } = _ref4;
              if (width <= 640) return {
                  flex: 1,
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  alignItems: "center"
              }
          }
      },
      tabNavTop: {
          flexDirection: "row",
          screen: _ref5 => {
              var {
                  width: width
              } = _ref5;
              if (width <= 640) return {
                  height: 48
              }
          }
      }
  }),
  TabNavigatorScrollView = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props), this.scrollRef = React__default.createRef(), this.handleScroll = this.handleScroll.bind(this), this.handleLayout = this.handleLayout.bind(this), this.handleControlLeftPress = this.handleControlLeftPress.bind(this), this.handleControlRightPress = this.handleControlRightPress.bind(this), this.isInitialized = !1, this.offset = null, this.contentSize = null, this.size = null, this.lastScrollEvent = null, this.state = {
              controlLeftVisible: !1,
              controlRightVisible: !1
          }
      }
      componentDidMount() {
          this.props.tabNavigator && this.props.tabNavigator.activeItemRef.current && setTimeout(() => {
              this.props.tabNavigator && this.props.tabNavigator.activeItemRef && this.props.tabNavigator.activeItemRef.current && this.props.tabNavigator.activeItemRef.current.measure((offsetLeft, b, c, d) => {
                  offsetLeft >= 32 && this.scrollRef.current.scrollTo({
                      x: offsetLeft - 32
                  })
              })
          }, 100)
      }
      updateScrollEvent() {
          this.scrollRef.current.triggerOnScroll()
      }
      handleLayout() {
          this.updateScrollEvent()
      }
      handleScroll(ev) {
          this.lastScrollEvent = ev.nativeEvent;
          var width = ev.nativeEvent.layout.width,
              contentWidth = ev.nativeEvent.contentSize.width,
              offset = ev.nativeEvent.contentOffset,
              controlLeftVisible = !1,
              controlRightVisible = !1;
          contentWidth > width && (offset.x > 16 && (controlLeftVisible = !0), offset.x + width < contentWidth && (controlRightVisible = !0)), this.state.controlLeftVisible === controlLeftVisible && this.state.controlRightVisible === controlRightVisible || this.setState({
              controlLeftVisible: controlLeftVisible,
              controlRightVisible: controlRightVisible
          })
      }
      handleControlLeftPress() {
          var {
              contentOffset: contentOffset,
              contentSize: contentSize,
              layout: layout
          } = this.lastScrollEvent, scrollTo = contentOffset.x - .8 * layout.width;
          scrollTo < 0 && (scrollTo = 0), this.scrollRef.current.scrollTo({
              x: scrollTo
          })
      }
      handleControlRightPress() {
          var {
              contentOffset: contentOffset,
              contentSize: contentSize,
              layout: layout
          } = this.lastScrollEvent, scrollTo = contentOffset.x + .8 * layout.width;
          scrollTo > contentSize.width && (scrollTo = contentSize.width), this.scrollRef.current.scrollTo({
              x: scrollTo
          })
      }
      render() {
          var styles = TabNavigatorScrollViewStyles;
          return React__default.createElement(ViewBase, {
              style: [styles.tabNavigatorScrollViewWrapper, this.props.style]
          }, React__default.createElement(ScrollViewBase, {
              onScroll: this.handleScroll,
              ref: this.scrollRef,
              style: styles.tabNavigatorScrollView,
              horizontal: !0,
              showsHorizontalScrollIndicator: !1,
              onLayout: this.handleLayout
          }, this.props.children), React__default.createElement(FadeView, {
              visible: this.state.controlLeftVisible,
              style: [styles.controls, styles.controlsLeft]
          }, React__default.createElement(IconButton, {
              style: styles.controlIcon,
              onPress: this.handleControlLeftPress,
              icon: "keyboardArrowLeft"
          })), React__default.createElement(FadeView, {
              visible: this.state.controlRightVisible,
              style: [styles.controls, styles.controlsRight]
          }, React__default.createElement(IconButton, {
              style: styles.controlIcon,
              onPress: this.handleControlRightPress,
              icon: "keyboardArrowRight"
          })))
      }
  }),
  TabNavigatorScrollViewStyles = StyleSheet.create({
      tabNavigatorScrollViewWrapper: {
          flex: 1,
          flexDirection: "row",
          overflow: "hidden",
          height: 48
      },
      tabNavigatorScrollView: {
          paddingBottom: 128
      },
      controls: {
          position: "absolute",
          flex: 1,
          height: 48,
          justifyContent: "space-around",
          screen: _ref6 => {
              var {
                  width: width,
                  height: height
              } = _ref6;
              if (width <= 640) return {
                  height: 48
              }
          }
      },
      controlIcon: _extends({}, StyleSheet.margin(0)),
      controlsLeft: {
          left: 0,
          screen: _ref7 => {
              var {
                  width: width
              } = _ref7;
              return width <= 640 ? {
                  backgroundImage: "linear-gradient(to right, ".concat(Colors.surface, ", ").concat(Colors.surface, ", transparent)")
              } : {
                  backgroundImage: "linear-gradient(to right, ".concat(Colors.background, ", ").concat(Colors.background, ", transparent)")
              }
          }
      },
      controlsRight: {
          right: 0,
          screen: _ref8 => {
              var {
                  width: width
              } = _ref8;
              return width <= 640 ? {
                  backgroundImage: "linear-gradient(to left, ".concat(Colors.surface, ", ").concat(Colors.surface, ", transparent)")
              } : {
                  backgroundImage: "linear-gradient(to left, ".concat(Colors.background, ", ").concat(Colors.background, ", transparent)")
              }
          }
      }
  });
class TabNavigatorItem extends React__default.Component {
  constructor(props) {
      super(props), this.handleActive = this.handleActive.bind(this), this.ref = React__default.createRef()
  }
  handleActive(link) {
      console.log(this.ref), this.props.onActive && this.props.onActive(this)
  }
  measure(callback) {
      this.ref.current.wrappedInstance.measure(callback)
  }
  render() {
      var styles = this.styles(),
          activeStyles = [styles.active],
          position = this.props.position || "top",
          tabNavItemStyles = [styles.tabNavigatorItem];
      switch (position) {
          case "top":
              activeStyles.push(styles.topActive), tabNavItemStyles.push(styles.top);
              break;
          case "bottom":
              activeStyles.push(styles.bottomActive);
              break;
          case "left":
              activeStyles.push(styles.leftActive);
              break;
          case "responsive-left-bottom":
              activeStyles.push(styles.responsiveLeftBottomActive)
      }
      return React__default.createElement(Link, {
          style: tabNavItemStyles,
          activeStyle: activeStyles,
          to: this.props.to,
          onActive: this.props.onActive && this.handleActive,
          ref: this.ref
      }, this.props.icon && React__default.createElement(Icon, {
          color: Colors.onPrimaryDark,
          name: this.props.icon
      }), this.props.label && React__default.createElement(TextInput, {
          style: styles.label
      }, this.props.label))
  }
  styles() {
      var backgroundColor = StyleSheet.color(Colors.primary).rgba(.4),
          labelColor = Colors.onPrimaryDark;
      switch (this.props.position) {
          case "top":
              backgroundColor = Colors.surface, labelColor = Colors.onSurface
      }
      return StyleSheet.create({
          tabNavigatorItem: {
              flex: 0,
              flexShrink: 0,
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              padding: 16,
              height: 48,
              margin: 0,
              opacity: .7,
              backgroundColor: StyleSheet.color(Colors.primary).rgba(.4),
              screen: _ref => {
                  var {
                      width: width
                  } = _ref;
                  if (width <= 640) return {
                      display: "flex",
                      flexShrink: this.props.scrollEnabled ? 0 : 1,
                      flexGrow: this.props.scrollEnabled ? 0 : 1
                  }
              }
          },
          top: {
              height: 48,
              backgroundColor: Colors.background,
              minWidth: 90,
              screen: _ref2 => {
                  var {
                      width: width
                  } = _ref2;
                  return width <= 480 ? {
                      minWidth: "40%",
                      height: 48,
                      backgroundColor: Colors.surface
                  } : width <= 640 ? {
                      minWidth: "28.5%",
                      height: 48,
                      backgroundColor: Colors.surface
                  } : void 0
              }
          },
          label: {
              color: labelColor,
              fontWeight: "500",
              fontSize: 14
          },
          active: {
              borderStyle: "solid",
              borderWidth: 0,
              borderColor: Colors.primaryLight,
              backgroundColor: backgroundColor,
              opacity: .94
          },
          leftActive: {
              borderLeftWidth: 2,
              paddingLeft: 14
          },
          responsiveLeftBottomActive: {
              borderLeftWidth: 2,
              paddingLeft: 14,
              screen: _ref3 => {
                  var {
                      width: width
                  } = _ref3;
                  if (width <= 640) return {
                      borderLeftWidth: 0,
                      borderTopWidth: 2,
                      paddingLeft: 16,
                      paddingTop: 14
                  }
              }
          },
          bottomActive: {
              borderTopWidth: 2,
              paddingTop: 14
          },
          topActive: {
              borderBottomWidth: 2,
              paddingBottom: 14
          }
      })
  }
}
class DrawerNavigatorItem extends React__default.Component {
  render() {
      var styles = this.styles(),
          activeStyles = [],
          position = this.props.position || "top",
          drawerNavItemStyles = [],
          labelStyles = [],
          iconColor = null,
          sidebarOnBackground = Theme.componentColors("sidebar").onBackground;
      switch (this.props.type) {
          case "minimized":
              switch (drawerNavItemStyles.push(styles.drawerNavigatorMinimizedItem), iconColor = Colors.onPrimary, activeStyles.push(styles.activeMinimized), position) {
                  case "left":
                      activeStyles.push(styles.leftActiveMinimized)
              }
              break;
          default:
              switch (drawerNavItemStyles.push(styles.drawerNavigatorItem), iconColor = this.props.active ? this.props.activeIconColor || Colors.primary : this.props.iconColor || Colors.onBackground, activeStyles.push(styles.active), position) {
                  case "left":
                      if (!this.props.active && sidebarOnBackground) {
                          this.props.iconColor || (iconColor = sidebarOnBackground);
                          var labelStyleSheet = StyleSheet.create({
                              label: {
                                  color: sidebarOnBackground
                              }
                          });
                          labelStyles.push(labelStyleSheet.label)
                      }
                      activeStyles.push(styles.leftActive), this.props.style && drawerNavItemStyles.push(this.props.style), this.props.activeStyle && activeStyles.push(this.props.activeStyle), this.props.labelTextStyle && labelStyles.push(this.props.labelTextStyle), this.props.activeLabelTextStyle && this.props.active && labelStyles.push(this.props.activeLabelTextStyle)
              }
      }
      var label = null;
      if (this.props.label)
          if ("function" == typeof this.props.label) {
              var LabelComponent = this.props.label;
              label = React__default.createElement(LabelComponent, {
                  style: [styles.label, this.props.active && styles.activeLabel, labelStyles],
                  active: this.props.active
              })
          } else {
              var labelText = this.props.label;
              this.props.upperCaseLabel && (labelText = labelText.toUpperCase()), label = React__default.createElement(TextInput, {
                  style: [styles.label, this.props.active && styles.activeLabel, labelStyles]
              }, this.props.label)
          } return React__default.createElement(TouchableBase, {
          style: [drawerNavItemStyles, this.props.active && activeStyles],
          to: this.props.to,
          onPress: this.props.onPress
      }, this.props.icon && React__default.createElement(Icon, {
          style: styles.icon,
          color: iconColor,
          name: this.props.icon
      }), "minimized" !== this.props.type && label)
  }
  styles() {
      var backgroundColor = StyleSheet.color(Colors.primary).rgba(.1),
          labelColor = Colors.onBackground;
      return StyleSheet.create({
          drawerNavigatorItem: _extends({
              flex: 0,
              flexShrink: 0,
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center"
          }, StyleSheet.padding(0, 12, 0, 12), StyleSheet.margin(4, 8, 4, 8), {
              height: 42,
              margin: 0,
              opacity: .7
          }),
          drawerNavigatorMinimizedItem: _extends({
              flex: 0,
              flexShrink: 0,
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center"
          }, StyleSheet.padding(0, 20, 0, 20), {
              height: 50,
              margin: 0,
              opacity: .7,
              backgroundColor: StyleSheet.color(Colors.primary).rgba(.1),
              screen: _ref => {
                  var {
                      width: width
                  } = _ref;
                  if (width <= 640) return _extends({}, StyleSheet.padding(0, 16, 0, 16))
              }
          }),
          label: {
              color: labelColor,
              fontWeight: "500",
              fontSize: 14
          },
          activeLabel: {
              color: Colors.primary
          },
          active: {
              color: Colors.primaryDark,
              borderStyle: "solid",
              borderWidth: 0,
              borderColor: Colors.primaryLight,
              backgroundColor: backgroundColor,
              opacity: .94
          },
          leftActive: {
              borderRadius: 4
          },
          bottomActive: {
              borderTopWidth: 2,
              paddingTop: 14
          },
          activeMinimized: {
              borderStyle: "solid",
              borderLeftWidth: 2,
              paddingLeft: 18,
              borderColor: Colors.primaryLight,
              opacity: .94,
              backgroundColor: StyleSheet.color(Colors.primary).rgba(.2),
              screen: _ref2 => {
                  var {
                      width: width
                  } = _ref2;
                  if (width <= 640) return {
                      paddingLeft: 14
                  }
              }
          },
          leftActiveMinimized: {},
          icon: {
              marginRight: 24
          }
      })
  }
}
class DrawerItems extends React__default.Component {
  constructor(props) {
      super(props), this.handlePress = this.handlePress.bind(this)
  }
  handlePress() {
      "modal" === this.props.type && this.props.navigator.hide(), this.props.onPress && this.props.onPress()
  }
  render() {
      var drawerItems = [];
      for (var routeName in this.props.routes) {
          var route = this.props.routes[routeName],
              to = route.to || {
                  route: routeName
              };
          if (this.props.itemRenderer) {
              var ret = this.props.itemRenderer({
                  route: route,
                  app: this.props.app
              });
              if (!ret) continue;
              if (React__default.isValidElement(ret)) {
                  drawerItems.push(ret);
                  continue
              }
          }
          var label = route.label,
              toRoute = routeName;
          route.to && (toRoute = route.to);
          var isActive = this.props.app.r14Instance.navigation.isActiveRoute(toRoute);
          (route.icon || label) && drawerItems.push(React__default.createElement(DrawerNavigatorItem, {
              key: routeName,
              icon: route.icon,
              type: this.props.type,
              label: label,
              to: to,
              style: this.props.itemStyle,
              iconColor: this.props.itemIconColor,
              labelTextStyle: this.props.itemLabelTextStyle,
              activeStyle: this.props.itemActiveStyle,
              activeLabelTextStyle: this.props.itemActiveLabelTextStyle,
              activeIconColor: this.props.itemActiveIconColor,
              onPress: this.handlePress,
              position: this.props.position,
              scrollEnabled: this.props.scrollEnabled,
              active: isActive,
              upperCaseLabel: this.props.upperCaseLabel
          }))
      }
      return drawerItems
  }
}
var DrawerNavigator = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props), this.handleItemPress = this.handleItemPress.bind(this), this.drawerNavRef = React__default.createRef(), this.drawerNavCntrRef = React__default.createRef()
      }
      componentDidMount() {
          this.props.scrollEnabled, this.updateLayoutStyles()
      }
      handleItemPress() {
          "modal" === this.props.type && this.props.navigator.hide()
      }
      updateLayout() {}
      updateLayoutStyles() {
          this.props.onLayoutStylesUpdate && this.props.onLayoutStylesUpdate(this.layoutStyles)
      }
      componentDidUpdate(prevProps) {
          prevProps.visible === this.props.visible && prevProps.type === this.props.type || this.updateLayoutStyles()
      }
      componentWillUnmount() {
          this.props.onWillBlur && this.props.onWillBlur(this.props, this.props.app)
      }
      renderItems() {
          var drawerType = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
          if (this.props.contentComponent) {
              var ContentComponent = this.props.contentComponent;
              return React__default.createElement(ContentComponent, _extends({}, this.props, {
                  activeItemKey: this.props.app.r14Instance.navigation.activeRoute
              }))
          }
          return this.props.routes ? React__default.createElement(DrawerItems, _extends({}, this.props, {
              type: drawerType || this.props.type
          })) : this.props.children.map(element => {
              this.props.app.r14Instance.navigation.parseNavigationProps(element.props);
              throw new Error("DrawerNavigator Error: Child items in dev.")
          })
      }
      render() {
          var drawerNavCntrStyles = [styles$a.drawerNavCntr],
              drawerNavMinimizedCntrStyles = [styles$a.drawerNavMinimizedCntr],
              drawerNavStyles = [styles$a.drawerNav],
              drawerCntrStyles = [styles$a.drawerCntr],
              drawerModalStyles = [styles$a.drawerModal],
              drawerMinimizedCntrStyles = [styles$a.drawerMinimizedCntr];
          switch (this.props.position || "top") {
              case "left":
                  drawerNavCntrStyles.push(styles$a.drawerNavCntrLeft), drawerNavStyles.push(styles$a.drawerNavLeft), drawerCntrStyles.push(styles$a.drawerCntrLeft);
                  var drawerCntrColor = Theme.componentColors("sidebar").background;
                  if (drawerCntrColor) {
                      var sidebarStyles = StyleSheet.create({
                          sidebar: {
                              backgroundColor: drawerCntrColor
                          }
                      });
                      drawerCntrStyles.push(sidebarStyles.sidebar), drawerModalStyles.push(sidebarStyles.sidebar)
                  }
                  drawerMinimizedCntrStyles.push(styles$a.drawerMinimizedCntrLeft), drawerNavMinimizedCntrStyles.push(styles$a.drawerNavMinimizedCntrLeft)
          }
          var DrawerNavCntr = ViewBase,
              DrawerNavMinimizedCntr = ViewBase,
              drawerNavCntrProps = {};
          this.props.scrollEnabled && (DrawerNavCntr = ScrollViewBase, DrawerNavMinimizedCntr = ScrollViewBase), drawerNavCntrProps.style = drawerNavCntrStyles;
          var ModalHeader = this.props.modalHeader || null;
          return React__default.createElement(React__default.Fragment, null, React__default.createElement(AnimatedView, {
              in: "modal" !== this.props.type && this.props.visible,
              enter: {
                  transform: [{
                      translateX: 0
                  }, {
                      scale: 1
                  }],
                  opacity: 1
              },
              exit: {
                  transform: [{
                      translateX: -256
                  }, {
                      scale: 1
                  }],
                  opacity: 0
              },
              duration: 150,
              unmountOnExit: !0,
              style: drawerCntrStyles
          }, React__default.createElement(DrawerNavCntr, _extends({}, drawerNavCntrProps, {
              ref: this.drawerNavCntrRef
          }), React__default.createElement(ViewBase, {
              ref: this.drawerNavRef,
              style: drawerNavStyles
          }, this.renderItems()))), React__default.createElement(AnimatedView, {
              in: "modal" !== this.props.type && !this.props.visible,
              enter: {
                  transform: [{
                      translateX: 0
                  }],
                  opacity: 1
              },
              exit: {
                  transform: [{
                      translateX: -64
                  }],
                  opacity: 0,
                  screen: _ref => {
                      var {
                          width: width
                      } = _ref;
                      if (width <= 640) return {
                          transform: [{
                              translateX: -56
                          }]
                      }
                  }
              },
              duration: 150,
              unmountOnExit: !0,
              style: drawerMinimizedCntrStyles
          }, React__default.createElement(DrawerNavMinimizedCntr, {
              style: drawerNavMinimizedCntrStyles
          }, this.renderItems("minimized"))), React__default.createElement(Modal$1, {
              visible: "modal" === this.props.type && this.props.visible,
              transparent: !0,
              animationType: "fade",
              backdrop: !0,
              backdropStyle: styles$a.drawerModalBackdrop,
              contentStyle: styles$a.drawerModalContent,
              onBackdropPress: () => this.props.navigator.hide(),
              scrollEnabled: !0
          }, React__default.createElement(AnimatedView, {
              in: this.props.visible,
              animateOnMount: !0,
              enter: {
                  transform: [{
                      translateX: 0
                  }, {
                      scale: 1
                  }],
                  opacity: 1
              },
              exit: {
                  transform: [{
                      translateX: -256
                  }, {
                      scale: 1
                  }],
                  opacity: 0
              },
              duration: 150,
              animateOnMount: !0,
              unmountOnExit: !0,
              style: drawerModalStyles
          }, ModalHeader && React__default.createElement(ViewBase, {
              style: styles$a.drawerModalHeader
          }, React__default.createElement(ModalHeader, null)), this.renderItems())))
      }
      get layoutStyles() {
          var layoutStyles = null;
          switch (this.props.position || "top") {
              case "left":
                  layoutStyles = StyleSheet.create({
                      offset: {
                          marginLeft: this.props.visible ? 256 : 64,
                          screen: _ref2 => {
                              var {
                                  width: width
                              } = _ref2;
                              if (width <= 640) return {
                                  marginLeft: 0
                              }
                          }
                      }
                  })
          }
          return layoutStyles
      }
  }),
  styles$a = StyleSheet.create({
      drawerNavCntr: {
          position: "absolute",
          backgroundColor: "transparent"
      },
      drawerCntr: {
          position: "absolute",
          backgroundColor: "transparent",
          screen: _ref3 => {
              var {
                  width: width
              } = _ref3;
              if (width <= 640) return {
                  backgroundColor: Colors.surface,
                  elevation: 4
              }
          }
      },
      drawerMinimizedCntr: {
          position: "absolute",
          backgroundColor: "transparent"
      },
      drawerNavMinimizedCntr: {
          position: "absolute",
          backgroundColor: Colors.primaryDark
      },
      drawerModal: {
          backgroundColor: Colors.surface,
          width: 256,
          elevation: 12,
          flex: 1,
          zIndex: 2,
          marginTop: 0,
          marginRight: "auto",
          paddingTop: 8
      },
      drawerModalHeader: _extends({
          height: 56
      }, StyleSheet.margin(-4, 0, 4, 0)),
      drawerModalContent: _extends({
          flex: 1,
          flexDirection: "column"
      }, StyleSheet.padding(0, 0, 0, 0), {
          justifyContent: "flex-end"
      }),
      drawerModalBackdrop: _extends({}, StyleSheet.absoluteFill, {
          zIndex: 1,
          backgroundColor: StyleSheet.color(Colors.background).rgba(.8)
      }),
      drawerNavCntrTop: {
          height: 56,
          top: 0,
          right: 0,
          left: 0,
          bottom: null,
          backgroundColor: Colors.surface,
          screen: _ref4 => {
              var {
                  width: width
              } = _ref4;
              if (width <= 640) return {
                  height: 48,
                  elevation: 4
              }
          }
      },
      drawerNavCntrLeft: {
          top: 0,
          right: null,
          paddingTop: 8,
          elevation: 3,
          left: 0,
          bottom: 0,
          width: 256
      },
      drawerNavMinimizedCntrLeft: {
          top: 0,
          right: null,
          paddingTop: 8,
          elevation: 1,
          left: 0,
          bottom: 0,
          width: 64
      },
      drawerCntrLeft: {
          top: 0,
          right: null,
          left: 0,
          bottom: 0,
          width: 256
      },
      drawerMinimizedCntrLeft: {
          top: 0,
          right: null,
          left: 0,
          bottom: 0,
          width: 64
      },
      drawerNav: {
          flex: 1,
          flexDirection: "column",
          justifyContent: "flex-start"
      },
      drawerNavTop: {
          flexDirection: "row",
          screen: _ref5 => {
              var {
                  width: width
              } = _ref5;
              if (width <= 640) return {
                  height: 48
              }
          }
      }
  });
class ButtonBase extends React__default.PureComponent {
  constructor(props) {
      super(props)
  }
  render() {
      var props = {};
      return this.props.onPressIn && (props.onMouseDown = this.props.onPressIn, props.onTouchStart = this.props.onPressIn), this.props.onPressOut && (props.onMouseUp = this.props.onPressOut, props.onTouchEnd = this.props.onPressOut), React__default.createElement("button", _extends({
          type: this.props.type || "button",
          onClick: this.props.onPress,
          disabled: this.props.disabled || null,
          className: StyleSheet.className([styles$b.button, this.props.style]),
          onFocus: this.props.onFocus || null,
          onBlur: this.props.onBlur || null
      }, props), this.props.children)
  }
}
var _class$1, _temp$1, _class$2, _temp$2, _class$3, _temp$3, _class2, _temp2, _class3, _temp3, styles$b = StyleSheet.create({
      button: {
          cursor: "pointer",
          outline: 0,
          border: 0,
          display: "block"
      }
  }),
  Button = R14.connect((_temp$1 = _class$1 = class extends React__default.Component {
      constructor(props) {
          super(props), this.handlePress = this.handlePress.bind(this), this.handlePressIn = this.handlePressIn.bind(this), this.handlePressOut = this.handlePressOut.bind(this), this.handleFocus = this.handleFocus.bind(this), this.handleBlur = this.handleBlur.bind(this), this.state = {
              isFocused: !1,
              ripple: !1
          }
      }
      handlePress(event) {
          this.props.onPress ? this.props.onPress(event) : this.props.to && this.props.app.nav.to(this.props.to)
      }
      handleFocus() {
          this.setState({
              isFocused: !0
          })
      }
      handleBlur() {
          this.setState({
              isFocused: !1
          })
      }
      handlePressIn(event) {
          this.props.onPressIn && this.props.onPressIn(event)
      }
      handlePressOut(event) {
          this.props.onPressOut && this.props.onPressOut(event)
      }
      render() {
          var styles = this.styles(),
              iconColor = Colors.onPrimary,
              titleStyles = [styles.title],
              buttonStyles = [styles.button];
          if (this.props.disabled && buttonStyles.push(styles.disabled), this.props.style && buttonStyles.push(this.props.style), this.props.variant) switch (buttonStyles.push(styles["".concat(this.props.variant, "VariantButton")]), titleStyles.push(styles["".concat(this.props.variant, "VariantTitle")]), this.props.variant) {
              case "outlined":
              case "text":
                  iconColor = this.props.color || Colors.primary
          }
          this.props.titleTextStyle && titleStyles.push(this.props.titleTextStyle), this.state.isFocused && buttonStyles.push(styles.focused);
          var title = this.props.title ? this.props.title.toUpperCase() : null,
              icon = null;
          return this.props.icon && (icon = React__default.createElement(ViewBase, {
              style: styles.icon
          }, React__default.createElement(Icon, {
              name: this.props.icon,
              color: iconColor,
              size: "small"
          }))), React__default.createElement(ButtonBase, {
              type: this.props.type || "button",
              onPress: this.handlePress,
              onPressIn: this.handlePressIn,
              onPressOut: this.handlePressOut,
              disabled: this.props.disabled,
              style: buttonStyles,
              onFocus: this.handleFocus,
              onBlur: this.handleBlur
          }, React__default.createElement(ViewBase, {
              tooltip: this.props.tooltip || null,
              style: styles.content
          }, icon, React__default.createElement(TextInput, {
              style: titleStyles
          }, title)), React__default.createElement(ShowHideText, null))
      }
      styles() {
          return StyleSheet.create({
              button: {
                  flex: 0,
                  flexDirection: "row",
                  justifyContent: "space-around",
                  alignItems: "center",
                  position: "relative",
                  borderRadius: 4,
                  backgroundColor: this.props.color || this.props.backgroundColor || Colors.primary,
                  color: Colors.onPrimary,
                  paddingRight: 16,
                  paddingLeft: 16,
                  elevation: 3,
                  minWidth: 64,
                  alignContent: "center",
                  borderStyle: "solid",
                  borderWidth: 1,
                  borderColor: this.props.color || this.props.backgroundColor || Colors.primary
              },
              disabled: {
                  opacity: .4
              },
              content: {
                  flex: 0,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-around",
                  height: 34,
                  marginRight: "auto",
                  marginLeft: "auto"
              },
              title: {
                  fontSize: 14,
                  fontWeight: "500",
                  textTransform: "uppercase",
                  color: this.props.titleColor || Colors.onPrimary
              },
              icon: {
                  marginTop: 0,
                  marginRight: 4,
                  marginBottom: 0,
                  marginLeft: -4
              },
              errorColor: {
                  backgroundColor: Colors.error
              },
              textVariantButton: {
                  elevation: 0,
                  backgroundColor: "transparent",
                  borderColor: "transparent"
              },
              textVariantTitle: {
                  color: this.props.titleColor || this.props.color || Colors.primary,
                  backgroundColor: this.props.backgroundColor || null
              },
              outlinedVariantButton: {
                  elevation: 0,
                  backgroundColor: "transparent",
                  borderStyle: "solid",
                  borderWidth: 1,
                  borderColor: StyleSheet.color(Colors.onBackground).rgba(.1)
              },
              outlinedVariantTitle: {
                  color: this.props.titleColor || this.props.color || Colors.primary,
                  backgroundColor: this.props.backgroundColor || null
              },
              focused: {
                  borderColor: StyleSheet.color(Colors.onBackground).rgba(.3)
              }
          })
      }
  }, _defineProperty(_class$1, "propTypes", {
      title: PropTypes.string,
      color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      backgroundColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      titleColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      variant: PropTypes.oneOf(["outlined", "text"]),
      disabled: PropTypes.bool,
      style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      titleTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      onPress: PropTypes.func,
      icon: PropTypes.string,
      type: PropTypes.string
  }), _temp$1)),
  SnackBar = R14.connect((_temp$2 = _class$2 = class extends React__default.Component {
      constructor(props) {
          super(props), this.handleRequestDismiss = this.handleRequestDismiss.bind(this), this.handleActionButtonPress = this.handleActionButtonPress.bind(this), this._dismissTimeout = null
      }
      componentDidUpdate(prevProps) {
          this.props.dismissTimeout && (this.props.visible && !prevProps.visible ? this.createDismissTimeout() : !this.props.visible && prevProps.visible && this.clearDismissTimeout())
      }
      componentWillUnmount() {
          this.clearDismissTimeout()
      }
      handleRequestDismiss() {
          this.props.onRequestDismiss && this.props.onRequestDismiss()
      }
      handleActionButtonPress() {
          if ("string" == typeof this.props.action) switch (this.props.action) {
              case "dismiss":
                  this.handleRequestDismiss()
          } else this.props.action && this.props.action()
      }
      clearDismissTimeout() {
          this._dismissTimeout && clearTimeout(this._dismissTimeout)
      }
      createDismissTimeout() {
          this._dismissTimeout = setTimeout(() => {
              this.handleRequestDismiss(), this._dismissTimeout = null
          }, 1e3 * this.props.dismissTimeout)
      }
      createDynamicStyles() {
          var ret = {};
          return this.props.marginBottom && (ret.snackBar = {
              marginBottom: this.props.marginBottom
          }), Object.keys(ret).length ? StyleSheet.create(ret) : {}
      }
      render() {
          var components = [],
              iconName = null,
              variantIcon = null,
              onBackgroundColor = Colors.secondary,
              dynamicStyles = this.createDynamicStyles();
          if (!0 === this.props.variantIcon) throw new Error;
          switch (this.props.variant) {
              case "info":
                  variantIcon = "help";
                  break;
              case "error":
                  variantIcon = "error", onBackgroundColor = Colors.onError.default("#FFFFFF");
                  break;
              case "success":
                  variantIcon = "checkCircle", onBackgroundColor = Colors.onSuccess.default("#FFFFFF")
          }
          this.props.icon && (iconName = !0 === this.props.icon ? variantIcon || null : this.props.icon), this.props.icon && components.push(React__default.createElement(ViewBase, {
              key: "icon",
              color: this.props.iconColor || onBackgroundColor,
              style: [styles$c.icon]
          }, React__default.createElement(Icon, {
              size: "large",
              name: iconName
          })));
          var snackBarStyles = [styles$c.snackBar, styles$c["snackBarVariant".concat(R14.utils.str.capitalize(this.props.variant))], dynamicStyles.snackBar, this.props.style],
              contentStyles = [styles$c.content, styles$c["contentVariant".concat(R14.utils.str.capitalize(this.props.variant))]];
          components.push(React__default.createElement(ViewBase, {
              key: "message",
              style: [styles$c.message]
          }, React__default.createElement(TextInput, {
              style: [styles$c.messageText]
          }, this.props.message)));
          var contentComponents = [];
          return this.props.dismissOnPress ? contentComponents.push(React__default.createElement(TouchableBase, {
              key: "content",
              onPress: this.handleRequestDismiss,
              style: contentStyles
          }, components)) : contentComponents.push(React__default.createElement(ViewBase, {
              key: "content",
              style: contentStyles
          }, components)), this.props.actionText && contentComponents.push(React__default.createElement(Button, {
              key: "actionButton",
              variant: "text",
              color: this.props.actionButtonColor || onBackgroundColor,
              style: [styles$c.actionButton],
              title: this.props.actionText,
              onPress: this.handleActionButtonPress
          })), React__default.createElement(AnimatedView, {
              style: snackBarStyles,
              in: this.props.visible,
              unmountOnHide: !0,
              enter: {
                  opacity: 1,
                  transform: [{
                      scale: 1
                  }]
              },
              exit: {
                  opacity: 0,
                  transform: [{
                      scale: .75
                  }]
              },
              duration: 100
          }, contentComponents)
      }
  }, _defineProperty(_class$2, "propTypes", {
      name: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
      actionText: PropTypes.string,
      action: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf(["dismiss"])]),
      visible: PropTypes.bool.isRequired,
      variant: PropTypes.oneOf(["info", "error", "success"]),
      dismissTimeout: PropTypes.number,
      onPress: PropTypes.func,
      dismissOnPress: PropTypes.bool,
      onRequestDismiss: PropTypes.func,
      marginBottom: PropTypes.number
  }), _defineProperty(_class$2, "defaultProps", {
      variant: "info",
      dismissTimeout: 4,
      dismissOnPress: !0,
      action: "dismiss"
  }), _temp$2)),
  styles$c = StyleSheet.create({
      snackBar: _extends({
          position: "absolute",
          bottom: 8
      }, StyleSheet.margin(16, 16, 12, 16), {
          zIndex: 10,
          backgroundColor: "#2C2C2C",
          opacity: .95,
          flex: 1,
          flexDirection: "row",
          elevation: 8,
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: 4,
          minHeight: 48,
          width: "auto"
      }, StyleSheet.padding(6, 16, 6, 16), {
          screen: _ref => {
              var {
                  width: width
              } = _ref;
              return width <= 480 && {
                  left: 0,
                  right: 0
              }
          }
      }),
      icon: _extends({
          opacity: .8
      }, StyleSheet.margin(0, 0, 0, -8), {
          paddingRight: 8
      }),
      closeIcon: _extends({}, StyleSheet.margin(-8, -12, -12, 0)),
      title: {
          paddingBottom: 4
      },
      titleText: {
          fontSize: 16,
          fontWeight: 500
      },
      actionButton: _extends({
          flexGrow: 0,
          flexBasis: 0,
          opacity: .8
      }, StyleSheet.margin(-1, -4, -1, 8)),
      message: _extends({}, StyleSheet.padding(6, 0, 6, 0)),
      messageText: {
          color: "#FFFFFF"
      },
      content: {
          flex: 0,
          flexDirection: "row"
      },
      snackBarVariantInfo: {
          backgroundColor: "#2C2C2C"
      },
      textVariantInfo: {
          color: "#FFFFFF"
      },
      snackBarVariantError: {
          backgroundColor: Colors.error.default("#e53935")
      },
      textVariantError: {
          color: Colors.onError.default("#FFFFFF")
      },
      snackBarVariantSuccess: {
          backgroundColor: Colors.success.default("#43a047")
      },
      textVariantInfoSuccess: {
          color: Colors.onSuccess.default("#FFFFFF")
      }
  }),
  Header = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props), this.updateLayoutStyles()
      }
      updateLayoutStyles() {
          this.props.onLayoutStylesUpdate && this.props.onLayoutStylesUpdate(this.layoutStyles)
      }
      render() {
          return React__default.createElement(ViewBase, _extends({}, this.props, {
              htmlTag: "header",
              style: styles$d.header
          }), React__default.createElement(ViewBase, {
              style: styles$d.content
          }, this.props.controlsLeft && React__default.createElement(ViewBase, {
              style: styles$d.controlsLeft
          }, this.props.controlsLeft), this.props.title && React__default.createElement(ViewBase, {
              style: styles$d.title
          }, this.props.title), this.props.controlsRight && React__default.createElement(ViewBase, {
              style: styles$d.controlsRight
          }, this.props.controlsRight)))
      }
      get layoutStyles() {
          return layoutStyles
      }
  }),
  layoutStyles = StyleSheet.create({
      offset: {
          marginTop: 64,
          screen: _ref => {
              var {
                  width: width
              } = _ref;
              if (width <= 640) return {
                  marginTop: 56
              }
          }
      }
  }),
  styles$d = StyleSheet.create({
      header: {
          position: "absolute",
          top: 0,
          right: 0,
          left: 0,
          height: 64,
          elevation: 3,
          zIndex: 5,
          minWidth: 360,
          screen: _ref2 => {
              var {
                  width: width
              } = _ref2;
              if (width <= 640) return {
                  height: 56
              }
          }
      },
      content: {
          width: "auto",
          display: "flex",
          flexDirection: "row",
          margin: 0,
          alignItems: "center",
          backgroundColor: Theme.componentColors("header", {
              default: Colors.primary
          }).background,
          color: Theme.componentColors("header", {
              default: Colors.onPrimary
          }).onBackground,
          height: 64,
          screen: _ref3 => {
              var {
                  width: width
              } = _ref3;
              if (width <= 640) return {
                  height: 56
              }
          }
      },
      title: {
          flex: 0,
          paddingLeft: 16,
          paddingRight: 16,
          fontSize: 20,
          fontWeight: "500"
      },
      controlsLeft: {
          flex: 0,
          flexDirection: "row",
          margin: 0,
          alignItems: "center",
          opacity: .94
      },
      controlsRight: {
          flex: 0,
          flexDirection: "row",
          margin: 0,
          marginLeft: "auto",
          alignItems: "center",
          opacity: .94
      }
  }),
  ModalHeader = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props), this.handleBackPress = this.handleBackPress.bind(this), this.props.navigator.setLayoutStyles(this.layoutStyles)
      }
      handleBackPress() {
          R14.instance.app.nav.back()
      }
      renderControlLeft() {
          return this.props.controlsLeft || React__default.createElement(IconButton, {
              icon: "arrowBack",
              onPress: this.handleBackPress
          })
      }
      render() {
          return React__default.createElement(ViewBase, _extends({}, this.props, {
              htmlTag: "header",
              style: styles$e.modalHeader
          }), React__default.createElement(ViewBase, {
              style: styles$e.content
          }, this.renderControlLeft(), this.props.title && React__default.createElement(ViewBase, {
              style: styles$e.title
          }, React__default.createElement(TextInput, null, this.props.title)), this.props.controlsRight && React__default.createElement(ViewBase, {
              style: styles$e.controlsRight
          }, this.props.controlsRight)))
      }
      get layoutStyles() {
          return layoutStyles$1
      }
  }),
  layoutStyles$1 = StyleSheet.create({
      offset: {
          marginTop: 64,
          screen: _ref => {
              var {
                  width: width
              } = _ref;
              if (width <= 640) return {
                  marginTop: 56
              }
          }
      }
  }),
  styles$e = StyleSheet.create({
      modalHeader: {
          position: "absolute",
          top: 0,
          right: 0,
          left: 0,
          height: 64,
          elevation: 3,
          screen: _ref2 => {
              var {
                  width: width
              } = _ref2;
              if (width <= 640) return {
                  height: 56
              }
          }
      },
      content: {
          width: "auto",
          display: "flex",
          flexDirection: "row",
          margin: 0,
          alignItems: "center",
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          backgroundColor: Colors.surface,
          color: Colors.onSurface,
          height: 64,
          screen: _ref3 => {
              var {
                  width: width
              } = _ref3;
              if (width <= 640) return {
                  height: 56
              }
          }
      },
      title: {
          flex: 0,
          paddingLeft: 16,
          paddingRight: 16,
          fontSize: 20,
          fontWeight: "500"
      },
      controlsLeft: {
          flex: 0,
          flexDirection: "row",
          margin: 0,
          alignItems: "center",
          opacity: .94
      },
      controlsRight: {
          flex: 0,
          flexDirection: "row",
          margin: 0,
          marginLeft: "auto",
          alignItems: "center",
          opacity: .94
      }
  }),
  PortalContext = React__default.createContext(null),
  NavigationBase = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props)
      }
      static get Navigator() {
          return Navigator
      }
      static get ContainerPortal() {
          return ContainerPortal
      }
      componentDidMount() {
          this.props.app.r14Instance.navigation.initializeRouterProps(this.props)
      }
      componentDidUpdate() {
          this.props.app.r14Instance.navigation.initializeRouterProps(this.props)
      }
      parseNavigator(navigator) {
          if (!navigator.routes) return null
      }
      render() {
          this.props.app.r14Instance.navigation.portals;
          return React__default.createElement(React__default.Fragment, null, React__default.createElement(RootPortal, null), React__default.createElement(ModalPortal, null))
      }
  }),
  RootPortal = R14.connect((_temp$3 = _class$3 = class extends React__default.Component {
      constructor(props) {
          super(props), this._portal = this.props.app.r14Instance.navigation.addPortal("root", this.props.app.r14Instance.navigation.PORTAL_TYPE_ROOT)
      }
      componentWillUnmount() {
          this.props.app.r14Instance.navigation.removePortal("root")
      }
      render() {
          var activeRouteName = this.props.app.r14Instance.navigation.portals("root").activeRouteName,
              activeRoutePath = this.props.app.r14Instance.navigation.portals("root").activeRoutePath;
          return activeRouteName ? React__default.createElement(PortalContext.Provider, {
              value: "root"
          }, React__default.createElement(Navigator, {
              root: !0,
              name: "r14NavRoot",
              navigation: this.props.app.r14Instance.navigation,
              screen: activeRouteName,
              path: activeRoutePath || null
          })) : null
      }
  }, _defineProperty(_class$3, "contextType", PortalContext), _temp$3)),
  Navigator = R14.connect(class Navigator extends React__default.Component {
      constructor(props) {
          super(props)
      }
      render() {
          var nav = this.props.navigation,
              navigator = nav.navigators(this.props.name);
          if (!this.props.screen) return null;
          var components = [];
          if (nav.isScreenInNavigator(this.props.screen, this.props.name)) components.push(React__default.createElement(Route, {
              key: this.props.screen,
              name: this.props.screen,
              path: this.props.path,
              config: nav.screens(this.props.screen)
          }));
          else {
              var _navigator = nav.getNextNavigatorName(this.props.screen, this.props.name);
              if (!_navigator) throw "Navigator not found.";
              components.push(React__default.createElement(Navigator, {
                  key: "navigator",
                  name: _navigator,
                  path: this.props.path,
                  navigation: this.props.navigation,
                  screen: this.props.screen
              }))
          }
          return React__default.createElement(NavigatorLayout, {
              name: this.props.name,
              path: this.props.path,
              root: this.props.root,
              screen: this.props.screen,
              navigator: navigator
          }, components)
      }
  }),
  NavigatorLayout = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props), this._navRef = React__default.createRef(), this.state = {
              initialized: !1
          }, this.handleLayoutStylesUpdate = this.handleLayoutStylesUpdate.bind(this), this.handleToggle = this.handleToggle.bind(this), this.navigator = this.props.app.ui.navigator.create(this.props), this.layoutStyles = null, this.shouldResetLayout = !1, this.initNavigator()
      }
      renderControls() {
          var Controls = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
          return Controls ? React__default.createElement(Controls, null) : null
      }
      initNavigator() {
          switch (this.props.navigator.type) {
              case "drawer":
                  var drawerType = this.props.navigator.drawerNavigator.type || "standard",
                      updateByDimensions = dimensions => {
                          dimensions.width <= 800 ? (this.navigator.hide(), dimensions.width <= 640 && "modal" !== drawerType ? this.navigator.setOption("type", "modal") : this.navigator.setOption("type", drawerType)) : (this.navigator.setOption("type", drawerType), this.navigator.show())
                      },
                      windowDimensions = DimensionsBase.get("window");
                  updateByDimensions(windowDimensions), DimensionsBase.addEventListener("change", _ref => {
                      var {
                          window: window
                      } = _ref;
                      updateByDimensions(window)
                  })
          }
      }
      componentWillUnmount() {
          this.navigator.remove()
      }
      handleLayoutStylesUpdate(layoutStyles) {
          this.shouldResetLayout = !1, this.navigator.setLayoutStyles(layoutStyles)
      }
      handleToggle(visible) {
          console.log("handle toggle!", visible)
      }
      componentDidUpdate() {
          this.shouldResetLayout && this.navigator.state.layoutStyles && (this.shouldResetLayout = !1, this.navigator.setLayoutStyles(null))
      }
      getRouteParams(routeName) {
          var portal = this.props.r14.navigation.getPortalByRouteName(routeName),
              route = this.props.navigator.routes[routeName];
          if (!route.path && route.initialRoute && route.routes) {
              if (!route.routes[route.initialRoute]) throw new Error("Could not find initialRoute ".concat(route.initialRoute, " for route ").concat(routeName, "."));
              route = route.routes[route.initialRoute]
          }
          var routeParams = route.initialParams || {};
          if (portal.data) {
              var paramKeys = Object.keys(portal.data).sort((a, b) => b.length - a.length);
              for (var k of paramKeys) route.path && -1 !== route.path.indexOf(":".concat(k)) && (routeParams[k] = portal.data[k])
          }
          return routeParams
      }
      getRoute(routeName) {
          return this.getRouteConfig(routeName)
      }
      getRouteConfig(routeName) {
          var routeParams = this.getRouteParams(routeName),
              initialConfig = this.props.navigator.routes[routeName],
              config = _extends({}, initialConfig);
          return config.params = routeParams || {}, initialConfig.metadata && "function" == typeof initialConfig.metadata && (config.metadata = initialConfig.metadata({
              route: {
                  name: routeName,
                  params: routeParams
              },
              app: this.props.app
          })), initialConfig.options && (config.options = "function" == typeof initialConfig.options ? initialConfig.options({
              route: {
                  name: routeName,
                  params: routeParams
              },
              app: this.props.app
          }) : config.options, delete(config = _extends({}, config, config.options)).options), config
      }
      render() {
          var navComponent = null;
          if (this.props.navigator.type) switch (this.props.navigator.type) {
              case "tab":
                  var tabNavItems = [];
                  for (var routeName in this.props.navigator.routes) {
                      var route = this.getRoute(routeName);
                      if (this.props.navigator.tabNavigator.itemRenderer) {
                          var ret = this.props.navigator.tabNavigator.itemRenderer({
                              route: route,
                              app: this.props.app
                          });
                          if (!ret) continue;
                          if (React__default.isValidElement(ret)) {
                              tabNavItems.push(ret);
                              continue
                          }
                      }
                      var label = route.label;
                      label && !1 !== this.props.navigator.tabNavigator.showLabel && this.props.navigator.tabNavigator.upperCaseLabel && (label = label.toUpperCase()), (route.icon || label) && tabNavItems.push(React__default.createElement(TabNavigatorItem, {
                          key: routeName,
                          icon: this.props.navigator.tabNavigator.showIcon && route.icon,
                          label: label,
                          to: {
                              route: routeName,
                              params: route.params
                          }
                      }))
                  }
                  navComponent = React__default.createElement(TabNavigator, _extends({
                      ref: this._navRef,
                      key: this.props.name,
                      onLayoutStylesUpdate: this.handleLayoutStylesUpdate
                  }, this.props.navigator.tabNavigator), tabNavItems);
                  break;
              case "drawer":
                  navComponent = React__default.createElement(DrawerNavigator, _extends({
                      key: this.props.name,
                      name: this.props.name,
                      path: this.props.path,
                      routes: this.props.navigator.routes,
                      navigator: this.navigator,
                      onLayoutStylesUpdate: this.handleLayoutStylesUpdate,
                      onToggle: this.handleToggle,
                      visible: this.navigator.state.visible,
                      ref: this._navRef
                  }, this.props.navigator.drawerNavigator, {
                      type: this.navigator.state.options.type || "standard"
                  }));
                  break;
              case "stack":
                  if (this.props.navigator.header) {
                      var headerProps = _extends({}, this.props.navigator.header);
                      headerProps.controlsLeft && (headerProps.controlsLeft = this.renderControls(headerProps.controlsLeft)), headerProps.controlsRight && (headerProps.controlsRight = this.renderControls(headerProps.controlsRight)), navComponent = React__default.createElement(Header, _extends({
                          onLayoutStylesUpdate: this.handleLayoutStylesUpdate,
                          ref: this._navRef
                      }, headerProps))
                  } else this.shouldResetLayout = !0;
                  break;
              case "modal":
                  if (this.props.navigator.header) {
                      var _headerProps = _extends({}, this.props.navigator.header);
                      if (this.props.screen) {
                          var _route;
                          (_route = this.props.app.r14Instance.navigation.isScreenInNavigator(this.props.screen, this.props.name) ? this.getRoute(this.props.screen) : this.props.app.r14Instance.navigation.getRouteByRouteName(this.props.screen)) && _route.title && (_headerProps.title = _route.title)
                      }
                      navComponent = React__default.createElement(ModalHeader, _extends({
                          navigator: this.navigator,
                          ref: this._navRef
                      }, _headerProps))
                  }
          }
          var navigatorStyles = [styles$f.navigator],
              navigatorLayoutStyle = [styles$f.navigator];
          return this.props.root && navigatorStyles.push(styles$f.rootNavigator), this.navigator.state.layoutStyles && navigatorLayoutStyle.push(this.navigator.state.layoutStyles.offset), React__default.createElement(ViewBase, {
              style: navigatorStyles
          }, this.props.root && React__default.createElement("div", {
              key: "modal",
              id: "r14_navigator_root_modal_lay"
          }), this.props.root && React__default.createElement(SnackBar, _extends({
              key: "snackBar"
          }, this.props.app.ui.snackBar.props, {
              visible: this.props.app.ui.snackBar.state.visible,
              onRequestDismiss: this.props.app.ui.snackBar.handleRequestDismiss,
              onDismiss: this.props.app.ui.snackBar.handleDismiss
          })), React__default.createElement(ViewBase, {
              key: "children",
              style: navigatorLayoutStyle
          }, this.props.children), navComponent)
      }
  }),
  styles$f = StyleSheet.create({
      navigator: {
          flex: 1,
          flexDirection: "column",
          position: "relative",
          backgroundColor: Colors.backgroundColor,
          overflow: "hidden"
      },
      rootNavigator: _extends({
          position: "absolute"
      }, StyleSheet.absoluteFill, {
          backgroundColor: Colors.background
      })
  }),
  ContainerPortal = R14.connect((_temp2 = _class2 = class extends React__default.Component {
      constructor(props) {
          super(props), this._portal = this.props.app.r14Instance.navigation.addPortal(this.props.name, this.props.app.r14Instance.navigation.PORTAL_TYPE_CONTAINER)
      }
      componentDidMount() {
          this.props.app.r14Instance.navigation.initPortal(this.props.name, {
              parentPortalName: this.context
          })
      }
      componentWillUnmount() {
          this.props.app.r14Instance.navigation.removePortal(this.props.name)
      }
      render() {
          var activeRouteName = this._portal.activeRouteName,
              activeRoutePath = this._portal.activeRoutePath;
          return activeRouteName ? React__default.createElement(PortalContext.Provider, {
              value: this.props.name
          }, React__default.createElement(Navigator, {
              name: this.props.name,
              navigation: this.props.app.r14Instance.navigation,
              screen: activeRouteName,
              path: activeRoutePath || null
          })) : null
      }
  }, _defineProperty(_class2, "contextType", PortalContext), _temp2)),
  ModalPortal = R14.connect((_temp3 = _class3 = class extends React__default.Component {
      constructor(props) {
          super(props), this._portal = this.props.app.r14Instance.navigation.addPortal("modal", this.props.app.r14Instance.navigation.PORTAL_TYPE_MODAL), this.handleBackdropPress = this.handleBackdropPress.bind(this)
      }
      componentWillUnmount() {
          this.props.app.r14Instance.navigation.removePortal("modal")
      }
      handleBackdropPress() {
          var rootPortal = this.props.app.r14Instance.navigation.portals("root");
          this.props.app.nav.to(rootPortal.route.name, _extends({}, rootPortal.route.params, rootPortal.route.query))
      }
      render() {
          var activeRouteName = this.props.app.r14Instance.navigation.portals("modal").activeRouteName,
              activeRoutePath = this.props.app.r14Instance.navigation.portals("modal").activeRoutePath;
          return React__default.createElement(PortalContext.Provider, {
              value: "modal"
          }, React__default.createElement(Modal$1, {
              visible: !!activeRouteName,
              transparent: !0,
              animationType: "fade",
              style: ModalPortalStyles.modal,
              backdrop: !0,
              backdropStyle: ModalPortalStyles.backdrop,
              onBackdropPress: this.handleBackdropPress,
              scrollEnabled: !0
          }, React__default.createElement(Surface, {
              style: ModalPortalStyles.dialog,
              elevation: 12
          }, React__default.createElement(Navigator, {
              name: "modal",
              navigation: this.props.app.r14Instance.navigation,
              screen: activeRouteName,
              path: activeRoutePath
          }))))
      }
  }, _defineProperty(_class3, "contextType", PortalContext), _temp3)),
  ModalPortalStyles = StyleSheet.create({
      backdrop: {
          backgroundColor: StyleSheet.color(Colors.background).rgba(.8)
      },
      modal: {},
      dialog: _extends({
          borderRadius: 4,
          minWidth: 300,
          maxWidth: 640
      }, StyleSheet.padding(0), {
          marginTop: 80,
          marginBottom: 80,
          zIndex: 2,
          backgroundColor: Colors.background,
          overflow: "hidden",
          screen: _ref2 => {
              var {
                  width: width
              } = _ref2;
              if (width <= 640) return _extends({
                  maxWidth: null,
                  width: "100%",
                  minHeight: "100%",
                  borderRadius: 0
              }, StyleSheet.margin(0))
          }
      })
  }),
  ProgressIndicator = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props)
      }
      render() {
          var windowWidth = DimensionsBase.get("window").width;
          return React__default.createElement(Modal$1, {
              visible: this.props.app.ui.progressIndicator.isVisible(this.props.name),
              transparent: !0,
              animationType: "fade"
          }, React__default.createElement(ViewBase, {
              style: styles$g.progressIndicator
          }, this.props.app.ui.progressIndicator.shouldOverlay(this.props.name) && React__default.createElement(ViewBase, {
              style: styles$g.overlay
          }), React__default.createElement(ViewBase, {
              style: styles$g.title
          }), React__default.createElement(AnimatedView, {
              style: styles$g.throbber,
              animation: {
                  from: {
                      transform: [{
                          translateX: -windowWidth
                      }]
                  },
                  to: {
                      transform: [{
                          translateX: windowWidth
                      }]
                  }
              },
              iterationCount: "infinite",
              duration: 2e3
          })))
      }
  }),
  styles$g = StyleSheet.create({
      progressIndicator: {
          position: "absolute",
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
          overflow: "hidden"
      },
      visible: {
          opacity: 1
      },
      overlay: {
          position: "absolute",
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
          zIndex: 6,
          backgroundColor: StyleSheet.color(Colors.background).rgba(.5)
      },
      title: {
          display: "none"
      },
      throbber: {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 6,
          height: 4,
          backgroundColor: Colors.primary
      }
  });
class RootComponents extends React__default.Component {
  constructor(props) {
      super(props)
  }
  render() {
      return React__default.createElement(React__default.Fragment, null, React__default.createElement(ProgressIndicator, null))
  }
}
class AppBase extends React__default.Component {
  render() {
      return React__default.createElement(BrowserRouter, null, React__default.createElement(Route$1, {
          component: NavigationBase
      }), React__default.createElement(RootComponents, null))
  }
}
class App extends React__default.PureComponent {
  constructor(props) {
      super(props), this.app = new R14App(this.props), this.state = {
          initialized: !1
      }, this.initialize()
  }
  initialize() {
      var _this = this;
      return _asyncToGenerator((function*() {
          yield _this.app.initialize(), _this.setState({
              initialized: !0
          })
      }))()
  }
  render() {
      return this.state.initialized ? React__default.createElement(Provider, {
          app: this.app,
          r14: this.app.r14Instance
      }, React__default.createElement(AppBase, this.props)) : React__default.createElement(ActivityIndicator, {
          size: "large",
          color: "#CECECE",
          containerStyle: styles$h.activityIndicatorContainer
      })
  }
}
_defineProperty(App, "propTypes", {
  config: PropTypes.object.isRequired,
  routes: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  scrollBehavior: PropTypes.func,
  shouldActionLoad: PropTypes.func,
  actionWillLoad: PropTypes.func,
  onLoaded: PropTypes.func
});
var styles$h = StyleSheet.create({
  activityIndicatorContainer: _extends({
      position: "absolute"
  }, StyleSheet.absoluteFill)
});
class ShowHideText$1 extends React__default.PureComponent {
  constructor(props) {
      super(props), this.handlePress = this.handlePress.bind(this), this.state = {
          isHidden: this.text.length > this.props.maxCharacters
      }
  }
  handlePress() {
      this.setState({
          isHidden: !this.state.isHidden
      })
  }
  get text() {
      return "".concat(this.props.text)
  }
  renderText() {
      return !1 === this.state.isHidden || this.text.length <= this.props.maxCharacters ? this.text : "".concat(this.text.substring(0, this.props.maxCharacters), "...")
  }
  render() {
      var styles = this.styles(),
          showTouchable = this.text.length > this.props.maxCharacters,
          touchableText = this.state.isHidden ? "show" : "hide";
      return React__default.createElement(ViewBase, {
          style: styles.showHideText
      }, React__default.createElement(TextInput, {
          style: styles.text
      }, this.renderText()), showTouchable && React__default.createElement(TouchableBase, {
          onPress: this.handlePress
      }, React__default.createElement(TextInput, {
          style: [styles.touchableText, this.state.isHidden && styles.touchableTextHide]
      }, touchableText)))
  }
  styles() {
      return StyleSheet.create({
          showHideText: {
              flex: 0,
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "flex-end"
          },
          text: {
              paddingRight: 8
          },
          touchableText: {
              color: Colors.secondary,
              fontSize: 14,
              fontWeight: "600"
          },
          touchableTextHide: {
              color: Colors.primary
          }
      })
  }
}
_defineProperty(ShowHideText$1, "propTypes", {
  text: PropTypes.string,
  maxCharacters: PropTypes.number
}), _defineProperty(ShowHideText$1, "defaultProps", {
  maxCharacters: 20
});
class ShowHideView extends React__default.PureComponent {
  constructor(props) {
      throw super(props), new Error("In Dev")
  }
  handlePress() {
      this.setState({
          isHidden: !this.state.isHidden
      })
  }
  render() {
      var styles = this.styles();
      return React__default.createElement(ViewBase, {
          style: styles.showHideView
      }, React__default.createElement(ViewBase, {
          style: styles.content
      }, this.props.children), React__default.createElement(IconButton, {
          icon: "keyboardArrowDown",
          style: styles.button,
          onPress: this.handlePress
      }))
  }
  styles() {
      return StyleSheet.create({
          showHideView: {},
          content: {
              maxHeight: this.props.collapsedHeight || null,
              overflow: "hidden"
          },
          button: {
              position: "absolute",
              bottom: 0
          }
      })
  }
}
_defineProperty(ShowHideView, "propTypes", {
  collapsedHeight: PropTypes.number
}), _defineProperty(ShowHideView, "defaultProps", {
  collapsedHeight: 64
});
class SectionHeader extends React__default.PureComponent {
  constructor(props) {
      super(props)
  }
  render() {
      var level = this.props.level || 1,
          tagName = "h".concat(level),
          sectionHeaderStyle = [styles$i.h, styles$i[tagName], styles$i.props];
      return this.props.style && sectionHeaderStyle.push(this.props.style), React__default.createElement(TextInput, {
          style: sectionHeaderStyle,
          htmlTag: tagName,
          noWrap: this.props.noWrap || !1
      }, this.props.children)
  }
}
var styles$i = StyleSheet.create({
  h: {
      fontWeight: "500",
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      color: Colors.onBackground
  },
  h1: {
      fontSize: 32,
      paddingBottom: 20,
      fontWeight: "700"
  },
  h2: {
      fontSize: 24,
      paddingBottom: 16,
      fontWeight: "400"
  },
  h3: {
      fontSize: 18,
      paddingBottom: 12,
      fontWeight: "300"
  },
  h4: {
      fontSize: 18,
      paddingBottom: 12,
      fontWeight: "600"
  },
  h5: {
      fontSize: 16,
      paddingBottom: 8
  },
  h6: {
      fontSize: 13,
      paddingBottom: 20,
      fontWeight: "500",
      color: Colors.secondary
  }
});
class ControlsView extends React__default.PureComponent {
  constructor(props) {
      super(props)
  }
  render() {
      var controlsViewStyles = [styles$j.controlsView];
      if (styles$j[this.props.align] && controlsViewStyles.push(styles$j[this.props.align]), "icons" === this.props.type) switch (this.props.align) {
          case "left":
              controlsViewStyles.push(styles$j.iconsLeft);
              break;
          case "right":
              controlsViewStyles.push(styles$j.iconsRight)
      }
      return this.props.style && controlsViewStyles.push(this.props.style), React__default.createElement(ViewBase, _extends({}, this.props, {
          style: controlsViewStyles
      }), this.props.children)
  }
}
_defineProperty(ControlsView, "propTypes", {
  align: PropTypes.oneOf(["left", "center", "right"]),
  type: PropTypes.oneOf(["buttons", "icons"]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
}), _defineProperty(ControlsView, "defaultProps", {
  align: "left",
  type: "icons"
});
var _class$4, _temp$4, styles$j = StyleSheet.create({
      controlsView: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          height: 36
      },
      left: {
          justifyContent: "flex-start"
      },
      iconsLeft: {
          marginLeft: -8
      },
      center: {
          marginRight: "auto",
          marginLeft: "auto",
          justifyContent: "space-around"
      },
      right: {
          justifyContent: "flex-end"
      },
      iconsRight: {
          marginRight: -8
      }
  }),
  Card = R14.connect((_temp$4 = _class$4 = class extends React__default.Component {
      renderTitle() {
          return this.props.title || this.props.titleControlsRight ? React__default.createElement(ViewBase, {
              style: [styles$k.title, this.props.titleStyle]
          }, this.props.titleControlsLeft && React__default.createElement(ControlsView, {
              align: "left"
          }, this.props.titleControlsLeft), React__default.createElement(SectionHeader, {
              style: [styles$k.titleText, this.props.titleStyle],
              level: 2,
              noWrap: this.props.titleNoWrap || !1
          }, this.props.title), this.props.titleControlsRight && React__default.createElement(ControlsView, {
              align: "right"
          }, this.props.titleControlsRight)) : null
      }
      render() {
          var widthStyles = StyleSheet.create({
              card: {
                  minWidth: this.props.minWidth || 280,
                  width: this.props.width || null
              }
          });
          return React__default.createElement(ViewBase, {
              style: [styles$k.card, widthStyles.card, this.props.style]
          }, React__default.createElement(Surface, {
              style: [styles$k.surface, this.props.surfaceStyle],
              elevation: this.props.elevation || 2
          }, this.renderTitle(), React__default.createElement(ViewBase, {
              style: [styles$k.content, this.props.contentStyle]
          }, this.props.content || this.props.children)))
      }
  }, _defineProperty(_class$4, "propTypes", {
      title: PropTypes.string,
      titleControlsRight: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
      elevation: PropTypes.number,
      content: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
      width: PropTypes.number,
      minWidth: PropTypes.number
  }), _temp$4)),
  styles$k = StyleSheet.create({
      card: {
          flexGrow: 1,
          screen: _ref => {
              var {
                  width: width
              } = _ref;
              if (width <= 640) return {
                  width: "100%"
              }
          }
      },
      title: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          paddingBottom: 8
      },
      titleText: {
          fontSize: 20,
          paddingBottom: 0,
          lineHeight: 36,
          marginRight: "auto"
      },
      surface: {
          flex: 1,
          paddingTop: 12,
          marginRight: 16,
          marginBottom: 16,
          borderRadius: 4,
          screen: _ref2 => {
              var {
                  width: width
              } = _ref2;
              if (width <= 640) return {
                  marginRight: 0,
                  borderRadius: 0
              }
          }
      }
  });
class CardsView extends React__default.PureComponent {
  render() {
      var ContentWrapper = this.props.scrollEnabled ? ScrollViewBase : ViewBase;
      return React__default.createElement(ContentWrapper, null, React__default.createElement(ViewBase, {
          style: [styles$l.cardsView, this.props.style]
      }, this.props.children))
  }
}
var _class$5, _temp$5, styles$l = StyleSheet.create({
  cardsView: _extends({
      flex: 1,
      flexDirection: "row",
      alignItems: "flex-start",
      flexWrap: "wrap",
      flexBasis: "100%"
  }, StyleSheet.padding(16, 0, 16, 16), {
      marginRight: 0,
      backgroundColor: Colors.background,
      screen: _ref => {
          var {
              width: width
          } = _ref;
          if (width <= 640) return _extends({}, StyleSheet.padding(0, 0, 16, 0), {
              marginRight: 0
          })
      }
  })
});
class SafeAreaView extends React__default.Component {
  render() {
      return React__default.createElement(ViewBase, this.props)
  }
}
class AnimatedText extends React__default.Component {
  render() {
      return React__default.createElement(AnimatedElementBase, _extends({
          type: "text"
      }, this.props))
  }
}
class FormBase extends React__default.PureComponent {
  constructor(props) {
      super(props), this.handleSubmit = this.handleSubmit.bind()
  }
  handleSubmit(event) {
      event.preventDefault(), event.stopPropagation()
  }
  render() {
      return React__default.createElement("form", {
          onSubmit: this.handleSubmit,
          className: StyleSheet.className([this.props.style]),
          autoComplete: !1 === this.props.autoComplete ? "off" : "on"
      }, this.props.children)
  }
}
var _class$6, _temp$6, Form = R14.connect((_temp$5 = _class$5 = class extends React__default.Component {
      constructor(props) {
          super(props), this.form = this.props.app.ui.form.create(props)
      }
      componentDidMount() {
          this.form.handleMount(this.props.initialValues || this.props.values || {})
      }
      componentDidUpdate(prevProps) {
          prevProps.values !== this.props.values && this.form.setValues(this.props.values || {})
      }
      componentWillUnmount() {
          this.props.app.ui.form.submittedForm && this.props.app.ui.form.submittedForm.name === this.form.name || this.form.remove()
      }
      dynamicStyles() {
          return StyleSheet.create({
              form: {
                  backgroundColor: this.props.backgroundColor || Colors.onSurface
              }
          })
      }
      render() {
          return React__default.createElement(Provider, {
              form: this.form
          }, React__default.createElement(FormBase, {
              autoComplete: this.props.autoComplete,
              style: [styles$m.form, this.dynamicStyles.form, this.props.style]
          }, this.form.state.errors.length > 0 && React__default.createElement(ViewBase, null, this.form.state.errors.map((error, i) => React__default.createElement(ViewBase, {
              key: "".concat(error, "-").concat(i),
              style: styles$m.error
          }, React__default.createElement(TextInput, {
              style: styles$m.errorText
          }, error)))), this.form.state.redirect, this.props.children, this.props.controlsBottomRight && React__default.createElement(ControlsView, {
              align: "right",
              type: this.props.controlsBottomRightType || "buttons"
          }, this.props.controlsBottomRight)))
      }
  }, _defineProperty(_class$5, "propTypes", {
      name: PropTypes.string.isRequired,
      onSubmit: PropTypes.func,
      to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      validateBeforeSubmit: PropTypes.bool,
      values: PropTypes.object,
      initialValues: PropTypes.object,
      backgroundColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      onBeforeNavigation: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
  }), _defineProperty(_class$5, "defaultProps", {
      validateBeforeSubmit: !1
  }), _temp$5)),
  styles$m = StyleSheet.create({
      form: _extends({}, StyleSheet.padding(24, 16, 16, 16), {
          flex: 1,
          flexDirection: "column"
      }),
      errors: {},
      error: {
          paddingBottom: 12
      },
      errorText: {
          color: Colors.error
      }
  }),
  FieldGroup = R14.connect((_temp$6 = _class$6 = class extends React__default.Component {
      render() {
          var children = this.props.children;
          Array.isArray(children) || (children = [children]);
          var i = 1;
          return React__default.createElement(React__default.Fragment, null, this.props.label && React__default.createElement(ViewBase, {
              key: "fieldGroupLabel",
              style: [styles$n.fieldGroupLabel, this.props.labelStyle]
          }, React__default.createElement(TextInput, {
              style: [styles$n.fieldGroupLabelText, this.props.labelTextStyle]
          }, this.props.label)), React__default.createElement(ViewBase, {
              key: "fieldGroup",
              style: [styles$n.fieldGroup, this.props.style]
          }, children.map(child => React__default.createElement(ViewBase, {
              key: "formField".concat(i++),
              style: [styles$n.fieldGroupField, this.props.fieldStyle]
          }, child))))
      }
  }, _defineProperty(_class$6, "propTypes", {}), _defineProperty(_class$6, "defaultProps", {}), _temp$6)),
  styles$n = StyleSheet.create({
      fieldGroupLabel: {
          paddingBottom: 8
      },
      fieldGroupLabelText: {
          fontSize: 14
      },
      fieldGroup: {
          flex: 1,
          flexDirection: "row",
          marginRight: -15,
          screen: _ref => {
              var {
                  width: width
              } = _ref;
              if (width <= 640) return {
                  flexDirection: "column",
                  marginRight: 0
              }
          }
      },
      fieldGroupField: {
          marginRight: 15,
          flex: 1,
          flexBasis: 0,
          screen: _ref2 => {
              var {
                  width: width
              } = _ref2;
              if (width <= 640) return {
                  marginRight: 0
              }
          }
      }
  });
class Chip extends React__default.PureComponent {
  renderIcon(type) {
      var icon = null,
          iconProp = null,
          iconStyle = null;
      switch (type) {
          case "left":
              iconProp = this.props.iconLeft, iconStyle = styles$o.iconLeft;
              break;
          case "right":
              iconProp = this.props.iconRight, iconStyle = styles$o.iconRight
      }
      return iconProp ? (icon = "string" == typeof iconProp ? React__default.createElement(Icon, {
          name: iconProp,
          size: "small"
      }) : iconProp, React__default.createElement(ViewBase, {
          style: iconStyle
      }, icon)) : null
  }
  render() {
      var ContainerComponent = this.props.onPress ? TouchableBase : ViewBase,
          dynamicStyles = StyleSheet.create({
              chip: {
                  backgroundColor: this.props.color || StyleSheet.color(Colors.onSurface).rgba(.12)
              },
              label: {
                  color: this.props.labelColor || Colors.onSurface
              }
          }),
          label = this.props.LabelComponent || React__default.createElement(TextInput, {
              noWrap: this.props.noWrap,
              style: [styles$o.label, dynamicStyles.label, this.props.labelTextStyle, this.props.selected && styles$o.selectedLabel]
          }, this.props.label);
      return React__default.createElement(ContainerComponent, {
          onPress: this.props.onPress
      }, React__default.createElement(ViewBase, {
          style: [styles$o.chip, dynamicStyles.chip, this.props.style, this.props.selected && styles$o.selected]
      }, this.renderIcon("left"), label, this.renderIcon("right")))
  }
}
_defineProperty(Chip, "propTypes", {
  label: PropTypes.string.isRequired,
  onPress: PropTypes.func,
  variant: PropTypes.oneOf(["outlined", "filled"]),
  iconLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  iconRight: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  labelStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  LabelComponent: PropTypes.node,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  noWrap: PropTypes.bool,
  selected: PropTypes.bool
}), _defineProperty(Chip, "defaultProps", {
  noWrap: !0
});
var styles$o = StyleSheet.create({
  chip: _extends({
      flex: 0,
      flexDirection: "row",
      alignItems: "center",
      borderRadius: 16,
      height: 32
  }, StyleSheet.padding(4, 4, 4, 4), StyleSheet.margin(0, 8, 8, 0)),
  label: _extends({
      color: Colors.secondary,
      fontSize: 14
  }, StyleSheet.padding(0, 8, 0, 8)),
  iconLeft: _extends({}, StyleSheet.padding(0, 0, 0, 4), {
      marginRight: -4
  }),
  iconRight: _extends({}, StyleSheet.padding(0, 4, 0, 0), {
      marginLeft: -4
  }),
  selected: {
      backgroundColor: StyleSheet.color(Colors.primary).rgba(.1)
  },
  selectedLabel: {
      color: Colors.primary
  }
});
class ChipGroup extends React__default.PureComponent {
  render() {
      return React__default.createElement(ViewBase, {
          style: [styles$p.chipGroup, this.props.style]
      }, this.props.children)
  }
}
_defineProperty(ChipGroup, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
});
var styles$p = StyleSheet.create({
  chipGroup: {
      flex: 1,
      flexWrap: "wrap",
      justifyContent: "flex-start",
      flexDirection: "row",
      marginBottom: -8,
      marginRight: -8
  }
});
class TextInput$1 extends React__default.PureComponent {
  constructor(props) {
      super(props), this.ref = React__default.createRef(), this.handleChange = this.handleChange.bind(this), this.handleKeyUp = this.handleKeyUp.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handlePress = this.handlePress.bind(this), this._contentSize = null, this._isUpdatingContentSize = !1, this._updateContentSizeTimeout = null, this._lastScrollHeight = null, this._width = null, this._isContentInitialized = !1, this.state = {
          height: null,
          updateContentSize: !1
      }, this._autoFocusTimeout = null, this._autoSelectTimeout = null, this._contentSizeTimeout = null
  }
  componentDidMount() {
      this.autoFillFix(), this.props.autoFocus && this.autoFocus(), this.props.autoSelect && this.autoSelect(), this.shouldUpdateContentSize && (this._contentSizeTimeout = setTimeout(() => {
          this.props.onContentSizeChange && this.updateContentSize()
      }, 50))
  }
  componentDidUpdate(prevProps, prevState) {
      this.props.onContentSizeChange && prevState.height !== this.state.height && this.updateContentSize()
  }
  componentWillUnmount() {
      this._autoFocusTimeout && clearTimeout(this._autoFocusTimeout), this._autoSelectTimeout && clearTimeout(this._autoSelectTimeout), this._contentSizeTimeout && clearTimeout(this._contentSizeTimeout)
  }
  get shouldUpdateContentSize() {
      return !(!this.props.multiline || !this.props.onContentSizeChange)
  }
  updateContentSize() {
      var target = this.ref.current;
      target.style.height = "inherit";
      var computed = window.getComputedStyle(target),
          height = parseInt(computed.getPropertyValue("border-top-width"), 10) + target.scrollHeight + parseInt(computed.getPropertyValue("border-bottom-width"), 10);
      if (target.style.height = "".concat(height, "px"), !this._isContentInitialized) return !1;
      this.ref.current && (null === this._width && (this._width = this.ref.current.offsetWidth), this._isUpdatingContentSize ? 0 === this.state.height ? (this.ref.current.scrollHeight !== this._lastScrollHeight && (this._lastScrollHeight = this.ref.current.scrollHeight, this.props.onContentSizeChange({
          nativeEvent: {
              contentSize: {
                  width: this._width,
                  height: this.ref.current.scrollHeight
              }
          }
      })), this.setState({
          height: null
      })) : null === this.state.height && (this._isUpdatingContentSize = !1) : (this._isUpdatingContentSize = !0, this.setState({
          height: 0
      })))
  }
  autoFocus() {
      this._autoFocusTimeout = setTimeout(() => {
          this.focus()
      }, 350)
  }
  focus() {
      this.ref.current && this.ref.current.focus()
  }
  autoSelect() {
      this._autoSelectTimeout = setTimeout(() => {
          this.select()
      }, 350)
  }
  select() {
      this.ref.current && this.ref.current.select()
  }
  handleChange(event) {
      if (this.props.onContentSizeChange && this.updateContentSize(), this.props.onChangeText) return this.props.onChangeText(event.target.value)
  }
  handlePress(e) {
      this.props.onPress && this.props.onPress(this.normalizeEvent(e))
  }
  handleKeyUp(event) {
      this.props.handleKeyUp && this.props.handleKeyUp(event.target.value)
  }
  handleKeyDown(event) {
      this.props.onKeyPress && this.props.onKeyPress(event), this.props.onKeyDown && this.props.onKeyDown(event)
  }
  autoFillFix() {
      this.props.onAutoFill && this.ref.current.addEventListener("animationstart", _ref => {
          var {
              target: target,
              animationName: animationName
          } = _ref;
          switch (animationName) {
              case "onAutoFillStart":
                  this.props.onAutoFill("start");
                  break;
              case "onAutoFillCancel":
                  this.props.onAutoFill("cancel")
          }
      })
  }
  render() {
      var type = "text",
          tag = this.props.multiline ? "textarea" : "input";
      this.props.secureTextEntry && (type = "password");
      var color = StyleSheet.parseColor(this.props.color || Colors.onBackground),
          dynamicStyles = StyleSheet.create({
              input: {
                  "-webkit-text-fill-color": "".concat(color, " !important"),
                  color: "".concat(color, " !important")
              }
          }),
          autoComplete = "on";
      return !1 === this.props.autoComplete && (autoComplete = "password" === type ? "new-password" : "off"), React__default.createElement(tag, {
          type: type,
          name: this.props.name,
          ref: this.ref,
          placeholder: this.props.placeholder || null,
          value: null !== this.props.value ? "".concat(this.props.value) : "",
          autoComplete: autoComplete,
          onChange: (this.props.onChangeText || this.props.onContentSizeChange) && this.handleChange,
          onFocus: this.props.onFocus || null,
          onBlur: this.props.onBlur || null,
          autoFocus: this.props.autoFocus || null,
          readOnly: this.props.readOnly || null,
          onClick: this.props.onPress || null,
          onKeyDown: this.props.onKeyPress || this.props.onKeyDown ? this.handleKeyDown : null,
          onKeyUp: this.props.onKeyUp || this.props.onContentSizeChange ? this.handleKeyUp : null,
          className: StyleSheet.className([styles$q.input, this.props.style, dynamicStyles.input])
      })
  }
}
var styles$q = StyleSheet.create({
  input: {
      display: "block",
      boxSizing: "border-box",
      outline: "none",
      border: 0,
      placeholder: {
          color: "red"
      }
  }
});
class TextInput$2 extends React__default.PureComponent {
  constructor(props) {
      super(props), this.handleContentSizeChange = this.handleContentSizeChange.bind(this), this.handleValueRemove = this.handleValueRemove.bind(this), this.handleValueAdd = this.handleValueAdd.bind(this), this.inputRef = React__default.createRef(), this.state = {
          height: null
      }
  }
  handleContentSizeChange(event) {
      this.props.onContentSizeChange && this.props.onContentSizeChange(event), this.props.autoSize && this.setState({
          height: event.nativeEvent.contentSize.height
      })
  }
  handleValueAdd() {
      if (this.props.onValueAdd) return this.props.onValueAdd(this.props.textValue || "")
  }
  handleValueRemove(val) {
      if (this.props.onValueRemove) return this.props.onValueRemove(val)
  }
  renderChips() {
      var _this = this,
          ret = null;
      if (this.props.multiple) {
          var labels = [],
              values = this.props.value || [],
              _loop = function(i) {
                  var label = values[i];
                  if (!label) return "continue";
                  labels.push(React__default.createElement(Chip, {
                      key: "".concat(label).concat(i),
                      label: label,
                      style: styles$r.valueChip,
                      iconRight: "close",
                      onPress: () => {
                          _this.handleValueRemove(label)
                      }
                  }))
              };
          for (var i in values) _loop(i);
          labels.length && (ret = React__default.createElement(ChipGroup, {
              key: "selections",
              style: styles$r.valueChipGroup
          }, labels))
      }
      return ret
  }
  select() {
      this.inputRef && this.inputRef.current && this.inputRef.current.select && this.inputRef.current.select()
  }
  focus() {
      this.inputRef && this.inputRef.current && this.inputRef.current.focus && this.inputRef.current.focus()
  }
  render() {
      var dynamicStyles = {};
      this.state.height && (dynamicStyles = StyleSheet.create({
          input: {
              height: this.state.height
          }
      }));
      var input = React__default.createElement(TextInput$1, _extends({}, this.props, {
          placeholderTextColor: this.props.placeholderTextColor || StyleSheet.color(Colors.onBackground).rgba(.9),
          value: this.props.multiple ? this.props.textValue : this.props.value,
          style: [this.props.style, dynamicStyles.input],
          ref: this.inputRef,
          onContentSizeChange: this.props.onContentSizeChange || this.props.autoSize ? this.handleContentSizeChange : null
      }));
      return this.props.multiple && (input = React__default.createElement(ViewBase, {
          style: [styles$r.textInputMultiple, this.props.multipleStyle]
      }, React__default.createElement(ViewBase, {
          style: [styles$r.multipleRow]
      }, input, React__default.createElement(IconButton, {
          icon: "add",
          key: "add",
          variant: "circle",
          onPress: this.handleValueAdd,
          style: styles$r.addButton,
          disabled: !this.props.textValue
      })), this.renderChips())), input
  }
}
var _class$7, _temp$7, _class$8, _temp$8, styles$r = StyleSheet.create({
      textInputMultiple: {
          flex: 1,
          flexDirection: "column"
      },
      multipleRow: {
          flex: 1,
          flexDirection: "row",
          justifyContent: "space-between"
      },
      addButton: _extends({
          borderRadius: 18,
          elevation: 3
      }, StyleSheet.padding(4), {
          height: 32,
          width: 32
      }, StyleSheet.margin(10, 10, 10, 10)),
      valueChipGroup: _extends({}, StyleSheet.margin(2, 2, 6, 10))
  }),
  InputField = R14.connectForm((_temp$7 = _class$7 = class extends React__default.Component {
      constructor(props) {
          super(props), this.handleLayout = this.handleLayout.bind(this), this.state = {
              layout: null
          }, this._styles = null, this.elmt = this.props.element, this.utils = R14.utils, this.activeColor = this.props.activeColor || this.props.form.activeColor || "#1565c0", this.errorColor = this.props.errorColor || this.props.form.errorColor || "#B00020"
      }
      get hasLeftPadding() {
          return !(!this.props.icon && !this.props.controlsLeft)
      }
      get backgroundColor() {
          return this.props.backgroundColor || this.props.form.backgroundColor || null
      }
      handleLayout(event) {
          this.setState({
              layout: event.nativeEvent.layout
          })
      }
      renderIcon(propName, styles) {
          var icon = this.props[propName],
              onIconPress = this.props["on".concat(this.utils.str.capitalize(propName), "Press")];
          return icon ? onIconPress ? React__default.createElement(IconButton, {
              icon: icon,
              style: [styles[propName], styles["".concat(propName, "Button")]],
              onPress: () => onIconPress(),
              color: this.elmt.isFocused ? Colors.primary : StyleSheet.color(Colors.onBackground).rgba(.5)
          }) : React__default.createElement(Icon, {
              name: icon,
              style: styles[propName],
              color: this.elmt.isFocused ? Colors.primary : StyleSheet.color(Colors.onBackground).rgba(.5),
              pointerEvents: "none"
          }) : null
      }
      render() {
          var styles = this.styles(),
              variantStyles = this.variantStyles(),
              helperText = this.elmt.error ? this.elmt.error : this.elmt.helper,
              helperTextStyle = this.elmt.error ? [styles.helperText, styles.errorText] : [styles.helperText],
              labelTranslateY = -16,
              labelTranslateX = 0;
          if (this.state.layout) {
              var width = this.state.layout.width;
              labelTranslateX = (.75 * width - width + (this.props.icon ? 24 : 8)) / 1.5
          }
          var showIndicator = !0;
          switch (this.props.variant) {
              case "outlined":
                  labelTranslateY = -28, showIndicator = !1
          }
          return React__default.createElement(ViewBase, {
              style: [styles.inputFieldWrapper, this.elmt.disabled && styles.disabled, this.props.style],
              pointerEvents: this.elmt.disabled ? "none" : null,
              tooltip: this.props.tooltip || null
          }, React__default.createElement(ViewBase, {
              style: [styles.inputField, variantStyles.inputField],
              onLayout: this.handleLayout
          }, this.state.layout && this.props.label && React__default.createElement(AnimatedView, {
              style: styles.animatedLabel,
              debug: this.props.debug || null,
              pointerEvents: "none",
              animation: {
                  exit: {
                      transform: [{
                          scale: 1
                      }, {
                          translateY: 0
                      }, {
                          translateX: 0
                      }]
                  },
                  enter: {
                      transform: [{
                          scale: .75
                      }, {
                          translateY: labelTranslateY
                      }, {
                          translateX: labelTranslateX
                      }]
                  }
              },
              timingFunction: "linear",
              in: this.elmt.isActive,
              duration: 150,
              htmlTag: "label",
              htmlFor: this.props.name
          }, React__default.createElement(ViewBase, {
              style: [styles.label, variantStyles.label, this.props.labelStyle]
          }, React__default.createElement(TextInput, {
              style: [styles.labelText, variantStyles.labelText, this.props.labelTextStyle]
          }, this.props.label))), React__default.createElement(ViewBase, {
              style: [styles.inputCntr, variantStyles.inputCntr, this.props.containerStyle]
          }, this.props.icon && this.renderIcon("icon", styles), this.props.controlsLeft && React__default.createElement(ViewBase, {
              style: styles.controlsLeft
          }, this.props.controlsLeft), this.props.InputComponent, this.props.iconRight && this.renderIcon("iconRight", styles)), helperText && React__default.createElement(TextInput, {
              style: [helperTextStyle, this.props.helperTextStyle]
          }, helperText), showIndicator && React__default.createElement(AnimatedView, {
              style: styles.indicator,
              animation: {
                  exit: {
                      transform: [{
                          scaleX: 0
                      }],
                      opacity: 0
                  },
                  enter: {
                      transform: [{
                          scaleX: 1
                      }],
                      opacity: 1
                  }
              },
              in: this.elmt.isFocused || this.elmt.error,
              duration: 150
          })))
      }
      variantStyles() {
          switch (this.props.variant) {
              case "outlined":
                  return StyleSheet.create({
                      inputCntr: _extends({
                          borderColor: this.elmt.isFocused ? Colors.primary : StyleSheet.color(Colors.onBackground).rgba(.4),
                          borderRadius: 4,
                          borderWidth: this.elmt.isFocused ? 2 : 1
                      }, StyleSheet.padding(this.elmt.isFocused ? 0 : 1)),
                      label: {
                          backgroundColor: this.backgroundColor || Colors.background
                      }
                  });
              case "filled":
                  return StyleSheet.create({
                      inputField: {
                          backgroundColor: StyleSheet.color(Colors.onBackground).rgba(.1)
                      }
                  });
              case "simple":
                  return StyleSheet.create({
                      inputCntr: {
                          borderBottomWidth: 0
                      },
                      inputField: {
                          backgroundColor: StyleSheet.color(Colors.onBackground).rgba(.1),
                          borderWidth: 0
                      }
                  });
              default:
                  return {}
          }
      }
      styles() {
          return StyleSheet.create({
              inputFieldWrapper: {
                  flex: 1,
                  marginBottom: 32,
                  screen: _ref => {
                      var {
                          width: width
                      } = _ref;
                      if (width <= 640) return {
                          maxWidth: null
                      }
                  }
              },
              inputField: {
                  position: "relative",
                  borderTopRightRadius: 4,
                  borderTopLeftRadius: 4
              },
              inputCntr: {
                  borderBottomWidth: 1,
                  borderColor: StyleSheet.color(Colors.onBackground).rgba(.4),
                  borderStyle: "solid"
              },
              disabled: {
                  opacity: .5
              },
              indicator: {
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: this.elmt.error ? Colors.error : Colors.primary,
                  transform: [{
                      scaleX: .1
                  }],
                  opacity: 0
              },
              helperText: {
                  fontSize: 12,
                  lineHeight: 20,
                  position: "absolute",
                  bottom: -20,
                  left: this.hasLeftPadding ? 44 : 12,
                  color: StyleSheet.color(Colors.onBackground).rgba(.6)
              },
              errorText: {
                  color: Colors.error
              },
              labelText: {
                  color: this.elmt.isFocused ? Colors.primary : StyleSheet.color(Colors.onBackground).rgba(.5),
                  lineHeight: 16
              },
              animatedLabel: {
                  zIndex: 2,
                  display: "flex"
              },
              label: {
                  position: "absolute",
                  top: 20,
                  left: this.hasLeftPadding ? 40 : 8,
                  paddingLeft: 4,
                  paddingRight: 4,
                  zIndex: 2
              },
              icon: {
                  position: "absolute",
                  top: 16,
                  left: 12
              },
              iconButton: _extends({}, StyleSheet.margin(0), {
                  top: 10,
                  left: 6
              }),
              controlsLeft: {
                  position: "absolute",
                  top: 16,
                  left: 12
              },
              iconRight: {
                  position: "absolute",
                  top: 16,
                  right: 12
              },
              iconRightButton: _extends({}, StyleSheet.margin(0), {
                  top: 10,
                  right: 6
              })
          })
      }
  }, _defineProperty(_class$7, "propTypes", {
      InputComponent: PropTypes.node.isRequired,
      element: PropTypes.object.isRequired,
      label: PropTypes.string,
      variant: PropTypes.oneOf(["outlined", "filled", "simple"]),
      disabled: PropTypes.bool,
      icon: PropTypes.string,
      onIconPress: PropTypes.func,
      iconRight: PropTypes.string,
      onIconRightPress: PropTypes.func,
      helper: PropTypes.string,
      backgroundColor: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      helperTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      labelTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
  }), _defineProperty(_class$7, "defaultProps", {
      variant: "outlined"
  }), _temp$7)),
  TextInputField = R14.connectForm((_temp$8 = _class$8 = class extends React__default.Component {
      constructor(props) {
          super(props);
          var opts = {};
          this.props.multiple && (opts.useTextValue = !0), this.elmt = this.props.form.addElement(props, opts), this.handleChangeText = this.handleChangeText.bind(this), this.handleFocus = this.handleFocus.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleAutoFill = this.handleAutoFill.bind(this), this.handleValueAdd = this.handleValueAdd.bind(this), this.handleKeyPress = this.handleKeyPress.bind(this), this.handleValueRemove = this.handleValueRemove.bind(this)
      }
      handleFocus() {
          this.elmt.setFocus(!0), this.props.onFocus && this.props.onFocus(this.elmt)
      }
      handleBlur() {
          this.elmt.setBlur(!0), this.props.onBlur && this.props.onBlur(this.elmt)
      }
      handleChangeText(text) {
          this.props.multiple ? this.elmt.setTextValue(text) : this.elmt.setValue(text), this.props.onChangeText && this.props.onChangeText(text, this.elmt, this.elmt.form), this.elmt.form.triggerValueChange(text, this.elmt)
      }
      handleKeyPress(event) {
          this.props.handleKeyPress && this.props.handleKeyPress(event), this.props.multiple && "Enter" === event.nativeEvent.key && (event.preventDefault(), this.handleValueAdd())
      }
      handleValueAdd() {
          var _this = this;
          return _asyncToGenerator((function*() {
              var text = _this.elmt.textValue;
              if (!text) return !1;
              if (!_this.props.multiple) throw new Error("Text Input Field Error: handleAdd for multiple only");
              if (!0 !== (yield _this.elmt.validate({
                      useTextValue: !0,
                      unique: _this.props.unique
                  }))) return !1;
              if (_this.props.unique && _this.elmt.value && _this.elmt.value.includes(text)) return _this.elmt.error = "Value must be unique", !1;
              _this.props.onValueAdd && _this.props.onValueAdd(text, _this.elmt.value, _this.elmt, _this.elmt.form);
              var val = _this.elmt.value;
              val || (val = []), val.push(text), _this.elmt.setValue(val), _this.elmt.setTextValue("")
          }))()
      }
      handleValueRemove(val) {
          if (!this.props.multiple) throw new Error("Text Input Field Error: handleRemove for multiple only");
          this.props.onValueRemove && this.props.onValueRemove(val, this.elmt.value, this.elmt, this.elmt.form);
          var vals = this.elmt.value;
          vals && (vals = vals.filter(n => n !== val)) !== this.elmt.value && this.elmt.setValue(vals)
      }
      handleAutoFill(action) {
          switch (action) {
              case "start":
                  this.elmt.setAutoFill(!0);
                  break;
              default:
                  this.elmt.setAutoFill(!1)
          }
      }
      componentWillUnmount() {
          this.elmt.remove()
      }
      renderValue() {
          var val = this.elmt.value;
          if (this.props.multiple) {
              if ((val = val || val) && !Array.isArray(val)) throw new Error("Text Input Error: Given value must be array for multiple text input")
          } else val = val ? "".concat(val) : "";
          return val
      }
      render() {
          var styles = this.styles(),
              variantStyles = this.variantStyles(),
              type = "text";
          return this.props.secure && (type = "password"), React__default.createElement(InputField, _extends({}, this.props, {
              element: this.elmt,
              InputComponent: React__default.createElement(TextInput$2, {
                  type: type,
                  name: this.elmt.name,
                  ref: this.elmt.ref,
                  placeholder: this.elmt.isActive && this.props.placeholder ? this.props.placeholder : null,
                  value: this.renderValue(),
                  textValue: this.elmt.textValue ? "".concat(this.elmt.textValue) : "",
                  onChangeText: this.handleChangeText,
                  onFocus: this.handleFocus,
                  onBlur: this.handleBlur,
                  onValueAdd: this.handleValueAdd,
                  onValueRemove: this.handleValueRemove,
                  onKeyPress: this.props.onKeyPress || this.props.multiple ? this.handleKeyPress : null,
                  autoFocus: this.props.autoFocus || null,
                  autoSelect: this.props.autoSelect || null,
                  readOnly: this.props.readOnly || null,
                  style: [styles.textInput, variantStyles.textInput, this.props.style],
                  multipleStyle: [styles.textInputMultiple, variantStyles.textInputMultiple, this.props.multipleStyle],
                  secureTextEntry: this.props.secure || !1,
                  autoComplete: this.props.autoComplete,
                  multiline: this.props.multiline || !1,
                  multiple: this.props.multiple || !1,
                  autoSize: this.props.autoSize || !1,
                  onAutoFill: this.handleAutoFill
              })
          }))
      }
      variantStyles() {
          this.elmt.value;
          switch (this.props.multiple && !(!this.elmt.value || !this.elmt.value.length), this.props.variant) {
              case "outlined":
                  return StyleSheet.create({
                      textInput: {
                          paddingTop: 16,
                          paddingBottom: 16,
                          paddingLeft: this.props.icon ? 43 : 11,
                          paddingRight: this.props.iconRight ? 43 : 11,
                          lineHeight: 22,
                          height: 52
                      },
                      textInputMultiple: {}
                  });
              default:
                  return StyleSheet.create({
                      textInput: {
                          paddingTop: 20,
                          paddingBottom: 5,
                          minHeight: 55,
                          lineHeight: 30
                      }
                  })
          }
      }
      styles() {
          return StyleSheet.create({
              textInput: {
                  margin: 0,
                  paddingLeft: this.props.icon ? 44 : 12,
                  paddingRight: this.props.iconRight ? 44 : 12,
                  width: "100%",
                  backgroundColor: "transparent",
                  color: Colors.onBackground,
                  fontSize: 16
              }
          })
      }
  }, _defineProperty(_class$8, "propTypes", {
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      textValue: PropTypes.string,
      variant: PropTypes.oneOf(["outlined", "filled"]),
      disabled: PropTypes.bool,
      secure: PropTypes.bool,
      onChangeText: PropTypes.func,
      onPress: PropTypes.func,
      onFocus: PropTypes.func,
      onBlur: PropTypes.func,
      onValueAdd: PropTypes.func,
      onValueRemove: PropTypes.func,
      icon: PropTypes.string,
      onIconPress: PropTypes.func,
      iconRight: PropTypes.string,
      onIconRightPress: PropTypes.func,
      helper: PropTypes.string,
      multiline: PropTypes.bool,
      multiple: PropTypes.bool,
      unique: PropTypes.bool,
      autoSize: PropTypes.bool,
      autoComplete: PropTypes.bool,
      style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      helperTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      labelTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      valueParser: PropTypes.func
  }), _defineProperty(_class$8, "defaultProps", {
      variant: "outlined",
      autoSize: !1,
      multiple: !1
  }), _temp$8));
class FileInputBase extends React__default.PureComponent {
  constructor(props) {
      super(props), this.handleChange = this.handleChange.bind(this), this.handleClick = this.handleClick.bind(this), this.handleFocus = this.handleFocus.bind(this), this.handleBlur = this.handleBlur.bind(this), this._clicked = !1, this.ref = React__default.createRef()
  }
  handleChange(event) {
      event.target && event.target.files && event.target.files.length ? (event.target.files[0], this._fileName = event.target && event.target.files && event.target.files.length ? event.target.files[0].name : null) : this._fileName = null, this.props.onValueChange && this.props.onValueChange(event.target.files[0]), this._clicked = !1
  }
  handleFocus(event) {
      !this._clicked && this.props.onFocus && this.props.onFocus(event), this._clicked = !1
  }
  handleBlur(event) {
      !this._clicked && this.props.onBlur && this.props.onBlur(event)
  }
  handleClick(event) {
      this.props.onPress && this.props.onPress(event), this._clicked = !0
  }
  renderLabel() {
      return this.props.label && React__default.createElement(TextInput, null, this.props.label)
  }
  render() {
      return React__default.createElement(ViewBase, {
          style: [styles$s.fileInput, this.props.style]
      }, React__default.createElement("input", {
          type: "file",
          name: this.props.name,
          ref: this.ref,
          placeholder: this.props.placeholder || null,
          value: "",
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          onClick: this.handleClick,
          onBlur: this.handleBlur,
          autoFocus: this.props.autoFocus || null,
          className: StyleSheet.className([styles$s.input])
      }), this.renderLabel())
  }
}
var _class$9, _temp$9, styles$s = StyleSheet.create({
  fileInput: {
      position: "relative",
      overflow: "hidden"
  },
  input: {
      position: "absolute",
      height: "300%",
      width: "300%",
      top: -50,
      left: -50,
      cursor: "pointer"
  }
});
class FileInput extends FileInputBase {}
_defineProperty(FileInput, "propTypes", {}), _defineProperty(FileInput, "defaultProps", {});
var FileInputField = R14.connectForm((_temp$9 = _class$9 = class extends React__default.Component {
      constructor(props) {
          super(props), this.elmt = this.props.form.addElement(props), this.handleValueChange = this.handleValueChange.bind(this), this.handleFocus = this.handleFocus.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleIconRightPress = this.handleIconRightPress.bind(this)
      }
      handleFocus() {
          this.elmt.setFocus(!0), this.props.onFocus && this.props.onFocus(this.elmt)
      }
      handleBlur() {
          this.elmt.setBlur(!0), this.props.onBlur && this.props.onBlur(this.elmt)
      }
      handleValueChange(file) {
          this.elmt.setValue(file), this.props.onValueChange && this.props.onValueChange(file, this.elmt, this.elmt.form), this.elmt.form.triggerValueChange(file, this.elmt)
      }
      handleIconRightPress() {
          this.elmt.setValue(null), this.props.onIconRightPress && this.props.onIconRightPress(this.elmt)
      }
      componentWillUnmount() {
          this.elmt.remove()
      }
      getValue() {
          var file = this.elmt.value,
              value = null;
          return file instanceof File ? value = null : file && file.value && (value = file.value), value
      }
      getLabel() {
          var file = this.elmt.value,
              label = null;
          return file instanceof File ? label = file.name : file && file.label && (label = file.label), label
      }
      render() {
          var styles = this.createDynamicStyles(),
              variantStyles = this.variantStyles();
          return React__default.createElement(InputField, _extends({}, this.props, {
              icon: this.props.icon || "folder",
              iconRight: this.elmt.value && "close",
              onIconRightPress: this.handleIconRightPress,
              element: this.elmt,
              InputComponent: React__default.createElement(FileInput, {
                  name: this.elmt.name,
                  ref: this.elmt.ref,
                  placeholder: this.elmt.isActive && this.props.placeholder ? this.props.placeholder : null,
                  label: this.getLabel(),
                  value: this.getValue(),
                  onValueChange: this.handleValueChange,
                  onFocus: this.handleFocus,
                  onBlur: this.handleBlur,
                  autoFocus: this.props.autoFocus || null,
                  style: [styles.fileInput, variantStyles.fileInput, this.props.style]
              })
          }))
      }
      variantStyles() {
          switch (this.props.variant) {
              case "outlined":
                  return StyleSheet.create({
                      fileInput: {
                          overFlow: "hidden",
                          flex: 1,
                          flexDirection: "row",
                          alignItems: "center",
                          paddingLeft: !1 !== this.props.icon ? 43 : 11,
                          paddingRight: this.props.iconRight ? 43 : 11,
                          lineHeight: 22,
                          height: 52
                      }
                  });
              default:
                  return StyleSheet.create({
                      fileInput: {
                          paddingTop: 20,
                          paddingBottom: 5,
                          minHeight: 55,
                          lineHeight: 30
                      }
                  })
          }
      }
      createDynamicStyles() {
          return StyleSheet.create({
              fileInput: {
                  margin: 0,
                  paddingLeft: this.props.icon ? 44 : 12,
                  paddingRight: this.props.iconRight ? 44 : 12,
                  width: "100%",
                  backgroundColor: "transparent",
                  color: Colors.onBackground,
                  fontSize: 16
              }
          })
      }
  }, _defineProperty(_class$9, "propTypes", {
      label: PropTypes.string,
      value: PropTypes.string,
      variant: PropTypes.oneOf(["outlined", "filled"]),
      disabled: PropTypes.bool,
      onValueChange: PropTypes.func,
      onPress: PropTypes.func,
      onFocus: PropTypes.func,
      onBlur: PropTypes.func,
      icon: PropTypes.string,
      onIconPress: PropTypes.func,
      iconRight: PropTypes.string,
      onIconRightPress: PropTypes.func,
      helper: PropTypes.string,
      multiline: PropTypes.bool,
      autoSize: PropTypes.bool,
      autoComplete: PropTypes.bool,
      style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      helperTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      labelTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      valueParser: PropTypes.func
  }), _defineProperty(_class$9, "defaultProps", {
      variant: "outlined",
      autoSize: !1
  }), _temp$9)),
  SearchableText = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props), this.scrollRef = this.props.scrollRef || React__default.createRef(), this.textMatches = [], this.textMatchIdx = 0, this.handleSearchChangeText = this.handleSearchChangeText.bind(this), this.handleNextMatchPress = this.handleNextMatchPress.bind(this), this.handlePreviousMatchPress = this.handlePreviousMatchPress.bind(this), this.handleSearchBarShowPress = this.handleSearchBarShowPress.bind(this), this.handleSearchBarClosePress = this.handleSearchBarClosePress.bind(this), this.state = {
              search: "",
              matchIndex: null,
              textComponents: null,
              searchBarVisible: !1
          }
      }
      componentDidMount() {}
      componentDidUpdate(prevProps, prevState) {
          this.textMatches.length && null === this.state.matchIndex ? this.setState({
              matchIndex: 0
          }) : this.textMatches.length || null === this.state.matchIndex ? prevState.matchIndex !== this.state.matchIndex && this.scrollToMatch() : this.setState({
              matchIndex: null
          })
      }
      handleSearchChangeText(value) {
          value !== this.state.search && this.setState({
              search: value,
              matchIndex: null
          })
      }
      handleNextMatchPress() {
          var matchIndex = this.state.matchIndex;
          this.textMatches.length && (this.textMatches.length <= matchIndex + 1 && (matchIndex = 0), this.setState({
              matchIndex: matchIndex + 1
          }))
      }
      handlePreviousMatchPress() {
          var matchIndex = this.state.matchIndex;
          this.textMatches.length && (matchIndex < 1 && (matchIndex = this.textMatches.length), this.setState({
              matchIndex: matchIndex - 1
          }))
      }
      scrollToMatch() {
          null !== this.state.matchIndex && this.textMatches[this.state.matchIndex] && this.scrollRef.current.scrollTo({
              y: this.textMatches[this.state.matchIndex].y - 16,
              animated: !0
          })
      }
      handleSearchBarShowPress() {
          this.setState({
              searchBarVisible: !0
          })
      }
      handleSearchBarClosePress() {
          this.setState({
              search: "",
              totalMatches: 0,
              searchBarVisible: !1
          })
      }
      scrollToEnd() {
          var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
              animated: !1
          };
          this.scrollRef.current && this.scrollRef.current.scrollToEnd(options)
      }
      renderText() {
          var text = this.props.text || "",
              textComponents = [],
              search = this.state.search;
          if (this.textMatches = [], search.length && text.length) {
              for (var textIdx = 0, textMatchIdx = 0, sIdx = 0, idx = null, indices = [], currDate = new Date;
                  (idx = text.toLowerCase().indexOf(search.toLowerCase(), sIdx)) > -1;) {
                  indices.push(idx);
                  var preText = text.substring(sIdx, idx),
                      searchText = text.substring(idx, idx + search.length);
                  textComponents.push(React__default.createElement(TextInput, {
                      style: this.props.textStyle,
                      key: "txt".concat(currDate.getTime()).concat(textIdx)
                  }, preText)), textComponents.push(React__default.createElement(SearchableTextMatch, {
                      idx: textMatchIdx,
                      key: "searchTxt".concat(currDate.getTime()).concat(textMatchIdx),
                      highlight: this.state.matchIndex === textMatchIdx,
                      onLayout: (e, idx) => {
                          this.textMatches[idx] = e.nativeEvent.layout
                      },
                      textStyle: this.props.textStyle
                  }, searchText)), this.textMatches[textMatchIdx] = null, sIdx = idx + search.length, textIdx++, textMatchIdx++
              }
              sIdx < text.length && textComponents.push(React__default.createElement(TextInput, {
                  style: this.props.textStyle,
                  key: "txt".concat(currDate.getTime()).concat(textIdx)
              }, text.substring(sIdx, text.length)))
          }
          return textComponents.length ? React__default.createElement(ViewBase, {
              onLayout: e => {
                  console.log(this.textMatches)
              },
              style: styles$t.searchableTextMatch
          }, textComponents) : React__default.createElement(TextInput, {
              style: this.props.textStyle
          }, this.props.text)
      }
      render() {
          if (!this.props.text) return null;
          var textComponents = this.renderText();
          return React__default.createElement(ViewBase, {
              style: styles$t.searchableText,
              onLayout: this.props.onLayout || null
          }, React__default.createElement(IconButton, {
              icon: "search",
              style: styles$t.searchIconButton,
              size: "small",
              key: "close",
              variant: "circle",
              onPress: this.handleSearchBarShowPress
          }), React__default.createElement(TextSearchBar, {
              onChangeText: this.handleSearchChangeText,
              searchValue: this.state.search,
              matchIndex: this.state.matchIndex,
              totalMatches: this.textMatches.length,
              onNextMatchPress: this.handleNextMatchPress,
              onPreviousMatchPress: this.handlePreviousMatchPress,
              onClosePress: this.handleSearchBarClosePress,
              visible: this.state.searchBarVisible
          }), React__default.createElement(ScrollViewBase, {
              style: styles$t.scrollView,
              height: this.props.height || 300,
              ref: this.scrollRef
          }, React__default.createElement(ViewBase, {
              style: styles$t.textComponents
          }, textComponents)))
      }
  });
class TextSearchBar extends React__default.Component {
  constructor(props) {
      super(props)
  }
  render() {
      var matchNum = null !== this.props.matchIndex ? this.props.matchIndex + 1 : 0;
      return React__default.createElement(AnimatedView, {
          in: this.props.visible,
          enter: {
              transform: [{
                  translateY: 0
              }, {
                  scale: 1
              }],
              opacity: 1
          },
          exit: {
              transform: [{
                  translateY: 48
              }, {
                  scale: .95
              }],
              opacity: 0
          },
          duration: 150,
          unmountOnExit: !0,
          style: styles$t.textSearchBar
      }, React__default.createElement(Surface, {
          style: styles$t.textSearchBarSurface,
          elevation: 6
      }, React__default.createElement(TextInput$2, {
          name: "search",
          value: this.props.searchValue,
          onChangeText: this.props.onChangeText,
          style: styles$t.textSearchBarTextInput,
          autoFocus: !0,
          placeholder: "Search",
          onBlur: this.handleBlur
      }), React__default.createElement(ViewBase, {
          style: styles$t.textSearchBarControlsRight
      }, React__default.createElement(TextInput, {
          style: styles$t.textSearchBarInfoText
      }, matchNum, "/", this.props.totalMatches || 0), React__default.createElement(IconButton, {
          icon: "keyboardArrowDown",
          key: "nextMatch",
          size: "small",
          style: styles$t.textSearchBarIcon,
          onPress: this.props.onNextMatchPress
      }), React__default.createElement(IconButton, {
          icon: "keyboardArrowUp",
          style: styles$t.textSearchBarIcon,
          size: "small",
          key: "prevMatch",
          onPress: this.props.onPreviousMatchPress
      }), React__default.createElement(IconButton, {
          icon: "close",
          style: styles$t.textSearchBarIcon,
          size: "small",
          key: "close",
          onPress: this.props.onClosePress
      }))))
  }
}
class SearchableTextMatch extends React__default.Component {
  constructor(props) {
      super(props)
  }
  render() {
      return React__default.createElement(TextInput, {
          style: [styles$t.searchableTextMatch, this.props.textStyle, this.props.highlight && styles$t.searchableTextMatchHighlight],
          onLayout: e => {
              this.props.onLayout(e, this.props.idx)
          }
      }, this.props.children)
  }
}
var styles$t = StyleSheet.create({
  searchableText: {
      flex: 1,
      borderWidth: 1,
      borderColor: StyleSheet.color(Colors.onSurface).rgba(.05)
  },
  searchableTextMatch: {
      color: Colors.primary,
      fontWeight: "500"
  },
  searchableTextMatchHighlight: {
      backgroundColor: StyleSheet.color(Colors.primary).rgba(.2)
  },
  scrollView: _extends({}, StyleSheet.margin(0), StyleSheet.padding(16, 16, 64, 16), {
      backgroundColor: Colors.background
  }),
  textComponents: {
      width: "100%"
  },
  searchIconButton: {
      position: "absolute",
      bottom: 6,
      right: 6,
      margin: 0
  },
  textSearchBar: {
      position: "absolute",
      bottom: 0,
      right: 0,
      left: 0
  },
  textSearchBarSurface: _extends({
      flex: 0,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center"
  }, StyleSheet.padding(6, 6, 6, 12)),
  textSearchBarControlsRight: {
      flex: 0,
      flexDirection: "row",
      alignItems: "center"
  },
  textSearchBarIcon: _extends({}, StyleSheet.margin(0)),
  textSearchBarTextInput: {
      backgroundColor: "transparent",
      color: Colors.onSurface,
      fontSize: 16,
      width: 144
  },
  textSearchBarControlRight: {},
  textSearchBarInfoText: _extends({
      fontSize: 14,
      fontWeight: "300",
      minWidth: 100
  }, StyleSheet.padding(4, 8, 4, 8))
});
class StatusBarBase {
  constructor() {
      _defineProperty(this, "currentHeight", 0)
  }
}
class PopUpMenu extends React__default.PureComponent {
  constructor(props) {
      super(props), this.handleControlPress = this.handleControlPress.bind(this), this.handleItemPress = this.handleItemPress.bind(this), this.handlePressOutside = this.handlePressOutside.bind(this), this.handleBackdropPress = this.handleBackdropPress.bind(this), this.handleLayout = this.handleLayout.bind(this), this.handleScrollItemLayout = this.handleScrollItemLayout.bind(this), this.containerRef = React__default.createRef(), this.scrollViewRef = React__default.createRef(), this.itemRef = React__default.createRef(), this.currScrollToItem = null, this.state = {
          isOpen: !1,
          controlLayout: {
              top: 0,
              left: 0,
              height: 0,
              width: 0
          },
          popUpLayout: {
              height: 0,
              width: 0
          },
          scrollToOffset: null
      }
  }
  open() {
      this.containerRef.current.measureInWindow((px, py, width, height) => {
          this.setState({
              controlLayout: {
                  top: py,
                  left: px,
                  width: width,
                  height: height
              }
          }), this.setState({
              isOpen: !0
          }), this.props.onOpen && this.props.onOpen()
      })
  }
  close() {
      this.setState({
          isOpen: !1
      }), this.props.onClose && this.props.onClose()
  }
  handleBackdropPress() {
      this.close()
  }
  handleControlPress() {
      if (this.props.disabled) return !1;
      this.state.isOpen ? this.close() : this.open()
  }
  componentDidMount() {}
  componentDidUpdate(prevProps) {}
  handleItemPress(value, label) {
      this.props.onSelect && this.props.onSelect(value, label), this.state.isOpen && this.close()
  }
  handlePressOutside() {
      this.close()
  }
  handleLayout(event) {
      this.setState({
          popUpLayout: {
              height: event.nativeEvent.layout.height || 0,
              width: event.nativeEvent.layout.width || 0
          }
      })
  }
  handleScrollItemLayout(event) {
      this.scrollViewRef.current.scrollTo({
          y: event.nativeEvent.layout.y,
          animated: !1
      })
  }
  get scrollToItem() {
      return !1 in this.props ? null : this.props.scrollToItem
  }
  renderControl() {
      var control = null;
      if (this.props.controlIcon ? control = React__default.createElement(IconButton, {
              icon: this.props.controlIcon,
              size: this.props.controlIconSize,
              color: this.props.controlIconColor,
              style: this.props.controlIconStyle || null,
              onPress: this.handleControlPress
          }) : this.props.Control && (control = React__default.cloneElement(this.props.Control, {
              onPress: this.handleControlPress,
              ref: this._controlRef
          })), !control) throw new Error("PopUpMenu Error: No control found.");
      return control
  }
  get exitTransformAnimation() {
      switch (this.props.direction) {
          case "down":
              return [{
                  translateX: 0
              }, {
                  translateY: -35
              }, {
                  scale: .8
              }];
          case "downLeft":
              return [{
                  translateX: 10
              }, {
                  translateY: -20
              }, {
                  scale: .8
              }];
          case "upLeft":
              return [{
                  translateX: 10
              }, {
                  translateY: 20
              }, {
                  scale: .8
              }];
          case "downRight":
              return [{
                  translateX: -10
              }, {
                  translateY: -20
              }, {
                  scale: 1
              }];
          case "upRight":
              return [{
                  translateX: -10
              }, {
                  translateY: 20
              }, {
                  scale: 1
              }]
      }
  }
  render() {
      var items = this.props.children || null;
      return items && !Array.isArray(this.props.children) && (items = [items]), React__default.createElement(ViewBase, {
          style: [styles$u.container, this.props.controlStyle],
          ref: this.containerRef,
          onLayout: null
      }, this.renderControl(), React__default.createElement(Modal$1, {
          visible: this.state.isOpen,
          transparent: !0,
          animationType: "none",
          style: styles$u.modal,
          backdrop: !0,
          onBackdropPress: this.handleBackdropPress
      }, React__default.createElement(AnimatedView, {
          enter: {
              opacity: 1,
              transform: [{
                  translateX: 0
              }, {
                  translateY: 0
              }, {
                  scale: 1
              }]
          },
          exit: {
              opacity: 0,
              transform: this.exitTransformAnimation
          },
          duration: 100,
          in: this.state.isOpen,
          style: [styles$u.popUpMenu, this.layoutStyles.popUpMenu, this.props.style],
          animateOnMount: !0,
          unmountOnExit: !0
      }, React__default.createElement(Surface, {
          elevation: 10,
          style: [styles$u.surface, this.props.style],
          onLayout: this.handleLayout
      }, this.props.HeaderComponent, React__default.createElement(ScrollViewBase, {
          ref: this.scrollViewRef,
          style: styles$u.scrollView
      }, items && items.map(child => {
          var itemProps = {
              popUpMenu: this
          };
          return child ? React__default.cloneElement(child, itemProps) : null
      }))))))
  }
  get layoutStyles() {
      var windowDimensions = DimensionsBase.get("window"),
          windowHeight = StatusBarBase.currentHeight ? windowDimensions.height - StatusBarBase.currentHeight : windowDimensions.height,
          positionStyle = {
              top: null,
              right: null,
              bottom: null,
              left: null
          };
      switch (this.props.direction) {
          case "down":
              positionStyle.top = this.state.controlLayout.top + this.state.controlLayout.height, positionStyle.left = this.state.controlLayout.left;
              break;
          case "downLeft":
              positionStyle.top = this.state.controlLayout.top + this.state.controlLayout.height, positionStyle.right = windowDimensions.width - (this.state.controlLayout.left + this.state.controlLayout.width) || 0;
              break;
          case "upLeft":
              positionStyle.right = windowDimensions.width - (this.state.controlLayout.left + this.state.controlLayout.width) || 0, positionStyle.bottom = windowHeight - this.state.controlLayout.top - this.state.controlLayout.height || 0;
              break;
          case "downRight":
              positionStyle.top = this.state.controlLayout.top + this.state.controlLayout.height, positionStyle.left = this.state.controlLayout.left;
              break;
          case "upRight":
              positionStyle.left = this.state.controlLayout.left, positionStyle.bottom = windowHeight - this.state.controlLayout.top - this.state.controlLayout.height || 0
      }
      if (this.props.controlWidthCover && (positionStyle.minWidth = 80, this.state.controlLayout.width > 80 && (positionStyle.width = this.state.controlLayout.width)), null !== positionStyle.top) {
          var topOffset = positionStyle.top + this.state.popUpLayout.height;
          topOffset > windowDimensions.height && (positionStyle.top -= topOffset - windowDimensions.height + 8)
      }
      if (null !== positionStyle.left) {
          var leftOffset = positionStyle.left + this.state.popUpLayout.width;
          leftOffset > windowDimensions.width && (positionStyle.left -= leftOffset - windowDimensions.width + 8)
      }
      return StyleSheet.create({
          popUpMenu: _extends({
              position: "absolute"
          }, positionStyle)
      })
  }
}
_defineProperty(PopUpMenu, "propTypes", {
  direction: PropTypes.oneOf(["down", "upRight", "downLeft", "downRight", "upLeft"]),
  Control: PropTypes.node,
  controlIcon: PropTypes.string,
  controlWidthCover: PropTypes.bool,
  controlIconSize: PropTypes.oneOf(["small", "medium", "large"]),
  controlIconStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  HeaderComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.elementType])
}), _defineProperty(PopUpMenu, "defaultProps", {
  direction: "downLeft"
});
var styles$u = StyleSheet.create({
  container: {},
  modal: {},
  popUpMenu: {
      position: "absolute",
      flex: 1,
      flexDirection: "column",
      zIndex: 10,
      maxHeight: 264
  },
  surface: _extends({
      borderRadius: 4
  }, StyleSheet.padding(8, 0, 8, 0), {
      flex: 1
  }),
  scrollView: {
      position: "relative",
      maxHeight: 264
  },
  downRight: {
      top: 0,
      left: 0
  },
  downLeft: {
      top: 0,
      right: 0
  },
  upLeft: {
      bottom: 0,
      right: 0
  },
  upRight: {
      bottom: 0,
      left: 0
  }
});
class PopUpMenuItem extends React__default.PureComponent {
  constructor(props) {
      if (super(props), !this.props.popUpMenu) throw new Error("PopUpMenuItem Error: No popupmenu found");
      this.handlePress = this.handlePress.bind(this), this.handleLayout = this.handleLayout.bind(this), this.popUpMenu = this.props.popUpMenu
  }
  handleLayout(event) {
      this.props.onLayout && this.props.onLayout(event), this.scrollToItem && this.popUpMenu.handleScrollItemLayout(event)
  }
  handlePress() {
      this.popUpMenu.handleItemPress(this.props.value, this.props.label), this.props.onPress && this.props.onPress(this.props.value, this.props.label)
  }
  get scrollToItem() {
      return null !== this.popUpMenu.scrollToItem && "value" in this.props && this.popUpMenu.scrollToItem === this.props.value
  }
  render() {
      return React__default.createElement(ViewBase, {
          style: [styles$v.popUpMenuItem, this.props.style]
      }, this.props.controlsLeft && React__default.createElement(ControlsView, {
          style: styles$v.controlsLeft,
          align: "left"
      }, this.props.controlsLeft), React__default.createElement(TouchableBase, {
          style: styles$v.touchable,
          onPress: this.handlePress
      }, React__default.createElement(ViewBase, null, React__default.createElement(ViewBase, {
          onLayout: this.handleLayout,
          style: [styles$v.container, this.props.controlsLeft && styles$v.containerControlsLeft]
      }, this.props.icon && React__default.createElement(Icon, {
          color: this.props.iconColor || StyleSheet.color(Colors.onSurface).rgba(.75),
          name: this.props.icon,
          size: this.props.iconSize || "small",
          style: [styles$v.icon, this.props.iconStyle]
      }), React__default.createElement(TextInput, {
          style: [styles$v.labelText, this.props.labelTextStyle]
      }, this.props.label)))))
  }
}
var styles$v = StyleSheet.create({
  popUpMenuItem: {
      flex: 1,
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      hover: {
          backgroundColor: StyleSheet.color(Colors.onSurface).rgba(.1)
      }
  },
  container: {
      flex: 1,
      flexDirection: "row",
      flexWrap: "nowrap",
      alignItems: "flex-start",
      paddingRight: 16,
      paddingLeft: 16,
      minHeight: 48
  },
  containerControlsLeft: {
      paddingLeft: 0
  },
  touchable: {
      flex: 1
  },
  labelText: {
      lineHeight: 22,
      paddingTop: 13,
      paddingBottom: 13,
      color: Colors.onSurface
  },
  icon: {
      marginRight: 8,
      marginTop: 14,
      marginLeft: -6
  },
  controlsLeft: {
      flex: 0,
      marginLeft: 8,
      marginRight: 0,
      marginTop: 6
  }
});
class Checkbox extends React__default.PureComponent {
  constructor(props) {
      super(props), this.ref = React__default.createRef(), this.handleValueChange = this.handleValueChange.bind(this), this.handleChange = this.handleChange.bind(this)
  }
  componentDidMount() {
      this.props.autoFocus && this.autoFocus()
  }
  autoFocus() {
      setTimeout(() => {
          this.elmt.ref.current && this.ref.current.focus()
      }, 350)
  }
  handleValueChange(value) {
      this.props.onValueChange && this.props.onValueChange(value)
  }
  handleChange() {
      this.props.onPress && this.props.onPress(), this.handleValueChange(!this.props.value)
  }
  render() {
      var styles = this.styles();
      return React__default.createElement(ViewBase, {
          style: styles.checkbox
      }, React__default.createElement(AnimatedView, {
          style: [styles.handle, this.props.value && styles.handleOn],
          in: !!this.props.value,
          enter: {
              opacity: 1
          },
          exit: {
              opacity: .6
          },
          duration: 100
      }, React__default.createElement(IconButton, {
          icon: this.props.value ? this.props.iconMarked : this.props.iconBlank,
          onPress: this.handleChange,
          color: this.props.value ? this.props.colorMarked : this.props.colorBlank,
          ref: this.ref,
          disabled: this.props.disabled
      })))
  }
  styles() {
      return StyleSheet.create({
          checkbox: {
              marginLeft: -6
          },
          input: {
              position: "absolute",
              left: -18,
              top: -17,
              width: 68,
              height: 48,
              margin: 0,
              opacity: 0,
              cursor: "pointer"
          }
      })
  }
}
_defineProperty(Checkbox, "propTypes", {
  disabled: PropTypes.bool,
  value: PropTypes.bool,
  onValueChange: PropTypes.func,
  iconBlank: PropTypes.string,
  iconMarked: PropTypes.string,
  colorBlank: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  colorMarked: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}), _defineProperty(Checkbox, "defaultProps", {
  value: !1,
  iconBlank: "checkboxBlank",
  iconMarked: "checkboxMarked",
  colorBlank: Colors.onBackground,
  colorMarked: Colors.primary
});
class SelectMenu extends React__default.PureComponent {
  constructor(props) {
      super(props), this.MODE_LABEL_VALUE = "LABEL_VALUE", this.MODE_VALUE = "VALUE", this.ref = React__default.createRef(), this.popupMenuRef = React__default.createRef(), this.handleSelect = this.handleSelect.bind(this), this.handleOpen = this.handleOpen.bind(this), this.handleClose = this.handleClose.bind(this), this.handleSearchResetText = this.handleSearchResetText.bind(this), this.handleSearchChangeText = this.handleSearchChangeText.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.state = {
          isOpen: !1,
          searchText: "",
          activeItemIdx: null
      }, this.lastSearchText = null, this.lastSearchTimeoutText = null, this.searchTimeout = null, this.hasInitializedValueLabels = !1, this.valueLabels = this.props.initialValueLabels || {}
  }
  componentDidMount() {
      this.props.autoFocus && this.autoFocus(), this.initValueLabels()
  }
  autoFocus() {
      setTimeout(() => {
          this.elmt.ref.current && this.ref.current.focus()
      }, 750)
  }
  handleSelect(value, label) {
      var val = {
          value: value,
          label: label
      };
      if (this.props.onValueChange) return this.props.onValueChange(val, this.mode)
  }
  handleRemove(value) {
      var val = {
          value: value,
          label: null
      };
      if (this.props.onValueChange) return this.props.onValueChange(val, this.mode)
  }
  handleOpen() {
      this.props.onOpen && this.props.onOpen(), this.setState({
          isOpen: !0
      })
  }
  handleClose() {
      this.props.onClose && this.props.onClose();
      var activeItemIdx = this.props.multiple ? null : this.state.activeItemIdx;
      this.setState({
          isOpen: !1,
          activeItemIdx: activeItemIdx
      })
  }
  handleKeyDown(e) {
      if (this.props.handleKeyDown && this.props.handleKeyDown(e), !e.nativeEvent || !e.nativeEvent.key) return !1;
      var activeItemIdx = this.state.activeItemIdx,
          isOpen = this.state.isOpen,
          totalItems = this.props.items ? this.props.items.length : 0,
          shouldPreventDefault = !0,
          shouldSelect = !this.props.multiple;
      switch (e.nativeEvent.key) {
          case "ArrowDown":
              totalItems > 0 && (this.props.multiple && (isOpen = !0), null === activeItemIdx ? activeItemIdx = 0 : activeItemIdx < totalItems - 1 && activeItemIdx++);
              break;
          case "ArrowUp":
              totalItems > 0 && (this.props.multiple && (isOpen = !0), null !== activeItemIdx && activeItemIdx > 0 ? activeItemIdx-- : 0 !== activeItemIdx && (activeItemIdx = null));
              break;
          case "Enter":
              this.props.multiple ? this.state.isOpen ? shouldSelect = !0 : isOpen = !0 : isOpen = !this.state.isOpen;
              break;
          case "Tab":
              shouldPreventDefault = !1, this.state.isOpen && (isOpen = !1);
              break;
          default:
              shouldPreventDefault = !1
      }
      activeItemIdx !== this.state.activeItemIdx && this.setState({
          activeItemIdx: activeItemIdx
      }), shouldSelect && null !== activeItemIdx && this.handleSelect(this.props.items[activeItemIdx].value, this.props.items[activeItemIdx].label), isOpen !== this.state.isOpen && (isOpen ? this.open() : this.close()), shouldPreventDefault && e.preventDefault()
  }
  initValueLabels() {
      if (this.props.value && !this.hasInitializedValueLabels) {
          var valueLabels = {},
              values = this.props.value || [];
          if (Array.isArray(values) || (values = [values]), values.length && "object" == typeof values[0]) {
              if (this.mode === this.MODE_VALUE) throw new Error("SelectMenu Value Error: Mode set to useValuesOnly, but given object.");
              if (!("label" in values[0]) || !("value" in values[0])) throw new Error("SelectMenu Value Error: Value must contain value / label")
          } else switch (this.mode) {
              case this.MODE_LABEL_VALUE:
                  if (values.length) throw new Error("SelectMenu Value Error: Mode not set to useValuesOnly, but given simple values.");
                  break;
              default:
                  for (var i in this.props.items) valueLabels[this.props.items[i].value] = this.props.items[i].label;
                  for (var _i in values) this.valueLabels[values[_i]] && (valueLabels[values[_i]] = this.valueLabels[values[_i]]);
                  this.valueLabels = valueLabels
          }
          this.hasInitializedValueLabels = !0
      }
  }
  getValueLabel(value) {
      return this.mode === this.MODE_LABEL_VALUE ? value.label : this.valueLabels[value] ? this.valueLabels[value] : value
  }
  getValue(value) {
      return this.mode === this.MODE_LABEL_VALUE ? value.value : value
  }
  get hasSearchText() {
      return this.state.searchText && "" !== this.state.searchText
  }
  get hasItems() {
      return !(!this.props.items || !this.props.items.length)
  }
  get mode() {
      return this.props.useValuesOnly ? this.MODE_VALUE : this.MODE_LABEL_VALUE
  }
  handleSearchChangeText(text) {
      this.props.onSearchChangeText && text !== this.lastSearchTimeoutText && (this.searchTimeout && clearTimeout(this.searchTimeout), this.lastSearchTimeoutText = text, this.searchTimeout = setTimeout(() => {
          this.props.onSearchChangeText && this.lastSearchText !== text && (this.lastSearchText = text, this.props.onSearchChangeText(text)), this.searchTimeout = null
      }, 350)), this.setState({
          searchText: text
      })
  }
  handleSearchResetText() {
      this.handleSearchChangeText("")
  }
  isSelectedValue(value) {
      if (this.props.multiple) {
          if (!this.props.value) return !1;
          switch (this.mode) {
              case this.MODE_LABEL_VALUE:
                  if (!this.props.value.length) return !1;
                  for (var val of this.props.value)
                      if (val.value === value) return !0;
                  break;
              default:
                  return -1 !== this.props.value.indexOf(value)
          }
      } else switch (this.mode) {
          case this.MODE_LABEL_VALUE:
              return this.props.value && this.props.value.value === value;
          default:
              return this.props.value === value
      }
      return !1
  }
  open() {
      this.popupMenuRef.current && this.popupMenuRef.current.open()
  }
  close() {
      this.popupMenuRef.current && this.popupMenuRef.current.close()
  }
  renderItems() {
      var menuItems = [];
      !this.props.loading && !this.hasItems && this.hasSearchText && menuItems.push(React__default.createElement(PopUpMenuItem, {
          labelTextStyle: styles$w.searchHelperLabelText,
          label: "No Results Found",
          key: "noResults"
      })), this.props.searchable && !this.hasItems && !this.hasSearchText && menuItems.push(React__default.createElement(PopUpMenuItem, {
          labelTextStyle: styles$w.searchHelperLabelText,
          label: "Type in a search value...",
          key: "noResults"
      }));
      var itemIdx = 0;
      return this.hasItems && this.props.items.forEach(item => {
          menuItems.push(React__default.createElement(PopUpMenuItem, {
              icon: item.icon,
              iconSize: "small",
              label: item.label,
              value: item.value,
              controlsLeft: this.props.multiple && React__default.createElement(Checkbox, {
                  value: this.isSelectedValue(item.value),
                  onPress: () => this.handleSelect(item.value, item.label)
              }),
              key: item.value || "default",
              style: [this.isSelectedValue(item.value) && styles$w.menuItemSelected, this.state.activeItemIdx === itemIdx && styles$w.menuItemActive]
          })), itemIdx++
      }), menuItems
  }
  renderChips() {
      var _this = this;
      this.initValueLabels();
      var label = null;
      if (this.props.multiple) {
          var labels = [],
              values = this.props.value || [],
              _loop = function(i) {
                  var label = _this.getValueLabel(values[i]),
                      value = _this.getValue(values[i]);
                  if (!label) return "continue";
                  labels.push(React__default.createElement(Chip, {
                      key: value,
                      label: label,
                      style: styles$w.selectValueChip,
                      iconRight: "close",
                      onPress: () => {
                          _this.handleRemove(value)
                      }
                  }))
              };
          for (var i in values) _loop(i);
          labels.length && (label = React__default.createElement(ChipGroup, {
              key: "selections",
              style: styles$w.selectValueChipGroup
          }, labels))
      }
      return label
  }
  renderSearchInput() {
      return this.props.searchable ? React__default.createElement(Surface, {
          key: "search",
          elevation: 2,
          style: styles$w.searchTextInputField
      }, React__default.createElement(AnimatedView, {
          enter: {
              opacity: 1
          },
          exit: {
              opacity: .5
          },
          in: this.hasSearchText,
          duration: 100,
          style: styles$w.searchText
      }, React__default.createElement(TextInput$2, {
          name: "search",
          autoComplete: !1,
          value: this.state.searchText,
          onChangeText: this.handleSearchChangeText,
          style: styles$w.searchTextInput,
          autoFocus: !0,
          placeholder: "Search".concat(this.props.label ? " ".concat(this.props.label) : "")
      })), this.props.loading && React__default.createElement(ActivityIndicator, {
          size: "small",
          containerStyle: styles$w.searchActivityIndicator
      }), React__default.createElement(AnimatedView, {
          enter: {
              opacity: .5
          },
          exit: {
              opacity: 0
          },
          in: this.hasSearchText,
          duration: 250,
          unmountOnExit: !0
      }, React__default.createElement(IconButton, {
          icon: "close",
          onPress: this.handleSearchResetText
      }))) : null
  }
  renderLabel() {
      this.initValueLabels();
      var ret = null;
      if (!this.props.multiple) {
          var value = this.props.value || "",
              valueLabel = this.getValueLabel(value),
              label = this.props.labelRenderer ? this.props.labelRenderer(value) : React__default.createElement(TextInput, {
                  style: this.props.valueLabelTextStyle
              }, valueLabel);
          ret = React__default.createElement(ViewBase, {
              style: styles$w.selectValueLabel,
              pointerEvents: "none"
          }, this.props.icon && React__default.createElement(Icon, {
              name: this.props.icon
          }), label)
      }
      return ret
  }
  render() {
      this.props.items;
      if (this.props.multiple && this.props.value && !Array.isArray(this.props.value)) throw new Error("SelectMenu Error: SelectMenu with option multiple must have an array of values as it's value.");
      return React__default.createElement(ViewBase, {
          style: [styles$w.selectMenu, this.props.style],
          tabIndex: this.props.tabIndex || 0,
          onFocus: this.props.onFocus,
          onBlur: this.props.onBlur,
          onKeyDown: this.handleKeyDown
      }, React__default.createElement(PopUpMenu, {
          controlWidthCover: !0,
          disabled: this.props.disabled,
          style: [styles$w.popUpMenu, this.props.popupMenuStyle],
          HeaderComponent: this.renderSearchInput(),
          ref: this.popupMenuRef,
          Control: React__default.createElement(TouchableBase, null, React__default.createElement(ViewBase, {
              style: [styles$w.selectInput, this.props.inputStyle]
          }, this.renderLabel(), React__default.createElement(ViewBase, {
              key: "control",
              style: [styles$w.iconContainer, this.props.iconStyle]
          }, this.props.multiple ? React__default.createElement(Icon, {
              style: styles$w.addIcon,
              name: "add",
              color: Colors.onSecondary
          }) : React__default.createElement(AnimatedView, {
              enter: {
                  transform: [{
                      rotate: "-180deg"
                  }]
              },
              exit: {
                  transform: [{
                      rotate: "0deg"
                  }]
              },
              in: this.state.isOpen,
              duration: 100
          }, React__default.createElement(Icon, {
              style: styles$w.icon,
              name: "menuDown",
              color: this.props.iconColor || StyleSheet.color(Colors.onBackground).rgba(.6)
          }))))),
          key: "userMenu",
          direction: "down",
          scrollToItem: this.props.value,
          onSelect: this.handleSelect,
          onOpen: this.handleOpen,
          onClose: this.handleClose
      }, this.renderItems()), this.renderChips())
  }
}
_defineProperty(SelectMenu, "propTypes", {
  items: PropTypes.array,
  value: PropTypes.any,
  multiple: PropTypes.bool,
  searchable: PropTypes.bool,
  itemLoader: PropTypes.func
}), _defineProperty(SelectMenu, "defaultProps", {
  multiple: !1,
  searchable: !1,
  items: []
});
var _class$a, _temp$a, _class$b, _temp$b, _class$c, _temp$c, styles$w = StyleSheet.create({
      iconContainer: _extends({}, StyleSheet.margin(0, 0, 0, "auto")),
      addIcon: _extends({
          backgroundColor: Colors.secondary,
          borderRadius: 18,
          elevation: 3
      }, StyleSheet.padding(4), {
          height: 32,
          width: 32
      }),
      popUpMenu: _extends({}, StyleSheet.margin(2, -6, 0, -2)),
      selectValueLabel: _extends({
          position: "relative"
      }, StyleSheet.margin(0, 8, 0, 0)),
      selectValueChipGroup: _extends({
          position: "relative",
          zIndex: 2
      }, StyleSheet.margin(-42, 52, 2, 8)),
      selectValueChip: {},
      selectMenu: {},
      selectInput: _extends({
          position: "relative",
          flex: 1,
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          margin: 0
      }, StyleSheet.padding(10, 8, 10, 10), {
          width: "100%",
          height: "auto",
          minHeight: 52,
          backgroundColor: "transparent",
          color: Colors.onBackground,
          lineHeight: 20,
          fontSize: 16
      }),
      searchTextInputField: _extends({
          flex: 1,
          flexDirection: "row",
          alignItems: "center"
      }, StyleSheet.padding(4, 0, 4, 16), {
          marginBottom: 8,
          height: 48,
          backgroundColor: Colors.background
      }),
      searchText: {
          width: "100%"
      },
      searchActivityIndicator: _extends({}, StyleSheet.padding(8), StyleSheet.margin(0, 4, 0, 4)),
      searchTextInput: {
          backgroundColor: "transparent",
          color: Colors.onBackground,
          fontSize: 16,
          width: "100%"
      },
      searchHelperLabelText: {
          opacity: .5
      },
      menuItemSelected: {
          backgroundColor: StyleSheet.color(Colors.secondary).rgba(.1)
      },
      menuItemActive: {
          backgroundColor: StyleSheet.color(Colors.secondary).rgba(.08)
      }
  }),
  SelectMenuField = R14.connectForm((_temp$a = _class$a = class extends React__default.Component {
      constructor(props) {
          super(props), this.elmt = this.props.form.addElement(props), this.handleValueChange = this.handleValueChange.bind(this), this.handleSearchChangeText = this.handleSearchChangeText.bind(this), this.handleFocus = this.handleFocus.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleOpen = this.handleOpen.bind(this), this._autoLoadComplete = !1
      }
      handleFocus() {
          this.elmt.setFocus(!0), this.props.onFocus && this.props.onFocus(this.elmt)
      }
      handleBlur() {
          this.elmt.setBlur(!0), this.props.onBlur && this.props.onBlur(this.elmt)
      }
      handleOpen() {
          this.props.autoLoad && !this._autoLoadComplete && (this._autoLoadComplete = !0, this.loadItems({}))
      }
      loadItems(params) {
          var _this = this;
          return _asyncToGenerator((function*() {
              if (!_this.props.itemLoader) return !1;
              _this.elmt.setLoading(!0);
              var items = yield _this.props.itemLoader(params);
              _this.elmt.setLoading(!1), items && _this.elmt.setItems(items)
          }))()
      }
      handleSearchChangeText(text) {
          this.loadItems({
              search: text
          })
      }
      handleValueChange(vals, mode) {
          var {
              value: value,
              label: label
          } = vals;
          if (this.props.multiple) {
              var values = this.elmt.value || [];
              Array.isArray(values) || (values = [values]);
              var valueIndex = -1,
                  newValue = null;
              switch (mode) {
                  case "LABEL_VALUE":
                      for (var i in values)
                          if (value === values[i].value) {
                              valueIndex = i;
                              break
                          } newValue = {
                          label: label,
                          value: value
                      };
                      break;
                  default:
                      valueIndex = values.indexOf(value), newValue = value
              }
              switch (-1 === valueIndex ? values.push(newValue) : values.splice(valueIndex, 1), values.length ? this.elmt.setValue(values) : this.elmt.setValue(null), mode) {
                  case "LABEL_VALUE":
                      this.props.onValueChange && this.props.onValueChange(values.length ? newValue : null, this.elmt, this.elmt.form), this.elmt.form.triggerValueChange(values.length ? newValue : null, this.elmt);
                      break;
                  default:
                      this.props.onValueChange && this.props.onValueChange(values.length ? newValue : null, this.elmt, this.elmt.form), this.elmt.form.triggerValueChange(values.length ? newValue : null, this.elmt)
              }
          } else switch (mode) {
              case "LABEL_VALUE":
                  this.elmt.setValue({
                      value: value,
                      label: label
                  }), this.props.onValueChange && this.props.onValueChange({
                      label: label,
                      value: value
                  }, this.elmt, this.elmt.form), this.elmt.form.triggerValueChange({
                      label: label,
                      value: value
                  }, this.elmt);
                  break;
              default:
                  this.elmt.setValue(value), this.props.onValueChange && this.props.onValueChange(value, label, this.elmt, this.elmt.form), this.elmt.form.triggerValueChange(value, this.elmt)
          }
      }
      componentWillUnmount() {
          this.elmt.remove()
      }
      render() {
          var styles = this.styles(),
              variantStyles = this.variantStyles();
          return React__default.createElement(InputField, _extends({}, this.props, {
              element: this.elmt,
              InputComponent: React__default.createElement(SelectMenu, {
                  name: this.elmt.name,
                  label: this.props.label,
                  items: this.elmt.items,
                  ref: this.elmt.ref,
                  placeholder: this.elmt.isActive && this.props.placeholder ? this.props.placeholder : null,
                  useValuesOnly: !!this.props.useValuesOnly,
                  value: this.elmt.value,
                  initialValueLabels: this.props.initialValueLabels,
                  multiple: this.props.multiple,
                  searchable: this.props.searchable,
                  itemLoader: this.props.itemLoader,
                  onSearchChangeText: this.handleSearchChangeText,
                  onValueChange: this.handleValueChange,
                  onFocus: this.handleFocus,
                  onBlur: this.handleBlur,
                  onOpen: this.handleOpen,
                  disabled: this.elmt.disabled,
                  loading: this.elmt.loading,
                  autoFocus: this.props.autoFocus || null,
                  style: [styles.selectMenu, variantStyles.selectMenu],
                  valueLabelTextStyle: [styles.selectValueLabelTextStyle, this.props.valueLabelTextStyle],
                  iconColor: this.elmt.isFocused && Colors.primary
              })
          }))
      }
      variantStyles() {
          switch (this.props.variant) {
              case "outlined":
                  return StyleSheet.create({
                      selectMenu: {
                          minHeight: 52,
                          height: "auto",
                          paddingLeft: this.props.icon ? 43 : 1,
                          paddingRight: this.props.iconRight ? 43 : 1,
                          lineHeight: 30
                      }
                  });
              default:
                  return StyleSheet.create({
                      selectMenu: {
                          paddingTop: 20,
                          paddingBottom: 5,
                          height: 55,
                          lineHeight: 30
                      }
                  })
          }
      }
      styles() {
          return StyleSheet.create({
              selectMenu: {
                  margin: 0,
                  width: "100%"
              },
              selectValueLabelTextStyle: {
                  lineHeight: 30
              },
              selectMenuIcon: {}
          })
      }
  }, _defineProperty(_class$a, "propTypes", {
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      value: PropTypes.string,
      variant: PropTypes.oneOf(["outlined", "filled"]),
      disabled: PropTypes.bool,
      secure: PropTypes.bool,
      onValueChange: PropTypes.func,
      onPress: PropTypes.func,
      onFocus: PropTypes.func,
      onBlur: PropTypes.func,
      multiple: PropTypes.bool,
      searchable: PropTypes.bool,
      itemLoader: PropTypes.func,
      autoLoad: PropTypes.bool,
      icon: PropTypes.string,
      iconRight: PropTypes.string,
      style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      helperTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      labelTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      useValuesOnly: PropTypes.bool
  }), _defineProperty(_class$a, "defaultProps", {
      variant: "outlined",
      multiple: !1,
      useValuesOnly: !1
  }), _temp$a)),
  HiddenInputField = R14.connectForm((_temp$b = _class$b = class extends React__default.Component {
      constructor(props) {
          super(props), this.elmt = this.props.form.addElement(props)
      }
      componentWillUnmount() {
          this.elmt.remove()
      }
      render() {
          return null
      }
  }, _defineProperty(_class$b, "propTypes", {
      name: PropTypes.string.isRequired,
      value: PropTypes.any
  }), _temp$b));
class SwitchBase extends React__default.PureComponent {
  constructor(props) {
      super(props), this.ref = React__default.createRef(), this.handleValueChange = this.handleValueChange.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleChange = this.handleChange.bind(this)
  }
  componentDidMount() {
      this.props.autoFocus && this.autoFocus()
  }
  autoFocus() {
      setTimeout(() => {
          this.elmt.ref.current && this.ref.current.focus()
      }, 350)
  }
  handleValueChange(value) {
      this.props.onValueChange && this.props.onValueChange(value)
  }
  handleChange(event) {
      this.handleValueChange(event.target.checked)
  }
  toggleValue() {
      this.handleValueChange(!this.props.value)
  }
  handleKeyDown(e) {
      if (this.props.handleKeyDown && this.props.handleKeyDown(e), !e.nativeEvent || !e.nativeEvent.key) return !1;
      switch (e.nativeEvent.key) {
          case "Enter":
              this.toggleValue()
      }
  }
  render() {
      var styles = this.styles();
      return React__default.createElement(ViewBase, {
          style: styles.switch,
          tabIndex: 0,
          onFocus: this.props.onFocus || null,
          onBlur: this.props.onBlur || null,
          onKeyDown: this.handleKeyDown
      }, React__default.createElement(AnimatedView, {
          style: [styles.track, this.props.value && styles.trackOn],
          in: !!this.props.value,
          enter: {
              backgroundColor: StyleSheet.color(Colors.primary).rgba(.6)
          },
          exit: {
              backgroundColor: StyleSheet.color(Colors.onBackground).rgba(.5)
          },
          duration: 100
      }), React__default.createElement(AnimatedView, {
          style: [styles.handle, this.props.value && styles.handleOn],
          in: !!this.props.value,
          enter: {
              transform: [{
                  translateX: 20
              }],
              backgroundColor: Colors.primary
          },
          exit: {
              transform: [{
                  translateX: 0
              }],
              backgroundColor: "#EFEFEF"
          },
          duration: 100
      }), React__default.createElement("input", {
          tabIndex: -1,
          className: StyleSheet.className(styles.input),
          name: this.props.name,
          ref: this.ref,
          type: "checkbox",
          checked: !!this.props.value,
          onChange: this.handleChange
      }))
  }
  styles() {
      return StyleSheet.create({
          switch: {
              position: "relative",
              width: 32,
              height: 14,
              overflow: "visible"
          },
          input: {
              position: "absolute",
              left: -18,
              top: -17,
              width: 68,
              height: 48,
              margin: 0,
              opacity: 0,
              cursor: "pointer"
          },
          track: {
              position: "absolute",
              top: 0,
              left: 0,
              height: 14,
              width: 32,
              borderRadius: 7
          },
          handle: {
              position: "absolute",
              top: -3,
              left: -3,
              height: 20,
              width: 20,
              borderRadius: 10,
              backgroundColor: "#EFEFEF",
              elevation: 2
          }
      })
  }
}
var SwitchField = R14.connectForm((_temp$c = _class$c = class extends React__default.Component {
      constructor(props) {
          super(props), this.elmt = this.props.form.addElement(props), this.handleValueChange = this.handleValueChange.bind(this), this.handleFocus = this.handleFocus.bind(this), this.handleBlur = this.handleBlur.bind(this)
      }
      handleValueChange(value) {
          this.elmt.setValue(value), this.props.onValueChange && this.props.onValueChange(value, this.elmt)
      }
      handleFocus() {
          this.elmt.setFocus(!0), this.props.onFocus && this.props.onFocus(this.elmt)
      }
      handleBlur() {
          this.elmt.setBlur(!0), this.props.onBlur && this.props.onBlur(this.elmt)
      }
      componentWillUnmount() {
          this.elmt.remove()
      }
      render() {
          return React__default.createElement(InputField, {
              style: this.props.style,
              element: this.elmt,
              InputComponent: React__default.createElement(ViewBase, {
                  style: styles$x.switchFieldWrapper
              }, this.props.label && React__default.createElement(TextInput, {
                  style: styles$x.labelText
              }, this.props.label), React__default.createElement(SwitchBase, {
                  name: this.elmt.name,
                  ref: this.elmt.ref,
                  value: !!this.elmt.value,
                  onValueChange: this.handleValueChange,
                  onFocus: this.handleFocus,
                  onBlur: this.handleBlur,
                  autoFocus: this.props.autoFocus || null,
                  style: styles$x.switch
              }))
          })
      }
  }, _defineProperty(_class$c, "propTypes", {
      label: PropTypes.string,
      name: PropTypes.string.isRequired,
      value: PropTypes.bool,
      handleValueChange: PropTypes.func,
      disabled: PropTypes.bool
  }), _temp$c)),
  styles$x = StyleSheet.create({
      switchFieldWrapper: _extends({
          flex: 1,
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center"
      }, StyleSheet.padding(0, 12, 0, 12), {
          height: 52
      }),
      labelText: {
          lineHeight: 14,
          fontWeight: "500",
          paddingRight: 12,
          color: StyleSheet.color(Colors.onBackground).rgba(.8)
      }
  }),
  SubmitButton = R14.connectForm(class extends React__default.Component {
      constructor(props) {
          super(props), this.handlePress = this.handlePress.bind(this), this.backgroundColor = this.props.backgroundColor || this.props.form.activeColor
      }
      handlePress() {
          this.props.form.submit()
      }
      render() {
          return React__default.createElement(Button, _extends({
              tabIndex: 0,
              backgroundColor: this.backgroundColor
          }, this.props, {
              onPress: this.handlePress,
              type: "submit"
          }))
      }
  });
class BackButton extends React__default.PureComponent {
  constructor(props) {
      super(props), this.handlePress = this.handlePress.bind(this)
  }
  handlePress() {
      if (this.props.onPress && !1 === this.props.onPress()) return !1;
      R14.instance.app.nav.back()
  }
  render() {
      return React__default.createElement(Button, _extends({}, this.props, {
          onPress: this.handlePress
      }))
  }
}
_defineProperty(BackButton, "propTypes", {
  onPress: PropTypes.func
});
class Calendar extends React__default.PureComponent {
  constructor(props) {
      super(props), this._loadingIndicator = this.props.loadingIndicator, this._month = null, this._currMonth = new Date, this._startDay = null, this._endDay = null, this._onSelectDay = this.props.onSelectDay || null, this.handleNextMonthButtonClick = this.handleNextMonthButtonClick.bind(this), this.handlePreviousMonthButtonClick = this.handlePreviousMonthButtonClick.bind(this), this.initialize()
  }
  initialize() {
      this.initializeDays()
  }
  initializeDays() {
      var startDay = new Date(this.month);
      startDay.setHours(0, 0, 0, 0), startDay.setDate(1);
      var endDay = new Date(startDay);
      if (endDay.setHours(23, 59, 59, 999), endDay.setDate(endDay.getDate() + 41), startDay.getDay() > 0)
          for (var day = startDay.getDay(); day > 0; day--) startDay.setDate(startDay.getDate() - 1);
      this._startDay = startDay, this._endDay = endDay
  }
  get month() {
      return this.props.month
  }
  get startDay() {
      return this._startDay
  }
  get endDay() {
      return this._endDay
  }
  get loadingIndicator() {
      return this._loadingIndicator
  }
  handleNextMonthButtonClick() {
      this.calendar.loadNextMonth()
  }
  handlePreviousMonthButtonClick() {
      this.calendar.loadPreviousMonth()
  }
  handleSelectDay(date) {
      this._onSelectDay(date)
  }
  renderMonthHeader() {
      var monthLabel = R14.utils.date.getMonthLabel(this.month),
          label = "".concat(monthLabel, " ").concat(this.month.getFullYear());
      return React__default.createElement(ViewBase, {
          style: styles$y.monthLabel
      }, React__default.createElement(TextInput, {
          style: styles$y.monthLabelText
      }, label))
  }
  renderDaysHeader() {
      for (var ret = [], d = 0; d <= 6; d++) ret.push(React__default.createElement(ViewBase, {
          style: styles$y.cell,
          key: "".concat(this.keyPrefix, "}dh").concat(d)
      }, React__default.createElement(TextInput, {
          style: styles$y.dayHeaderText
      }, R14.utils.date.getDayLabel(d, R14.utils.date.LABEL_TYPE_SINGLE_LETTER))));
      return ret
  }
  dayRenderer(date) {
      var key = R14.utils.date.toShortDate(date);
      return this.dayContent && this.dayContent(key) ? this.dayContent(key) : null
  }
  renderDays() {
      for (var currDay = new Date(this.startDay), weeks = [], days = [], today = new Date; currDay <= this.endDay;) {
          var isDisabled = !1,
              d = currDay.getDay(),
              dayStyles = [styles$y.cell],
              dayTextStyles = [styles$y.cellText, styles$y.dayText],
              onSelectDay = this._onSelectDay ? this.handleSelectDay.bind(this, new Date(currDay)) : null;
          currDay.getMonth() < this.month.getMonth() ? dayTextStyles.push(styles$y.dayPreviousMonthText) : currDay.getMonth() > this.month.getMonth() && dayTextStyles.push(styles$y.dayNextMonthText), this.props.minDate && currDay < this.props.minDate && !R14.utils.date.areDatesSameDay(currDay, this.props.minDate) || this.props.maxDate && currDay > this.props.maxDate && !R14.utils.date.areDatesSameDay(currDay, this.props.maxDate) ? (dayTextStyles.push(styles$y.dayDisabledText), isDisabled = !0) : R14.utils.date.areDatesSameDay(currDay, today) ? (dayTextStyles.push(styles$y.dayTodayText), dayStyles.push(styles$y.dayToday)) : currDay < today && dayTextStyles.push(styles$y.dayPastText), this.props.day && R14.utils.date.areDatesSameDay(currDay, this.props.day) && (dayTextStyles.push(styles$y.daySelectedText), dayStyles.push(styles$y.daySelected)), console.log(isDisabled), days.push(React__default.createElement(TouchableBase, {
              key: "".concat(this.keyPrefix, "}d").concat(currDay.getDate()),
              onPress: isDisabled ? null : onSelectDay
          }, React__default.createElement(ViewBase, {
              style: dayStyles
          }, React__default.createElement(ViewBase, {
              style: styles$y.dayLabel
          }, React__default.createElement(TextInput, {
              style: dayTextStyles
          }, currDay.getDate())), React__default.createElement(ViewBase, {
              style: styles$y.dayContent
          }, React__default.createElement(TextInput, {
              style: styles$y.dayContentText
          }, this.dayRenderer(currDay)))))), 6 === d && (weeks.push(React__default.createElement(ViewBase, {
              style: styles$y.week,
              key: "".concat(this.keyPrefix, "}d").concat(weeks.length)
          }, days)), days = []), currDay.setDate(currDay.getDate() + 1)
      }
      return weeks
  }
  render() {
      this.props.month && this._month !== this.props.month && (this.initialize(), this._month = new Date(this.props.month));
      return this.props.style && ["calendar"].push(this.props.style), React__default.createElement(ViewBase, {
          style: styles$y.calendar
      }, React__default.createElement(ViewBase, {
          style: styles$y.header
      }, this.props.headerControlsLeft && React__default.createElement(ControlsView, {
          align: "left"
      }, this.props.headerControlsLeft), this.renderMonthHeader(), this.props.headerControlsRight && React__default.createElement(ControlsView, {
          align: "right"
      }, this.props.headerControlsRight)), React__default.createElement(ViewBase, {
          style: styles$y.dayHeader
      }, this.renderDaysHeader()), React__default.createElement(ViewBase, {
          style: styles$y.month
      }, React__default.createElement(ViewBase, {
          style: styles$y.days
      }, this.renderDays())))
  }
}
var styles$y = StyleSheet.create({
      calendar: {
          width: 280,
          flex: 0,
          paddingBottom: 16,
          backgroundColor: Colors.surface
      },
      header: {
          flex: 1,
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginLeft: 6,
          marginRight: 6,
          marginBottom: -12
      },
      dayHeader: {
          flex: 0,
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center"
      },
      dayHeaderText: {
          opacity: .6,
          color: Colors.onSurface
      },
      week: {
          flex: 0,
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center"
      },
      cell: {
          borderRadius: 20,
          height: 40,
          width: 40,
          flex: 0,
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center"
      },
      cellText: {
          lineHeight: 20,
          color: Colors.onSurface
      },
      dayToday: {
          backgroundColor: StyleSheet.color(Colors.onSurface).rgba(.1)
      },
      dayText: {},
      dayDisabledText: {
          opacity: .2
      },
      dayPreviousMonthText: {
          opacity: .3
      },
      dayNextMonthText: {
          opacity: .3
      },
      monthLabel: {
          height: 64
      },
      monthLabelText: {
          fontWeight: "500",
          lineHeight: 64,
          color: Colors.onSurface
      },
      daySelected: {
          backgroundColor: Colors.secondary
      },
      daySelectedText: {
          color: Colors.onSecondary
      }
  }),
  Chart = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props), this.chart = this.props.app.ui.chart.create(this.props)
      }
      componentDidMount() {
          this.initChart()
      }
      componentDidUpdate(prevProps) {
          this.initChart()
      }
      componentWillUnmount() {
          this.chart.remove()
      }
      initChart() {
          var _this = this;
          return _asyncToGenerator((function*() {
              _this.chart.initialize(_this.props.data)
          }))()
      }
      render() {
          return React__default.createElement("div", {
              id: this.chart.domElementId,
              style: {
                  width: "100%",
                  height: "300px"
              }
          })
      }
  });
class Chart$1 extends React__default.Component {
  render() {
      return React__default.createElement(ViewBase, {
          style: this.props.style
      }, React__default.createElement(Chart, this.props))
  }
}
_defineProperty(Chart$1, "propTypes", {
  name: PropTypes.string.isRequired
});
var DatePicker = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props), this.itemIndex = 0, this.handleSelectDay = this.handleSelectDay.bind(this), this.handlePreviousMonthButtonPress = this.handlePreviousMonthButtonPress.bind(this), this.handleNextMonthButtonPress = this.handleNextMonthButtonPress.bind(this), this.state = {
              month: this.props.date ? new Date(this.props.date) : new Date
          }
      }
      get hasNext() {
          if (!this.props.maxDate) return !0;
          var nextDate = new Date(this.state.month);
          nextDate.setMonth(nextDate.getMonth() + 1);
          var maxDate = new Date(this.props.maxDate);
          return maxDate.setMonth(maxDate.getMonth() + 1), this.props.app.utils.date.isMonthLessThan(nextDate, maxDate)
      }
      get hasPrevious() {
          if (!this.props.minDate) return !0;
          var prevDate = new Date(this.state.month);
          prevDate.setMonth(prevDate.getMonth() - 1);
          var minDate = new Date(this.props.minDate);
          return minDate.setMonth(minDate.getMonth() - 1), this.props.app.utils.date.isMonthLessThan(minDate, prevDate)
      }
      handleSelectDay(date) {
          this.props.onDateChange && this.props.onDateChange(date)
      }
      handlePreviousMonthButtonPress() {
          if (!this.hasPrevious) return !1;
          var month = this.state.month;
          month.setMonth(month.getMonth() - 1), this.setState({
              month: month
          })
      }
      handleNextMonthButtonPress() {
          if (!this.hasNext) return !1;
          var month = this.state.month;
          month.setMonth(month.getMonth() + 1), this.setState({
              month: month
          })
      }
      render() {
          var nextMonthIcon = this.props.nextMonthIcon || "keyboardArrowRight",
              previousMonthIcon = this.props.previousMonthIcon || "keyboardArrowLeft",
              month = this.state.month;
          return React__default.createElement(ViewBase, {
              style: styles$z.datePicker
          }, React__default.createElement(Calendar, _extends({}, this.props, {
              day: this.props.date,
              month: month,
              onSelectDay: this.handleSelectDay,
              minDate: this.props.minDate,
              maxDate: this.props.maxDate,
              headerControlsLeft: React__default.createElement(AnimatedView, {
                  style: styles$z.monthPreviousButton,
                  in: this.hasPrevious,
                  enter: {
                      opacity: 1
                  },
                  exit: {
                      opacity: .2
                  },
                  duration: 100
              }, React__default.createElement(IconButton, {
                  onPress: this.handlePreviousMonthButtonPress,
                  icon: previousMonthIcon
              })),
              headerControlsRight: React__default.createElement(AnimatedView, {
                  style: styles$z.monthNextButton,
                  in: this.hasNext,
                  enter: {
                      opacity: 1
                  },
                  exit: {
                      opacity: .2
                  },
                  duration: 100
              }, React__default.createElement(IconButton, {
                  onPress: this.handleNextMonthButtonPress,
                  icon: nextMonthIcon
              }))
          })))
      }
  }),
  styles$z = StyleSheet.create({
      datePicker: {
          position: "relative",
          flex: 0
      },
      monthNextButton: {},
      monthPreviousButton: {}
  });
class DatePickerModal extends React__default.PureComponent {
  constructor(props) {
      super(props), this.handleCancelPress = this.handleCancelPress.bind(this), this.handleConfirmPress = this.handleConfirmPress.bind(this), this.handleDateChange = this.handleDateChange.bind(this), this.state = {
          selectedDate: this.props.date || null
      }
  }
  handleCancelPress() {
      this.props.onCancelPress && this.props.onCancelPress()
  }
  handleConfirmPress() {
      this.props.onConfirmPress && this.props.onConfirmPress(this.state.selectedDate)
  }
  handleDateChange(date) {
      this.props.onDateChange && !1 === this.props.onDateChange(date) || this.setState({
          selectedDate: date
      })
  }
  componentDidUpdate(prevProps) {
      if (this.props.date !== prevProps.date) {
          var date = null;
          this.props.date && (date = "string" == typeof this.props.date ? new Date(this.props.date) : this.props.date), date !== this.state.selectedDate && this.setState({
              selectedDate: date
          })
      }
  }
  render() {
      var date = this.state.selectedDate || new Date,
          dayLabel = R14.utils.date.getDayLabel(date, R14.utils.date.LABEL_TYPE_SHORT),
          monthLabel = R14.utils.date.getMonthLabel(date, R14.utils.date.LABEL_TYPE_SHORT);
      return React__default.createElement(Modal$1, {
          animationType: "fade",
          backdropStyle: styles$A.backdrop,
          onBackdropPress: this.handleCancelPress,
          transparent: !0,
          visible: this.props.visible,
          style: styles$A.datePickerModal,
          onRequestClose: () => {},
          unmountOnExit: !0,
          backdrop: !0,
          scrollEnabled: !0
      }, React__default.createElement(ViewBase, {
          style: styles$A.datePicker
      }, React__default.createElement(ViewBase, {
          style: styles$A.header
      }, React__default.createElement(ViewBase, null, React__default.createElement(TextInput, {
          style: styles$A.headerTextYear
      }, date.getFullYear())), React__default.createElement(ViewBase, null, React__default.createElement(TextInput, {
          style: styles$A.headerTextDate
      }, dayLabel, ", ", monthLabel, " ", date.getDate()))), React__default.createElement(DatePicker, _extends({}, this.props, {
          date: this.state.selectedDate,
          onDateChange: this.handleDateChange
      })), React__default.createElement(ViewBase, {
          style: styles$A.buttons
      }, React__default.createElement(Button, {
          title: "cancel",
          variant: "text",
          onPress: this.handleCancelPress
      }), React__default.createElement(Button, {
          title: "ok",
          variant: "text",
          onPress: this.handleConfirmPress
      }))))
  }
}
var _class$d, _temp$d, styles$A = StyleSheet.create({
      datePicker: {
          position: "relative",
          borderRadius: 4,
          backgroundColor: Colors.surface,
          paddingBottom: 16,
          elevation: 8,
          marginBottom: 80,
          marginTop: 80,
          width: 280,
          zIndex: 2
      },
      backdrop: {
          backgroundColor: StyleSheet.color(Colors.background).rgba(.5)
      },
      header: {
          backgroundColor: Colors.primary,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          padding: 16
      },
      headerTextYear: {
          color: Colors.onSurface,
          fontSize: 18,
          opacity: .6
      },
      headerTextDate: {
          color: Colors.onSurface,
          fontSize: 36,
          fontWeight: "300",
          lineHeight: 40
      },
      buttons: {
          flex: 0,
          flexDirection: "row",
          justifyContent: "flex-end",
          paddingRight: 8
      }
  }),
  DatePickerField = R14.connectForm((_temp$d = _class$d = class extends React__default.Component {
      constructor(props) {
          super(props), this.handleFocus = this.handleFocus.bind(this), this.handleChangeText = this.handleChangeText.bind(this), this.handleCancelPress = this.handleCancelPress.bind(this), this.handleConfirmPress = this.handleConfirmPress.bind(this), this.handleIconButtonPress = this.handleIconButtonPress.bind(this), this.handleClearPress = this.handleClearPress.bind(this), this.valueParser = this.valueParser.bind(this), this.ref = React__default.createRef(), this.state = {
              datePickerVisible: !1,
              date: null,
              showClear: !1
          }
      }
      handleFocus() {
          this.show()
      }
      handleChangeText(text) {
          var showClear = this.state.showClear,
              date = this.state.date;
          if (this.props.textInputEditable) {
              var newDate = this.props.app.utils.date.isShortDate(text) ? text : null;
              date !== newDate && (date = newDate)
          } else this.props.form.elmts[this.props.name].value = date ? this.props.app.utils.date.toShortDate(date) : "";
          text && (showClear = !0), this.state.date === date && this.state.showClear === showClear || this.setState({
              date: date,
              showClear: showClear
          })
      }
      handleIconButtonPress() {
          this.show()
      }
      handleClearPress() {
          this.props.form.elmts[this.props.name].value = null, this.props.onValueChange && this.props.onValueChange(null, this.elmt), this.props.form.triggerValueChange(null, this.props.form.elmts[this.props.name]), this.setState({
              date: null,
              showClear: !1
          })
      }
      show() {
          var newState = {
              datePickerVisible: !0
          };
          !this.state.date && this.props.form.elmts[this.props.name].value && (newState.date = this.props.form.elmts[this.props.name].value), this.ref.current && this.props.form.elmts[this.props.name].blur(), this.setState(newState)
      }
      handleCancelPress() {
          this.setState({
              datePickerVisible: !1
          })
      }
      handleConfirmPress(date) {
          var currDate = this.props.form.elmts[this.props.name].value;
          date && (this.props.form.elmts[this.props.name].value = this.props.app.utils.date.toShortDate(date)), currDate !== this.props.form.elmts[this.props.name].value && (this.props.onValueChange && this.props.onValueChange(date, this.elmt), this.props.form.triggerValueChange(date, this.props.form.elmts[this.props.name])), this.setState({
              datePickerVisible: !1,
              date: date,
              showClear: !0
          })
      }
      valueParser(value) {
          return value && this.props.app.utils.date.isShortDate(value) ? new Date(value) : null
      }
      render() {
          var textInputFieldProps = {
              onChangeText: this.handleChangeText
          };
          if (this.props.textInputEditable && !this.props.icon) throw new Error("Must provide an icon if using model open mode iconButtonPress");
          return this.props.icon && (textInputFieldProps.onIconPress = this.handleIconButtonPress), this.props.textInputEditable || (textInputFieldProps.onFocus = this.handleFocus), this.state.showClear && (textInputFieldProps.iconRight = "close", textInputFieldProps.onIconRightPress = this.handleClearPress), React__default.createElement(React__default.Fragment, null, React__default.createElement(TextInputField, _extends({}, this.props, textInputFieldProps, {
              autoComplete: !1,
              ref: this.ref,
              validator: "shortDate"
          })), React__default.createElement(DatePickerModal, {
              visible: this.state.datePickerVisible,
              date: this.state.date,
              minDate: this.props.minDate,
              maxDate: this.props.maxDate,
              onCancelPress: this.handleCancelPress,
              onConfirmPress: this.handleConfirmPress
          }))
      }
  }, _defineProperty(_class$d, "propTypes", {
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      value: PropTypes.string,
      variant: PropTypes.oneOf(["outlined", "filled"]),
      mode: PropTypes.oneOf(["dropdown", "modal"]),
      textInputEditable: PropTypes.bool,
      disabled: PropTypes.bool,
      onValueChange: PropTypes.func,
      onPress: PropTypes.func,
      onFocus: PropTypes.func,
      onBlur: PropTypes.func,
      icon: PropTypes.string,
      iconRight: PropTypes.string,
      minDate: PropTypes.instanceOf(Date),
      maxDate: PropTypes.instanceOf(Date),
      style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      helperTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      labelTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
  }), _defineProperty(_class$d, "defaultProps", {
      variant: "outlined",
      mode: "modal",
      textInputEditable: !1,
      icon: "calendar"
  }), _temp$d));
class TimePicker extends React__default.PureComponent {
  constructor(props) {
      super(props), this.dateUtils = R14.utils.date, this.shouldAnimateIndicator = !1, this.indicatorAngle = null, this.mode = this.props.mode, this.handleLabelPress = this.handleLabelPress.bind(this)
  }
  handleLabelPress(val) {
      if (this.props.time) {
          var timeInfo = this.timeInfo;
          timeInfo[this.props.mode] = val, this.props.onTimeChange && this.props.onTimeChange(this.dateUtils.toTime(timeInfo))
      }
  }
  get value() {
      return this.props.value || ("hour" === this.props.mode ? 12 : "00")
  }
  get size() {
      return this.props.size || 248
  }
  get radius() {
      return this.size / 2
  }
  get time() {
      return this.props.time || "12:00 AM"
  }
  get timeInfo() {
      return this.dateUtils.parseTime(this.time)
  }
  getValueByIdx(idx) {
      var val = null;
      return "hour" === this.props.mode ? (val = idx + 6) > 12 && (val -= 12) : "minute" === this.props.mode && ((val = 5 * idx - 30) < 0 && (val += 60), val < 10 && (val = "0".concat(val))), "".concat(val)
  }
  getIndicatorAngleByValue(val) {
      var ret = val;
      return "hour" === this.props.mode && (12 === val && (ret = 0), ret *= 30), "minute" === this.props.mode && (ret *= 6), ret
  }
  createDynamicStyles() {
      for (var dynamicStyles = {
              timePicker: {
                  position: "relative",
                  height: this.size,
                  width: this.size
              }
          }, radius = this.radius - 18, width = radius, i = 1; i <= 12; i++) {
          var angle = i / 6 * Math.PI,
              x = radius * Math.cos(angle) + width,
              y = radius * Math.sin(angle) + width;
          dynamicStyles["label".concat(i)] = {
              position: "absolute",
              top: x,
              right: y
          }
      }
      return dynamicStyles.selectionIndicator = {
          position: "absolute",
          top: 0,
          right: this.radius - 18,
          flex: 1,
          flexDirection: "column",
          alignItems: "center",
          height: this.size,
          width: 36
      }, dynamicStyles.selectionIndicatorLine = {
          height: this.radius - 36 - 8,
          width: 3,
          backgroundColor: Colors.secondary
      }, dynamicStyles.selectionIndicatorCircle = {
          flexGrow: 0,
          flexShrink: 0,
          height: 36,
          width: 36,
          borderRadius: 18,
          backgroundColor: Colors.secondary
      }, dynamicStyles.selectionIndicatorCenter = {
          flexGrow: 0,
          flexShrink: 0,
          height: 8,
          width: 8,
          borderRadius: 4,
          backgroundColor: Colors.secondary
      }, StyleSheet.create(dynamicStyles)
  }
  getLabelArr() {
      return ["7", "8", "9", "10", "11", "12", "1", "2", "3", "4", "5", "6"]
  }
  getIdxByValue(val) {
      return this.getLabelArr().indexOf(val) + 1
  }
  renderFace(dynamicStyles) {
      var _this = this,
          ret = [],
          timeInfo = this.timeInfo,
          val = "hour" === this.props.mode ? timeInfo.hour : timeInfo.minute,
          indicatorAngle = this.getIndicatorAngleByValue(val),
          fromIndicatorAngle = indicatorAngle;
      this.props.mode !== this.mode && (fromIndicatorAngle = this.indicatorAngle), this.mode = this.props.mode, this.indicatorAngle = indicatorAngle, ret.push(React__default.createElement(AnimatedView, {
          to: {
              transform: [{
                  rotate: "".concat(this.indicatorAngle, "deg")
              }]
          },
          from: {
              transform: [{
                  rotate: "".concat(fromIndicatorAngle, "deg")
              }]
          },
          duration: 200,
          key: "selectionIndicator",
          style: dynamicStyles.selectionIndicator
      }, React__default.createElement(ViewBase, {
          style: dynamicStyles.selectionIndicatorCircle
      }), React__default.createElement(ViewBase, {
          style: dynamicStyles.selectionIndicatorLine
      }), React__default.createElement(ViewBase, {
          style: dynamicStyles.selectionIndicatorCenter
      })));
      for (var _loop = function(i) {
              var val = _this.getValueByIdx(i);
              ret.push(React__default.createElement(TouchableBase, {
                  key: "label".concat(i),
                  onPress: () => {
                      _this.handleLabelPress(val)
                  },
                  style: [dynamicStyles["label".concat(i)], styles$B.label]
              }, React__default.createElement(TextInput, {
                  style: [styles$B.labelText]
              }, val)))
          }, i = 1; i <= 12; i++) _loop(i);
      return ret
  }
  render() {
      var dynamicStyles = this.createDynamicStyles();
      return React__default.createElement(ViewBase, {
          style: [dynamicStyles.timePicker]
      }, this.renderFace(dynamicStyles))
  }
}
var styles$B = StyleSheet.create({
  label: {
      height: 36,
      width: 36,
      borderRadius: 18,
      flex: 0,
      justifyContent: "space-between",
      alignItems: "center"
  },
  labelText: {
      width: 36,
      height: 36,
      lineHeight: 36,
      fontWeight: 500,
      textAlign: "center"
  }
});
class TimePickerModal extends React__default.PureComponent {
  constructor(props) {
      super(props), this.handleCancelPress = this.handleCancelPress.bind(this), this.handleConfirmPress = this.handleConfirmPress.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.handleTimePress = this.handleTimePress.bind(this), this.handlePeriodPress = this.handlePeriodPress.bind(this), this.dateUtils = R14.utils.date, this.state = {
          selectedTime: this.props.time || "12:00 AM",
          pickerMode: "hour"
      }
  }
  get time() {
      return this.state.selectedTime || "12:00 AM"
  }
  get timeInfo() {
      return this.dateUtils.parseTime(this.time)
  }
  handleCancelPress() {
      this.props.onCancelPress && this.props.onCancelPress()
  }
  handleConfirmPress() {
      this.props.onConfirmPress && this.props.onConfirmPress(this.state.selectedTime)
  }
  handleTimeChange(time) {
      var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if (!this.props.onTimeChange || !1 !== this.props.onTimeChange(time)) {
          var nState = {
              selectedTime: time
          };
          "hour" !== this.state.pickerMode || options.disablePickerModeChange || (nState.pickerMode = "minute"), this.setState(nState)
      }
  }
  handleTimePress(pickerMode) {
      this.setState({
          pickerMode: pickerMode
      })
  }
  handlePeriodPress(period) {
      var timeInfo = this.timeInfo;
      timeInfo.period = period, this.handleTimeChange(this.dateUtils.toTime(timeInfo), {
          disablePickerModeChange: !0
      })
  }
  componentDidUpdate(prevProps) {
      var nState = {};
      if (this.props.visible && !prevProps.visible && (nState.pickerMode = "hour"), !prevProps.time && this.props.time) {
          var time = this.props.time;
          nState.selectedTime = time
      }
      Object.keys(nState).length && this.setState(nState)
  }
  render() {
      var timeInfo = this.timeInfo;
      return React__default.createElement(Modal$1, {
          animationType: "fade",
          backdropStyle: styles$C.backdrop,
          onBackdropPress: this.handleCancelPress,
          transparent: !0,
          visible: this.props.visible,
          style: styles$C.timePickerModal,
          onRequestClose: () => {},
          unmountOnExit: !0,
          backdrop: !0,
          scrollEnabled: !0
      }, React__default.createElement(ViewBase, {
          style: styles$C.container
      }, React__default.createElement(ViewBase, {
          style: styles$C.header
      }, React__default.createElement(ViewBase, {
          style: styles$C.headerTime
      }, React__default.createElement(TouchableBase, {
          onPress: () => this.handleTimePress("hour"),
          style: styles$C.headerMinuteTouchable
      }, React__default.createElement(TextInput, {
          style: [styles$C.headerMinuteHourText, "hour" === this.state.pickerMode && styles$C.headerActiveText]
      }, timeInfo.hour)), React__default.createElement(TextInput, {
          style: styles$C.headerMinuteHourText
      }, ":"), React__default.createElement(TouchableBase, {
          onPress: () => this.handleTimePress("minute"),
          style: styles$C.headerHourTouchable
      }, React__default.createElement(TextInput, {
          style: [styles$C.headerMinuteHourText, "minute" === this.state.pickerMode && styles$C.headerActiveText]
      }, timeInfo.minute)), React__default.createElement(ViewBase, {
          style: styles$C.headerPeriod
      }, React__default.createElement(TouchableBase, {
          onPress: () => this.handlePeriodPress("AM"),
          style: styles$C.headerPeriodTouchable
      }, React__default.createElement(TextInput, {
          style: [styles$C.headerPeriodText, "AM" === timeInfo.period && styles$C.headerActiveText]
      }, "AM")), React__default.createElement(TouchableBase, {
          onPress: () => this.handlePeriodPress("PM"),
          style: styles$C.headerPeriodTouchable
      }, React__default.createElement(TextInput, {
          style: [styles$C.headerPeriodText, "PM" === timeInfo.period && styles$C.headerActiveText]
      }, "PM"))))), React__default.createElement(ViewBase, {
          style: styles$C.timePicker
      }, React__default.createElement(TimePicker, _extends({}, this.props, {
          time: this.state.selectedTime,
          onTimeChange: this.handleTimeChange,
          mode: this.state.pickerMode,
          size: 248
      }))), React__default.createElement(ViewBase, {
          style: styles$C.buttons
      }, React__default.createElement(Button, {
          title: "cancel",
          variant: "text",
          onPress: this.handleCancelPress
      }), React__default.createElement(Button, {
          title: "ok",
          variant: "text",
          onPress: this.handleConfirmPress
      }))))
  }
}
_defineProperty(TimePickerModal, "propTypes", {
  time: PropTypes.string,
  visible: PropTypes.bool,
  onTimeChange: PropTypes.func,
  onConfirmPress: PropTypes.func,
  onCancelPress: PropTypes.func
}), _defineProperty(TimePickerModal, "defaultProps", {
  time: "12:00 AM"
});
var _class$e, _temp$e, _class$f, _temp$f, _class$g, _temp$g, styles$C = StyleSheet.create({
      container: {
          position: "relative",
          borderRadius: 4,
          backgroundColor: Colors.surface,
          paddingBottom: 16,
          elevation: 8,
          marginBottom: 80,
          marginTop: 80,
          width: 280,
          zIndex: 2
      },
      backdrop: {
          backgroundColor: StyleSheet.color(Colors.background).rgba(.5)
      },
      header: {
          flex: 1,
          flexDirection: "row",
          justifyContent: "flex-end",
          backgroundColor: Colors.primary,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          padding: 16
      },
      headerTime: {
          flex: 1,
          flexDirection: "row",
          marginLeft: "auto",
          alignItems: "center"
      },
      headerMinuteHourText: {
          fontSize: 52,
          color: StyleSheet.color(Colors.onPrimary).rgba(.5)
      },
      headerHourTouchable: {
          marginRight: 4
      },
      headerPeriod: {
          marginRight: 8
      },
      headerPeriodTouchable: _extends({
          height: 24
      }, StyleSheet.padding(4), {
          flex: 0,
          flexDirection: "column",
          alignItems: "center"
      }),
      headerPeriodText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 16,
          color: StyleSheet.color(Colors.onPrimary).rgba(.5)
      },
      headerActiveText: {
          color: Colors.onPrimary
      },
      timePicker: _extends({}, StyleSheet.padding(16)),
      buttons: {
          flex: 0,
          flexDirection: "row",
          justifyContent: "flex-end",
          paddingRight: 8
      }
  }),
  TimePickerField = R14.connectForm((_temp$e = _class$e = class extends React__default.Component {
      constructor(props) {
          super(props), this.handleFocus = this.handleFocus.bind(this), this.handleCancelPress = this.handleCancelPress.bind(this), this.handleConfirmPress = this.handleConfirmPress.bind(this), this.ref = React__default.createRef(), this.state = {
              timePickerVisible: !1,
              time: null
          }
      }
      handleFocus() {
          var newState = {
              timePickerVisible: !0
          };
          !this.state.time && this.props.form.elmts[this.props.name].value && (newState.time = this.props.form.elmts[this.props.name].value), this.setState(newState)
      }
      handleCancelPress() {
          this.setState({
              timePickerVisible: !1
          })
      }
      handleConfirmPress(time) {
          time && (this.props.form.elmts[this.props.name].value = time), this.setState({
              timePickerVisible: !1,
              time: time
          })
      }
      render() {
          return React__default.createElement(React__default.Fragment, null, React__default.createElement(TextInputField, _extends({}, this.props, {
              autoComplete: !1,
              ref: this.ref,
              onFocus: this.handleFocus,
              validator: "time"
          })), React__default.createElement(TimePickerModal, {
              visible: this.state.timePickerVisible,
              time: this.state.time,
              onCancelPress: this.handleCancelPress,
              onConfirmPress: this.handleConfirmPress
          }))
      }
  }, _defineProperty(_class$e, "propTypes", {
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      value: PropTypes.string,
      variant: PropTypes.oneOf(["outlined", "filled"]),
      mode: PropTypes.oneOf(["dropdown", "modal"]),
      disabled: PropTypes.bool,
      onValueChange: PropTypes.func,
      onPress: PropTypes.func,
      onFocus: PropTypes.func,
      onBlur: PropTypes.func,
      icon: PropTypes.string,
      iconRight: PropTypes.string
  }), _defineProperty(_class$e, "defaultProps", {
      variant: "outlined",
      mode: "modal",
      icon: "clock"
  }), _temp$e)),
  ColorInputField = R14.connectForm((_temp$f = _class$f = class extends React__default.Component {
      constructor(props) {
          super(props), this.elmt = this.props.form.addElement(props), this.handleValueChange = this.handleValueChange.bind(this), this.handleFocus = this.handleFocus.bind(this), this.handleBlur = this.handleBlur.bind(this), this.state = {
              color: null
          }
      }
      handleValueChange(value) {
          this.elmt.setValue(value), this.props.onValueChange && this.props.onValueChange(value, this.elmt)
      }
      handleFocus() {
          this.elmt.setFocus(!0), this.props.onFocus && this.props.onFocus(this.elmt)
      }
      handleBlur() {
          this.elmt.setBlur(!0), this.props.onBlur && this.props.onBlur(this.elmt)
      }
      calculateControlColor() {
          var value = this.elmt.value;
          return value && this.isHexColor(value) ? value : "transparent"
      }
      isHexColor(hex) {
          return !!/^#([A-Fa-f0-9]{3}$)|([A-Fa-f0-9]{6}$)/.test(hex)
      }
      componentWillUnmount() {
          this.elmt.remove()
      }
      renderControls() {
          var style = StyleSheet.create({
              colorControl: {
                  backgroundColor: this.calculateControlColor(),
                  height: 24,
                  width: 24,
                  borderStyle: "solid",
                  borderWidth: 1,
                  borderColor: StyleSheet.color(Colors.onBackground).rgba(.1),
                  borderRadius: 2
              }
          });
          return React__default.createElement(ViewBase, {
              style: style.colorControl
          })
      }
      render() {
          var styles = this.styles(),
              variantStyles = this.variantStyles(),
              type = "text";
          return this.props.secure && (type = "password"), React__default.createElement(InputField, _extends({}, this.props, {
              element: this.elmt,
              controlsLeft: this.renderControls(),
              InputComponent: React__default.createElement(TextInput$2, {
                  type: type,
                  name: this.elmt.name,
                  ref: this.elmt.ref,
                  placeholder: this.elmt.isActive && this.props.placeholder ? this.props.placeholder : null,
                  value: null !== this.elmt.value ? "".concat(this.elmt.value) : "",
                  onChangeText: this.handleValueChange,
                  onFocus: this.handleFocus,
                  onBlur: this.handleBlur,
                  autoFocus: this.props.autoFocus || null,
                  style: [styles.textInput, variantStyles.textInput, this.props.style],
                  secureTextEntry: this.props.secure || !1,
                  autoComplete: this.props.autoComplete,
                  multiline: this.props.multiline || !1,
                  autoSize: this.props.autoSize || !1,
                  onAutoFill: this.handleAutoFill
              })
          }))
      }
      variantStyles() {
          switch (this.props.variant) {
              case "outlined":
                  return StyleSheet.create({
                      textInput: {
                          paddingTop: 16,
                          paddingBottom: 16,
                          paddingLeft: 44 - (this.elmt.isFocused ? 1 : 0),
                          paddingRight: (this.props.iconRight ? 44 : 12) - (this.elmt.isFocused ? 1 : 0),
                          lineHeight: 22,
                          height: this.elmt.isFocused ? 52 : 54
                      }
                  });
              default:
                  return StyleSheet.create({
                      textInput: {
                          paddingTop: 20,
                          paddingBottom: 5,
                          minHeight: 55,
                          lineHeight: 30
                      }
                  })
          }
      }
      styles() {
          return StyleSheet.create({
              textInput: {
                  margin: 0,
                  paddingLeft: 44,
                  paddingRight: this.props.iconRight ? 44 : 12,
                  width: "100%",
                  backgroundColor: "transparent",
                  color: Colors.onBackground,
                  fontSize: 16
              }
          })
      }
  }, _defineProperty(_class$f, "propTypes", {
      label: PropTypes.string,
      value: PropTypes.string,
      variant: PropTypes.oneOf(["outlined", "filled"]),
      disabled: PropTypes.bool,
      secure: PropTypes.bool,
      onValueChange: PropTypes.func,
      onPress: PropTypes.func,
      onFocus: PropTypes.func,
      onBlur: PropTypes.func,
      iconRight: PropTypes.string
  }), _defineProperty(_class$f, "defaultProps", {
      variant: "outlined",
      autoSize: !1
  }), _temp$f));
class Redirect extends React__default.PureComponent {
  componentDidMount() {
      R14.instance.app.nav.to(this.props.to, this.props.params || {})
  }
  render() {
      return null
  }
}
class AsyncSessionStorage extends AsyncStorageBase {}
class FloatingActionButton extends React__default.PureComponent {
  constructor(props) {
      super(props)
  }
  render() {
      var styles = this.styles(),
          Component = this.props.animate ? FadeView : Surface,
          props = this.props.animate ? {
              visible: !0 === this.props.visible,
              animateOnMount: !0,
              duration: 200
          } : {
              elevation: 8
          };
      return React__default.createElement(Component, _extends({
          style: [styles.floatingActionButton, this.props.style]
      }, props), React__default.createElement(IconButton, {
          icon: this.props.icon,
          to: this.props.to,
          onPress: this.props.onPress,
          style: styles.iconButton,
          color: this.props.iconColor || Colors.onSecondary
      }))
  }
  styles() {
      return StyleSheet.create({
          floatingActionButton: {
              position: "absolute",
              bottom: 16,
              right: 16,
              zIndex: 4,
              height: 56,
              width: 56,
              padding: 0,
              borderRadius: 28,
              backgroundColor: this.props.color || Colors.secondary,
              elevation: 8
          },
          iconButton: _extends({
              height: 56,
              width: 56,
              padding: 16,
              borderRadius: 28,
              overflow: "hidden"
          }, StyleSheet.margin(0))
      })
  }
}
var ScreenHeader = R14.connect((_temp$g = _class$g = class extends React__default.Component {
      render() {
          return React__default.createElement(Surface, {
              style: [styles$D.screenHeader, this.props.style],
              elevation: this.props.elevation || 4
          }, this.props.RowTopComponent ? this.props.RowTopComponent : null, (this.props.controlsLeft || this.props.TitleComponent || this.props.title || this.props.controlsRight) && React__default.createElement(ViewBase, {
              style: [styles$D.content, this.props.contentStyle]
          }, this.props.controlsLeft && React__default.createElement(ControlsView, {
              style: styles$D.controlsLeft,
              align: "left"
          }, this.props.controlsLeft), this.props.TitleComponent ? this.props.TitleComponent : null, !this.props.TitleComponent && React__default.createElement(SectionHeader, {
              style: styles$D.title,
              level: 1
          }, this.props.title), this.props.controlsRight && React__default.createElement(ControlsView, {
              style: styles$D.controlsRight,
              align: "right"
          }, this.props.controlsRight)))
      }
  }, _defineProperty(_class$g, "propTypes", {
      title: PropTypes.string,
      consolsLeft: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
      controlsRight: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
      RowTopComponent: PropTypes.node,
      elevation: PropTypes.number,
      style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      contentStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
  }), _temp$g)),
  styles$D = StyleSheet.create({
      screenHeader: _extends({
          marginBottom: 16
      }, StyleSheet.padding(0)),
      content: _extends({
          flex: 1,
          flexDirection: "row",
          alignItems: "center"
      }, StyleSheet.padding(16)),
      controlsRight: {
          marginLeft: "auto"
      },
      title: {
          fontSize: 20,
          paddingBottom: 0,
          lineHeight: 36
      }
  });
class ScreenLayout extends React__default.PureComponent {
  render() {
      var component = React__default.createElement(ViewBase, _extends({}, this.props, {
          style: [styles$E.screenLayout, this.props.style]
      }), (this.props.headerTitle || this.props.HeaderTitleComponent || this.props.HeaderRowTopComponent || this.props.headerTitle || this.props.headerControlsLeft || this.props.headerControlsRight) && React__default.createElement(ViewBase, {
          style: styles$E.header
      }, React__default.createElement(ScreenHeader, {
          style: this.props.headerStyle,
          contentStyle: this.props.headerContentStyle,
          title: this.props.headerTitle,
          TitleComponent: this.props.HeaderTitleComponent,
          controlsLeft: this.props.headerControlsLeft,
          controlsRight: this.props.headerControlsRight,
          RowTopComponent: this.props.HeaderRowTopComponent
      })), React__default.createElement(ViewBase, {
          style: styles$E.content
      }, this.props.children));
      return this.props.scrollEnabled && (component = React__default.createElement(ScrollViewBase, {
          overflow: this.props.scrollOverflow || null
      }, component)), this.props.floatingActionButton && (component = React__default.createElement(React__default.Fragment, null, React__default.createElement(FloatingActionButton, this.props.floatingActionButton), component)), component
  }
}
var styles$E = StyleSheet.create({
  header: {
      flex: 0,
      backgroundColor: Colors.background,
      color: Colors.onBackground
  },
  content: {
      flex: 1,
      position: "relative"
  },
  screenLayout: {
      flex: 1
  }
});
class FlatListBase extends React__default.PureComponent {
  constructor(props) {
      if (super(props), this._scrollViewRef = React__default.createRef(), this.props.horizontal) throw new Error("Horizontal flatlist not supported at this time.")
  }
  getItemKey(item, index) {}
  scrollToOffset(params) {
      var scrollToParams = {
          animated: !1 !== params.animated
      };
      this.props.horizontal ? scrollToParams.x = params.offset || 0 : scrollToParams.y = params.offset || 0, this._scrollViewRef.current.scrollTo(scrollToParams)
  }
  renderItems() {
      for (var rowArr = [], numCols = this.props.numColumns || 1, numRows = Math.ceil(this.props.data.length / numCols), index = 0, row = 0; row < numRows; row++) {
          for (var colArr = [], keyArr = [], col = 0; col < numCols && !(index >= this.props.data.length); col++) {
              var key = this.props.keyExtractor ? this.props.keyExtractor(this.props.data[index], index) : this.props.key || index;
              keyArr.push(key), colArr.push(React__default.createElement(ViewBase, {
                  style: styles$F.item,
                  key: key
              }, this.props.renderItem({
                  item: this.props.data[index],
                  index: index
              }))), index++
          }
          rowArr.push(React__default.createElement(ViewBase, {
              key: keyArr.join("-"),
              style: styles$F.row,
              onLayout: this.props.onLayout
          }, colArr))
      }
      return rowArr
  }
  render() {
      return React__default.createElement(ScrollViewBase, _extends({}, this.props, {
          ref: this._scrollViewRef
      }), this.props.ListHeaderComponent && React__default.createElement(ViewBase, {
          style: this.props.ListHeaderComponentStyle
      }, this.props.ListHeaderComponent), !this.props.data.length && this.props.ListEmptyComponent, this.renderItems(), this.props.ListFooterComponent && React__default.createElement(ViewBase, {
          style: this.props.ListFooterComponentStyle
      }, this.props.ListFooterComponent))
  }
}
var _class$h, _temp$h, styles$F = StyleSheet.create({
  row: {
      flex: 0,
      flexDirection: "row"
  },
  item: {
      flex: 1
  }
});
class FlatList extends FlatListBase {}
_defineProperty(FlatList, "propTypes", {
  data: PropTypes.array.isRequired,
  renderItem: PropTypes.func.isRequired,
  keyExtractor: PropTypes.func,
  numColumns: PropTypes.number,
  ListHeaderComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.elementType]),
  ListHeaderComponent: PropTypes.object
}), _defineProperty(FlatList, "defaultProps", {});
var _class$i, _temp$i, _class$j, _temp$j, _class$k, _temp$k, InfiniteList = R14.connect((_temp$h = _class$h = class extends React__default.Component {
      constructor(props) {
          super(props), this.infiniteList = this.props.app.ui.infiniteList.create(props, this), this.keyExtractor = this.keyExtractor.bind(this), this.renderRow = this.renderRow.bind(this), this.loadNextPage = this.loadNextPage.bind(this), this.loadPreviousPage = this.loadPreviousPage.bind(this)
      }
      componentDidMount() {
          this.infiniteList.load()
      }
      componentWillUnmount() {
          this.infiniteList.remove()
      }
      keyExtractor(row, index) {
          return this.infiniteList.keyExtractor(row)
      }
      loadNextPage() {
          var _this = this;
          return _asyncToGenerator((function*() {
              return yield _this.infiniteList.load(_this.infiniteList.page + 1)
          }))()
      }
      loadPreviousPage() {
          var _this2 = this;
          return _asyncToGenerator((function*() {
              return yield _this2.infiniteList.load(_this2.infiniteList.page - 1)
          }))()
      }
      renderRow(_ref) {
          var {
              item: item,
              index: index
          } = _ref, row = item, colArr = [], rowKey = this.infiniteList.keyExtractor(row), RowComponent = ViewBase;
          if (colArr.push(React__default.createElement(RowComponent, {
                  key: rowKey
              }, this.props.rowRenderer({
                  row: row
              }))), this.props.rowControlsRight) {
              var rowControlsRight = this.props.rowControlsRight;
              "function" == typeof rowControlsRight && (rowControlsRight = rowControlsRight(row, this.infiniteList)), colArr.push(React__default.createElement(ViewBase, {
                  style: [styles$G.headerColsCell, this.rowControlsRightWidthStyle],
                  key: "rowControlsRight"
              }, React__default.createElement(ViewBase, {
                  style: styles$G.rowControlsRight
              }, rowControlsRight)))
          }
          return React__default.createElement(ViewBase, {
              style: [styles$G.row]
          }, colArr)
      }
      renderListEmptyComponent() {
          return !this.infiniteList.state.hasLoaded && this.infiniteList.state.showActivityIndicator ? React__default.createElement(ActivityIndicator, {
              size: "large",
              containerStyle: styles$G.activityIndicator
          }) : this.props.ListEmptyComponent ? "function" == typeof this.props.ListFooterComponent ? this.props.ListEmptyComponent() : this.props.ListEmptyComponent : React__default.createElement(TextInput, {
              style: styles$G.emptyComponent
          }, "No Results")
      }
      render() {
          var ListEmptyComponent = this.renderListEmptyComponent();
          return React__default.createElement(FlatList, {
              ListHeaderComponent: this.props.ListHeaderComponent,
              ListHeaderComponentStyle: this.props.ListHeaderComponentStyle,
              ListFooterComponent: this.props.ListFooterComponent,
              ListFooterComponentStyle: this.props.ListFooterComponentStyle,
              ListEmptyComponent: ListEmptyComponent,
              data: this.infiniteList.data,
              autoSize: !0,
              numColumns: 1,
              keyExtractor: this.keyExtractor,
              renderItem: this.renderRow,
              ref: this._flatListRef,
              onLayout: this.handleLayout
          })
      }
  }, _defineProperty(_class$h, "propTypes", {
      name: PropTypes.string.isRequired,
      initializer: PropTypes.func.isRequired,
      pageLoader: PropTypes.func.isRequired,
      rowRenderer: PropTypes.func.isRequired,
      initialTotalRows: PropTypes.number,
      rowKeyExtractor: PropTypes.func,
      initialRowsPerPage: PropTypes.number,
      headerTitle: PropTypes.string,
      headerControlsRight: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.func]),
      ListEmptyComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
      ListFooterComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
      ListFooterComponentStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      ListHeaderComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
      ListHeaderComponentStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      rowControlsRight: PropTypes.func,
      onRowPress: PropTypes.func,
      initialPage: PropTypes.number
  }), _defineProperty(_class$h, "defaultProps", {
      initialPage: 1,
      initialRowsPerPage: 10,
      initialTotalRows: 0,
      headerControlsRight: []
  }), _temp$h)),
  styles$G = StyleSheet.create({}),
  Dialog = R14.connect((_temp$i = _class$i = class extends React__default.Component {
      constructor(props) {
          super(props), this.handleOkPress = this.handleOkPress.bind(this), this.handleBackdropPress = this.handleBackdropPress.bind(this), this.handleCancelPress = this.handleCancelPress.bind(this), this.handleClosePress = this.handleClosePress.bind(this), this.handleBackPress = this.handleBackPress.bind(this)
      }
      handleOkPress() {
          this.props.onOkPress && this.props.onOkPress()
      }
      handleBackdropPress() {
          this.props.onBackdropPress && this.props.onBackdropPress()
      }
      handleCancelPress() {
          this.props.onCancelPress && this.props.onCancelPress()
      }
      handleBackPress() {
          this.props.onBackPress && this.props.onBackPress()
      }
      handleClosePress() {
          this.props.onClosePress && this.props.onClosePress()
      }
      renderHeaderControlLeft() {
          if (this.props.controlsLeft) return this.props.controlsLeft;
          if (!this.props.titleControlVariant) return null;
          var ret = null;
          switch (this.props.titleControlVariant) {
              case "close":
                  ret = React__default.createElement(IconButton, {
                      icon: "close",
                      onPress: this.handleCancelPress
                  });
                  break;
              case "back":
                  ret = React__default.createElement(IconButton, {
                      icon: "arrowBack",
                      onPress: this.handleBackPress
                  })
          }
          return ret
      }
      renderHeader() {
          return React__default.createElement(ViewBase, {
              htmlTag: "header",
              style: styles$H.header
          }, React__default.createElement(ViewBase, {
              style: styles$H.headerContent
          }, this.renderHeaderControlLeft(), this.props.title && React__default.createElement(ViewBase, {
              style: styles$H.headerTitle
          }, React__default.createElement(TextInput, null, this.props.title)), this.props.headerControlsRight && React__default.createElement(ViewBase, {
              style: styles$H.headerControlsRight
          }, this.props.headerControlsRight)))
      }
      render() {
          return React__default.createElement(Modal$1, {
              animationType: "fade",
              backdropStyle: styles$H.backdrop,
              onBackdropPress: this.handleBackdropPress,
              transparent: !0,
              visible: this.props.visible,
              style: styles$H.modal,
              onRequestClose: () => {},
              unmountOnExit: !0,
              backdrop: !0,
              scrollEnabled: !0
          }, React__default.createElement(Surface, {
              style: styles$H.dialog,
              elevation: 12
          }, this.renderHeader(), React__default.createElement(ViewBase, {
              style: styles$H.content
          }, this.props.children), React__default.createElement(ViewBase, {
              style: styles$H.buttons
          }, React__default.createElement(Button, {
              title: "cancel",
              variant: this.props.cancelButtonVariant || "text",
              onPress: this.handleCancelPress,
              style: styles$H.cancelButton
          }), this.props.OkButtonComponent, !this.props.OkButtonComponent && React__default.createElement(Button, {
              title: this.props.okButtonTitle || "Ok",
              variant: this.props.okButtonVariant || "text",
              onPress: this.handleOkPress
          }))))
      }
  }, _defineProperty(_class$i, "propTypes", {
      name: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      visible: PropTypes.bool.isRequired,
      onOkPress: PropTypes.func.isRequired,
      onCancelPress: PropTypes.func.isRequired,
      onBackPress: PropTypes.func,
      onClosePress: PropTypes.func,
      onBackdropPress: PropTypes.func,
      okButtonTitle: PropTypes.string,
      titleControlVariant: PropTypes.oneOf(["close", "back"])
  }), _temp$i)),
  styles$H = StyleSheet.create({
      showModalButton: _extends({}, StyleSheet.margin(16, 0, 0, 16)),
      modal: {},
      backdrop: {
          backgroundColor: StyleSheet.color(Colors.background).rgba(.8)
      },
      dialog: _extends({
          flex: 0,
          position: "relative",
          flexDirection: "column",
          justifyContent: "space-between",
          borderRadius: 4
      }, StyleSheet.padding(84, 0, 0, 0), {
          minWidth: 300,
          maxWidth: 480,
          minHeight: 300,
          marginTop: 80,
          marginBottom: 80,
          zIndex: 2,
          backgroundColor: Colors.background,
          overflow: "hidden",
          screen: _ref => {
              var {
                  width: width
              } = _ref;
              if (width <= 640) return {
                  width: 280,
                  minWidth: 280
              }
          }
      }),
      header: {
          position: "absolute",
          top: 0,
          right: 0,
          left: 0,
          height: 64,
          elevation: 3,
          screen: _ref2 => {
              var {
                  width: width
              } = _ref2;
              if (width <= 640) return {
                  height: 56
              }
          }
      },
      headerContent: {
          width: "auto",
          display: "flex",
          flexDirection: "row",
          margin: 0,
          alignItems: "center",
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          backgroundColor: Colors.surface,
          color: Colors.onSurface,
          height: 64,
          screen: _ref3 => {
              var {
                  width: width
              } = _ref3;
              if (width <= 640) return {
                  height: 56
              }
          }
      },
      headerTitle: {
          flex: 0,
          paddingLeft: 16,
          paddingRight: 16,
          fontSize: 20,
          fontWeight: "500"
      },
      headerControlsLeft: {
          flex: 0,
          flexDirection: "row",
          margin: 0,
          alignItems: "center",
          opacity: .94
      },
      headerControlsRight: {
          flex: 0,
          flexDirection: "row",
          margin: 0,
          marginLeft: "auto",
          alignItems: "center",
          opacity: .94
      },
      content: _extends({
          alignSelf: "flex-start"
      }, StyleSheet.padding(0, 16, 0, 16), {
          marginBottom: "auto",
          width: "100%"
      }),
      buttons: _extends({
          flex: 0,
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "center",
          height: 52
      }, StyleSheet.padding(0, 8, 0, 8)),
      cancelButton: {
          marginRight: 8
      }
  }),
  DataTable = R14.connect((_temp$j = _class$j = class extends React__default.Component {
      constructor(props) {
          super(props), this.dataTable = this.props.app.ui.dataTable.create(props, this), this.keyExtractor = this.keyExtractor.bind(this), this.renderRow = this.renderRow.bind(this), this.loadNextPage = this.loadNextPage.bind(this), this.loadPreviousPage = this.loadPreviousPage.bind(this), this.handleRowsPerPageValueChange = this.handleRowsPerPageValueChange.bind(this), this.handleRowCheckboxValueChange = this.handleRowCheckboxValueChange.bind(this), this.handleSelectAllCheckboxValueChange = this.handleSelectAllCheckboxValueChange.bind(this), this.handleLayout = this.handleLayout.bind(this), this.handleHeaderSortMenuClose = this.handleHeaderSortMenuClose.bind(this), this.handleHeaderFilterMenuClose = this.handleHeaderFilterMenuClose.bind(this), this.handleHeaderFiltersReset = this.handleHeaderFiltersReset.bind(this), this.handleFilterDialogClosePress = this.handleFilterDialogClosePress.bind(this), this.handleFilterDialogOkPress = this.handleFilterDialogOkPress.bind(this), this.handleFilterDialogControlPress = this.handleFilterDialogControlPress.bind(this), this.handleFilterDialogResetPress = this.handleFilterDialogResetPress.bind(this), this._flatListRef = React__default.createRef(), this._widthStyles = {}, this._rowControlsRightWidthStyle = null, this.state = {
              visibleColumnCount: 0
          }, this._headerSortMenuRef = React__default.createRef(), this._headerFilterMenuRef = React__default.createRef()
      }
      componentDidMount() {
          this.dataTable.load()
      }
      componentWillUnmount() {
          this.dataTable.remove()
      }
      componentDidUpdate(prevProps, prevState) {}
      handleLayout(event) {
          var visibleColumnCount = 0;
          for (var colName in this.dataTable.columns) this.dataTable.columns[colName].collapse && (this.dataTable.columns[colName].collapsed = this.dataTable.columns[colName].collapse({
              height: event.nativeEvent.layout.height,
              width: event.nativeEvent.layout.width
          }), this.dataTable.columns[colName].collapsed || visibleColumnCount++);
          this.state.visibleColumnCount !== visibleColumnCount && this.setState({
              visibleColumnCount: visibleColumnCount
          })
      }
      widthStyle(colName) {
          if (!this._widthStyles[colName] && this.dataTable.columns[colName].width) {
              var style = StyleSheet.create({
                  width: {
                      flexBasis: this.dataTable.columns[colName].width,
                      flexGrow: 0,
                      flexShrink: 0
                  }
              });
              this._widthStyles[colName] = style.width
          }
          return this._widthStyles[colName] || null
      }
      get rowControlsRightWidthStyle() {
          if (this._rowControlsRightWidthStyle, this.props.rowControlsRightWidth) {
              var style = StyleSheet.create({
                  width: {
                      flexBasis: this.props.rowControlsRightWidth,
                      flexGrow: 0,
                      flexShrink: 0
                  }
              });
              this._rowControlsRightWidthStyle = style.width
          }
          return this._rowControlsRightWidthStyle || null
      }
      handleRowsPerPageValueChange(_ref) {
          var {
              value: value
          } = _ref;
          this.dataTable.load({
              rowsPerPage: value
          })
      }
      handleHeaderSortMenuClose() {
          this._headerSortMenuRef.current && this._headerSortMenuRef.current.close()
      }
      handleHeaderFilterMenuClose() {
          this._headerFilterMenuRef.current && this._headerFilterMenuRef.current.close()
      }
      handleHeaderFiltersReset() {
          this.dataTable.resetFilters(), this.handleHeaderFilterMenuClose()
      }
      handleFilterDialogClosePress() {
          this.dataTable.hideFilters()
      }
      handleFilterDialogOkPress() {
          this.dataTable.submitFilters("dataTable".concat(this.props.name, "DialogFilterForm")), this.dataTable.hideFilters()
      }
      handleFilterDialogControlPress() {
          this.dataTable.showFilters()
      }
      handleFilterDialogResetPress() {
          window.confirm("Are you sure?") && (this.dataTable.resetFilters(), this.dataTable.hideFilters())
      }
      handleRowCheckboxValueChange(key, value) {
          var _this = this;
          return _asyncToGenerator((function*() {
              return yield _this.dataTable.handleRowCheckboxValueChange(key, value)
          }))()
      }
      handleSelectAllCheckboxValueChange(value) {
          var _this2 = this;
          return _asyncToGenerator((function*() {
              return yield _this2.dataTable.handleSelectAllCheckboxValueChange(value)
          }))()
      }
      keyExtractor(row, index) {
          return this.dataTable.keyExtractor(row)
      }
      loadNextPage() {
          var _this3 = this;
          return _asyncToGenerator((function*() {
              return yield _this3.dataTable.load(_this3.dataTable.page + 1)
          }))()
      }
      loadPreviousPage() {
          var _this4 = this;
          return _asyncToGenerator((function*() {
              return yield _this4.dataTable.load(_this4.dataTable.page - 1)
          }))()
      }
      scrollToOffset(params) {
          this._flatListRef.current.scrollToOffset({
              offset: params.offset,
              animated: !1 !== params.animated
          })
      }
      renderRow(_ref2) {
          var {
              item: item,
              index: index
          } = _ref2, row = item, colArr = [], rowKey = this.dataTable.keyExtractor(row), isSelected = this.dataTable.isSelectedRow(row);
          for (var colName in this.props.checkboxes && colArr.push(React__default.createElement(ViewBase, {
                  style: styles$I.checkboxCell,
                  key: "rowCheckbox"
              }, React__default.createElement(Checkbox, {
                  value: isSelected,
                  onValueChange: value => {
                      this.handleRowCheckboxValueChange(rowKey, value)
                  }
              }))), this.dataTable.columns) {
              var col = this.dataTable.columns[colName];
              if (!col.collapsed && this.dataTable.isColumnVisible(colName)) {
                  var rowColKey = "".concat(colName, "-").concat(rowKey),
                      touchableProps = {
                          style: [styles$I.cellTouchable]
                      },
                      cellProps = {
                          style: [styles$I.cell, "right" === col.align && styles$I.cellRight, col.cellStyle, this.widthStyle(colName)],
                          key: rowColKey
                      },
                      TouchableComponent = null;
                  this.props.onRowPress && (TouchableComponent = TouchableBase, touchableProps.onPress = () => {
                      this.props.onRowPress(row, this.tableData)
                  });
                  var renderFn = col.renderer || this.props.cellRenderer || null,
                      renderedCell = renderFn ? renderFn({
                          cell: row[colName] || null,
                          columnName: colName,
                          row: row,
                          columns: this.dataTable.columns
                      }) : React__default.createElement(TextInput, null, row[colName] || null);
                  colArr.push(React__default.createElement(ViewBase, cellProps, renderedCell, TouchableComponent && React__default.createElement(TouchableComponent, touchableProps, React__default.createElement(ViewBase, {
                      style: styles$I.cellTouchableView
                  }))))
              }
          }
          if (this.props.rowControlsRight) {
              var rowControlsRight = this.props.rowControlsRight;
              "function" == typeof rowControlsRight && (rowControlsRight = rowControlsRight(row, this.dataTable)), colArr.push(React__default.createElement(ViewBase, {
                  style: [styles$I.cell, styles$I.rowControlsRightCell, this.rowControlsRightWidthStyle],
                  key: "rowControlsRight"
              }, React__default.createElement(ViewBase, {
                  style: styles$I.rowControlsRight
              }, rowControlsRight)))
          }
          var rowBottom = this.props.rowBottom ? this.props.rowBottom({
              row: row,
              columns: this.dataTable.columns
          }) : null;
          return rowBottom ? React__default.createElement(ViewBase, {
              style: [styles$I.row, isSelected && styles$I.rowSelected]
          }, React__default.createElement(ViewBase, {
              style: [styles$I.rowCells]
          }, colArr), React__default.createElement(ViewBase, {
              style: [styles$I.rowBottom]
          }, rowBottom)) : React__default.createElement(ViewBase, {
              style: [styles$I.row, styles$I.rowCells, isSelected && styles$I.rowSelected]
          }, colArr)
      }
      renderListEmptyComponent() {
          return !this.dataTable.state.hasLoaded && this.dataTable.state.showActivityIndicator ? React__default.createElement(ActivityIndicator, {
              size: "large",
              containerStyle: styles$I.activityIndicator
          }) : this.props.TableEmptyComponent ? this.props.TableEmptyComponent : React__default.createElement(TextInput, {
              key: "noResults",
              style: styles$I.emptyComponent
          }, "No Results")
      }
      renderHeader() {
          var _this5 = this,
              colArr = [];
          this.props.checkboxes && colArr.push(React__default.createElement(ViewBase, {
              style: styles$I.checkboxCell,
              key: "rowCheckbox"
          }, React__default.createElement(Checkbox, {
              value: this.dataTable.hasSelectedAllRows(),
              onValueChange: this.handleSelectAllCheckboxValueChange,
              iconBlank: "checkboxMultipleBlank",
              iconMarked: "checkboxMultipleMarked"
          })));
          var shouldRenderSortMenu = !1,
              colIdx = 0,
              firstVisibleColIdx = null,
              hasFilterForm = !1,
              _loop = function(colName) {
                  colIdx++;
                  var col = _this5.dataTable.columns[colName];
                  firstVisibleColIdx || (firstVisibleColIdx = colIdx);
                  var cellContent = null,
                      cellLabel = null;
                  col.FilterField && (hasFilterForm = !0);
                  var isSortable = !!col.sortable;
                  isSortable && (shouldRenderSortMenu = !0), col.width;
                  var isSortActive = isSortable && colName === _this5.dataTable.state.sortColumnName;
                  if (col.label && (cellLabel = React__default.createElement(TextInput, {
                          style: [styles$I.headerColsCellText, isSortActive && styles$I.headerColsCellTextActive]
                      }, col.label)), col.sortable) {
                      var sortIcon, sortIconColor = StyleSheet.color(Colors.onSurface).rgba(.6),
                          iconStyles = [styles$I.sortIcon];
                      colIdx === firstVisibleColIdx && "right" !== col.align ? iconStyles.push(styles$I.sortIconRight) : iconStyles.push(styles$I.sortIconLeft), sortIcon = React__default.createElement(FadeView, {
                          visible: colName === _this5.dataTable.sortColumnName
                      }, React__default.createElement(AnimatedView, {
                          key: colName,
                          in: "desc" === _this5.dataTable.sortDirection,
                          enter: {
                              transform: [{
                                  rotate: "180deg"
                              }]
                          },
                          exit: {
                              transform: [{
                                  rotate: "0deg"
                              }]
                          },
                          style: iconStyles
                      }, React__default.createElement(Icon, {
                          color: sortIconColor,
                          size: "small",
                          name: "arrowUp"
                      }))), cellContent = React__default.createElement(TouchableBase, {
                          onPress: () => {
                              _this5.dataTable.setSort(colName)
                          }
                      }, React__default.createElement(ViewBase, {
                          style: [styles$I.headerColsCellTouchable, _this5.widthStyle(colName)]
                      }, colIdx > firstVisibleColIdx && sortIcon, cellLabel, colIdx === firstVisibleColIdx && sortIcon))
                  } else cellContent = cellLabel;
                  colArr.push(React__default.createElement(ViewBase, {
                      style: [styles$I.headerColsCell, "right" === col.align && styles$I.headerColsCellRight, _this5.widthStyle(colName)],
                      key: "".concat(colName, "ColHeader")
                  }, cellContent, col.FilterField || null))
              };
          for (var colName in this.dataTable.columns) _loop(colName);
          var headerControlsRight = this.props.headerControlsRight;
          "function" == typeof headerControlsRight && (headerControlsRight = headerControlsRight(this.dataTable)), this.props.rowControlsRight && colArr.push(React__default.createElement(ViewBase, {
              style: [styles$I.headerColsCell, this.rowControlsRightWidthStyle],
              key: "rowControlsRightColHeader"
          })), headerControlsRight = Array.isArray(headerControlsRight) ? [...headerControlsRight] : [headerControlsRight], shouldRenderSortMenu && headerControlsRight.unshift(this.renderHeaderSortMenu()), (this.props.filterFields || this.props.headerFilterFields) && headerControlsRight.unshift(this.renderFilterDialogControl()), this.props.collapsable && headerControlsRight.unshift(this.renderHeaderCollapsableMenu()), this.props.searchable && headerControlsRight.unshift(React__default.createElement(DataTableSearchWidget, {
              key: "dataTableSearchWidget",
              dataTable: this.dataTable
          }));
          var headerControls = headerControlsRight && headerControlsRight.length ? React__default.createElement(ControlsView, {
              align: "right"
          }, headerControlsRight) : null;
          return React__default.createElement(ViewBase, {
              style: styles$I.header
          }, (headerControlsRight && headerControlsRight.length || this.props.headerTitle) && React__default.createElement(ViewBase, {
              style: styles$I.headerTitle
          }, React__default.createElement(TextInput, {
              style: [styles$I.headerTitleText, this.props.headerTitleTextStyle]
          }, this.props.headerTitle || null), headerControls), !hasFilterForm && React__default.createElement(ViewBase, {
              style: styles$I.headerCols
          }, colArr), hasFilterForm && React__default.createElement(Form, {
              name: "dataTable".concat(this.props.name, "ColumnFilterForm"),
              onValueChange: (val, elmt, form) => this.dataTable.submitFilters("dataTable".concat(this.props.name, "ColumnFilterForm")),
              backgroundColor: Colors.surface
          }, React__default.createElement(ViewBase, {
              style: styles$I.headerCols
          }, colArr)), this.renderFilterDialog())
      }
      renderHeaderCollapsableMenu() {
          var _this6 = this,
              items = [],
              _loop2 = function(colName) {
                  var col = _this6.dataTable.columns[colName];
                  if (_this6.dataTable.columns[colName].collapsed) return "continue";
                  items.push(React__default.createElement(PopUpMenuItem, {
                      label: col.label,
                      icon: _this6.dataTable.isColumnVisible(colName) ? "checkboxMarked" : "checkboxBlank",
                      key: colName,
                      onPress: () => {
                          _this6.dataTable.toggleColumn(colName)
                      }
                  }))
              };
          for (var colName in this.dataTable.columns) _loop2(colName);
          return React__default.createElement(PopUpMenu, {
              controlIcon: "column",
              key: "dataTableHeaderCollapseMenu",
              direction: "downLeft",
              style: styles$I.headerMenu,
              onSelect: (value, label) => {}
          }, items)
      }
      renderHeaderSortMenu() {
          var _this7 = this,
              items = [],
              _loop3 = function(colName) {
                  var col = _this7.dataTable.columns[colName];
                  col.sortable && items.push(React__default.createElement(ViewBase, {
                      key: colName,
                      style: styles$I.headerSortMenuRow,
                      key: colName
                  }, React__default.createElement(TextInput, {
                      style: styles$I.headerSortMenuLabel
                  }, col.label), React__default.createElement(IconButton, {
                      variant: _this7.dataTable.sortColumnName === colName && "asc" === _this7.dataTable.sortDirection && "circle",
                      style: styles$I.headerSortMenuIcon,
                      icon: "arrowUp",
                      size: "small",
                      onPress: () => {
                          _this7.dataTable.setSort(colName, "asc")
                      }
                  }), React__default.createElement(IconButton, {
                      variant: _this7.dataTable.sortColumnName === colName && "desc" === _this7.dataTable.sortDirection && "circle",
                      style: styles$I.headerSortMenuIcon,
                      icon: "arrowDown",
                      size: "small",
                      onPress: () => {
                          _this7.dataTable.setSort(colName, "desc")
                      }
                  })))
              };
          for (var colName in this.dataTable.columns) _loop3(colName);
          return React__default.createElement(PopUpMenu, {
              controlIcon: "sort",
              ref: this._headerSortMenuRef,
              key: "dataTableHeaderSortMenu-".concat(this.dataTable.sortColumnName, "-").concat(this.dataTable.sortDirection),
              direction: "downLeft",
              style: styles$I.headerMenu,
              onSelect: (value, label) => {}
          }, React__default.createElement(ViewBase, {
              key: "headerSortMenuHeader",
              style: styles$I.headerMenuHeader
          }, React__default.createElement(TextInput, {
              style: styles$I.headerMenuHeaderText
          }, "Sort By"), React__default.createElement(IconButton, {
              style: styles$I.headerMenuIcon,
              icon: "close",
              onPress: this.handleHeaderSortMenuClose
          })), React__default.createElement(ViewBase, {
              key: "headerSortMenuItems"
          }, items))
      }
      renderFilterDialogControl() {
          return React__default.createElement(IconButton, {
              key: "filterDialogControl",
              icon: "filter",
              onPress: this.handleFilterDialogControlPress,
              color: this.dataTable.hasFilterValues ? Colors.primary : Colors.onSurface
          })
      }
      renderFilterDialog() {
          var filterFields = this.props.filterFields || this.props.headerFilterFields;
          return "function" == typeof filterFields && (filterFields = filterFields(this.dataTable)), filterFields ? React__default.createElement(Dialog, {
              name: "filterDialog",
              title: "Filters",
              visible: this.dataTable.state.showFilters,
              titleControlVariant: "close",
              onClosePress: this.handleFilterDialogClosePress,
              onCancelPress: this.handleFilterDialogClosePress,
              onBackdropPress: this.handleFilterDialogClosePress,
              onOkPress: this.handleFilterDialogOkPress,
              okButtonVariant: "outlined",
              headerControlsRight: this.dataTable.hasFilterValues && [React__default.createElement(IconButton, {
                  key: "delete",
                  style: styles$I.filterDialogResetIconButton,
                  icon: "deleteSweep",
                  onPress: this.handleFilterDialogResetPress,
                  tooltip: "Clear Filters"
              })]
          }, React__default.createElement(Form, {
              style: styles$I.filterDialogForm,
              name: "dataTable".concat(this.props.name, "DialogFilterForm"),
              values: this.dataTable.state.filters,
              backgroundColor: Colors.surface
          }, filterFields)) : null
      }
      renderFooter() {
          var minRowsPerPage = this.dataTable.rowsPerPageSelectMenuItems.length ? this.dataTable.rowsPerPageSelectMenuItems[0].value : null;
          if (!this.dataTable.isInitialized || !this.dataTable.totalRows || !minRowsPerPage || this.dataTable.totalRows <= minRowsPerPage) return null;
          var styles = this.footerStyles();
          return React__default.createElement(ViewBase, {
              style: styles.footer
          }, React__default.createElement(ViewBase, {
              style: styles.footerCell
          }, React__default.createElement(ViewBase, {
              style: styles.footerRowControls
          }, React__default.createElement(ViewBase, null, React__default.createElement(TextInput, {
              style: styles.footerText
          }, "Rows Per Page:")), React__default.createElement(SelectMenu, {
              name: "rowsPerPage",
              style: styles.rowsPerPageSelectMenu,
              useValuesOnly: !0,
              valueLabelTextStyle: styles.rowsPerPageSelectMenuText,
              onValueChange: this.handleRowsPerPageValueChange,
              items: this.dataTable.rowsPerPageSelectMenuItems,
              value: this.dataTable.state.rowsPerPage
          }))), React__default.createElement(ViewBase, {
              style: styles.footerCell
          }, React__default.createElement(ViewBase, {
              style: styles.footerRowInfo
          }, React__default.createElement(TextInput, {
              style: styles.footerText
          }, this.dataTable.startIndex + 1, " -", " ", this.dataTable.totalRows <= this.dataTable.endIndex ? this.dataTable.totalRows : this.dataTable.endIndex + 1, " ", "of ", this.dataTable.totalRows)), React__default.createElement(ViewBase, {
              style: styles.footerControls
          }, React__default.createElement(IconButton, {
              icon: "keyboardArrowLeft",
              disabled: 1 === this.dataTable.page,
              onPress: this.loadPreviousPage,
              size: "large"
          }), React__default.createElement(IconButton, {
              icon: "keyboardArrowRight",
              disabled: this.dataTable.page >= this.dataTable.totalPages,
              onPress: this.loadNextPage,
              size: "large"
          }))))
      }
      render() {
          var ListHeaderComponent = this.renderHeader(),
              ListFooterComponent = this.renderFooter(),
              ListEmptyComponent = this.renderListEmptyComponent();
          return React__default.createElement(FlatList, {
              ListHeaderComponent: ListHeaderComponent,
              ListFooterComponent: ListFooterComponent,
              ListEmptyComponent: ListEmptyComponent,
              nestedScrollEnabled: !0,
              data: this.dataTable.pageData,
              autoSize: !0,
              numColumns: 1,
              keyExtractor: this.keyExtractor,
              renderItem: this.renderRow,
              ref: this._flatListRef,
              onLayout: this.handleLayout
          })
      }
      footerStyles() {
          return StyleSheet.create({
              footer: {
                  flex: 1,
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  paddingBottom: this.props.paddingBottom || 0,
                  screen: _ref3 => {
                      var {
                          width: width
                      } = _ref3;
                      if (width <= 480) return {
                          flexDirection: "column-reverse",
                          alignItems: "flex-end"
                      }
                  }
              },
              footerText: {
                  color: StyleSheet.color(Colors.onSurface).rgba(.6),
                  fontWeight: "500",
                  fontSize: 14
              },
              footerCell: {
                  flex: 0,
                  flexDirection: "row",
                  alignItems: "center"
              },
              footerRowControls: {
                  flex: 1,
                  flexDirection: "row",
                  alignItems: "center",
                  screen: _ref4 => {
                      var {
                          width: width
                      } = _ref4;
                      if (width <= 480) return {
                          marginRight: -14
                      }
                  }
              },
              footerRowInfo: {
                  marginLeft: 30
              },
              footerControls: {
                  height: 48,
                  flex: 0,
                  flexDirection: "row",
                  justifyContent: "space-around",
                  alignItems: "center",
                  marginLeft: 44
              },
              rowsPerPageSelectMenu: {
                  screen: _ref5 => {
                      var {
                          width: width
                      } = _ref5;
                      if (width <= 480) return {
                          marginRight: 20
                      }
                  }
              },
              rowsPerPageSelectMenuText: {
                  color: StyleSheet.color(Colors.onSurface).rgba(.8),
                  fontWeight: "500"
              }
          })
      }
  }, _defineProperty(_class$j, "propTypes", {
      name: PropTypes.string.isRequired,
      columns: PropTypes.object.isRequired,
      initializer: PropTypes.func.isRequired,
      pageLoader: PropTypes.func.isRequired,
      cellRenderer: PropTypes.func,
      rowBottom: PropTypes.func,
      initialTotalRows: PropTypes.number,
      autoRefresh: PropTypes.number,
      rowKeyExtractor: PropTypes.func,
      onSelection: PropTypes.func,
      initialRowsPerPage: PropTypes.number,
      headerTitle: PropTypes.string,
      headerControlsRight: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.func]),
      checkboxes: PropTypes.bool,
      initialSelectedRows: PropTypes.array,
      rowControlsRight: PropTypes.func,
      onRowPress: PropTypes.func,
      initialPage: PropTypes.number,
      initialSortColumnName: PropTypes.string,
      initialSortDirection: PropTypes.oneOf(["asc", "desc"]),
      searchable: PropTypes.bool,
      collapsable: PropTypes.bool,
      displayMode: PropTypes.oneOf(["dataTable", "cardGrid"])
  }), _defineProperty(_class$j, "defaultProps", {
      initialPage: 1,
      initialRowsPerPage: 10,
      initialTotalRows: 0,
      initialSortDirection: "asc",
      initialSelectedRows: [],
      headerControlsRight: [],
      displayMode: "dataTable"
  }), _temp$j)),
  DataTableSearchWidget = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props), this.dataTable = this.props.dataTable, this.handleChangeText = this.handleChangeText.bind(this), this.handleShowPress = this.handleShowPress.bind(this), this.handleHidePress = this.handleHidePress.bind(this), this.handleBlur = this.handleBlur.bind(this)
      }
      handleChangeText(value) {
          var _this8 = this;
          return _asyncToGenerator((function*() {
              return yield _this8.dataTable.handleSearchChangeText(value)
          }))()
      }
      handleShowPress() {
          this.dataTable.showSearch()
      }
      handleHidePress() {
          this.dataTable.hideSearch()
      }
      handleBlur() {
          this.dataTable.hideSearch()
      }
      render() {
          var placeholder = this.props.headerTitle ? "Search ".concat(this.props.headerTitle) : "Search";
          return React__default.createElement(ViewBase, {
              style: styles$I.searchWidget,
              tooltip: 'Search'
          }, React__default.createElement(AnimatedView, {
              enter: {
                  transform: [{
                      translateX: 0
                  }, {
                      scale: 1
                  }],
                  opacity: 1
              },
              exit: {
                  transform: [{
                      translateX: 80
                  }, {
                      scale: .25
                  }],
                  opacity: 0
              },
              in: this.dataTable.state.showSearch,
              duration: 150,
              style: styles$I.searchTextInputFieldContainer,
              unmountOnExit: !0
          }, React__default.createElement(ViewBase, {
              style: styles$I.searchTextInputField
          }, React__default.createElement(TextInput$2, {
              name: "search",
              value: this.dataTable.state.searchTextInputValue,
              onChangeText: this.handleChangeText,
              style: styles$I.searchTextInput,
              autoFocus: !0,
              placeholder: placeholder
          }), React__default.createElement(IconButton, {
              icon: "arrowForward",
              key: "close",
              size: "small",
              onPress: this.handleHidePress,
              style: styles$I.hideIconButton
          }))), React__default.createElement(IconButton, {
              icon: "search",
              key: "search",
              color: this.dataTable.searchTextExists() ? Colors.primary : Colors.onSurface,
              onPress: this.handleShowPress
          }))
      }
  }),
  styles$I = StyleSheet.create({
      dataTable: {
          flex: 1,
          flexDirection: "column"
      },
      header: {
          backgroundColor: Colors.surface,
          elevation: 2
      },
      headerTitle: _extends({
          flex: 1,
          flexDirection: "row",
          justifyContent: "space-between"
      }, StyleSheet.padding(16, 16, 12, 16)),
      headerTitleText: {
          fontSize: 18,
          fontWeight: "500",
          lineHeight: 36,
          color: Colors.onSurface
      },
      headerCols: {
          flex: 1,
          flexDirection: "row",
          width: "100%",
          height: 56
      },
      filterDialogForm: _extends({}, StyleSheet.padding(4, 0, 0, 0), StyleSheet.margin(0, 0, -16, 0)),
      filterDialogResetIconButton: {
          marginRight: 12
      },
      headerFilterForm: _extends({
          flex: 0,
          flexDirection: "column",
          justifyContent: "center"
      }, StyleSheet.padding(16, 12, 0, 12)),
      headerFilterField: _extends({
          flex: 0,
          minWidth: 280
      }, StyleSheet.margin(-16, 8, -24, 8)),
      headerColsFilters: {
          backgroundColor: Colors.secondaryDark
      },
      headerColsCell: _extends({
          flex: 1,
          flexBasis: 1,
          flexGrow: 1,
          flexDirection: "row",
          alignItems: "center"
      }, StyleSheet.padding(16, 16, 12, 16)),
      headerColsCellRight: {
          justifyContent: "flex-end"
      },
      headerColsCellTouchable: {
          flex: 0,
          flexDirection: "row",
          alignItems: "center"
      },
      headerColsCellText: {
          color: StyleSheet.color(Colors.onSurface).rgba(.6),
          fontWeight: "500",
          fontSize: 14,
          color: Colors.onSurface
      },
      headerColsCellTextActive: {},
      headerMenu: {
          minWidth: 160
      },
      headerMenuIcon: _extends({}, StyleSheet.margin(0)),
      headerMenuHeader: _extends({
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
          height: 36,
          justifyContent: "space-between"
      }, StyleSheet.padding(0, 4, 0, 12), StyleSheet.margin(0, 0, 0, 0)),
      headerMenuHeaderText: {
          fontWeight: 500,
          marginRight: "auto"
      },
      headerSortMenuRow: _extends({
          flex: 1,
          flexDirection: "row",
          height: 44,
          alignItems: "center",
          minWidth: 160,
          maxWidth: 256
      }, StyleSheet.padding(0, 4, 0, 12)),
      headerSortMenuLabel: {
          marginRight: "auto",
          fontSize: 14,
          paddingRight: 8
      },
      headerFilterMenu: {
          width: 256
      },
      row: {
          width: "100%",
          borderStyle: "solid",
          borderBottomWidth: 1,
          borderColor: StyleSheet.color(Colors.onBackground).rgba(.1),
          hover: {
              backgroundColor: StyleSheet.color(Colors.onBackground).rgba(.05)
          }
      },
      rowCells: {
          flex: 1,
          flexDirection: "row",
          width: "100%",
          justifyContent: "flex-start"
      },
      rowBottom: _extends({}, StyleSheet.margin(-16, 16, 16, 16)),
      rowSelected: {
          backgroundColor: StyleSheet.color(Colors.onBackground).rgba(.1)
      },
      rowControlsRightCell: {
          marginLeft: "auto"
      },
      rowControlsRight: _extends({
          flex: 1,
          flexBasis: 1,
          flexGrow: 0,
          flexDirection: "row"
      }, StyleSheet.margin(-8, -8, -8, "auto"), {
          justifyContent: "flex-end",
          alignItems: "flex-start"
      }),
      checkboxCell: {
          flex: 0,
          flexDirection: "row",
          justifyContent: "flex-start",
          paddingTop: 8,
          alignItems: "flex-start",
          width: 32,
          borderStyle: "solid"
      },
      cell: _extends({
          flex: 1,
          flexBasis: 1,
          flexGrow: 1,
          position: "relative"
      }, StyleSheet.padding(16, 16, 16, 16)),
      cellTouchable: _extends({
          position: "absolute"
      }, StyleSheet.absoluteFill, {
          flex: 1
      }),
      cellTouchableView: _extends({
          position: "absolute"
      }, StyleSheet.absoluteFill, {
          flex: 1
      }),
      cellRight: {
          alignItems: "flex-end"
      },
      activityIndicator: {
          flex: 1,
          justifyContent: "space-around",
          alignItems: "center"
      },
      emptyComponent: {
          textAlign: "center",
          padding: 16,
          color: StyleSheet.color(Colors.onBackground).rgba(.5)
      },
      sortIconLeft: _extends({}, StyleSheet.margin(0, 4, 0, -24)),
      sortIconLeftAlignRight: _extends({}, StyleSheet.margin(0, 4, 0, 0)),
      sortIconRight: _extends({}, StyleSheet.margin(0, 0, 0, 4)),
      searchWidget: {
          position: "relative",
          overflow: "visible"
      },
      searchTextInputField: _extends({
          flex: 1,
          backgroundColor: StyleSheet.color(Colors.onBackground).rgba(.1)
      }, StyleSheet.padding(4, 16, 4, 16), {
          borderRadius: 4,
          flex: 1,
          flexDirection: "row"
      }),
      searchTextInputFieldContainer: {
          backgroundColor: Colors.surface,
          height: 36,
          position: "absolute",
          right: 2,
          top: -4,
          zIndex: 2
      },
      searchTextInput: {
          backgroundColor: "transparent",
          color: Colors.onBackground,
          fontSize: 16,
          width: 144
      },
      hideIconButton: {
          marginRight: -12
      }
  }),
  EntityDataTable = R14.connect((_temp$k = _class$k = class extends React__default.Component {
      constructor(props) {
          super(props), this.initializer = this.initializer.bind(this), this.pageLoader = this.pageLoader.bind(this), this.rowKeyExtractor = this.rowKeyExtractor.bind(this), this.state = {}
      }
      get entityFields() {
          var ret = [];
          for (var f in this.props.columns) ret.push(f);
          return ret.includes(this.props.entityIdField) || ret.push(this.props.entityIdField), ret
      }
      getPageData() {
          return _asyncToGenerator((function*() {
              throw new Error("FIX WITH ROLLUP")
          }))()
      }
      initializer(gridState) {
          var _this = this;
          return _asyncToGenerator((function*() {
              return yield _this.getPageData(gridState, {
                  totalCount: !0
              })
          }))()
      }
      pageLoader(gridState) {
          var _this2 = this;
          return _asyncToGenerator((function*() {
              return (yield _this2.getPageData(gridState)).pageData
          }))()
      }
      rowKeyExtractor(row) {
          return row.uid
      }
      render() {
          return React__default.createElement(DataTable, _extends({
              initializer: this.initializer,
              rowKeyExtractor: this.rowKeyExtractor,
              pageLoader: this.pageLoader
          }, this.props))
      }
  }, _defineProperty(_class$k, "propTypes", {
      entity: PropTypes.string.isRequired,
      entityIdField: PropTypes.string.isRequired
  }), _temp$k));
class EventView extends React__default.PureComponent {
  constructor(props) {
      super(props), this.ref = React__default.createRef(), this.handlePressOutside = this.handlePressOutside.bind(this), this.eventListeners = {}, this.hasMounted = !1
  }
  handlePressOutside(e) {
      if (this.props.onPressOutside) {
          if (!this.ref || !this.ref.current || !this.ref.current) return;
          this.props.onPressOutside && !this.ref.current.contains(e.target) && this.props.onPressOutside()
      }
  }
  updateEventListeners() {
      this.removeEventListeners(), this.props.onPressOutside && !this.eventListeners.pressOutside && (document.addEventListener("pointerdown", this.handlePressOutside), this.eventListeners.pressOutside = !0)
  }
  removeEventListeners() {
      this.eventListeners.pressOutside && (document.removeEventListener("pointerdown", this.handlePressOutside), delete this.eventListeners.pressOutside)
  }
  componentDidMount() {
      this.hasMounted = !0, this.updateEventListeners()
  }
  componentDidUpdate() {
      this.updateEventListeners()
  }
  componentWillUnmount() {
      this.removeEventListeners()
  }
  render() {
      return React__default.createElement(ViewBase, _extends({}, this.props, {
          htmlRef: this.ref
      }), this.props.children)
  }
}
class EventView$1 extends EventView {}
_defineProperty(EventView$1, "propTypes", {
  onPressOutside: PropTypes.func
});
class FieldSet extends React__default.PureComponent {
  constructor(props) {
      super(props)
  }
  render() {
      return React__default.createElement(ViewBase, {
          style: styles$J.fieldSet
      }, this.props.children)
  }
}
var styles$J = StyleSheet.create({
  fieldSet: {
      flex: 1,
      flexDirection: "row",
      justifyContent: "space-between"
  }
});
class ImageBase extends React__default.PureComponent {
  constructor(props) {
      super(props), this.handleLayout = this.handleLayout.bind(this)
  }
  static getSize(uri) {
      return _asyncToGenerator((function*() {
          if (!uri) throw new Error("No image uri found.");
          return new Promise((resolve, reject) => {
              var image = new Image;
              image.onload = () => {
                  resolve({
                      width: image.width,
                      height: image.height
                  })
              }, image.onerror = () => {
                  reject("Failed to load image: ".concat(uri))
              }, image.src = uri
          })
      }))()
  }
  handleLayout(layout) {
      this.props.onLayout && this.props.onLayout(layout)
  }
  defaultSource(uri) {
      return null
  }
  render() {
      var src = this.props.source;
      if (this.props.source && "object" == typeof this.props.source) {
          var imageKey = this.props.source.key || null;
          if (src = this.props.source.uri || this.props.source.default || null, imageKey) {
              var config = R14.getInstance().config;
              if (!config.storage && !config.storage.url || !config.storage.url.image) throw new Error("Error displaying image by key. Image routepath not defined in config");
              src = "".concat(config.storage.url.image, "/").concat(imageKey)
          }
      }
      var imgStyles = {
          backgroundImage: "url(".concat(src, ")"),
          backgroundRepeat: "no-repeat",
          height: "height" in this.props ? this.props.height : 0,
          width: "width" in this.props ? this.props.width : 0
      };
      switch (this.props.resizeMode) {
          case "cover":
          case "contain":
              imgStyles.backgroundSize = this.props.resizeMode;
              break;
          case "repeat":
              imgStyles.backgroundRepeat = "repeat";
              break;
          default:
              if (this.props.resizeMode) throw new Error("Image Error: Resize mode '".concat(this.props.resizeMode, "'"))
      }
      var dynamicStyles = StyleSheet.create({
          img: imgStyles
      });
      return React__default.createElement(ViewBase, {
          tooltip: this.props.tooltip || null,
          style: [dynamicStyles.img, this.props.style],
          htmlTag: "span",
          onLayout: this.props.onLayout ? this.handleLayout : null
      })
  }
  styles() {
      return StyleSheet.create({})
  }
}
StyleSheet.create({});
class Image$1 extends React__default.PureComponent {
  constructor(props) {
      super(props)
  }
  static getSize(uri) {
      return _asyncToGenerator((function*() {
          return yield ImageBase.getSize(uri)
      }))()
  }
  render() {
      return React__default.createElement(ImageBase, this.props)
  }
}
_defineProperty(Image$1, "propTypes", {
  source: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  resizeMode: PropTypes.oneOf(["cover", "contain", "stretch", "repeat", "center"]),
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}), _defineProperty(Image$1, "defaultProps", {});
StyleSheet.create({});
var DialogFormField = R14.connectForm(class extends React__default.Component {
      constructor(props) {
          super(props), this.elmt = this.props.form.addElement(props), this.handleItemAddPress = this.handleItemAddPress.bind(this), this.handleItemEditPress = this.handleItemEditPress.bind(this), this.handleItemRemovePress = this.handleItemRemovePress.bind(this), this.handleDialogClosePress = this.handleDialogClosePress.bind(this), this.handleDialogOkPress = this.handleDialogOkPress.bind(this), this.handleDialogFormSubmit = this.handleDialogFormSubmit.bind(this), this.handleValueChange = this.handleValueChange.bind(this), this.handleFocus = this.handleFocus.bind(this), this.handleBlur = this.handleBlur.bind(this), this.state = {
              modalVisible: !1,
              editIdx: null
          }
      }
      componentWillUnmount() {
          this.elmt.remove()
      }
      componentDidUpdate(prevProps, prevState) {}
      get isEditMode() {
          return !(!this.form.values || !this.form.values.uid)
      }
      get dialogFormName() {
          return this.props.dialogFormName || "dialogFormFieldForm"
      }
      handleFocus() {
          this.elmt.setFocus(!0), this.props.onFocus && this.props.onFocus(this.elmt)
      }
      handleBlur() {
          this.elmt.setBlur(!0), this.props.onBlur && this.props.onBlur(this.elmt)
      }
      handleValueChange(val) {
          this.props.onValueChange && this.props.onValueChange(val, this.elmt, this.elmt.form), this.elmt.form.triggerValueChange(val, this.elmt)
      }
      handleItemAddPress() {
          var _this = this;
          return _asyncToGenerator((function*() {
              _this.props.onItemAddPress && _this.props.onItemAddPress(), _this.setState({
                  modalVisible: !0,
                  editIdx: null
              })
          }))()
      }
      handleItemEditPress(i) {
          var _this2 = this;
          return _asyncToGenerator((function*() {
              _this2.props.onItemEditPress && _this2.props.onItemEditPress(_this2.elmt.value[i]), _this2.setState({
                  modalVisible: !0,
                  editIdx: i
              })
          }))()
      }
      handleItemRemovePress(i) {
          var _this3 = this;
          return _asyncToGenerator((function*() {
              if (window.confirm("Are you sure?")) {
                  var items = [..._this3.elmt.value],
                      item = items[i] || null;
                  items.splice(i, 1), _this3.elmt.value = items.length ? items : null, _this3.props.onRemoveItem && _this3.props.onRemoveItem(item, _this3.elmt, _this3.props.form), _this3.handleValueChange(_this3.elmt.value)
              }
          }))()
      }
      handleDialogClosePress() {
          var _this4 = this;
          return _asyncToGenerator((function*() {
              _this4.props.onDialogClose && _this4.props.onDialogClose("cancel"), _this4.setState({
                  modalVisible: !1,
                  editIdx: null
              })
          }))()
      }
      handleDialogOkPress() {
          var _this5 = this;
          return _asyncToGenerator((function*() {
              _this5.props.app.ui.form[_this5.dialogFormName].submit()
          }))()
      }
      handleDialogFormSubmit(dialogForm) {
          var _this6 = this;
          return _asyncToGenerator((function*() {
              if (!_this6.props.onSubmit || _this6.props.onSubmit(dialogForm)) {
                  var items = _this6.elmt.value || [],
                      newVals = _this6.props.itemValueFormatter ? _this6.props.itemValueFormatter(dialogForm.values) : dialogForm.values;
                  (yield dialogForm.validate()) && (_this6.isDialogEditMode ? items[_this6.state.editIdx] = newVals : items.push(newVals), _this6.elmt.value = items, _this6.handleValueChange(_this6.elmt.value), _this6.props.onDialogClose && _this6.props.onDialogClose("ok"), _this6.setState({
                      modalVisible: !1,
                      editIdx: null
                  }))
              }
          }))()
      }
      get isDialogEditMode() {
          return null !== this.state.editIdx
      }
      render() {
          var elementVals = this.props.form.values[this.props.name],
              dialogFormVals = this.isDialogEditMode ? this.elmt.value[this.state.editIdx] : null;
          this.props.formValueFormatter && (dialogFormVals = this.props.formValueFormatter(dialogFormVals));
          var dialogFormKey = this.isDialogEditMode ? "r14DialogForm".concat(this.state.editIdx) : "r14DialogForm";
          return React__default.createElement(InputField, _extends({}, this.props, {
              label: null,
              element: this.elmt,
              InputComponent: React__default.createElement(ViewBase, {
                  style: styles$M.addRemoveFormWidget
              }, React__default.createElement(Card, {
                  surfaceStyle: styles$M.surface,
                  title: this.props.label,
                  titleStyle: [styles$M.title, this.elmt.value && styles$M.titleValue],
                  titleControlsRight: [React__default.createElement(IconButton, {
                      icon: "add",
                      key: "add",
                      variant: "circle",
                      onPress: this.handleItemAddPress,
                      style: styles$M.addMoreButton
                  })]
              }, elementVals && elementVals.length > 0 && React__default.createElement(ViewBase, {
                  style: styles$M.items
              }, elementVals.map((val, i) => React__default.createElement(ViewBase, {
                  key: "".concat(val[this.props.name]).concat(i),
                  style: styles$M.item
              }, React__default.createElement(ViewBase, {
                  style: styles$M.itemLeft
              }, this.props.itemRenderer(val)), React__default.createElement(ControlsView, {
                  style: styles$M.itemControlsRight,
                  align: "right"
              }, React__default.createElement(PopUpMenu, {
                  controlIcon: "dotsVertical",
                  key: "menu",
                  direction: "downLeft",
                  onSelect: (value, label) => {}
              }, React__default.createElement(PopUpMenuItem, {
                  label: "Edit",
                  icon: "edit",
                  key: "edit",
                  onPress: () => this.handleItemEditPress(i)
              }), React__default.createElement(PopUpMenuItem, {
                  label: "Remove",
                  icon: "close",
                  key: "remove",
                  onPress: () => this.handleItemRemovePress(i)
              })))))), React__default.createElement(Dialog, {
                  name: "addRemoveWidgetDialog",
                  title: this.props.dialogTitle || "Add ".concat(this.props.label),
                  visible: this.state.modalVisible,
                  titleControlVariant: "close",
                  onClosePress: this.handleDialogClosePress,
                  onCancelPress: this.handleDialogClosePress,
                  onBackdropPress: this.handleDialogClosePress,
                  onOkPress: this.handleDialogOkPress,
                  okButtonTitle: this.isDialogEditMode ? "Update" : "Add"
              }, React__default.createElement(Form, {
                  key: dialogFormKey,
                  name: this.dialogFormName,
                  style: styles$M.dialogForm,
                  onSubmit: this.handleDialogFormSubmit,
                  validateBeforeSubmit: !0,
                  validators: this.props.form.validators || null,
                  initialValues: dialogFormVals
              }, this.props.dialogFormRenderer ? this.props.dialogFormRenderer(dialogFormVals) : this.props.children))))
          }))
      }
  }),
  styles$M = StyleSheet.create({
      addRemoveFormWidget: {},
      surface: _extends({}, StyleSheet.margin(0, 0, 0, 0), StyleSheet.padding(8, 8, 8, 12), {
          elevation: 0,
          backgroundColor: "transparent"
      }),
      title: _extends({
          fontSize: 16,
          color: StyleSheet.color(Colors.onBackground).rgba(.5)
      }, StyleSheet.padding(0)),
      titleValue: {
          fontSize: 16,
          fontWeight: "500",
          color: Colors.onBackground
      },
      addMoreButton: {
          marginRight: 4
      },
      dialogForm: _extends({}, StyleSheet.padding(0)),
      items: _extends({}, StyleSheet.margin(8, -4, -8, -8)),
      itemLeft: {
          width: "100%"
      },
      item: _extends({
          flex: 1,
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          backgroundColor: StyleSheet.color(Colors.onBackground).rgba(.1),
          borderRadius: 4
      }, StyleSheet.padding(8), StyleSheet.margin(0, 0, 0, 0), {
          marginBottom: 4
      }),
      itemDark: {
          backgroundColor: StyleSheet.color(Colors.onBackground).rgba(.05)
      },
      itemControlsRight: _extends({}, StyleSheet.margin(-8, -12, 0, 0))
  });
class NavigationContainer extends React__default.Component {
  constructor(props) {
      super(props)
  }
  render() {
      return React__default.createElement(NavigationBase.ContainerPortal, this.props)
  }
}
class WebViewBase extends React__default.Component {
  render() {
      var uri = this.props.source.uri,
          props = {};
      return this.props.style && (props.className = StyleSheet.className([this.props.style])), React__default.createElement("iframe", _extends({
          src: uri
      }, props))
  }
}
StyleSheet.create({});
class WebView extends React__default.PureComponent {
  render() {
      return React__default.createElement(WebViewBase, _extends({}, this.props, {
          style: [styles$O.webView, this.props.style]
      }))
  }
}
var _class$l, _temp$l, _class$m, _temp$m, styles$O = StyleSheet.create({
      webView: {}
  }),
  DraggableView = R14.connectDraggableContainer((_temp$l = _class$l = class extends React__default.Component {
      constructor(props) {
          super(props), this.draggableView = this.props.draggableContainer.addView(this.props), this.handlePressMove = this.handlePressMove.bind(this), this.handleLayout = this.handleLayout.bind(this), this.handlePressIn = this.handlePressIn.bind(this), this.handlePressOut = this.handlePressOut.bind(this), this.handlePressCancel = this.handlePressCancel.bind(this), this.ref = React__default.createRef(), this.state = {
              dragging: !1
          }
      }
      componentWillUnmount() {
          this.draggableView.remove()
      }
      handlePressMove(event) {
          this.draggableView.handlePressMove(event)
      }
      handlePressOut(event) {
          this.draggableView.handlePressOut(event)
      }
      handlePressIn(event) {
          var disabled = this.props.disabled;
          if (this.props.onPressIn) {
              var pressInDisabled = !1 === this.props.onPressIn(event);
              !disabled && pressInDisabled && (disabled = !0)
          }
          event.preventDefault(), !disabled && this.draggableView.handlePressIn(event)
      }
      handlePressCancel(event) {
          this.draggableView.handlePressCancel(event)
      }
      handleLayout(event) {
          this.draggableView.handleLayout(event)
      }
      createDynamicStyles() {
          var dynamicStyles = {
              draggable: {
                  position: "absolute",
                  top: this.props.offsetTop,
                  left: this.props.offsetLeft,
                  height: null !== this.draggableView.state.resizeHeight ? this.draggableView.state.resizeHeight : this.props.height || null,
                  width: null !== this.draggableView.state.resizeWidth ? this.draggableView.state.resizeWidth : this.props.width || null,
                  zIndex: this.draggableView.active ? 1 : 0,
                  opacity: this.draggableView.active ? .8 : 1,
                  transform: [{
                      translateX: this.draggableView.state.dragX
                  }, {
                      translateY: this.draggableView.state.dragY
                  }],
                  cursor: this.props.disabled ? null : this.draggableView.active ? "grabbing" : "grab"
              }
          };
          return this.draggableView.active && this.draggableView.styleOnDrag && (dynamicStyles.styleOnDrag = this.draggableView.styleOnDrag), StyleSheet.create(dynamicStyles)
      }
      getDelta(event) {
          var left = event.pageX,
              top = event.pageY,
              delta = {
                  left: left - this.previousLeft,
                  top: top - this.previousTop
              };
          return this.previousLeft = left, this.previousTop = top, delta
      }
      renderResizableTargets() {
          return [React__default.createElement(ViewBase, {
              key: "resizeLeftTarget",
              style: styles$P.resizeLeftTarget
          }), React__default.createElement(ViewBase, {
              key: "resizeTopTarget",
              style: styles$P.resizeTopTarget
          }), React__default.createElement(ViewBase, {
              key: "resizeBottomTarget",
              style: styles$P.resizeBottomTarget
          }), React__default.createElement(ViewBase, {
              key: "resizeRightTarget",
              style: styles$P.resizeRightTarget
          }), React__default.createElement(ViewBase, {
              key: "resizeTopLeftTarget",
              style: styles$P.resizeTopLeftTarget
          }), React__default.createElement(ViewBase, {
              key: "resizeTopRightTarget",
              style: styles$P.resizeTopRightTarget
          }), React__default.createElement(ViewBase, {
              key: "resizeBottomLeftTarget",
              style: styles$P.resizeBottomLeftTarget
          }), React__default.createElement(ViewBase, {
              key: "resizeBottomRightTarget",
              style: styles$P.resizeBottomRightTarget
          })]
      }
      render() {
          var dynamicStyles = this.createDynamicStyles();
          return React__default.createElement(TouchableBase, {
              ref: this.ref,
              onLayout: this.handleLayout,
              onPressOut: this.props.disabled ? null : this.handlePressOut,
              onPressIn: this.handlePressIn,
              onPress: this.props.onPress || null,
              feedback: !1,
              style: [dynamicStyles.draggable, this.props.style, this.draggableView.active && this.props.activeStyle, this.draggableView.active && dynamicStyles.styleOnDrag]
          }, this.props.children, this.props.resizable && this.renderResizableTargets())
      }
  }, _defineProperty(_class$l, "propTypes", {
      name: PropTypes.string.isRequired,
      draggableContainer: PropTypes.func.isRequired,
      offsetTop: PropTypes.number,
      offsetLeft: PropTypes.number,
      disabled: PropTypes.bool
  }), _defineProperty(_class$l, "defaultProps", {
      offsetTop: 0,
      offsetLeft: 0,
      disabled: !1
  }), _temp$l)),
  styles$P = StyleSheet.create({
      resizeLeftTarget: {
          position: "absolute",
          cursor: "w-resize",
          left: 0,
          top: 4,
          bottom: 4,
          width: 4
      },
      resizeRightTarget: {
          position: "absolute",
          cursor: "e-resize",
          right: 0,
          top: 4,
          bottom: 4,
          width: 4
      },
      resizeTopTarget: {
          position: "absolute",
          cursor: "n-resize",
          right: 4,
          left: 4,
          top: 0,
          height: 4
      },
      resizeBottomTarget: {
          position: "absolute",
          cursor: "s-resize",
          right: 4,
          left: 4,
          bottom: 0,
          height: 4
      },
      resizeTopLeftTarget: {
          position: "absolute",
          cursor: "nw-resize",
          left: 0,
          top: 0,
          width: 4,
          height: 4
      },
      resizeTopRightTarget: {
          position: "absolute",
          cursor: "ne-resize",
          right: 0,
          top: 0,
          width: 4,
          height: 4
      },
      resizeBottomLeftTarget: {
          position: "absolute",
          cursor: "sw-resize",
          left: 0,
          bottom: 0,
          width: 4,
          height: 4
      },
      resizeBottomRightTarget: {
          position: "absolute",
          cursor: "se-resize",
          right: 0,
          bottom: 0,
          width: 4,
          height: 4
      }
  }),
  DraggableContainer = R14.connect((_temp$m = _class$m = class extends React__default.Component {
      constructor(props) {
          super(props), this.ref = React__default.createRef(), this.handleLayout = this.handleLayout.bind(this), this.handlePressMove = this.handlePressMove.bind(this), this.handlePress = this.handlePress.bind(this), this.handlePressOut = this.handlePressOut.bind(this), this.handlePressIn = this.handlePressIn.bind(this), this.handlePressCancel = this.handlePressCancel.bind(this), this.draggable = this.props.app.ui.draggable.create(this.props)
      }
      handlePress(event) {
          this.props.onPress && this.props.onPress(event)
      }
      handlePressMove(event) {
          this.props.onPressMove && this.props.onPressMove(event), this.draggable.active && this.draggable.handlePressMove(event)
      }
      handlePressOut(event) {
          this.props.onPressOut && this.props.onPressOut(event)
      }
      handlePressIn(event) {
          this.props.onPressIn && this.props.onPressIn(event)
      }
      handlePressCancel(event) {
          this.props.onPressCancel && this.props.onPressCancel(event), this.draggable.active && this.draggable.handlePressCancel(event)
      }
      handleLayout(event) {
          this.measure((offsetLeft, offsetTop, width, height, left, top) => this.draggable.handleMeasure({
              height: height,
              width: width,
              x: left,
              y: width
          })), this.props.onLayout && this.props.onLayout(event)
      }
      measure(callback) {
          this.ref.current.measure(callback)
      }
      render() {
          return React__default.createElement(Provider, {
              draggableContainer: this.draggable
          }, React__default.createElement(TouchableBase, {
              onLayout: this.handleLayout,
              ref: this.ref,
              feedback: !1,
              onPress: this.props.onPress && this.handlePress,
              onPressIn: this.props.onPressIn && this.handlePressIn,
              onPressOut: this.props.onPressOut && this.handlePressOut,
              onPressMove: this.handlePressMove,
              onPressCancel: this.handlePressCancel,
              style: [styles$Q.draggableContainer, this.props.style]
          }, this.props.children))
      }
  }, _defineProperty(_class$m, "propTypes", {
      name: PropTypes.string.isRequired
  }), _temp$m)),
  styles$Q = StyleSheet.create({
      draggableContainer: {
          position: "relative",
          flex: 1,
          flexDirection: "row",
          cursor: null
      }
  });
class AreaSelectionView extends React__default.Component {
  constructor(props) {
      super(props), this.handlePressIn = this.handlePressIn.bind(this), this.handlePressMove = this.handlePressMove.bind(this), this.handlePressOut = this.handlePressOut.bind(this), this.handlePressCancel = this.handlePressCancel.bind(this), this.handleDragEnd = this.handleDragEnd.bind(this), this.state = {
          select: !1,
          selection: null
      }
  }
  handlePressIn(event) {
      if (event && event.nativeEvent) {
          var {
              locationX: locationX,
              locationY: locationY
          } = event.nativeEvent;
          this.state.selection && locationX >= this.state.selection.x && locationX <= this.state.selection.x + this.state.selection.width && locationY >= this.state.selection.y && locationY <= this.state.selection.y + this.state.selection.height || this.setState({
              select: !0,
              selection: {
                  startX: locationX,
                  startY: locationY,
                  x: locationX,
                  y: locationY,
                  width: 0,
                  height: 0
              }
          })
      }
  }
  handlePressMove(event) {
      var selection = this.calculateSelection(event);
      selection && this.setState({
          selection: selection
      })
  }
  calculateSelection(event) {
      if (!this.state.select || !event || !event.nativeEvent) return null;
      var {
          locationX: locationX,
          locationY: locationY
      } = event.nativeEvent, {
          startX: startX,
          startY: startY
      } = this.state.selection, diffX = locationX - startX, diffY = locationY - startY, selection = this.state.selection;
      return selection.height = Math.abs(diffY), selection.width = Math.abs(diffX), selection.x = diffX > 0 ? startX : locationX, selection.y = diffY > 0 ? startY : locationY, selection
  }
  handlePressOut(event) {
      var selection = this.calculateSelection(event),
          nState = {
              select: !1
          },
          minHeight = this.props.minHeight || 2,
          minWidth = this.props.minWidth || 2;
      (minWidth && selection.width < minWidth || minHeight && selection.height < minHeight) && (nState.selection = null, selection = null), this.props.onSelect && this.props.onSelect(selection), this.setState(nState)
  }
  handlePressCancel(event) {
      if (this.props.onCancel) {
          var selection = this.calculateSelection(event);
          this.props.onCancel(selection)
      }
      this.setState({
          select: !1,
          selection: null
      })
  }
  handleDragEnd(event) {
      var selection = this.state.selection;
      selection.x += event.nativeEvent.translationX, selection.y += event.nativeEvent.translationY, selection.height = event.nativeEvent.height, selection.width = event.nativeEvent.width, console.log("HANDLE DRAG END", event), this.setState({
          selection: selection
      })
  }
  createDynamicStyles() {
      var dynamicStyles = {};
      return this.state.select && (dynamicStyles.selection = {}, this.props.backgroundColor && (dynamicStyles.backgroundColor = this.props.backgroundColor)), StyleSheet.create(dynamicStyles)
  }
  render() {
      var dynamicStyles = this.createDynamicStyles();
      return React__default.createElement(DraggableContainer, {
          name: "areaSelection",
          style: [styles$R.areaSelectionView, this.props.style],
          onPressIn: this.handlePressIn,
          onPressOut: this.state.select ? this.handlePressOut : null,
          onPressMove: this.state.select ? this.handlePressMove : null,
          onPressCancel: this.state.select ? this.handlePressCancel : null
      }, this.state.selection && React__default.createElement(DraggableView, {
          name: "areaSelection",
          style: [styles$R.selection, dynamicStyles.selection],
          offsetTop: this.state.selection.y,
          offsetLeft: this.state.selection.x,
          height: this.state.selection.height,
          width: this.state.selection.width,
          disabled: this.state.select,
          onDragEnd: this.handleDragEnd,
          resizable: !this.state.select
      }))
  }
}
_defineProperty(AreaSelectionView, "propTypes", {
  onSelect: PropTypes.func.isRequired,
  onCancel: PropTypes.func
});
var styles$R = StyleSheet.create({
  areaSelectionView: {
      position: "relative",
      cursor: "crosshair"
  },
  selection: {
      position: "absolute",
      backgroundColor: StyleSheet.color(Colors.primary).rgba(.3)
  }
});
class SideSheetSection extends React__default.Component {
  render() {
      return React__default.createElement(ViewBase, {
          style: styles$S.sideSheetSection
      }, React__default.createElement(ViewBase, {
          style: styles$S.sideSheetSectionTitle
      }, React__default.createElement(TextInput, {
          style: styles$S.sideSheetSectionTitleText
      }, this.props.title)), React__default.createElement(ViewBase, {
          style: styles$S.sideSheetSectionContent
      }, this.props.children))
  }
}
class SideSheetDivider extends React__default.Component {
  render() {
      return React__default.createElement(ViewBase, {
          style: styles$S.sideSheetDivider
      })
  }
}
class SideSheet extends React__default.Component {
  constructor(props) {
      super(props)
  }
  render() {
      var sideSheet = React__default.createElement(ViewBase, {
          style: styles$S.sideSheet
      }, React__default.createElement(ScrollViewBase, null, React__default.createElement(Surface, {
          style: styles$S.surface
      }, this.props.children)));
      return this.props.modal && (sideSheet = React__default.createElement(Modal$1, {
          visible: this.props.visible,
          transparent: !0,
          animationType: "fade",
          backdrop: !0,
          backdropStyle: styles$S.sideSheetModalBackdrop,
          contentStyle: styles$S.sideSheetModalContent,
          onBackdropPress: this.props.onBackdropPress
      }, sideSheet)), sideSheet
  }
}
_defineProperty(SideSheet, "propTypes", {}), _defineProperty(SideSheet, "Section", SideSheetSection), _defineProperty(SideSheet, "Divider", SideSheetDivider);
var styles$S = StyleSheet.create({
  sideSheet: {
      position: "relative",
      width: 320
  },
  surface: _extends({
      elevation: 8
  }, StyleSheet.padding(0), {
      flex: 1,
      overFlow: "hidden"
  }),
  sideSheetSection: _extends({}, StyleSheet.padding(16, 16, 0, 16)),
  sideSheetSectionTitle: {
      paddingBottom: 12
  },
  sideSheetSectionTitleText: {
      fontSize: 16,
      fontWeight: 400,
      paddingBottom: 4,
      color: StyleSheet.color(Colors.onSurface).rgba(.8)
  },
  metric: {},
  sideSheetSectionItem: {},
  sideSheetDivider: {
      backgroundColor: StyleSheet.color(Colors.onSurface).rgba(.08),
      height: 1,
      width: "100%"
  }
});
class ZoomableView extends React__default.Component {
  constructor(props) {
      super(props), this.state = {
          layout: null
      }, this._ref = React__default.createRef(), this._prevLevel = this.props.level, this._height = this.props.height, this._width = this.props.width
  }
  componentDidUpdate() {
      this.props.level !== this._prevLevel && (this._prevLevel = this.props.level)
  }
  createDynamicStyles() {
      var dynamicStyles = {};
      return dynamicStyles.zoomableViewScale = {
          height: this.props.height,
          width: this.props.width
      }, StyleSheet.create(dynamicStyles)
  }
  render() {
      var dynamicStyles = this.createDynamicStyles();
      return React__default.createElement(AnimatedView, {
          timingFunction: "linear",
          style: [styles$T.zoomableView, this.props.styles],
          to: {
              height: this.props.height * this.props.level,
              width: this.props.width * this.props.level
          },
          from: {
              height: this.props.height * this._prevLevel,
              width: this.props.width * this._prevLevel
          },
          duration: this.props.duration || 150,
          key: "selectionIndicator",
          onLayout: this.props.onLayout || null
      }, React__default.createElement(AnimatedView, {
          timingFunction: "linear",
          to: {
              transform: [{
                  scale: this.props.level,
                  translateX: -this.props.width / (this.props.level / ((this.props.width - this.props.width * this.props.level) / 2 / this.props.width)),
                  translateY: -this.props.height / (this.props.level / ((this.props.height - this.props.height * this.props.level) / 2 / this.props.height))
              }]
          },
          from: {
              transform: [{
                  scale: this._prevLevel,
                  translateX: -this.props.width / (this._prevLevel / ((this.props.width - this.props.width * this._prevLevel) / 2 / this.props.width)),
                  translateY: -this.props.height / (this._prevLevel / ((this.props.height - this.props.height * this._prevLevel) / 2 / this.props.height))
              }]
          },
          duration: this.props.duration || 150,
          key: "zoomScale",
          style: [styles$T.zoomableViewScale, dynamicStyles.zoomableViewScale]
      }, this.props.children))
  }
}
_defineProperty(ZoomableView, "propTypes", {
  level: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  duration: PropTypes.number,
  onStart: PropTypes.func,
  onEnd: PropTypes.func
});
var styles$T = StyleSheet.create({
  zoomableView: {
      flex: 0
  },
  zoomableViewScale: {
      transformOrigin: "50% 50%"
  }
});
class TabBarItem extends React__default.Component {
  constructor(props) {
      super(props), this.handleActive = this.handleActive.bind(this), this.ref = React__default.createRef()
  }
  handleActive(link) {
      console.log(this.ref), this.props.onActive && this.props.onActive(this)
  }
  measure(callback) {
      this.ref.current.wrappedInstance.measure(callback)
  }
  render() {
      var styles = this.styles(),
          activeStyles = [styles.active],
          position = this.props.position || "top",
          tabNavItemStyles = [styles.tabNavigatorItem];
      switch (position) {
          case "top":
              activeStyles.push(styles.topActive), tabNavItemStyles.push(styles.top);
              break;
          case "bottom":
              activeStyles.push(styles.bottomActive);
              break;
          case "left":
              activeStyles.push(styles.leftActive);
              break;
          case "responsive-left-bottom":
              activeStyles.push(styles.responsiveLeftBottomActive)
      }
      return React__default.createElement(Link, {
          style: tabNavItemStyles,
          activeStyle: activeStyles,
          to: this.props.to,
          onActive: this.props.onActive && this.handleActive,
          ref: this.ref
      }, this.props.icon && React__default.createElement(Icon, {
          color: Colors.onPrimaryDark,
          name: this.props.icon
      }), this.props.label && React__default.createElement(TextInput, {
          style: styles.label
      }, this.props.label))
  }
  styles() {
      var backgroundColor = StyleSheet.color(Colors.primary).rgba(.4),
          labelColor = Colors.onPrimaryDark;
      switch (this.props.position) {
          case "top":
              backgroundColor = Colors.surface, labelColor = Colors.onSurface
      }
      return StyleSheet.create({
          tabNavigatorItem: {
              flex: 0,
              flexShrink: 0,
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              padding: 16,
              height: 56,
              margin: 0,
              opacity: .7,
              backgroundColor: StyleSheet.color(Colors.primary).rgba(.4),
              screen: _ref => {
                  var {
                      width: width
                  } = _ref;
                  if (width <= 640) return {
                      display: "flex",
                      flexShrink: this.props.scrollEnabled ? 0 : 1,
                      flexGrow: this.props.scrollEnabled ? 0 : 1
                  }
              }
          },
          top: {
              height: 56,
              backgroundColor: Colors.background,
              screen: _ref2 => {
                  var {
                      width: width
                  } = _ref2;
                  return width <= 480 ? {
                      minWidth: "40%",
                      height: 48,
                      backgroundColor: Colors.surface
                  } : width <= 640 ? {
                      minWidth: "28.5%",
                      height: 48,
                      backgroundColor: Colors.surface
                  } : void 0
              }
          },
          label: {
              color: labelColor,
              fontWeight: "500",
              fontSize: 14
          },
          active: {
              borderStyle: "solid",
              borderWidth: 0,
              borderColor: Colors.primaryLight,
              backgroundColor: backgroundColor,
              opacity: .94
          },
          leftActive: {
              borderLeftWidth: 2,
              paddingLeft: 14
          },
          responsiveLeftBottomActive: {
              borderLeftWidth: 2,
              paddingLeft: 14,
              screen: _ref3 => {
                  var {
                      width: width
                  } = _ref3;
                  if (width <= 640) return {
                      borderLeftWidth: 0,
                      borderTopWidth: 2,
                      paddingLeft: 16,
                      paddingTop: 14
                  }
              }
          },
          bottomActive: {
              borderTopWidth: 2,
              paddingTop: 14
          },
          topActive: {
              borderBottomWidth: 2,
              paddingBottom: 14
          }
      })
  }
}
var TabBar = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props), this.tabNavRef = React__default.createRef(), this.tabNavCntrRef = React__default.createRef(), this.activeItemRef = React__default.createRef(), this.handleActiveItem = this.handleActiveItem.bind(this), this.updateLayoutStyles()
      }
      static get Item() {
          return TabBarItem
      }
      updateLayoutStyles() {
          this.props.onLayoutStylesUpdate && this.props.onLayoutStylesUpdate(this.layoutStyles)
      }
      componentDidMount() {
          this.props.scrollEnabled
      }
      handleActiveItem(item) {
          item.measure(offsetLeft => {
              console.log("item.measureOffset", offsetLeft)
          })
      }
      componentWillUnmount() {
          this.props.onWillBlur && this.props.onWillBlur(this.props, this.props.app)
      }
      render() {
          var tabNavCntrStyles = [styles$U.tabNavCntr],
              tabNavStyles = [styles$U.tabNav],
              position = this.props.position || "top";
          switch (position) {
              case "top":
                  tabNavCntrStyles.push(styles$U.tabNavCntrTop), tabNavStyles.push(styles$U.tabNavTop);
                  break;
              case "bottom":
                  tabNavCntrStyles.push(styles$U.tabNavCntrBottom), tabNavStyles.push(styles$U.tabNavBottom);
                  break;
              case "left":
                  tabNavCntrStyles.push(styles$U.tabNavCntrLeft), tabNavStyles.push(styles$U.tabNavLeft);
                  break;
              case "responsive-left-bottom":
                  tabNavCntrStyles.push(styles$U.tabNavCntrResponsiveLeftBottom), tabNavStyles.push(styles$U.tabNavResponsiveLeftBottom)
          }
          var TabNavCntr = ViewBase,
              tabNavCntrProps = {};
          if (this.props.scrollEnabled) switch (position) {
              case "top":
              case "bottom":
                  TabNavCntr = TabBarScrollView, tabNavCntrProps.horizontal = !0, tabNavCntrProps.showsHorizontalScrollIndicator = !1, tabNavCntrStyles.push(styles$U.tabNavCntrScrollX), tabNavStyles.push(styles$U.tabNavScrollX)
          }
          return tabNavCntrProps.style = tabNavCntrStyles, React__default.createElement(TabNavCntr, _extends({}, tabNavCntrProps, {
              tabNavigator: this
          }), React__default.createElement(ViewBase, {
              ref: this.tabNavRef,
              style: tabNavStyles
          }, this.props.children))
      }
      get layoutStyles() {
          var layoutStyles = null;
          switch (this.props.position || "top") {
              case "top":
                  layoutStyles = StyleSheet.create({
                      offset: {
                          marginTop: 56,
                          screen: _ref => {
                              var {
                                  width: width
                              } = _ref;
                              if (width <= 640) return {
                                  marginTop: 48
                              }
                          }
                      }
                  });
                  break;
              case "bottom":
                  layoutStyles = StyleSheet.create({
                      offset: {
                          marginBottom: 56
                      }
                  });
                  break;
              case "left":
                  layoutStyles = StyleSheet.create({
                      offset: {
                          marginLeft: 56
                      }
                  });
                  break;
              case "responsive-left-bottom":
                  layoutStyles = StyleSheet.create({
                      offset: {
                          marginLeft: 56,
                          screen: _ref2 => {
                              var {
                                  width: width
                              } = _ref2;
                              if (width <= 640) return {
                                  marginLeft: 0,
                                  marginBottom: 56
                              }
                          }
                      }
                  })
          }
          return layoutStyles
      }
  }),
  styles$U = StyleSheet.create({
      tabNavCntr: {
          position: "absolute",
          backgroundColor: Colors.primaryDark,
          elevation: 2
      },
      tabNavCntrTop: {
          height: 56,
          top: 0,
          right: 0,
          left: 0,
          bottom: null,
          backgroundColor: Colors.background,
          screen: _ref3 => {
              var {
                  width: width
              } = _ref3;
              if (width <= 640) return {
                  height: 48,
                  elevation: 4
              }
          }
      },
      tabNavCntrLeft: {
          top: 0,
          right: null,
          left: 0,
          bottom: 0,
          width: 56
      },
      tabNavCntrResponsiveLeftBottom: {
          top: 0,
          right: null,
          left: 0,
          bottom: 0,
          width: 56,
          screen: _ref4 => {
              var {
                  width: width
              } = _ref4;
              if (width <= 640) return {
                  height: 56,
                  width: "auto",
                  elevation: 12,
                  top: null,
                  right: 0,
                  left: 0,
                  bottom: 0
              }
          }
      },
      tabNavCntrBottom: {
          top: null,
          right: 0,
          left: 0,
          bottom: 0
      },
      tabNav: {
          flex: 0,
          flexDirection: "column",
          justifyContent: "flex-start"
      },
      tabNavResponsiveLeftBottom: {
          screen: _ref5 => {
              var {
                  width: width
              } = _ref5;
              if (width <= 640) return {
                  flex: 1,
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  alignItems: "center"
              }
          }
      },
      tabNavTop: {
          flexDirection: "row",
          screen: _ref6 => {
              var {
                  width: width
              } = _ref6;
              if (width <= 640) return {
                  height: 48
              }
          }
      }
  }),
  TabBarScrollView = R14.connect(class extends React__default.Component {
      constructor(props) {
          super(props), this.scrollRef = React__default.createRef(), this.handleScroll = this.handleScroll.bind(this), this.handleLayout = this.handleLayout.bind(this), this.handleControlLeftPress = this.handleControlLeftPress.bind(this), this.handleControlRightPress = this.handleControlRightPress.bind(this), this.isInitialized = !1, this.offset = null, this.contentSize = null, this.size = null, this.lastScrollEvent = null, this.state = {
              controlLeftVisible: !1,
              controlRightVisible: !1
          }
      }
      componentDidMount() {
          this.props.tabNavigator && this.props.tabNavigator.activeItemRef.current && setTimeout(() => {
              this.props.tabNavigator && this.props.tabNavigator.activeItemRef && this.props.tabNavigator.activeItemRef.current && this.props.tabNavigator.activeItemRef.current.measure((offsetLeft, b, c, d) => {
                  offsetLeft >= 32 && this.scrollRef.current.scrollTo({
                      x: offsetLeft - 32
                  })
              })
          }, 100)
      }
      updateScrollEvent() {
          this.scrollRef.current.triggerOnScroll()
      }
      handleLayout() {
          this.updateScrollEvent()
      }
      handleScroll(ev) {
          this.lastScrollEvent = ev.nativeEvent;
          var width = ev.nativeEvent.layout.width,
              contentWidth = ev.nativeEvent.contentSize.width,
              offset = ev.nativeEvent.contentOffset,
              controlLeftVisible = !1,
              controlRightVisible = !1;
          contentWidth > width && (offset.x > 16 && (controlLeftVisible = !0), offset.x + width < contentWidth && (controlRightVisible = !0)), this.state.controlLeftVisible === controlLeftVisible && this.state.controlRightVisible === controlRightVisible || this.setState({
              controlLeftVisible: controlLeftVisible,
              controlRightVisible: controlRightVisible
          })
      }
      handleControlLeftPress() {
          var {
              contentOffset: contentOffset,
              contentSize: contentSize,
              layout: layout
          } = this.lastScrollEvent, scrollTo = contentOffset.x - .8 * layout.width;
          scrollTo < 0 && (scrollTo = 0), this.scrollRef.current.scrollTo({
              x: scrollTo
          })
      }
      handleControlRightPress() {
          var {
              contentOffset: contentOffset,
              contentSize: contentSize,
              layout: layout
          } = this.lastScrollEvent, scrollTo = contentOffset.x + .8 * layout.width;
          scrollTo > contentSize.width && (scrollTo = contentSize.width), this.scrollRef.current.scrollTo({
              x: scrollTo
          })
      }
      render() {
          var styles = tabBarScrollViewStyles;
          return React__default.createElement(ViewBase, {
              style: [styles.TabBarScrollViewWrapper, this.props.style]
          }, React__default.createElement(ScrollViewBase, {
              onScroll: this.handleScroll,
              ref: this.scrollRef,
              style: styles.TabBarScrollView,
              horizontal: !0,
              showsHorizontalScrollIndicator: !1,
              onLayout: this.handleLayout
          }, this.props.children), React__default.createElement(FadeView, {
              visible: this.state.controlLeftVisible,
              style: [styles.controls, styles.controlsLeft]
          }, React__default.createElement(IconButton, {
              style: styles.controlIcon,
              onPress: this.handleControlLeftPress,
              icon: "keyboardArrowLeft"
          })), React__default.createElement(FadeView, {
              visible: this.state.controlRightVisible,
              style: [styles.controls, styles.controlsRight]
          }, React__default.createElement(IconButton, {
              style: styles.controlIcon,
              onPress: this.handleControlRightPress,
              icon: "keyboardArrowRight"
          })))
      }
  }),
  tabBarScrollViewStyles = StyleSheet.create({
      TabBarScrollViewWrapper: {
          flex: 1,
          flexDirection: "row",
          overflow: "hidden",
          height: 56,
          screen: _ref7 => {
              var {
                  width: width,
                  height: height
              } = _ref7;
              if (width <= 640) return {
                  height: 48
              }
          }
      },
      TabBarScrollView: {
          paddingBottom: 128
      },
      controls: {
          position: "absolute",
          flex: 1,
          height: 56,
          justifyContent: "space-around",
          screen: _ref8 => {
              var {
                  width: width,
                  height: height
              } = _ref8;
              if (width <= 640) return {
                  height: 48
              }
          }
      },
      controlIcon: _extends({}, StyleSheet.margin(0)),
      controlsLeft: {
          left: 0,
          screen: _ref9 => {
              var {
                  width: width
              } = _ref9;
              return width <= 640 ? {
                  backgroundImage: "linear-gradient(to right, ".concat(Colors.surface, ", ").concat(Colors.surface, ", transparent)")
              } : {
                  backgroundImage: "linear-gradient(to right, ".concat(Colors.background, ", ").concat(Colors.background, ", transparent)")
              }
          }
      },
      controlsRight: {
          right: 0,
          screen: _ref10 => {
              var {
                  width: width
              } = _ref10;
              return width <= 640 ? {
                  backgroundImage: "linear-gradient(to left, ".concat(Colors.surface, ", ").concat(Colors.surface, ", transparent)")
              } : {
                  backgroundImage: "linear-gradient(to left, ".concat(Colors.background, ", ").concat(Colors.background, ", transparent)")
              }
          }
      }
  });
export default R14;
export {
  ActivityIndicator,
  AnimatedText,
  AnimatedView,
  App,
  AreaSelectionView,
  AsyncSessionStorage,
  AsyncStorage,
  BackButton,
  Button,
  Calendar,
  Card,
  CardsView,
  Chart$1 as Chart,
  Checkbox,
  Chip,
  ChipGroup,
  ColorInputField,
  Colors,
  ControlsView,
  DataTable,
  DatePicker,
  DatePickerField,
  DatePickerModal,
  Dialog,
  DialogFormField,
  DimensionsBase as Dimensions,
  DraggableContainer,
  DraggableView,
  EntityDataTable,
  EventView$1 as EventView,
  ExternalLink,
  FadeView,
  FieldGroup,
  FieldSet,
  FileInputField,
  FlatList,
  FloatingActionButton,
  Form,
  Header,
  HiddenInputField,
  Icon,
  IconButton,
  Image$1 as Image,
  InfiniteList,
  Link,
  Modal$1 as Modal,
  NavigationContainer,
  Platform,
  PopUpMenu,
  PopUpMenuItem,
  ProgressIndicator,
  Redirect,
  SafeAreaView,
  ScreenHeader,
  ScreenLayout,
  ScrollViewBase as ScrollView,
  SearchableText,
  SectionHeader,
  SelectMenu,
  SelectMenuField,
  ShowHideText$1 as ShowHideText,
  ShowHideView,
  SideSheet,
  StyleSheet,
  SubmitButton,
  Surface,
  SwitchBase as Switch,
  SwitchField,
  TabBar,
  TabBarItem,
  TextInput as Text,
  TextInput$2 as TextInput,
  TextInputField,
  Theme,
  TimePickerField,
  TouchableBase as Touchable,
  ViewBase as View,
  WebView,
  ZoomableView
};